webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var core = __webpack_require__(79);
var hide = __webpack_require__(63);
var redefine = __webpack_require__(64);
var ctx = __webpack_require__(80);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(686),
    baseMatchesProperty = __webpack_require__(687),
    identity = __webpack_require__(114),
    isArray = __webpack_require__(16),
    property = __webpack_require__(760);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(465);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(114),
    overRest = __webpack_require__(731),
    setToString = __webpack_require__(455);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(225)('wks');
var uid = __webpack_require__(145);
var Symbol = __webpack_require__(15).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(82);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(579);
var toPrimitive = __webpack_require__(95);
var dP = Object.defineProperty;

exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(93);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.restoreApp = exports.checkSession = exports.clearSession = exports.updateUser = exports.registerUser = exports.identifyUser = exports.setSelectEmployer = exports.setRequiresEmployer = exports.setCreateUserIfNotExists = exports.setIdentityUserFailureDueToMultipleEmployers = exports.setSelectMainEmployer = exports.setSelectEmployerDepartment = exports.bankAuthenticationLinkReceived = exports.bankAuthenticationStarted = exports.selectEmployer = exports.selectMainEmployer = exports.identityUserFailureDueToMultipleEmployers = exports.registrationUserFailure = exports.registrationUserSuccess = exports.registrationUserStart = exports.setUserPreRegistrationData = exports.setFlagRequiresEmployer = exports.setFlagCreateUserIfNotExists = exports.sessionTimeOut = exports.restoreInitialState = exports.clearSessionSuccess = exports.confirmContinue = exports.selectEmployerDepartment = exports.identifyUserFailureAccessNotAllowedByEmployerUserNoted = exports.identifyUserFailureAccessNotAllowedByEmployer = exports.identifyUserFailure = exports.identifyUserSuccess = exports.identifyUserStart = exports.checkUserFailure = undefined;

var _reduxActions = __webpack_require__(38);

var _finnishSsn = __webpack_require__(248);

var _finnishSsn2 = _interopRequireDefault(_finnishSsn);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _booking = __webpack_require__(68);

var _ehrResources = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var checkUserFailure = exports.checkUserFailure = _get__('makeActionCreator')('CHECK_USER_FAILURE');
var identifyUserStart = exports.identifyUserStart = _get__('makeActionCreator')('IDENTIFY_USER_START');
var identifyUserSuccess = exports.identifyUserSuccess = _get__('makeActionCreator')('IDENTIFY_USER_SUCCESS');
var identifyUserFailure = exports.identifyUserFailure = _get__('makeActionCreator')('IDENTIFY_USER_FAILURE');
var identifyUserFailureAccessNotAllowedByEmployer = exports.identifyUserFailureAccessNotAllowedByEmployer = _get__('makeActionCreator')('IDENTIFY_USER_FAILURE_ACCESS_NOT_ALLOWED_BY_EMPLOYER');
var identifyUserFailureAccessNotAllowedByEmployerUserNoted = exports.identifyUserFailureAccessNotAllowedByEmployerUserNoted = _get__('makeActionCreator')('IDENTIFY_USER_FAILURE_ACCESS_NOT_ALLOWED_BY_EMPLOYER_USER_NOTED');
var selectEmployerDepartment = exports.selectEmployerDepartment = _get__('makeActionCreator')('SELECT_EMPLOYER_DEPARTMENT');
var confirmContinue = exports.confirmContinue = _get__('makeActionCreator')('CONFIRM_CONTINUE');
var clearSessionSuccess = exports.clearSessionSuccess = _get__('makeActionCreator')('CLEAR_SESSION_SUCCESS');
var restoreInitialState = exports.restoreInitialState = _get__('makeActionCreator')('RESTORE_INITIAL_STATE');
var sessionTimeOut = exports.sessionTimeOut = _get__('makeActionCreator')('SESSION_TIMEOUT');
var setFlagCreateUserIfNotExists = exports.setFlagCreateUserIfNotExists = _get__('makeActionCreator')('SET_USER_FLAG_CREATE_IF_MOT_EXISTS');
var setFlagRequiresEmployer = exports.setFlagRequiresEmployer = _get__('makeActionCreator')('SET_USER_FLAG_REQUIRES_EMPLOYER');
var setUserPreRegistrationData = exports.setUserPreRegistrationData = _get__('makeActionCreator')('USER_SHOULD_REGISTER');
var registrationUserStart = exports.registrationUserStart = _get__('makeActionCreator')('REGISTRATION_USER_START');
var registrationUserSuccess = exports.registrationUserSuccess = _get__('makeActionCreator')('REGISTRATION_USER_SUCCESS');
var registrationUserFailure = exports.registrationUserFailure = _get__('makeActionCreator')('REGISTRATION_USER_FAILURE');
var identityUserFailureDueToMultipleEmployers = exports.identityUserFailureDueToMultipleEmployers = _get__('makeActionCreator')('LOGIN_FAILED_DUE_TO_MULTIPLE_EMPLOYERS');
var selectMainEmployer = exports.selectMainEmployer = _get__('makeActionCreator')('SELECT_MAIN_EMPLOYER');
var selectEmployer = exports.selectEmployer = _get__('makeActionCreator')('SELECT_EMPLOYER');
var bankAuthenticationStarted = exports.bankAuthenticationStarted = _get__('makeActionCreator')('BANK_AUTHENTICATION_ONGOING');
var bankAuthenticationLinkReceived = exports.bankAuthenticationLinkReceived = _get__('makeActionCreator')('BANK_AUTHENTICATION_LINK_RECEIVED');

var setSelectEmployerDepartment = exports.setSelectEmployerDepartment = function () {
  function setSelectEmployerDepartment(dispatch) {
    return function (payload) {
      dispatch(_get__('selectEmployerDepartment')(payload));
    };
  }

  return setSelectEmployerDepartment;
}();

var setSelectMainEmployer = exports.setSelectMainEmployer = function () {
  function setSelectMainEmployer(dispatch) {
    return function (user) {
      dispatch(_get__('selectMainEmployer')(user));
    };
  }

  return setSelectMainEmployer;
}();

var identifyUserErrorHandler = function () {
  function identifyUserErrorHandler(dispatch) {
    return function (error) {
      // otherwise continue with the error message
      var errorMessage = 'loginFailedGenericMessage';
      if (error.response && error.response.status) {
        if (error.response.status === 402) {
          errorMessage = 'loginFailedMessage-402';
        } else if (error.response.status === 403) {
          // Unauthorized error messages
          if (error.response.data.statusText === 'USER_WITH_SOTU_NOT_FOUND') {
            errorMessage = 'loginFailedUserWithSotuNotFound';
          } else if (error.response.data.statusText === 'MULTIPLE_USERS_WITH_SOTU') {
            errorMessage = 'loginFailedMultipleUsersWithSotu';
          } else if (error.response.data.statusText === 'PATH_REQUIRES_EMPLOYER_BUT_EMPLOYER_DOES_NOT_ALLOW_USER_ACCESS') {
            return dispatch(_get__('identifyUserFailureAccessNotAllowedByEmployer')(error.response.data.data.localizationKey)); // Message will be taken from organization localizations
          } else if (error.response.data.statusText === 'ORGANIZATION_DOES_NOT_ALLOW_CLIENT_WITHOUT_EMPLOYER') {
            errorMessage = 'loginFailedOrganizationDoesNotAllowClientWithoutEmployer';
          } else if (error.response.data.statusText === 'USER_WITHOUT_CREDIT_CHECK') {
            errorMessage = 'loginFailedUserWithoutCreditCheck';
          } else if (error.response.data.statusText === 'PATH_REQUIRES_EMPLOYER_BUT_NOT_FOUND') {
            errorMessage = 'loginFailedPathRequiresEmployerButNotFound';
          } else if (error.response.data.statusText === 'USER_WITH_SOTU_NOT_FOUND_AND_FAKE_SOTU') {
            errorMessage = 'loginFailedAndRegisterProhibited';
          }
        }
      }

      return dispatch(_get__('identifyUserFailure')(errorMessage));
    };
  }

  return identifyUserErrorHandler;
}();

var setIdentityUserFailureDueToMultipleEmployers = exports.setIdentityUserFailureDueToMultipleEmployers = function () {
  function setIdentityUserFailureDueToMultipleEmployers(dispatch) {
    return function () {
      return dispatch(_get__('identityUserFailureDueToMultipleEmployers')());
    };
  }

  return setIdentityUserFailureDueToMultipleEmployers;
}();

var setCreateUserIfNotExists = exports.setCreateUserIfNotExists = function () {
  function setCreateUserIfNotExists(dispatch) {
    return function (flagCreateUserIfNotExists) {
      dispatch(_get__('setFlagCreateUserIfNotExists')(!!flagCreateUserIfNotExists));
    };
  }

  return setCreateUserIfNotExists;
}();

var setRequiresEmployer = exports.setRequiresEmployer = function () {
  function setRequiresEmployer(dispatch) {
    return function (flagRequiresEmployer) {
      dispatch(_get__('setFlagRequiresEmployer')(!!flagRequiresEmployer));
    };
  }

  return setRequiresEmployer;
}();

var setSelectEmployer = exports.setSelectEmployer = function () {
  function setSelectEmployer(dispatch) {
    return function (selectedEmployer) {
      dispatch(_get__('selectEmployer')(selectedEmployer));
      dispatch(_get__('closePromptEmployerSelection')());
      dispatch(_get__('fetchPathAfterLogin'))();
    };
  }

  return setSelectEmployer;
}();

var identifyUser = exports.identifyUser = function () {
  function identifyUser(dispatch) {
    return function (formData, afterSuccess) {
      var createUserIfNotExists = formData.createUserIfNotExists;

      dispatch(_get__('identifyUserStart')());
      _get__('api').identifyUser(formData).then(function (data) {
        return dispatch(_get__('identifyUserSuccess')(data));
      }).then(function () {
        return dispatch(_get__('fetchUponLogin'))();
      }).then(function () {
        return dispatch(_get__('verifyEmployerForSelectedPath'))();
      }).then(function () {
        return dispatch(_get__('fetchPathAfterLogin'))();
      }).then(function () {
        if (typeof afterSuccess === 'function') {
          afterSuccess();
        }
      })['catch'](function (error) {
        // verify if the user can be created
        console.log('error in identifyUser: ', error);
        var notFound = error.response && error.response.data && (error.response.data.statusText === 'USER_WITH_SOTU_NOT_FOUND' || error.response.status === 403);
        if (createUserIfNotExists && notFound) {
          if (_get__('FinnishSSN').validate(formData.personId) || !_get__('FinnishSSN').validate(formData.personId) && formData.relaxedSotuVerificationEnabled) {
            return dispatch(_get__('setUserPreRegistrationData')(formData));
          }
        }
        return dispatch(_get__('identifyUserErrorHandler'))(error);
      });
    };
  }

  return identifyUser;
}();

var registerUser = exports.registerUser = function () {
  function registerUser(dispatch) {
    return function (formData, afterSuccess) {
      dispatch(_get__('registrationUserStart')());
      _get__('api').registerUser(formData).then(function (registrationData) {
        dispatch(_get__('registrationUserSuccess')());
        dispatch(_get__('identifyUserStart')());
        var identifyingData = formData;
        identifyingData.personId = registrationData.sotu; // Take the temporary SOTU created in Acute
        _get__('api').identifyUser(identifyingData).then(function (data) {
          return dispatch(_get__('identifyUserSuccess')(data));
        }).then(function (data) {
          if (typeof afterSuccess === 'function') {
            afterSuccess(data);
          }
        })['catch'](function (error) {
          dispatch(_get__('identifyUserErrorHandler'))(error);
        });
      })['catch'](function (error) {
        dispatch(_get__('registrationUserFailure'));
      });
    };
  }

  return registerUser;
}();

var updateUser = exports.updateUser = function () {
  function updateUser(dispatch) {
    return function (formData, afterSuccess) {
      _get__('api').updateUser(formData).then(function (data) {
        return dispatch(_get__('identifyUserSuccess')(data));
      }).then(function (data) {
        if (typeof afterSuccess === 'function') {
          afterSuccess(data);
        }
      })['catch'](function (error) {
        dispatch(_get__('registrationUserFailure'));
      });
    };
  }

  return updateUser;
}();

var clearSession = exports.clearSession = function () {
  function clearSession(dispatch) {
    return function (shouldCloseWindow) {
      _get__('api').clearSession().then(function (data) {
        dispatch(_get__('clearSessionSuccess')(data)).then(function () {
          return dispatch(_get__('restoreInitialState')());
        }).then(function () {
          dispatch(_get__('loadRoot'))();
        }).then(function () {
          if (shouldCloseWindow) {
            window.close();
          }
        });
      })['catch'](function (error) {
        // console.log(error.response.status);
        // session timeout
        Promise.resolve(true).then(function () {
          return dispatch(_get__('clearSessionSuccess')());
        }).then(function () {
          return dispatch(_get__('restoreInitialState')());
        })
        // .then(() => dispatch(sessionTimeOut()))
        .then(function () {
          dispatch(_get__('loadRoot'))();
        });
      });
    };
  }

  return clearSession;
}();

var checkSession = exports.checkSession = function () {
  function checkSession(dispatch) {
    return function () {
      _get__('api').checkSession()['catch'](function (error) {
        // Clear data.
        dispatch(_get__('clearSession'))();
        // Show a message that session is expired.
      });
    };
  }

  return checkSession;
}();

var restoreApp = exports.restoreApp = function () {
  function restoreApp(dispatch) {
    return function () {
      dispatch(_get__('restoreInitialState')());
    };
  }

  return restoreApp;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'selectEmployerDepartment':
      return selectEmployerDepartment;

    case 'selectMainEmployer':
      return selectMainEmployer;

    case 'identifyUserFailureAccessNotAllowedByEmployer':
      return identifyUserFailureAccessNotAllowedByEmployer;

    case 'identifyUserFailure':
      return identifyUserFailure;

    case 'identityUserFailureDueToMultipleEmployers':
      return identityUserFailureDueToMultipleEmployers;

    case 'setFlagCreateUserIfNotExists':
      return setFlagCreateUserIfNotExists;

    case 'setFlagRequiresEmployer':
      return setFlagRequiresEmployer;

    case 'selectEmployer':
      return selectEmployer;

    case 'closePromptEmployerSelection':
      return _booking.closePromptEmployerSelection;

    case 'fetchPathAfterLogin':
      return _booking.fetchPathAfterLogin;

    case 'identifyUserStart':
      return identifyUserStart;

    case 'api':
      return _api2['default'];

    case 'identifyUserSuccess':
      return identifyUserSuccess;

    case 'fetchUponLogin':
      return _ehrResources.fetchUponLogin;

    case 'verifyEmployerForSelectedPath':
      return _booking.verifyEmployerForSelectedPath;

    case 'FinnishSSN':
      return _finnishSsn2['default'];

    case 'setUserPreRegistrationData':
      return setUserPreRegistrationData;

    case 'identifyUserErrorHandler':
      return identifyUserErrorHandler;

    case 'registrationUserStart':
      return registrationUserStart;

    case 'registrationUserSuccess':
      return registrationUserSuccess;

    case 'registrationUserFailure':
      return registrationUserFailure;

    case 'clearSessionSuccess':
      return clearSessionSuccess;

    case 'restoreInitialState':
      return restoreInitialState;

    case 'loadRoot':
      return _booking.loadRoot;

    case 'clearSession':
      return clearSession;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(checkUserFailure, 'checkUserFailure', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserStart, 'identifyUserStart', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserSuccess, 'identifyUserSuccess', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserFailure, 'identifyUserFailure', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserFailureAccessNotAllowedByEmployer, 'identifyUserFailureAccessNotAllowedByEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserFailureAccessNotAllowedByEmployerUserNoted, 'identifyUserFailureAccessNotAllowedByEmployerUserNoted', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(selectEmployerDepartment, 'selectEmployerDepartment', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(confirmContinue, 'confirmContinue', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(clearSessionSuccess, 'clearSessionSuccess', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(restoreInitialState, 'restoreInitialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(sessionTimeOut, 'sessionTimeOut', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setFlagCreateUserIfNotExists, 'setFlagCreateUserIfNotExists', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setFlagRequiresEmployer, 'setFlagRequiresEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setUserPreRegistrationData, 'setUserPreRegistrationData', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(registrationUserStart, 'registrationUserStart', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(registrationUserSuccess, 'registrationUserSuccess', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(registrationUserFailure, 'registrationUserFailure', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identityUserFailureDueToMultipleEmployers, 'identityUserFailureDueToMultipleEmployers', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(selectMainEmployer, 'selectMainEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(selectEmployer, 'selectEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(bankAuthenticationStarted, 'bankAuthenticationStarted', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(bankAuthenticationLinkReceived, 'bankAuthenticationLinkReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setSelectEmployerDepartment, 'setSelectEmployerDepartment', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setSelectMainEmployer, 'setSelectMainEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUserErrorHandler, 'identifyUserErrorHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setIdentityUserFailureDueToMultipleEmployers, 'setIdentityUserFailureDueToMultipleEmployers', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setCreateUserIfNotExists, 'setCreateUserIfNotExists', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setRequiresEmployer, 'setRequiresEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(setSelectEmployer, 'setSelectEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(identifyUser, 'identifyUser', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(registerUser, 'registerUser', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(updateUser, 'updateUser', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(clearSession, 'clearSession', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(checkSession, 'checkSession', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');

  __REACT_HOT_LOADER__.register(restoreApp, 'restoreApp', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/session.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(671),
    baseKeys = __webpack_require__(433),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(233),
    isFlattenable = __webpack_require__(1775);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(115),
    isLength = __webpack_require__(310);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(56),
    isObjectLike = __webpack_require__(34);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(671),
    baseKeysIn = __webpack_require__(1730),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable */
var ICONS = {
  ARROW_DOWN: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 61 32' },
    _get__('React').createElement(
      'g',
      { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Home-login-screen', transform: 'translate(-690.000000, -792.000000)', className: 'svg-arrow-down' },
        _get__('React').createElement(
          'g',
          { id: 'Arrow-Green', transform: 'translate(720.500000, 808.000000) rotate(-270.000000) translate(-720.500000, -808.000000) translate(704.500000, 776.500000)' },
          _get__('React').createElement('path', { d: 'M32,31.3697948 C31.9994623,30.9151856 31.8259124,30.4616998 31.4809682,30.1149789 L3.03118245,1.51865846 C2.34311575,0.827047764 1.21707697,0.825729821 0.523366076,1.52301377 C-0.175181244,2.22515906 -0.172284769,3.34886844 0.519033076,4.04374702 L27.7084111,31.3731679 L0.519033076,58.7025887 C-0.169033629,59.3941994 -0.170344819,60.526038 0.523366076,61.223322 C1.2219134,61.9254672 2.33986461,61.9225558 3.03118245,61.2276773 L31.4809682,32.6313568 C31.8242859,32.2862708 31.9966283,31.8315851 31.9969684,31.3759668 L32,31.3697948 Z', id: 'Combined-Shape' })
        )
      )
    )
  ),
  ARROW_UP: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 61 32' },
    _get__('React').createElement(
      'g',
      { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Home-login-screen', transform: 'translate(-690.000000, -792.000000)', className: 'svg-arrow-up' },
        _get__('React').createElement(
          'g',
          { id: 'Arrow-Green', transform: 'translate(720.500000, 808.000000) rotate(-90.000000) translate(-720.500000, -808.000000) translate(704.500000, 776.500000)' },
          _get__('React').createElement('path', { d: 'M32,31.3697948 C31.9994623,30.9151856 31.8259124,30.4616998 31.4809682,30.1149789 L3.03118245,1.51865846 C2.34311575,0.827047764 1.21707697,0.825729821 0.523366076,1.52301377 C-0.175181244,2.22515906 -0.172284769,3.34886844 0.519033076,4.04374702 L27.7084111,31.3731679 L0.519033076,58.7025887 C-0.169033629,59.3941994 -0.170344819,60.526038 0.523366076,61.223322 C1.2219134,61.9254672 2.33986461,61.9225558 3.03118245,61.2276773 L31.4809682,32.6313568 C31.8242859,32.2862708 31.9966283,31.8315851 31.9969684,31.3759668 L32,31.3697948 Z', id: 'Combined-Shape' })
        )
      )
    )
  ),
  ARROW_LEFT: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 33 62' },
    _get__('React').createElement(
      'g',
      { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Home-login-screen', transform: 'translate(-704.000000, -777.000000)', className: 'svg-arrow-left' },
        _get__('React').createElement(
          'g',
          { id: 'Arrow-Green', transform: 'translate(720.500000, 808.000000) rotate(-180.000000) translate(-720.500000, -808.000000) translate(704.500000, 776.500000)' },
          _get__('React').createElement('path', { d: 'M32,31.3697948 C31.9994623,30.9151856 31.8259124,30.4616998 31.4809682,30.1149789 L3.03118245,1.51865846 C2.34311575,0.827047764 1.21707697,0.825729821 0.523366076,1.52301377 C-0.175181244,2.22515906 -0.172284769,3.34886844 0.519033076,4.04374702 L27.7084111,31.3731679 L0.519033076,58.7025887 C-0.169033629,59.3941994 -0.170344819,60.526038 0.523366076,61.223322 C1.2219134,61.9254672 2.33986461,61.9225558 3.03118245,61.2276773 L31.4809682,32.6313568 C31.8242859,32.2862708 31.9966283,31.8315851 31.9969684,31.3759668 L32,31.3697948 Z', id: 'Combined-Shape' })
        )
      )
    )
  ),
  ARROW_RIGHT: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 33 62' },
    _get__('React').createElement(
      'g',
      { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Home-login-screen', transform: 'translate(-704.000000, -777.000000)', className: 'svg-arrow-right' },
        _get__('React').createElement(
          'g',
          { id: 'Arrow-Green', transform: 'translate(720.500000, 808.000000) rotate(-360.000000) translate(-720.500000, -808.000000) translate(704.500000, 776.500000)' },
          _get__('React').createElement('path', { d: 'M32,31.3697948 C31.9994623,30.9151856 31.8259124,30.4616998 31.4809682,30.1149789 L3.03118245,1.51865846 C2.34311575,0.827047764 1.21707697,0.825729821 0.523366076,1.52301377 C-0.175181244,2.22515906 -0.172284769,3.34886844 0.519033076,4.04374702 L27.7084111,31.3731679 L0.519033076,58.7025887 C-0.169033629,59.3941994 -0.170344819,60.526038 0.523366076,61.223322 C1.2219134,61.9254672 2.33986461,61.9225558 3.03118245,61.2276773 L31.4809682,32.6313568 C31.8242859,32.2862708 31.9966283,31.8315851 31.9969684,31.3759668 L32,31.3697948 Z', id: 'Combined-Shape' })
        )
      )
    )
  ),
  CALENDAR: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 12 12' },
    _get__('React').createElement(
      'g',
      { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Date_Picker', transform: 'translate(-150.000000, -15.000000)', className: 'svg-calendar' },
        _get__('React').createElement('path', { d: 'M150,15.55 C150,15.396 150.051176,15.2658333 150.153882,15.1591333 C150.255882,15.0531667 150.381176,15 150.529412,15 L161.117647,15 C161.265882,15 161.391529,15.0531667 161.493529,15.1591333 C161.595882,15.2658333 161.647059,15.396 161.647059,15.55 L161.647059,16.69598 C161.647059,16.9743426 161.424794,17.2 161.146599,17.2 L150.50046,17.2 C150.224063,17.2 150,16.9705746 150,16.69598 L150,15.55 Z M161.647059,25.89 C161.647059,26.0366667 161.595882,26.165 161.493529,26.2746333 C161.391529,26.385 161.265882,26.44 161.117647,26.44 L150.529412,26.44 C150.381176,26.44 150.255882,26.385 150.153882,26.2746333 C150.051176,26.165 150,26.0366667 150,25.89 L150,18.1313685 C150,17.8599932 150.222265,17.64 150.50046,17.64 L161.146599,17.64 C161.422995,17.64 161.647059,17.8606676 161.647059,18.1313685 L161.647059,25.89 Z M151.711306,20.94 C151.935722,20.94 152.117647,20.768125 152.117647,20.5428748 L152.117647,20.2371252 C152.117647,20.017799 151.933214,19.84 151.711306,19.84 L151.465164,19.84 C151.240748,19.84 151.058824,20.011875 151.058824,20.2371252 L151.058824,20.5428748 C151.058824,20.762201 151.243257,20.94 151.465164,20.94 L151.711306,20.94 Z M151.711306,23.14 C151.935722,23.14 152.117647,22.968125 152.117647,22.7428748 L152.117647,22.4371252 C152.117647,22.217799 151.933214,22.04 151.711306,22.04 L151.465164,22.04 C151.240748,22.04 151.058824,22.211875 151.058824,22.4371252 L151.058824,22.7428748 C151.058824,22.962201 151.243257,23.14 151.465164,23.14 L151.711306,23.14 Z M151.711306,25.34 C151.935722,25.34 152.117647,25.168125 152.117647,24.9428748 L152.117647,24.6371252 C152.117647,24.417799 151.933214,24.24 151.711306,24.24 L151.465164,24.24 C151.240748,24.24 151.058824,24.411875 151.058824,24.6371252 L151.058824,24.9428748 C151.058824,25.162201 151.243257,25.34 151.465164,25.34 L151.711306,25.34 Z M153.828953,20.94 C154.053369,20.94 154.235294,20.768125 154.235294,20.5428748 L154.235294,20.2371252 C154.235294,20.017799 154.050861,19.84 153.828953,19.84 L153.582811,19.84 C153.358395,19.84 153.176471,20.011875 153.176471,20.2371252 L153.176471,20.5428748 C153.176471,20.762201 153.360904,20.94 153.582811,20.94 L153.828953,20.94 Z M153.828953,23.14 C154.053369,23.14 154.235294,22.968125 154.235294,22.7428748 L154.235294,22.4371252 C154.235294,22.217799 154.050861,22.04 153.828953,22.04 L153.582811,22.04 C153.358395,22.04 153.176471,22.211875 153.176471,22.4371252 L153.176471,22.7428748 C153.176471,22.962201 153.360904,23.14 153.582811,23.14 L153.828953,23.14 Z M153.828953,25.34 C154.053369,25.34 154.235294,25.168125 154.235294,24.9428748 L154.235294,24.6371252 C154.235294,24.417799 154.050861,24.24 153.828953,24.24 L153.582811,24.24 C153.358395,24.24 153.176471,24.411875 153.176471,24.6371252 L153.176471,24.9428748 C153.176471,25.162201 153.360904,25.34 153.582811,25.34 L153.828953,25.34 Z M155.946601,20.94 C156.171016,20.94 156.352941,20.768125 156.352941,20.5428748 L156.352941,20.2371252 C156.352941,20.017799 156.168508,19.84 155.946601,19.84 L155.700458,19.84 C155.476043,19.84 155.294118,20.011875 155.294118,20.2371252 L155.294118,20.5428748 C155.294118,20.762201 155.478551,20.94 155.700458,20.94 L155.946601,20.94 Z M155.946601,23.14 C156.171016,23.14 156.352941,22.968125 156.352941,22.7428748 L156.352941,22.4371252 C156.352941,22.217799 156.168508,22.04 155.946601,22.04 L155.700458,22.04 C155.476043,22.04 155.294118,22.211875 155.294118,22.4371252 L155.294118,22.7428748 C155.294118,22.962201 155.478551,23.14 155.700458,23.14 L155.946601,23.14 Z M155.946601,25.34 C156.171016,25.34 156.352941,25.168125 156.352941,24.9428748 L156.352941,24.6371252 C156.352941,24.417799 156.168508,24.24 155.946601,24.24 L155.700458,24.24 C155.476043,24.24 155.294118,24.411875 155.294118,24.6371252 L155.294118,24.9428748 C155.294118,25.162201 155.478551,25.34 155.700458,25.34 L155.946601,25.34 Z M158.064248,20.94 C158.288663,20.94 158.470588,20.768125 158.470588,20.5428748 L158.470588,20.2371252 C158.470588,20.017799 158.286155,19.84 158.064248,19.84 L157.818105,19.84 C157.59369,19.84 157.411765,20.011875 157.411765,20.2371252 L157.411765,20.5428748 C157.411765,20.762201 157.596198,20.94 157.818105,20.94 L158.064248,20.94 Z M158.064248,23.14 C158.288663,23.14 158.470588,22.968125 158.470588,22.7428748 L158.470588,22.4371252 C158.470588,22.217799 158.286155,22.04 158.064248,22.04 L157.818105,22.04 C157.59369,22.04 157.411765,22.211875 157.411765,22.4371252 L157.411765,22.7428748 C157.411765,22.962201 157.596198,23.14 157.818105,23.14 L158.064248,23.14 Z M158.064248,25.34 C158.288663,25.34 158.470588,25.168125 158.470588,24.9428748 L158.470588,24.6371252 C158.470588,24.417799 158.286155,24.24 158.064248,24.24 L157.818105,24.24 C157.59369,24.24 157.411765,24.411875 157.411765,24.6371252 L157.411765,24.9428748 C157.411765,25.162201 157.596198,25.34 157.818105,25.34 L158.064248,25.34 Z M160.181895,20.94 C160.40631,20.94 160.588235,20.768125 160.588235,20.5428748 L160.588235,20.2371252 C160.588235,20.017799 160.403802,19.84 160.181895,19.84 L159.935752,19.84 C159.711337,19.84 159.529412,20.011875 159.529412,20.2371252 L159.529412,20.5428748 C159.529412,20.762201 159.713845,20.94 159.935752,20.94 L160.181895,20.94 Z M160.181895,23.14 C160.40631,23.14 160.588235,22.968125 160.588235,22.7428748 L160.588235,22.4371252 C160.588235,22.217799 160.403802,22.04 160.181895,22.04 L159.935752,22.04 C159.711337,22.04 159.529412,22.211875 159.529412,22.4371252 L159.529412,22.7428748 C159.529412,22.962201 159.713845,23.14 159.935752,23.14 L160.181895,23.14 Z M160.181895,25.34 C160.40631,25.34 160.588235,25.168125 160.588235,24.9428748 L160.588235,24.6371252 C160.588235,24.417799 160.403802,24.24 160.181895,24.24 L159.935752,24.24 C159.711337,24.24 159.529412,24.411875 159.529412,24.6371252 L159.529412,24.9428748 C159.529412,25.162201 159.713845,25.34 159.935752,25.34 L160.181895,25.34 Z', id: 'Fill-192-Copy-2' })
      )
    )
  ),
  CHECKMARK: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 122 122' },
    _get__('React').createElement(
      'g',
      { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Aika-vahvistettu', transform: 'translate(-946.000000, -861.000000)', fillRule: 'nonzero', className: 'svg-checkmark' },
        _get__('React').createElement(
          'g',
          { id: 'Content', transform: 'translate(135.000000, 111.000000)' },
          _get__('React').createElement(
            'g',
            { id: 'Aika', transform: 'translate(169.000000, 683.000000)' },
            _get__('React').createElement('path', { d: 'M746.131313,171.131313 C769.956229,147.306397 769.956229,108.693603 746.131313,84.8686869 C722.306397,61.043771 683.693603,61.043771 659.868687,84.8686869 C636.043771,108.693603 636.043771,147.306397 659.868687,171.131313 C683.693603,194.956229 722.331293,194.956229 746.131313,171.131313 Z M679.291821,119.696134 C680.071899,118.916056 681.336143,118.915542 682.125359,119.704758 L693.559714,131.139113 C694.344555,131.923955 695.619669,131.92185 696.39555,131.146611 L724.839644,102.726083 C725.620992,101.945383 726.880929,101.93903 727.666856,102.724957 L735.905595,110.963696 C736.685674,111.743774 736.679708,113.014497 735.904469,113.789736 L706.070358,143.623847 L696.39656,153.275043 C695.614654,154.055121 694.354265,154.06097 693.568338,153.275043 L683.917142,143.623847 L671.061706,130.768411 C670.276865,129.98357 670.267155,128.720801 671.053082,127.934873 L679.291821,119.696134 Z', id: 'Shape' })
          )
        )
      )
    )
  ),
  CLOSE: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 24 24' },
    _get__('React').createElement('path', { d: 'M24 2.417L21.583 0 12 9.583 2.417 0 0 2.417 9.583 12 0 21.583 2.417 24 12 14.417 21.583 24 24 21.583 14.417 12z', className: 'svg-close', fillRule: 'evenodd' })
  ),
  INFO: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 60 60' },
    _get__('React').createElement(
      'title',
      null,
      'ECDD435C-DDA3-4B2D-BC53-CA6686999260'
    ),
    _get__('React').createElement(
      'defs',
      null,
      _get__('React').createElement('rect', { id: 'a', width: '832', height: '260', rx: '8' }),
      _get__('React').createElement(
        'mask',
        { id: 'b', x: '0', y: '0', width: '832', height: '260', fill: '#fff' },
        _get__('React').createElement('use', { xlinkHref: '#a' })
      )
    ),
    _get__('React').createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement('path', { fill: '#F4F4F4', d: 'M-334-2301h1440v4528H-334z' }),
      _get__('React').createElement(
        'g',
        { transform: 'translate(-30 -165)' },
        _get__('React').createElement('use', { className: 'svg-info', mask: 'url(#b)', strokeWidth: '2', fill: '#FFF', xlinkHref: '#a' }),
        _get__('React').createElement('path', { d: 'M60 225c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30zm-3.6-42.612c0 2.005 1.11 3.007 3.329 3.007 1.11 0 1.941-.264 2.496-.792.555-.528.832-1.266.832-2.215 0-1.992-1.11-2.988-3.328-2.988-2.22 0-3.329.996-3.329 2.988zm6.376 28.212v-22.417h-6.115V210.6h6.115z', className: 'svg-info-path' })
      )
    )
  ),
  PHONE: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 90 90' },
    _get__('React').createElement(
      'g',
      { id: 'Symbols', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _get__('React').createElement(
        'g',
        { id: 'Ajanvaraus-puhelimitse', transform: 'translate(-15.000000, -25.000000)', className: 'svg-phone' },
        _get__('React').createElement(
          'g',
          { id: 'Group-5', transform: 'translate(0.000000, 10.000000)' },
          _get__('React').createElement(
            'g',
            { id: 'ic_phone' },
            _get__('React').createElement(
              'g',
              { id: 'Icon-24px' },
              _get__('React').createElement('path', { d: 'M33.1,53.95 C40.3,68.1 51.9,79.65 66.05,86.9 L77.05,75.9 C78.4,74.55 80.4,74.1 82.15,74.7 C87.75,76.55 93.8,77.55 100,77.55 C102.75,77.55 105,79.8 105,82.55 L105,100 C105,102.75 102.75,105 100,105 C53.05,105 15,66.95 15,20 C15,17.25 17.25,15 20,15 L37.5,15 C40.25,15 42.5,17.25 42.5,20 C42.5,26.25 43.5,32.25 45.35,37.85 C45.9,39.6 45.5,41.55 44.1,42.95 L33.1,53.95 L33.1,53.95 Z', id: 'Shape' })
            )
          )
        )
      )
    )
  ),
  STAR: _get__('React').createElement(
    'svg',
    { width: '100%', height: '100%', viewBox: '0 0 14 14' },
    _get__('React').createElement('path', { d: 'M11.95 11.95a6.999 6.999 0 0 0 0-9.9 6.999 6.999 0 0 0-9.9 0 6.999 6.999 0 0 0 0 9.9 6.999 6.999 0 0 0 9.9 0zM8.206 5.533l2.605.224c.18.016.254.241.117.36L8.953 7.83l.592 2.547a.205.205 0 0 1-.306.222L7 9.249l-2.239 1.35a.205.205 0 0 1-.306-.222l.593-2.547L3.07 6.117a.205.205 0 0 1 .117-.36l2.605-.223 1.018-2.408a.205.205 0 0 1 .378 0l1.018 2.408z', fillRule: 'nonzero', className: 'svg-star' })
  )
};
/* eslint-enable */

var getSVG = function () {
  function getSVG(_ref) {
    var iconName = _ref.iconName;
    return _get__('ICONS')[iconName];
  }

  return getSVG;
}();

var AppIcon = function () {
  function AppIcon(_ref2) {
    var iconName = _ref2.iconName,
        containerClass = _ref2.containerClass;
    return _get__('React').createElement(
      'div',
      { className: containerClass },
      _get__('getSVG')({ iconName: iconName })
    );
  }

  return AppIcon;
}();

_get__('AppIcon').propTypes = {
  iconName: _get__('PropTypes').string.isRequired,
  containerClass: _get__('PropTypes').string
};

_get__('AppIcon').defaultProps = {
  containerClass: ''
};

var _default = _get__('AppIcon');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ICONS':
      return ICONS;

    case 'getSVG':
      return getSVG;

    case 'AppIcon':
      return AppIcon;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof AppIcon === 'undefined' ? 'undefined' : _typeof(AppIcon);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(AppIcon, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(AppIcon)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ICONS, 'ICONS', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AppIcon.jsx');

  __REACT_HOT_LOADER__.register(getSVG, 'getSVG', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AppIcon.jsx');

  __REACT_HOT_LOADER__.register(AppIcon, 'AppIcon', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AppIcon.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AppIcon.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _i18next = __webpack_require__(505);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextXhrBackend = __webpack_require__(504);

var _i18nextXhrBackend2 = _interopRequireDefault(_i18nextXhrBackend);

var _i18nextBrowserLanguagedetector = __webpack_require__(503);

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _constants = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_get__('i18n').use(_get__('XHR')).use(_get__('LngDetector')).init({
  detection: {
    order: ['querystring', 'cookie'],
    lookupQuerystring: 'lang',
    caches: ['cookie'], // Cache user language to co
    cookieMinutes: 40320 // One month
  },
  // List the namespaces aka *.json files
  ns: ['common', 'forgotpassword', 'forms', 'identification', 'menu', 'modals', 'roots', 'tables'],
  debug: false,
  defaultNS: 'common',
  fallbackLng: 'fi',
  backend: {
    loadPath:  false ? '/i18n/{{lng}}/{{ns}}.json' : '/i18n/v/' + _get__('APP_TIMESTAMP') + '/{{lng}}/{{ns}}.json'
  }
});

var _default = _get__('i18n');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18next2['default'];

    case 'XHR':
      return _i18nextXhrBackend2['default'];

    case 'LngDetector':
      return _i18nextBrowserLanguagedetector2['default'];

    case 'APP_TIMESTAMP':
      return _constants.APP_TIMESTAMP;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof(_i18next2['default']);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_i18next2['default'], name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_i18next2['default'])) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/i18n/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var createDesc = __webpack_require__(141);
module.exports = __webpack_require__(31) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var hide = __webpack_require__(63);
var has = __webpack_require__(70);
var SRC = __webpack_require__(145)('src');
var $toString = __webpack_require__(1242);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(79).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var fails = __webpack_require__(18);
var defined = __webpack_require__(93);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(86),
    isArrayLike = __webpack_require__(56),
    isIndex = __webpack_require__(128),
    isObject = __webpack_require__(39);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.restoreStateAndSelectionHandler = exports.saveStateAndSelectionHandler = exports.setReservationReasonCode = exports.unsetManagementOptionWithSinglePath = exports.setManagementOptionWithSinglePath = exports.setManagementOption = exports.resetBookingState = exports.storeReservation = exports.requestTimeSlots = exports.loadRoot = exports.fetchPathAfterLogin = exports.loadPath = exports.dynamicPathLoading = exports.verifyEmployerForSelectedPath = exports.unsetSelectedTimeslot = exports.setSelectedTimeslot = exports.loadStateAndSelectionHandler = exports.saveAppStateAndSelectionHandler = exports.setPathReservationReasonCode = exports.closePromptEmployerSelection = exports.openPromptEmployerSelection = exports.setLegalEntity = exports.unselectManagementOptionWithSinglePath = exports.selectManagementOptionWithSinglePath = exports.selectManagementOption = exports.setRequireSingleEmployer = exports.setSelectedPathType = exports.setSelectionHandler = exports.setUtilizeEmployerInformation = exports.setPathReservationByCodeEnabled = exports.setPathNamespace = exports.setLoginFirstShowLoginForm = exports.setLoginFirst = exports.setFetchTimesPermissions = exports.resetBooking = exports.reservationStored = exports.storingReservation = exports.clearTimeSlots = exports.timeSlotsReceived = exports.requestingTimeSlots = exports.additionalDiscussionChanged = exports.selectedOptionsChanged = exports.pathLoaded = exports.setSelectedPath = exports.setFetchPathAfterLogin = exports.pathLoading = exports.rootLoaded = exports.rootLoading = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _collection = __webpack_require__(198);

var _object = __webpack_require__(313);

var _reactGa = __webpack_require__(336);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _lodash = __webpack_require__(117);

var _lodash2 = _interopRequireDefault(_lodash);

var _localStorage = __webpack_require__(250);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _errors = __webpack_require__(118);

var _session = __webpack_require__(42);

var _app = __webpack_require__(217);

var _SelectionHandler = __webpack_require__(555);

var _SelectionHandler2 = _interopRequireDefault(_SelectionHandler);

var _ehrResources = __webpack_require__(174);

var _cancelling = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var rootLoading = exports.rootLoading = _get__('makeActionCreator')('ROOT_CONFIG_LOADING');
var rootLoaded = exports.rootLoaded = _get__('makeActionCreator')('ROOT_CONFIG_LOADED');
var pathLoading = exports.pathLoading = _get__('makeActionCreator')('PATH_CONFIG_LOADING');
var setFetchPathAfterLogin = exports.setFetchPathAfterLogin = _get__('makeActionCreator')('FETCH_PATH_AFTER_LOGIN');
var setSelectedPath = exports.setSelectedPath = _get__('makeActionCreator')('PATH_SELECTED');
var pathLoaded = exports.pathLoaded = _get__('makeActionCreator')('PATH_LOADED');
var selectedOptionsChanged = exports.selectedOptionsChanged = _get__('makeActionCreator')('SELECTED_OPTIONS_CHANGED');
var additionalDiscussionChanged = exports.additionalDiscussionChanged = _get__('makeActionCreator')('ADDITIONAL_DISCUSSION_CHANGED');
var requestingTimeSlots = exports.requestingTimeSlots = _get__('makeActionCreator')('REQUESTING_TIME_SLOTS');
var timeSlotsReceived = exports.timeSlotsReceived = _get__('makeActionCreator')('TIME_SLOTS_RECEIVED');
var clearTimeSlots = exports.clearTimeSlots = _get__('makeActionCreator')('CLEAR_TIME_SLOTS');
var storingReservation = exports.storingReservation = _get__('makeActionCreator')('STORING_RESERVATION');
var reservationStored = exports.reservationStored = _get__('makeActionCreator')('RESERVATION_STORED');
var resetBooking = exports.resetBooking = _get__('makeActionCreator')('RESET_BOOKING');
var setFetchTimesPermissions = exports.setFetchTimesPermissions = _get__('makeActionCreator')('SET_FETCH_TIMES_PERMISSIONS');
var setLoginFirst = exports.setLoginFirst = _get__('makeActionCreator')('SET_LOGIN_FIRST');
var setLoginFirstShowLoginForm = exports.setLoginFirstShowLoginForm = _get__('makeActionCreator')('SET_LOGIN_FIRST_SHOW_LOGIN_FORM');
var setPathNamespace = exports.setPathNamespace = _get__('makeActionCreator')('SET_PATH_NAMESPACE');
var setPathReservationByCodeEnabled = exports.setPathReservationByCodeEnabled = _get__('makeActionCreator')('SET_PATH_RESERVATION_BY_CODE_ENABLED');
var setUtilizeEmployerInformation = exports.setUtilizeEmployerInformation = _get__('makeActionCreator')('SET_UTILIZE_EMPLOYER_INFORMATION');
var setSelectionHandler = exports.setSelectionHandler = _get__('makeActionCreator')('SET_SELECTION_HANDLER');
var setSelectedPathType = exports.setSelectedPathType = _get__('makeActionCreator')('SET_PATH_TYPE');
var setRequireSingleEmployer = exports.setRequireSingleEmployer = _get__('makeActionCreator')('SET_REQUIRE_SINGLE_EMPLOYER');
var selectManagementOption = exports.selectManagementOption = _get__('makeActionCreator')('SELECT_MANAGEMENT_OPTION');
var selectManagementOptionWithSinglePath = exports.selectManagementOptionWithSinglePath = _get__('makeActionCreator')('SELECT_MANAGEMENT_OPTION_WITH_SINGLE_PATH');
var unselectManagementOptionWithSinglePath = exports.unselectManagementOptionWithSinglePath = _get__('makeActionCreator')('UNSELECT_MANAGEMENT_OPTION_WITH_SINGLE_PATH');
var setLegalEntity = exports.setLegalEntity = _get__('makeActionCreator')('SET_LEGAL_ENTITY');
var openPromptEmployerSelection = exports.openPromptEmployerSelection = _get__('makeActionCreator')('SET_PROMPT_EMPLOYER_SELECTION');
var closePromptEmployerSelection = exports.closePromptEmployerSelection = _get__('makeActionCreator')('CLOSE_PROMPT_EMPLOYER_SELECTION');
var setPathReservationReasonCode = exports.setPathReservationReasonCode = _get__('makeActionCreator')('SET_PATH_RESERVATION_REASON_CODE');
var saveAppStateAndSelectionHandler = exports.saveAppStateAndSelectionHandler = _get__('makeActionCreator')('SAVE_APP_STATE_AND_SELECTION_HANDLER');
var loadStateAndSelectionHandler = exports.loadStateAndSelectionHandler = _get__('makeActionCreator')('LOAD_APP_STATE_AND_SELECTION_HANDLER');
var setSelectedTimeslot = exports.setSelectedTimeslot = _get__('makeActionCreator')('SET_SELECTED_TIMESLOT');
var unsetSelectedTimeslot = exports.unsetSelectedTimeslot = _get__('makeActionCreator')('UNSET_SELECTED_TIMESLOT');

/**
 *
 * @param dispatch
 * @returns {function(...[*]=)}
 */
var setRootProperties = function () {
  function setRootProperties(dispatch) {
    return function (root) {
      dispatch(_get__('resetBooking')()); // clean any previous booking path selections
      dispatch(_get__('closeCancelReservationScreen')());
      // set the properties of the path into the store
      dispatch(_get__('setSelectedPath')(root.id));
      dispatch(_get__('setUtilizeEmployerInformation')(root.utilizeEmployerInformation));
      dispatch(_get__('setFetchTimesPermissions')(root.canAnonymousFetchTimes));
      if (root.canAnonymousFetchTimes) {
        dispatch(_get__('fetchThroughHashedApi'))(root.legalEntity);
      }
      dispatch(_get__('setCreateUserIfNotExists'))(root.createUserIfNotExists);
      dispatch(_get__('setRequiresEmployer'))(root.requiresEmployer);
      dispatch(_get__('setPathReservationByCodeEnabled')(root.reservationByCodeEnabled));
      dispatch(_get__('setLoginFirst')(root.loginFirst));
      if ('loginFirstShowLoginForm' in root) {
        dispatch(_get__('setLoginFirstShowLoginForm')(root.loginFirstShowLoginForm));
      }
      if ('pathType' in root) {
        dispatch(_get__('setSelectedPathType')(root.pathType));
      }
      if ('requireSingleEmployer' in root && root.requireSingleEmployer) {
        dispatch(_get__('setRequireSingleEmployer')(root.requireSingleEmployer));
      }
      // The application should load now that we have set all the variables in place.
      if ('legalEntity' in root) {
        dispatch(_get__('setLegalEntity')(root.legalEntity));
      }
      if ('reservationReason' in root) {
        dispatch(_get__('setPathReservationReasonCode')(root.reservationReason));
      }
    };
  }

  return setRootProperties;
}();

/**
 *
 * @param root
 * @param userIdentified
 * @param user
 * @param selectedEmployer
 * @param employerSelectionEnabled
 * @returns {{promptEmployerSelection: (*|[]|boolean), autoSelectMainEmployer: (boolean|*|{employers}|[])}}
 */
var verifyEmployerAndRoot = function () {
  function verifyEmployerAndRoot(root, userIdentified, user, selectedEmployer, employerSelectionEnabled) {
    var requiresEmployer = 'requiresEmployer' in root && root.requiresEmployer;
    var utilizeEmployerInformation = 'utilizeEmployerInformation' in root && root.utilizeEmployerInformation;
    var rootNeedsEmployer = requiresEmployer || utilizeEmployerInformation;
    var hasSelectedEmployer = selectedEmployer > -1;
    var hasMultipleEmployers = userIdentified && user && user.employers && user.employers.length > 1;
    var hasOneEmployer = userIdentified && user && user.employers && user.employers.length === 1;
    var rootNeedsEmployerAndHasMultiple = rootNeedsEmployer && hasMultipleEmployers;
    var promptEmployerSelection = rootNeedsEmployerAndHasMultiple && employerSelectionEnabled && !hasSelectedEmployer;
    var autoSelectMainEmployer = rootNeedsEmployer && (!employerSelectionEnabled || hasOneEmployer);
    return {
      rootNeedsEmployer: rootNeedsEmployer,
      promptEmployerSelection: promptEmployerSelection,
      autoSelectMainEmployer: autoSelectMainEmployer
    };
  }

  return verifyEmployerAndRoot;
}();

/**
 * This action verifies if the root requires employer and if this is the case it proceeds to check what are the configurations
 * either to auto-select an employer, log the user out or prompt the screen to select employer.
 * This action should be dispatched after the user logs in or after the user selects a path while already having a session.
 * This action might trigger a path reload if the organization allows for exclusive paths.
 * @param dispatch
 * @param getState
 * @returns {function(...[*]=)}
 */
var verifyEmployerForSelectedPath = exports.verifyEmployerForSelectedPath = function () {
  function verifyEmployerForSelectedPath(dispatch, getState) {
    return function () {
      // we can use getState to verify if the selected path needs an employer
      var _getState = getState(),
          booking = _getState.booking,
          session = _getState.session,
          organization = _getState.organization;

      var root = null;
      if (booking.path === -1) {
        return; // no path selected
      }
      root = _get__('_').find(booking.roots, { id: booking.path });
      // if the path/root requires a single employer but this user has multiple then we should log the user out
      if (root.requireSingleEmployer && session.user.employers.length > 1) {
        dispatch(_get__('setIdentityUserFailureDueToMultipleEmployers'))(); // This will trigger a logout.
        return; // No need to executing the logic of this function.
      }
      // Otherwise we have to check if we should prompt the user to select an employer.

      var _get__2 = _get__('verifyEmployerAndRoot')(root, session.userIdentified, session.user, session.selectedEmployer, organization.employerSelectionEnabled),
          promptEmployerSelection = _get__2.promptEmployerSelection,
          autoSelectMainEmployer = _get__2.autoSelectMainEmployer,
          rootNeedsEmployer = _get__2.rootNeedsEmployer;

      if (promptEmployerSelection) {
        dispatch(_get__('openPromptEmployerSelection')());
        // prompt the employer selection
        return; // Same here, stop the function execution.
      }
      // auto-select the employer
      if (autoSelectMainEmployer) {
        dispatch(_get__('setSelectMainEmployer'))(session.user);
      }
      if (!rootNeedsEmployer) {
        /*
        Discussion with Hannu: Do not reset the employer. Users must logout and log back in to change the employer.
         */
        // dispatch(setSelectEmployer)(-1);
      }
    };
  }

  return verifyEmployerForSelectedPath;
}();

/**
 *
 * @param dispatch
 * @param getState
 * @returns {function(...[*]=)}
 */
var dynamicPathLoading = exports.dynamicPathLoading = function () {
  function dynamicPathLoading(dispatch, getState) {
    return function (root) {
      var _getState2 = getState(),
          session = _getState2.session;
      // verify if this path can be fetched without logging in


      if (!session.userIdentified && 'loginBeforePathLoading' in root && root.loginBeforePathLoading) {
        dispatch(_get__('setLoginFirst')(true));
        dispatch(_get__('setFetchPathAfterLogin')(root));
        // we have to attach a listener into the login event to load this path
        return;
      } else if ('loginBeforePathLoading' in root && root.loginBeforePathLoading) {
        // if user came via sso (e.g. already identified) we need to keep the state consistent for proper logging out
        dispatch(_get__('setFetchPathAfterLogin')(root));
      }
      // verify if the user must select an employer
      dispatch(_get__('verifyEmployerForSelectedPath'))();
      // because an action was dispatched, the store has changed
      // get a new copy of the store before verifying the properties
      var applicationState = getState();
      var updatedSession = _extends({}, session, applicationState.session);
      var booking = applicationState.booking;


      if (booking.shouldSelectEmployer) {
        return; // The user needs to select the employer before we load the path.
      }
      // set the loading here so that the pumping logo does not blink
      // (gets removed after identifying but then put back on when fetching the path)
      dispatch(_get__('pathLoading')()); // set the state to "loading the path"
      // If there is a selected employer then add it to the request.
      // This is done to support exclusive paths.
      var employerId = null;
      if (updatedSession.selectedEmployer > -1) {
        var employer = updatedSession.user.employers[updatedSession.selectedEmployer];
        employerId = employer.employer;
      }
      _get__('loadPathNamespace')(root.pathNamespace, employerId).then(function () {
        dispatch(_get__('setPathNamespace')(root.pathNamespace));
        // now fetch the path that this root generates
        _get__('api').loadPath(root, employerId).then(function (data) {
          return new (_get__('SelectionHandler'))(data, root.pathNamespace);
        }).then(function (selectionHandlerInstance) {
          if (!applicationState.restoredState) {
            dispatch(_get__('setSelectionHandler')(selectionHandlerInstance));
            return selectionHandlerInstance.config;
          }
          return applicationState.selectionHandler.config; // data
        }).then(function (data) {
          dispatch(_get__('pathLoaded')()); // the application should load now that we have set all the variables in place
        })['catch'](function (error) {
          console.error(error);
          dispatch(_get__('handleError'))(error);
        });
      });
    };
  }

  return dynamicPathLoading;
}();

/**
 *
 * @param dispatch
 * @param getState
 * @returns {function(...[*]=)}
 */
var loadPath = exports.loadPath = function () {
  function loadPath(dispatch, getState) {
    return function (root) {
      dispatch(_get__('setRootProperties'))(root); // set root properties
      dispatch(_get__('dynamicPathLoading'))(root); // add the dynamic properties
    };
  }

  return loadPath;
}();

/**
 * Verify if a path should be fetched after logging in.
 * @param dispatch
 * @param getState
 * @returns {function(...[*]=)}
 */
var fetchPathAfterLogin = exports.fetchPathAfterLogin = function () {
  function fetchPathAfterLogin(dispatch, getState) {
    return function () {
      var _getState3 = getState(),
          booking = _getState3.booking;
      // verify if we should fetch a path after successful login.


      if (booking.fetchPathAfterLogin) {
        dispatch(_get__('dynamicPathLoading'))(booking.pathToLoadAfterLogin);
      }
    };
  }

  return fetchPathAfterLogin;
}();

var loadRoot = exports.loadRoot = function () {
  function loadRoot(dispatch, getState) {
    return function () {
      var _getState4 = getState(),
          booking = _getState4.booking;

      if (booking.restoredState) {
        return;
      }
      dispatch(_get__('rootLoading')());
      _get__('api').loadRoot().then(function (data) {
        dispatch(_get__('rootLoaded')(data.roots));
        if (data.roots.length === 1) {
          var root = data.roots[0];
          dispatch(_get__('loadPath'))(root);
        }
      })['catch'](function (error) {
        dispatch(_get__('handleError'))(error);
      });
    };
  }

  return loadRoot;
}();

var requestTimeSlots = exports.requestTimeSlots = function () {
  function requestTimeSlots(dispatch, getState) {
    return function (params) {
      dispatch(_get__('requestingTimeSlots')());
      console.log('Requesting timeslots', params);
      var legalEntity = params.legalEntity,
          canAnonymousFetchTimes = params.canAnonymousFetchTimes,
          userIdentified = params.userIdentified;

      _get__('api').requestTimeSlots(params).then(function (data) {
        console.log('Adding hasResponsible', data);

        var _getState5 = getState(),
            session = _getState5.session;

        var user = session.user;
        var timeSlotsData = _extends({}, data);
        if (user.employers && user.employers.length) {
          var userEmployer = user.employers[session.selectedEmployer] || {};
          var responsibleResources = void 0;
          if (session.hasDepartment) {
            var departments = userEmployer.departments || [];
            var userDepartment = departments[session.selectedDepartment];
            if (userDepartment && userDepartment.resources && userDepartment.resources.length) {
              responsibleResources = userDepartment.resources;
            }
          } else {
            responsibleResources = userEmployer.resources || [];
          }
          responsibleResources = _get__('map')(responsibleResources, function (r) {
            return r.resource;
          });
          console.log('responsibleResources', responsibleResources);
          // eslint-disable-next-line no-param-reassign
          timeSlotsData = _get__('mapValues')(data, function (timeSlots) {
            return _get__('map')(timeSlots, function (timeSlot) {
              return _extends({}, timeSlot, {
                hasResponsible: _get__('includes')(responsibleResources, timeSlot.resource)
              });
            });
          });
          console.log('Added hasResponsible', timeSlotsData);
        }
        // Before we set the time slots as received we should repopulate the units because depending on
        // whether the path has anonymous access or legal entity the units may be different.
        var getUnitsPromise = !userIdentified || canAnonymousFetchTimes ? _get__('api').requestUnitsThroughHashedApi(legalEntity) : _get__('api').requestUnits(legalEntity);
        getUnitsPromise.then(_get__('localizeUnitName')).then(function (unitData) {
          dispatch(_get__('unitsReceived')(unitData));
        }).then(function () {
          dispatch(_get__('timeSlotsReceived')(timeSlotsData));
        });
      })['catch'](function (error) {
        dispatch(_get__('handleError'))(error);
        dispatch(_get__('clearTimeSlots')());
      });
    };
  }

  return requestTimeSlots;
}();

var storeReservation = exports.storeReservation = function () {
  function storeReservation(dispatch) {
    return function (timeSlot, data, selectionPath) {
      dispatch(_get__('storingReservation')());
      _get__('api').storeReservation(data).then(function (response) {
        return dispatch(_get__('reservationStored')({ timeSlot: timeSlot, data: response, selectionPath: selectionPath }));
      }).then(function () {
        if (data.googleAnalyticsTrackingId && data.selectedPathType) {
          _get__('ReactGA').initialize(data.googleAnalyticsTrackingId, {
            titleCase: false,
            gaOptions: {
              allowLinker: true
            }
          });
          _get__('ReactGA').event({
            category: 'mBooking',
            action: 'reservationMade',
            label: data.selectedPathType
          });
        }
      })['catch'](function (error) {
        console.error(error);
        dispatch(_get__('handleError'))(error);
      });
    };
  }

  return storeReservation;
}();

var resetBookingState = exports.resetBookingState = function () {
  function resetBookingState(dispatch) {
    return function () {
      dispatch(_get__('resetBooking')());
      dispatch(_get__('loadRoot'))();
    };
  }

  return resetBookingState;
}();

var setManagementOption = exports.setManagementOption = function () {
  function setManagementOption(dispatch) {
    return function () {
      dispatch(_get__('selectManagementOption')());
    };
  }

  return setManagementOption;
}();

var setManagementOptionWithSinglePath = exports.setManagementOptionWithSinglePath = function () {
  function setManagementOptionWithSinglePath(dispatch) {
    return function () {
      dispatch(_get__('selectManagementOptionWithSinglePath')());
    };
  }

  return setManagementOptionWithSinglePath;
}();

var unsetManagementOptionWithSinglePath = exports.unsetManagementOptionWithSinglePath = function () {
  function unsetManagementOptionWithSinglePath(dispatch) {
    return function () {
      dispatch(_get__('unselectManagementOptionWithSinglePath')());
    };
  }

  return unsetManagementOptionWithSinglePath;
}();

var setReservationReasonCode = exports.setReservationReasonCode = function () {
  function setReservationReasonCode(dispatch) {
    return function (reservationReasonCode) {
      dispatch(_get__('setPathReservationReasonCode')(reservationReasonCode));
    };
  }

  return setReservationReasonCode;
}();

var saveStateAndSelectionHandler = exports.saveStateAndSelectionHandler = function () {
  function saveStateAndSelectionHandler(dispatch, getState) {
    return function () {
      dispatch(_get__('saveAppStateAndSelectionHandler')());
      var state = getState();
      if (state.booking.selectionHandler) {
        _get__('ls')('selectionHandler', JSON.stringify(state.booking.selectionHandler));
      }
      _get__('ls')('state', JSON.stringify(getState()));
    };
  }

  return saveStateAndSelectionHandler;
}();

var restoreStateAndSelectionHandler = exports.restoreStateAndSelectionHandler = function () {
  function restoreStateAndSelectionHandler(dispatch, getState) {
    return function () {
      var _getState6 = getState(),
          booking = _getState6.booking;

      if (booking.savedState) {
        dispatch(_get__('loadStateAndSelectionHandler')());
        dispatch(_get__('setSelectionHandler')(new (_get__('SelectionHandler'))()));
        _get__('ls').remove('state');
        _get__('ls').remove('selectionHandler');
      }
    };
  }

  return restoreStateAndSelectionHandler;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'resetBooking':
      return resetBooking;

    case 'closeCancelReservationScreen':
      return _cancelling.closeCancelReservationScreen;

    case 'setSelectedPath':
      return setSelectedPath;

    case 'setUtilizeEmployerInformation':
      return setUtilizeEmployerInformation;

    case 'setFetchTimesPermissions':
      return setFetchTimesPermissions;

    case 'fetchThroughHashedApi':
      return _ehrResources.fetchThroughHashedApi;

    case 'setCreateUserIfNotExists':
      return _session.setCreateUserIfNotExists;

    case 'setRequiresEmployer':
      return _session.setRequiresEmployer;

    case 'setPathReservationByCodeEnabled':
      return setPathReservationByCodeEnabled;

    case 'setLoginFirst':
      return setLoginFirst;

    case 'setLoginFirstShowLoginForm':
      return setLoginFirstShowLoginForm;

    case 'setSelectedPathType':
      return setSelectedPathType;

    case 'setRequireSingleEmployer':
      return setRequireSingleEmployer;

    case 'setLegalEntity':
      return setLegalEntity;

    case 'setPathReservationReasonCode':
      return setPathReservationReasonCode;

    case '_':
      return _lodash2['default'];

    case 'setIdentityUserFailureDueToMultipleEmployers':
      return _session.setIdentityUserFailureDueToMultipleEmployers;

    case 'verifyEmployerAndRoot':
      return verifyEmployerAndRoot;

    case 'openPromptEmployerSelection':
      return openPromptEmployerSelection;

    case 'setSelectMainEmployer':
      return _session.setSelectMainEmployer;

    case 'setFetchPathAfterLogin':
      return setFetchPathAfterLogin;

    case 'verifyEmployerForSelectedPath':
      return verifyEmployerForSelectedPath;

    case 'pathLoading':
      return pathLoading;

    case 'loadPathNamespace':
      return _app.loadPathNamespace;

    case 'setPathNamespace':
      return setPathNamespace;

    case 'api':
      return _api2['default'];

    case 'SelectionHandler':
      return _SelectionHandler2['default'];

    case 'setSelectionHandler':
      return setSelectionHandler;

    case 'pathLoaded':
      return pathLoaded;

    case 'handleError':
      return _errors.handleError;

    case 'setRootProperties':
      return setRootProperties;

    case 'dynamicPathLoading':
      return dynamicPathLoading;

    case 'rootLoading':
      return rootLoading;

    case 'rootLoaded':
      return rootLoaded;

    case 'loadPath':
      return loadPath;

    case 'requestingTimeSlots':
      return requestingTimeSlots;

    case 'map':
      return _collection.map;

    case 'mapValues':
      return _object.mapValues;

    case 'includes':
      return _collection.includes;

    case 'localizeUnitName':
      return _ehrResources.localizeUnitName;

    case 'unitsReceived':
      return _ehrResources.unitsReceived;

    case 'timeSlotsReceived':
      return timeSlotsReceived;

    case 'clearTimeSlots':
      return clearTimeSlots;

    case 'storingReservation':
      return storingReservation;

    case 'reservationStored':
      return reservationStored;

    case 'ReactGA':
      return _reactGa2['default'];

    case 'loadRoot':
      return loadRoot;

    case 'selectManagementOption':
      return selectManagementOption;

    case 'selectManagementOptionWithSinglePath':
      return selectManagementOptionWithSinglePath;

    case 'unselectManagementOptionWithSinglePath':
      return unselectManagementOptionWithSinglePath;

    case 'saveAppStateAndSelectionHandler':
      return saveAppStateAndSelectionHandler;

    case 'ls':
      return _localStorage2['default'];

    case 'loadStateAndSelectionHandler':
      return loadStateAndSelectionHandler;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(rootLoading, 'rootLoading', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(rootLoaded, 'rootLoaded', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(pathLoading, 'pathLoading', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setFetchPathAfterLogin, 'setFetchPathAfterLogin', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setSelectedPath, 'setSelectedPath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(pathLoaded, 'pathLoaded', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(selectedOptionsChanged, 'selectedOptionsChanged', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(additionalDiscussionChanged, 'additionalDiscussionChanged', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(requestingTimeSlots, 'requestingTimeSlots', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(timeSlotsReceived, 'timeSlotsReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(clearTimeSlots, 'clearTimeSlots', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(storingReservation, 'storingReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(reservationStored, 'reservationStored', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(resetBooking, 'resetBooking', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setFetchTimesPermissions, 'setFetchTimesPermissions', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setLoginFirst, 'setLoginFirst', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setLoginFirstShowLoginForm, 'setLoginFirstShowLoginForm', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setPathNamespace, 'setPathNamespace', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setPathReservationByCodeEnabled, 'setPathReservationByCodeEnabled', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setUtilizeEmployerInformation, 'setUtilizeEmployerInformation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setSelectionHandler, 'setSelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setSelectedPathType, 'setSelectedPathType', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setRequireSingleEmployer, 'setRequireSingleEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(selectManagementOption, 'selectManagementOption', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(selectManagementOptionWithSinglePath, 'selectManagementOptionWithSinglePath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(unselectManagementOptionWithSinglePath, 'unselectManagementOptionWithSinglePath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setLegalEntity, 'setLegalEntity', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(openPromptEmployerSelection, 'openPromptEmployerSelection', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(closePromptEmployerSelection, 'closePromptEmployerSelection', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setPathReservationReasonCode, 'setPathReservationReasonCode', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(saveAppStateAndSelectionHandler, 'saveAppStateAndSelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(loadStateAndSelectionHandler, 'loadStateAndSelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setSelectedTimeslot, 'setSelectedTimeslot', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(unsetSelectedTimeslot, 'unsetSelectedTimeslot', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setRootProperties, 'setRootProperties', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(verifyEmployerAndRoot, 'verifyEmployerAndRoot', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(verifyEmployerForSelectedPath, 'verifyEmployerForSelectedPath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(dynamicPathLoading, 'dynamicPathLoading', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(loadPath, 'loadPath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(fetchPathAfterLogin, 'fetchPathAfterLogin', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(loadRoot, 'loadRoot', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(requestTimeSlots, 'requestTimeSlots', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(storeReservation, 'storeReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(resetBookingState, 'resetBookingState', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setManagementOption, 'setManagementOption', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setManagementOptionWithSinglePath, 'setManagementOptionWithSinglePath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(unsetManagementOptionWithSinglePath, 'unsetManagementOptionWithSinglePath', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(setReservationReasonCode, 'setReservationReasonCode', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(saveStateAndSelectionHandler, 'saveStateAndSelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');

  __REACT_HOT_LOADER__.register(restoreStateAndSelectionHandler, 'restoreStateAndSelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/booking.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(502);

var _dompurify2 = _interopRequireDefault(_dompurify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerHtmlContent = function (_get__2) {
  _inherits(InnerHtmlContent, _get__2);

  function InnerHtmlContent() {
    _classCallCheck(this, InnerHtmlContent);

    return _possibleConstructorReturn(this, (InnerHtmlContent.__proto__ || Object.getPrototypeOf(InnerHtmlContent)).apply(this, arguments));
  }

  _createClass(InnerHtmlContent, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            content = _props.content,
            elementClass = _props.elementClass;

        // TODO: When allowing target = _BLANK, we should add "noopener" and "noreferrer" values for rel attribute i.e. node.setAttribute('rel', 'noopener noreferrer');
        // https://medium.com/@darrensimio/security-vulnerability-and-browser-performance-impact-of-target-blank-80e5e67db547
        // https://github.com/cure53/DOMPurify/issues/317
        // We should add hook to "afterSanitizeAttributes" (https://github.com/cure53/DOMPurify/blob/main/demos/hooks-target-blank-demo.html)

        var sanitizedContent = _get__('DOMPurify').sanitize(content, { ADD_ATTR: ['target'] });

        if (!sanitizedContent) {
          return null;
        }
        return elementClass ? _get__('React').createElement('span', {
          className: elementClass,
          dangerouslySetInnerHTML: { __html: sanitizedContent }
        }) : _get__('React').createElement('span', {
          dangerouslySetInnerHTML: { __html: sanitizedContent }
        });
      }

      return render;
    }()
  }]);

  return InnerHtmlContent;
}(_get__('Component'));

_get__('InnerHtmlContent').propTypes = {
  content: _get__('PropTypes').string.isRequired,
  elementClass: _get__('PropTypes').string
};

_get__('InnerHtmlContent').defaultProps = {
  elementClass: ''
};

var _default = _get__('InnerHtmlContent');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'DOMPurify':
      return _dompurify2['default'];

    case 'Component':
      return _react.Component;

    case 'InnerHtmlContent':
      return InnerHtmlContent;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof InnerHtmlContent === 'undefined' ? 'undefined' : _typeof(InnerHtmlContent);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(InnerHtmlContent, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(InnerHtmlContent)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InnerHtmlContent, 'InnerHtmlContent', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/InnerHtmlContent/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/InnerHtmlContent/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 70 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(224);
var createDesc = __webpack_require__(141);
var toIObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(95);
var has = __webpack_require__(70);
var IE8_DOM_DEFINE = __webpack_require__(579);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(70);
var toObject = __webpack_require__(35);
var IE_PROTO = __webpack_require__(378)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(223);
var defined = __webpack_require__(93);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line global-require
// const api = (process.env.NODE_ENV === 'prod') ? require('./api') : require('./mockApi');
var api = __webpack_require__(1107);

console.log('Using ' + ( true ? '' : 'dummmy ') + 'api implementation', _get__('api'));

var _DefaultExportValue = _get__('api')['default'];

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'api':
      return api;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
var version = exports.version = '1.6.0';
var scrollDelay = exports.scrollDelay = 50;
var scrollDuration = exports.scrollDuration = 700;
var scrollOffset = exports.scrollOffset = -60;
var scrollSettings = exports.scrollSettings = {
  smooth: true,
  delay: _get__('scrollDelay'),
  duration: _get__('scrollDuration'),
  offset: _get__('scrollOffset'),
  isDynamic: true
};
var reservationReasonTextMaxLength = exports.reservationReasonTextMaxLength = 40;
var DATE_FORMAT_SYSTEM = exports.DATE_FORMAT_SYSTEM = 'YYYY-MM-DD';
var EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION = exports.EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION = 15;
var showAdditionalDiscussionCheckbox = exports.showAdditionalDiscussionCheckbox = false;
var showEmailConfirmationField = exports.showEmailConfirmationField = false;
var letUserModifyTimeSlotParams = exports.letUserModifyTimeSlotParams = false;
var DEFAULT_START_TIME = exports.DEFAULT_START_TIME = 7;
var GOOGLE_MAPS_ZOOM = exports.GOOGLE_MAPS_ZOOM = 14;
var APP_UPDATE_COOKIE_NAME = exports.APP_UPDATE_COOKIE_NAME = 'APP-BUILD-TIMESTAMP';
var APP_UPDATE_HEADER_NAME = exports.APP_UPDATE_HEADER_NAME = 'app-update';
var APP_UPDATE_EXPIRE_TIME = exports.APP_UPDATE_EXPIRE_TIME = 'Thu, 01 Jan 1970 00:00:01 GMT';
var APP_TIMESTAMP = exports.APP_TIMESTAMP = new Date().getTime();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'scrollDelay':
      return scrollDelay;

    case 'scrollDuration':
      return scrollDuration;

    case 'scrollOffset':
      return scrollOffset;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(version, 'version', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(scrollDelay, 'scrollDelay', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(scrollDuration, 'scrollDuration', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(scrollOffset, 'scrollOffset', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(scrollSettings, 'scrollSettings', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(reservationReasonTextMaxLength, 'reservationReasonTextMaxLength', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(DATE_FORMAT_SYSTEM, 'DATE_FORMAT_SYSTEM', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION, 'EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(showAdditionalDiscussionCheckbox, 'showAdditionalDiscussionCheckbox', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(showEmailConfirmationField, 'showEmailConfirmationField', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(letUserModifyTimeSlotParams, 'letUserModifyTimeSlotParams', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(DEFAULT_START_TIME, 'DEFAULT_START_TIME', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(GOOGLE_MAPS_ZOOM, 'GOOGLE_MAPS_ZOOM', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(APP_UPDATE_COOKIE_NAME, 'APP_UPDATE_COOKIE_NAME', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(APP_UPDATE_HEADER_NAME, 'APP_UPDATE_HEADER_NAME', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(APP_UPDATE_EXPIRE_TIME, 'APP_UPDATE_EXPIRE_TIME', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');

  __REACT_HOT_LOADER__.register(APP_TIMESTAMP, 'APP_TIMESTAMP', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/constants.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(50);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(18);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(80);
var IObject = __webpack_require__(223);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(29);
var asc = __webpack_require__(362);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(79);
var fails = __webpack_require__(18);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(234),
    baseAssignValue = __webpack_require__(109);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(116);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.cancelReservation = exports.fetchReservation = exports.triggerCloseCancelReservationScreen = exports.reservationAlreadyCancelled = exports.reservationCancelled = exports.cancellingReservationFailed = exports.cancellingReservation = exports.reservationReceived = exports.fetchingReservationFailed = exports.fetchingReservation = exports.closeCancelReservationScreen = exports.openCancelReservationScreen = undefined;

var _reduxActions = __webpack_require__(38);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _errors = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var openCancelReservationScreen = exports.openCancelReservationScreen = _get__('makeActionCreator')('OPEN_CANCEL_RESERVATION_SCREEN');
var closeCancelReservationScreen = exports.closeCancelReservationScreen = _get__('makeActionCreator')('CLOSE_CANCEL_RESERVATION_SCREEN');

var fetchingReservation = exports.fetchingReservation = _get__('makeActionCreator')('FETCHING_RESERVATION');
var fetchingReservationFailed = exports.fetchingReservationFailed = _get__('makeActionCreator')('FETCHING_RESERVATION_FAILED');
var reservationReceived = exports.reservationReceived = _get__('makeActionCreator')('RESERVATION_RECEIVED');

var cancellingReservation = exports.cancellingReservation = _get__('makeActionCreator')('CANCELLING_RESERVATION');
var cancellingReservationFailed = exports.cancellingReservationFailed = _get__('makeActionCreator')('CANCELLING_RESERVATION_FAILED');
var reservationCancelled = exports.reservationCancelled = _get__('makeActionCreator')('RESERVATION_CANCELLED');

var reservationAlreadyCancelled = exports.reservationAlreadyCancelled = _get__('makeActionCreator')('RESERVATION_ALREADY_CANCELLED');

var triggerCloseCancelReservationScreen = exports.triggerCloseCancelReservationScreen = function () {
  function triggerCloseCancelReservationScreen(dispatch) {
    return function () {
      return dispatch(_get__('closeCancelReservationScreen')());
    };
  }

  return triggerCloseCancelReservationScreen;
}();

var fetchReservation = exports.fetchReservation = function () {
  function fetchReservation(dispatch) {
    return function (reservationCode) {
      dispatch(_get__('fetchingReservation')());
      _get__('api').fetchReservation({ reservationCode: reservationCode }).then(function (data) {
        if (data.status === 5) {
          dispatch(_get__('reservationAlreadyCancelled')(data));
        } else {
          dispatch(_get__('reservationReceived')(data));
        }
      })['catch'](function (error) {
        dispatch(_get__('handleError'))(_get__('fetchingReservationFailed')(_get__('getErrorMessage')(error)));
      });
    };
  }

  return fetchReservation;
}();

var cancelReservation = exports.cancelReservation = function () {
  function cancelReservation(dispatch) {
    return function (reservationId, cbAction) {
      dispatch(_get__('cancellingReservation')());
      _get__('api').cancelReservation({ reservationId: reservationId }).then(function (data) {
        return dispatch(_get__('reservationCancelled')(data));
      }).then(function () {
        if (cbAction) {
          cbAction();
        }
      })['catch'](function (error) {
        dispatch(_get__('handleError'))(_get__('cancellingReservationFailed')(_get__('getErrorMessage')(error)));
      });
    };
  }

  return cancelReservation;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'closeCancelReservationScreen':
      return closeCancelReservationScreen;

    case 'fetchingReservation':
      return fetchingReservation;

    case 'api':
      return _api2['default'];

    case 'reservationAlreadyCancelled':
      return reservationAlreadyCancelled;

    case 'reservationReceived':
      return reservationReceived;

    case 'handleError':
      return _errors.handleError;

    case 'fetchingReservationFailed':
      return fetchingReservationFailed;

    case 'getErrorMessage':
      return _errors.getErrorMessage;

    case 'cancellingReservation':
      return cancellingReservation;

    case 'reservationCancelled':
      return reservationCancelled;

    case 'cancellingReservationFailed':
      return cancellingReservationFailed;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(openCancelReservationScreen, 'openCancelReservationScreen', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(closeCancelReservationScreen, 'closeCancelReservationScreen', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(fetchingReservation, 'fetchingReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(fetchingReservationFailed, 'fetchingReservationFailed', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(reservationReceived, 'reservationReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(cancellingReservation, 'cancellingReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(cancellingReservationFailed, 'cancellingReservationFailed', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(reservationCancelled, 'reservationCancelled', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(reservationAlreadyCancelled, 'reservationAlreadyCancelled', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(triggerCloseCancelReservationScreen, 'triggerCloseCancelReservationScreen', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(fetchReservation, 'fetchReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');

  __REACT_HOT_LOADER__.register(cancelReservation, 'cancelReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/cancelling.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(601);
var $export = __webpack_require__(4);
var shared = __webpack_require__(225)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(605))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(31)) {
  var LIBRARY = __webpack_require__(121);
  var global = __webpack_require__(15);
  var fails = __webpack_require__(18);
  var $export = __webpack_require__(4);
  var $typed = __webpack_require__(274);
  var $buffer = __webpack_require__(383);
  var ctx = __webpack_require__(80);
  var anInstance = __webpack_require__(136);
  var propertyDesc = __webpack_require__(141);
  var hide = __webpack_require__(63);
  var redefineAll = __webpack_require__(142);
  var toInteger = __webpack_require__(82);
  var toLength = __webpack_require__(29);
  var toIndex = __webpack_require__(599);
  var toAbsoluteIndex = __webpack_require__(144);
  var toPrimitive = __webpack_require__(95);
  var has = __webpack_require__(70);
  var classof = __webpack_require__(177);
  var isObject = __webpack_require__(20);
  var toObject = __webpack_require__(35);
  var isArrayIter = __webpack_require__(369);
  var create = __webpack_require__(138);
  var getPrototypeOf = __webpack_require__(72);
  var gOPN = __webpack_require__(139).f;
  var getIterFn = __webpack_require__(385);
  var uid = __webpack_require__(145);
  var wks = __webpack_require__(28);
  var createArrayMethod = __webpack_require__(92);
  var createArrayIncludes = __webpack_require__(262);
  var speciesConstructor = __webpack_require__(226);
  var ArrayIterators = __webpack_require__(386);
  var Iterators = __webpack_require__(178);
  var $iterDetect = __webpack_require__(267);
  var setSpecies = __webpack_require__(143);
  var arrayFill = __webpack_require__(361);
  var arrayCopyWithin = __webpack_require__(571);
  var $DP = __webpack_require__(33);
  var $GOPD = __webpack_require__(71);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(718);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    arrayEach = __webpack_require__(189),
    assignValue = __webpack_require__(234),
    baseAssign = __webpack_require__(675),
    baseAssignIn = __webpack_require__(1713),
    cloneBuffer = __webpack_require__(702),
    copyArray = __webpack_require__(85),
    copySymbols = __webpack_require__(1747),
    copySymbolsIn = __webpack_require__(1748),
    getAllKeys = __webpack_require__(721),
    getAllKeysIn = __webpack_require__(448),
    getTag = __webpack_require__(113),
    initCloneArray = __webpack_require__(1772),
    initCloneByTag = __webpack_require__(1773),
    initCloneObject = __webpack_require__(725),
    isArray = __webpack_require__(16),
    isBuffer = __webpack_require__(158),
    isMap = __webpack_require__(754),
    isObject = __webpack_require__(39),
    isSet = __webpack_require__(756),
    keys = __webpack_require__(46),
    keysIn = __webpack_require__(58);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(151),
    arrayMap = __webpack_require__(36),
    isArray = __webpack_require__(16),
    isSymbol = __webpack_require__(116);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(114);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1701),
    Map = __webpack_require__(424),
    Promise = __webpack_require__(1703),
    Set = __webpack_require__(667),
    WeakMap = __webpack_require__(669),
    baseGetTag = __webpack_require__(55),
    toSource = __webpack_require__(739);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObject = __webpack_require__(39);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.handleError = exports.getErrorMessage = exports.genericError = undefined;

var _reduxActions = __webpack_require__(38);

var _session = __webpack_require__(42);

var _helpers = __webpack_require__(119);

var genericError = exports.genericError = _get__('makeActionCreator')('GENERIC_ERROR_OCCURRED');

var getErrorMessage = exports.getErrorMessage = function () {
  function getErrorMessage(error) {
    if (error.response && error.response.data && error.response.data.message) {
      // Use .trim(), as server returns the error code followed by carriage return...
      // At least with invalid reservation code.
      return error.response.data.message.trim ? error.response.data.message.trim() : error.response.data.message;
    }
    return error;
  }

  return getErrorMessage;
}();

var handleError = exports.handleError = function () {
  function handleError(dispatch) {
    return function (actionOrError) {
      // We accept either an error or an action with the error in the payload.
      var error = actionOrError.payload || actionOrError;
      // check for app updates
      if (error.response) {
        _get__('checkAppUpdate')(error.response);
      }
      if (error.response && error.response.status === 401) {
        dispatch(_get__('sessionTimeOut')());
      } else {
        // If an action was sent, dispatch it. If an error was sent, create a new action to dispatch.
        dispatch(actionOrError.payload ? actionOrError : _get__('genericError')(_get__('getErrorMessage')(error)));
      }
    };
  }

  return handleError;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'checkAppUpdate':
      return _helpers.checkAppUpdate;

    case 'sessionTimeOut':
      return _session.sessionTimeOut;

    case 'genericError':
      return genericError;

    case 'getErrorMessage':
      return getErrorMessage;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(genericError, 'genericError', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/errors.js');

  __REACT_HOT_LOADER__.register(getErrorMessage, 'getErrorMessage', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/errors.js');

  __REACT_HOT_LOADER__.register(handleError, 'handleError', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/errors.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.cyrillicLetterScanner = exports.transformReservationsToTimeSlot = exports.isElementVisible = exports.htmlDecode = exports.checkAppUpdate = exports.trimResourceNames = exports.getWithDot = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _collection = __webpack_require__(198);

var _string = __webpack_require__(160);

var _jquery = __webpack_require__(249);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(76);

var _ClientStorage = __webpack_require__(351);

var _ClientStorage2 = _interopRequireDefault(_ClientStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// For getting nested items from Immutable.js Map with dot notation
var getWithDot = exports.getWithDot = function () {
  function getWithDot(m, path) {
    return m.getIn(path.split('.'));
  }

  return getWithDot;
}();

var trimResourceNames = exports.trimResourceNames = function () {
  function trimResourceNames(resources) {
    return _get__('map')(resources, function (resource) {
      return _extends({}, resource, {
        name: _get__('trim')(resource.name).replace(/^\w\s+/, '')
      });
    });
  }

  return trimResourceNames;
}();

var checkAppUpdate = exports.checkAppUpdate = function () {
  function checkAppUpdate(response) {
    // console.log('>>check for updated...<<');
    if (response.headers && response.headers[_constants.APP_UPDATE_HEADER_NAME]) {
      // set this in the storage but do not trigger the full refresh yet
      _get__('ClientStorage').setAppBuildTimestamp(_get__('APP_UPDATE_HEADER_NAME'));
    }
  }

  return checkAppUpdate;
}();

var htmlDecode = exports.htmlDecode = function () {
  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.documentElement.textContent;
  }

  return htmlDecode;
}();

var isElementVisible = exports.isElementVisible = function () {
  function isElementVisible(element) {
    var docViewTop = _get__('$')(window).scrollTop();
    var docViewBottom = docViewTop + _get__('$')(window).height();

    var elemTop = _get__('$')(element).offset().top;
    var elemBottom = elemTop + _get__('$')(element).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }

  return isElementVisible;
}();

var transformReservationsToTimeSlot = exports.transformReservationsToTimeSlot = function () {
  function transformReservationsToTimeSlot(reservation, resources, t) {
    var timeSlot = Object.assign({}, reservation);
    var resource = resources[reservation.resource];
    // type 1 is person 
    if (resource && resource.type === 1) {
      var speciality = resource.speciality;

      var resourceType = t('resources.time_type_' + resource.type, { defaultValue: t('resources.' + (Array.isArray(speciality) ? speciality[0] : speciality), { defaultValue: '' }) });
      timeSlot.resourceType = resourceType;
      timeSlot.resourceName = resource.name;
    }

    timeSlot.timeMoment = _get__('moment')(reservation.start);
    timeSlot.reservation = reservation.reservation;
    return timeSlot;
  }

  return transformReservationsToTimeSlot;
}();

var cyrillicLetterScanner = exports.cyrillicLetterScanner = function () {
  function cyrillicLetterScanner(string) {
    var CYRILLIC_PATTERN_REGEX = /^[\u0400-\u04FF]+$/;
    return _get__('trim')(string).split('').some(function (letter) {
      return letter.match(CYRILLIC_PATTERN_REGEX);
    });
  }

  return cyrillicLetterScanner;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'map':
      return _collection.map;

    case 'trim':
      return _string.trim;

    case 'ClientStorage':
      return _ClientStorage2['default'];

    case 'APP_UPDATE_HEADER_NAME':
      return _constants.APP_UPDATE_HEADER_NAME;

    case '$':
      return _jquery2['default'];

    case 'moment':
      return _moment2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getWithDot, 'getWithDot', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(trimResourceNames, 'trimResourceNames', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(checkAppUpdate, 'checkAppUpdate', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(htmlDecode, 'htmlDecode', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(isElementVisible, 'isElementVisible', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(transformReservationsToTimeSlot, 'transformReservationsToTimeSlot', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');

  __REACT_HOT_LOADER__.register(cyrillicLetterScanner, 'cyrillicLetterScanner', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/helpers.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(28)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(63)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(145)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(70);
var setDesc = __webpack_require__(33).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(152),
    createBaseEach = __webpack_require__(708);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(16),
    isKey = __webpack_require__(453),
    stringToPath = __webpack_require__(738),
    toString = __webpack_require__(25);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1710),
    hasUnicode = __webpack_require__(195),
    unicodeToArray = __webpack_require__(1811);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ErrorMessage = function () {
  function ErrorMessage(_ref) {
    var isVisible = _ref.isVisible,
        children = _ref.children;

    if (isVisible) {
      return _get__('React').createElement(
        _get__('Alert'),
        { bsStyle: 'danger' },
        children
      );
    }
    return null;
  }

  return ErrorMessage;
}();

_get__('ErrorMessage').propTypes = {
  isVisible: _get__('PropTypes').bool,
  children: _get__('PropTypes').node.isRequired
};

_get__('ErrorMessage').defaultProps = {
  isVisible: false
};

var _default = _get__('ErrorMessage');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ErrorMessage':
      return ErrorMessage;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'Alert':
      return _reactBootstrap.Alert;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof ErrorMessage === 'undefined' ? 'undefined' : _typeof(ErrorMessage);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(ErrorMessage, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ErrorMessage)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ErrorMessage, 'ErrorMessage', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Messages/ErrorMessage.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Messages/ErrorMessage.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(80);
var call = __webpack_require__(582);
var isArrayIter = __webpack_require__(369);
var anObject = __webpack_require__(10);
var toLength = __webpack_require__(29);
var getIterFn = __webpack_require__(385);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(10);
var dPs = __webpack_require__(588);
var enumBugKeys = __webpack_require__(365);
var IE_PROTO = __webpack_require__(378)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(364)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(367).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(590);
var hiddenKeys = __webpack_require__(365).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(590);
var enumBugKeys = __webpack_require__(365);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(64);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var dP = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(31);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(82);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 145 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(428),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(291),
    arrayIncludes = __webpack_require__(293),
    arrayIncludesWith = __webpack_require__(426),
    cacheHas = __webpack_require__(300),
    createSet = __webpack_require__(1753),
    setToArray = __webpack_require__(308);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(749),
    overRest = __webpack_require__(731),
    setToString = __webpack_require__(455);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(684),
    getValue = __webpack_require__(1764);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(45),
    stubFalse = __webpack_require__(464);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'castArray': __webpack_require__(1821),
  'clone': __webpack_require__(1823),
  'cloneDeep': __webpack_require__(1824),
  'cloneDeepWith': __webpack_require__(1825),
  'cloneWith': __webpack_require__(1826),
  'conformsTo': __webpack_require__(1831),
  'eq': __webpack_require__(86),
  'gt': __webpack_require__(1876),
  'gte': __webpack_require__(1877),
  'isArguments': __webpack_require__(199),
  'isArray': __webpack_require__(16),
  'isArrayBuffer': __webpack_require__(1889),
  'isArrayLike': __webpack_require__(56),
  'isArrayLikeObject': __webpack_require__(57),
  'isBoolean': __webpack_require__(1890),
  'isBuffer': __webpack_require__(158),
  'isDate': __webpack_require__(1891),
  'isElement': __webpack_require__(1892),
  'isEmpty': __webpack_require__(1893),
  'isEqual': __webpack_require__(1894),
  'isEqualWith': __webpack_require__(1895),
  'isError': __webpack_require__(460),
  'isFinite': __webpack_require__(1896),
  'isFunction': __webpack_require__(115),
  'isInteger': __webpack_require__(753),
  'isLength': __webpack_require__(310),
  'isMap': __webpack_require__(754),
  'isMatch': __webpack_require__(1897),
  'isMatchWith': __webpack_require__(1898),
  'isNaN': __webpack_require__(1899),
  'isNative': __webpack_require__(1900),
  'isNil': __webpack_require__(1901),
  'isNull': __webpack_require__(1902),
  'isNumber': __webpack_require__(755),
  'isObject': __webpack_require__(39),
  'isObjectLike': __webpack_require__(34),
  'isPlainObject': __webpack_require__(238),
  'isRegExp': __webpack_require__(461),
  'isSafeInteger': __webpack_require__(1903),
  'isSet': __webpack_require__(756),
  'isString': __webpack_require__(311),
  'isSymbol': __webpack_require__(116),
  'isTypedArray': __webpack_require__(200),
  'isUndefined': __webpack_require__(1904),
  'isWeakMap': __webpack_require__(1905),
  'isWeakSet': __webpack_require__(1906),
  'lt': __webpack_require__(1914),
  'lte': __webpack_require__(1915),
  'toArray': __webpack_require__(1986),
  'toFinite': __webpack_require__(465),
  'toInteger': __webpack_require__(21),
  'toLength': __webpack_require__(764),
  'toNumber': __webpack_require__(314),
  'toPlainObject': __webpack_require__(767),
  'toSafeInteger': __webpack_require__(1989),
  'toString': __webpack_require__(25)
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'camelCase': __webpack_require__(1820),
  'capitalize': __webpack_require__(744),
  'deburr': __webpack_require__(745),
  'endsWith': __webpack_require__(1847),
  'escape': __webpack_require__(746),
  'escapeRegExp': __webpack_require__(1850),
  'kebabCase': __webpack_require__(1909),
  'lowerCase': __webpack_require__(1912),
  'lowerFirst': __webpack_require__(1913),
  'pad': __webpack_require__(1934),
  'padEnd': __webpack_require__(1935),
  'padStart': __webpack_require__(1936),
  'parseInt': __webpack_require__(1937),
  'repeat': __webpack_require__(1951),
  'replace': __webpack_require__(1952),
  'snakeCase': __webpack_require__(1962),
  'split': __webpack_require__(1973),
  'startCase': __webpack_require__(1974),
  'startsWith': __webpack_require__(1975),
  'template': __webpack_require__(1984),
  'templateSettings': __webpack_require__(762),
  'toLower': __webpack_require__(1987),
  'toUpper': __webpack_require__(1990),
  'trim': __webpack_require__(1992),
  'trimEnd': __webpack_require__(1993),
  'trimStart': __webpack_require__(1994),
  'truncate': __webpack_require__(1995),
  'unescape': __webpack_require__(1996),
  'upperCase': __webpack_require__(2007),
  'upperFirst': __webpack_require__(467),
  'words': __webpack_require__(769)
};


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.fetchUnitInfo = exports.fetchThroughHashedApi = exports.fetchUponLogin = exports.localizeUnitName = exports.staticDataFetched = exports.fetchingStaticData = exports.groupsReceived = exports.resourcesReceived = exports.unitsReceived = exports.unitInfoReceived = exports.unitInfoRequested = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(117);

var _reduxActions = __webpack_require__(38);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _errors = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var unitInfoRequested = exports.unitInfoRequested = _get__('makeActionCreator')('UNIT_INFO_REQUESTED');
var unitInfoReceived = exports.unitInfoReceived = _get__('makeActionCreator')('UNIT_INFO_RECEIVED');
var unitsReceived = exports.unitsReceived = _get__('makeActionCreator')('UNITS_RECEIVED');
var resourcesReceived = exports.resourcesReceived = _get__('makeActionCreator')('RESOURCES_RECEIVED');
var groupsReceived = exports.groupsReceived = _get__('makeActionCreator')('GROUPS_RECEIVED');
var fetchingStaticData = exports.fetchingStaticData = _get__('makeActionCreator')('LOADING_DATA_FETCHED');
var staticDataFetched = exports.staticDataFetched = _get__('makeActionCreator')('STATIC_DATA_FETCHED');

var localizeUnitName = function () {
  function localizeUnitName(units) {
    var activeLanguage = _get__('i18n').language;
    var t = _get__('i18n').getFixedT(activeLanguage, 'common');
    return units.map(function (u) {
      var unit = u.unit,
          name = u.name,
          rest = _objectWithoutProperties(u, ['unit', 'name']);

      return _extends({
        unit: unit
      }, rest, {
        name: t('units.' + unit, name)
      });
    });
  }

  return localizeUnitName;
}();

exports.localizeUnitName = localizeUnitName;
var fetchUponLogin = exports.fetchUponLogin = function () {
  function fetchUponLogin(dispatch, getState) {
    return function () {
      dispatch(_get__('fetchingStaticData'));

      var _getState = getState(),
          booking = _getState.booking;

      var unitsPromise = _get__('api').requestUnits(booking.legalEntity).then(_get__('localizeUnitName')).then(function (data) {
        return dispatch(_get__('unitsReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      var resourcesPromise = _get__('api').requestResources().then(function (data) {
        return dispatch(_get__('resourcesReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      var groupsPromise = _get__('api').requestGroups().then(function (data) {
        return dispatch(_get__('groupsReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      Promise.all([unitsPromise, groupsPromise, resourcesPromise]).then(function () {
        return dispatch(_get__('staticDataFetched'));
      });
    };
  }

  return fetchUponLogin;
}();

var fetchThroughHashedApi = exports.fetchThroughHashedApi = function () {
  function fetchThroughHashedApi(dispatch) {
    return function (legalEntity) {
      dispatch(_get__('fetchingStaticData'));
      var unitsPromise = _get__('api').requestUnitsThroughHashedApi(legalEntity).then(_get__('localizeUnitName')).then(function (data) {
        return dispatch(_get__('unitsReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      var resourcesPromise = _get__('api').requestResourcesThroughHashedApi().then(function (data) {
        return dispatch(_get__('resourcesReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      var groupsPromise = _get__('api').requestGroupsThroughHashedApi().then(function (data) {
        return dispatch(_get__('groupsReceived')(data));
      })['catch'](dispatch(_get__('handleError')));
      Promise.all([unitsPromise, groupsPromise, resourcesPromise]).then(function () {
        return dispatch(_get__('staticDataFetched'));
      });
    };
  }

  return fetchThroughHashedApi;
}();

var fetchUnitInfoPromise = function () {
  function fetchUnitInfoPromise(unit, userIdentified) {
    if (userIdentified) {
      return _get__('api').requestUnitInfo(unit);
    }
    return _get__('api').requestUnitInfoThroughHashedApi(unit);
  }

  return fetchUnitInfoPromise;
}();

var fetchUnitInfo = exports.fetchUnitInfo = function () {
  function fetchUnitInfo(dispatch) {
    return function (unit, userIdentified) {
      console.log('Fetching unit info', unit);
      // check for canAnonymousFetchTimes and either call api.requestUnitInfo or api.requestUnitInfoThroughHashedApi
      _get__('fetchUnitInfoPromise')(unit, userIdentified).then(function (data) {
        return dispatch(_get__('unitInfoReceived')(_extends({}, data, { unit: unit })));
      })['catch'](dispatch(_get__('handleError')));
    };
  }

  return fetchUnitInfo;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'i18n':
      return _i18n2['default'];

    case 'fetchingStaticData':
      return fetchingStaticData;

    case 'api':
      return _api2['default'];

    case 'localizeUnitName':
      return localizeUnitName;

    case 'unitsReceived':
      return unitsReceived;

    case 'handleError':
      return _errors.handleError;

    case 'resourcesReceived':
      return resourcesReceived;

    case 'groupsReceived':
      return groupsReceived;

    case 'staticDataFetched':
      return staticDataFetched;

    case 'fetchUnitInfoPromise':
      return fetchUnitInfoPromise;

    case 'unitInfoReceived':
      return unitInfoReceived;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(unitInfoRequested, 'unitInfoRequested', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(unitInfoReceived, 'unitInfoReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(unitsReceived, 'unitsReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(resourcesReceived, 'resourcesReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(groupsReceived, 'groupsReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(fetchingStaticData, 'fetchingStaticData', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(staticDataFetched, 'staticDataFetched', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(localizeUnitName, 'localizeUnitName', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(fetchUponLogin, 'fetchUponLogin', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(fetchThroughHashedApi, 'fetchThroughHashedApi', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(fetchUnitInfoPromise, 'fetchUnitInfoPromise', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');

  __REACT_HOT_LOADER__.register(fetchUnitInfo, 'fetchUnitInfo', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ehrResources.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _string = __webpack_require__(160);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TimeSlotCard = function () {
  function TimeSlotCard(_ref) {
    var active = _ref.active,
        disabled = _ref.disabled,
        large = _ref.large,
        timeSlot = _ref.timeSlot,
        unit = _ref.unit,
        _onClick = _ref.onClick,
        actionElement = _ref.actionElement;

    var duration = Object.prototype.hasOwnProperty.call(timeSlot.duration, timeSlot.type) ? timeSlot.duration[timeSlot.type] : timeSlot.duration;
    return _get__('React').createElement(
      _get__('Button'),
      {
        className: 'time-slot-card ' + (large ? 'time-slot-card-large' : 'time-slot-card-small'),
        active: active,
        disabled: disabled,
        onClick: function () {
          function onClick() {
            _onClick(timeSlot);
          }

          return onClick;
        }(),
        block: true,
        bsStyle: 'default',
        bsSize: 'large',
        key: timeSlot.reservation + '-TimeSlotCard-Button'
      },
      _get__('React').createElement(
        'span',
        { className: 'time-slot-card-flex' },
        _get__('React').createElement(
          'span',
          { className: 'time-slot-card-left' },
          _get__('React').createElement(
            'span',
            { className: 'time-slot-date' },
            _get__('capitalize')(timeSlot.timeMoment.format('dd D.M.')),
            ' ',
            '',
            'Klo ',
            timeSlot.timeMoment.format('H.mm'),
            '\u2013',
            timeSlot.timeMoment.clone().add(duration, 'minutes').format('H.mm'),
            timeSlot.hasResponsible && _get__('React').createElement(
              'span',
              null,
              _get__('React').createElement(_get__('AppIcon'), { iconName: 'STAR', containerClass: 'resp-image' })
            )
          ),
          _get__('React').createElement(
            'span',
            { className: 'time-slot-info' },
            unit && _get__('React').createElement(
              'span',
              { className: 'time-slot-unit' },
              _get__('React').createElement(
                'div',
                { className: 'time-slot-unit-name' },
                unit.name
              ),
              _get__('React').createElement(
                'div',
                { className: 'time-slot-unit-address' },
                unit.address,
                ', ',
                unit.city
              )
            ),
            timeSlot && _get__('React').createElement(
              'span',
              { className: 'time-slot-resource' },
              _get__('React').createElement(
                'span',
                { className: 'time-slot-resource-name' },
                timeSlot.resourceName
              ),
              _get__('React').createElement('br', null),
              _get__('React').createElement(
                'span',
                { className: 'time-slot-speciality' },
                timeSlot.resourceType
              )
            )
          )
        ),
        _get__('React').createElement(
          'span',
          { className: 'time-slot-card-right' },
          actionElement
        )
      )
    );
  }

  return TimeSlotCard;
}();

_get__('TimeSlotCard').propTypes = {
  active: _get__('PropTypes').bool,
  disabled: _get__('PropTypes').bool,
  large: _get__('PropTypes').bool,
  timeSlot: _get__('PropTypes').shape({
    timeMoment: _get__('PropTypes').instanceOf(_get__('moment')).isRequired,
    unitName: _get__('PropTypes').string,
    resourceName: _get__('PropTypes').string.isRequired,
    resourceType: _get__('PropTypes').string,
    hasResponsible: _get__('PropTypes').bool,
    reservation: _get__('PropTypes').string
  }).isRequired,
  unit: _get__('PropTypes').shape({
    name: _get__('PropTypes').string.isRequired,
    address: _get__('PropTypes').string.isRequired,
    city: _get__('PropTypes').string.isRequired,
    info: _get__('PropTypes').string
  }).isRequired,
  onClick: _get__('PropTypes').func,
  actionElement: _get__('PropTypes').element.isRequired
};

_get__('TimeSlotCard').defaultProps = {
  active: false,
  disabled: false,
  large: false,
  onClick: function () {
    function onClick() {}

    return onClick;
  }()
};

var _default = _get__('TimeSlotCard');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'capitalize':
      return _string.capitalize;

    case 'TimeSlotCard':
      return TimeSlotCard;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'moment':
      return _moment2['default'];

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof TimeSlotCard === 'undefined' ? 'undefined' : _typeof(TimeSlotCard);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(TimeSlotCard, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(TimeSlotCard)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TimeSlotCard, 'TimeSlotCard', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/TimeSlotCard/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/TimeSlotCard/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 176 */,
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(78);
var TAG = __webpack_require__(28)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f;
var has = __webpack_require__(70);
var TAG = __webpack_require__(28)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var defined = __webpack_require__(93);
var fails = __webpack_require__(18);
var spaces = __webpack_require__(381);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(39);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(295),
    baseIsNaN = __webpack_require__(683),
    strictIndexOf = __webpack_require__(1807);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    isIterateeCall = __webpack_require__(66);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(672),
    deburr = __webpack_require__(745),
    words = __webpack_require__(769);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(720);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1709),
    hasUnicode = __webpack_require__(195),
    unicodeSize = __webpack_require__(1810);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'countBy': __webpack_require__(1832),
  'each': __webpack_require__(1845),
  'eachRight': __webpack_require__(1846),
  'every': __webpack_require__(1851),
  'filter': __webpack_require__(1855),
  'find': __webpack_require__(1856),
  'findLast': __webpack_require__(1858),
  'flatMap': __webpack_require__(1861),
  'flatMapDeep': __webpack_require__(1862),
  'flatMapDepth': __webpack_require__(1863),
  'forEach': __webpack_require__(750),
  'forEachRight': __webpack_require__(751),
  'groupBy': __webpack_require__(1875),
  'includes': __webpack_require__(1879),
  'invokeMap': __webpack_require__(1888),
  'keyBy': __webpack_require__(1910),
  'map': __webpack_require__(312),
  'orderBy': __webpack_require__(1930),
  'partition': __webpack_require__(1938),
  'reduce': __webpack_require__(1947),
  'reduceRight': __webpack_require__(1948),
  'reject': __webpack_require__(1949),
  'sample': __webpack_require__(1955),
  'sampleSize': __webpack_require__(1956),
  'shuffle': __webpack_require__(1959),
  'size': __webpack_require__(1960),
  'some': __webpack_require__(1963),
  'sortBy': __webpack_require__(1964)
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1722),
    isObjectLike = __webpack_require__(34);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1729),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(442),
    keys = __webpack_require__(46);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.triggerLoginOnlyBySsoView = exports.loadConfiguration = exports.loadPathNamespace = exports.requestAuthentication = exports.loginOnlyBySsoView = exports.localizationsFetched = exports.configurationLoaded = exports.loadingConfiguration = exports.fetchingLocalizations = undefined;

var _reduxActions = __webpack_require__(38);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _booking = __webpack_require__(68);

var _organization = __webpack_require__(545);

var _session = __webpack_require__(42);

var _errors = __webpack_require__(118);

var _ehrResources = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var fetchingLocalizations = exports.fetchingLocalizations = _get__('makeActionCreator')('FETCHING_LOCALIZATIONS');
var loadingConfiguration = exports.loadingConfiguration = _get__('makeActionCreator')('LOADING_CONFIGURATION');
var configurationLoaded = exports.configurationLoaded = _get__('makeActionCreator')('CONFIGURATION_LOADED');
var localizationsFetched = exports.localizationsFetched = _get__('makeActionCreator')('LOCALIZATIONS_FETCHED');
var loginOnlyBySsoView = exports.loginOnlyBySsoView = _get__('makeActionCreator')('SHOW_LOGIN_ONLY_BY_SSO_VIEW');

var languages = [];

var getLocalizations = function () {
  function getLocalizations(options) {
    return new Promise(function (resolve, reject) {
      // initialize the i18n localization first to avoid showing the key strings
      console.log('LOCALIZATIONS INITIALIZE:', options);
      _get__('i18n').loadLanguages(_get__('languages'), function (err, t) {
        console.log('All languages fetched');
        // request all the namespaces for all the languages
        _get__('api').requestAllByLanguages(_get__('languages'), options.ns).then(function (localizationsByLanguage) {
          // localizationsByLanguage is an array with the language and the namespace map
          localizationsByLanguage.forEach(function (localizationByLanguage) {
            var language = localizationByLanguage.language,
                namespaceMap = localizationByLanguage.namespaceMap;
            // the map contains the name of the namespace and the dictionary (data) of translations

            namespaceMap.forEach(function (namespaceEntry) {
              var namespaceName = namespaceEntry.namespaceName,
                  namespaceData = namespaceEntry.namespaceData;

              _get__('i18n').addResourceBundle(language, namespaceName, namespaceData, true, true);
            });
          });
          // we have finished assigning the namespaces in all the languages
          resolve();
        })['catch'](function (error) {
          reject(error);
        });
      });
    });
  }

  return getLocalizations;
}();

var requestAuthentication = exports.requestAuthentication = function () {
  function requestAuthentication(dispatch) {
    return function (method, createUserIfNotExists) {
      dispatch(_get__('bankAuthenticationStarted')());
      _get__('api').requestAuthentication(method, createUserIfNotExists).then(function (data) {
        var url = data.url;

        dispatch(_get__('bankAuthenticationLinkReceived')());
        dispatch(_get__('saveStateAndSelectionHandler'))();
        // console.log(url);
        window.location.replace(url);
      })['catch'](function (error) {
        dispatch(_get__('bankAuthenticationLinkReceived')());
        console.log(error);
      });
    };
  }

  return requestAuthentication;
}();

var loadPathNamespace = exports.loadPathNamespace = function () {
  function loadPathNamespace(pathNamespace, employerId) {
    return new Promise(function (resolve, reject) {
      if (!pathNamespace) {
        resolve();
        return;
      }

      // Clean the previously existing (if any) bundle with this path namespace.
      _get__('languages').forEach(function (language) {
        return _get__('i18n').removeResourceBundle(language, pathNamespace);
      });

      _get__('api').requestAllByLanguages(_get__('languages'), [pathNamespace], employerId).then(function (localizationsByLanguage) {
        // localizationsByLanguage is an array with the language and the namespace map
        localizationsByLanguage.forEach(function (localizationByLanguage) {
          var language = localizationByLanguage.language,
              namespaceMap = localizationByLanguage.namespaceMap;
          // the map contains the name of the namespace and the dictionary (data) of translations

          namespaceMap.forEach(function (namespaceEntry) {
            var namespaceName = namespaceEntry.namespaceName,
                namespaceData = namespaceEntry.namespaceData;

            _get__('i18n').addResourceBundle(language, namespaceName, namespaceData, true, true);
          });
        });
        // we have finished assigning the namespaces in all the languages
        resolve();
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return loadPathNamespace;
}();

var loadConfiguration = exports.loadConfiguration = function () {
  function loadConfiguration(dispatch, getState) {
    return function () {
      var _getState = getState(),
          booking = _getState.booking,
          session = _getState.session;

      dispatch(_get__('loadingConfiguration')());
      _get__('i18n').on('initialized', function (options) {
        _get__('moment').locale('fi');
        dispatch(_get__('fetchingLocalizations')());
        _get__('api').requestOrganization().then(function (organizationData) {
          dispatch(_get__('organizationReceived')(organizationData));
          _assign__('languages', organizationData.locales.map(function (locale) {
            return locale.split('_')[0];
          }));
          _get__('getLocalizations')(options).then(function () {
            //  if language in i18n taken from cookie doesn't exist in organization's locales, change it to organization's default language
            if (!_get__('languages').includes(_get__('i18n').language)) {
              //  take the default locale for organization. if default locale is not supported, then take Finnish
              var newLocale = !_get__('languages').includes(organizationData.defaultLocale.split('_')[0]) ? 'fi' : organizationData.defaultLocale.split('_')[0];
              _get__('i18n').changeLanguage(newLocale);
            }
            // after all the localizations are loaded then we fetch the configurations
            dispatch(_get__('localizationsFetched')());
            dispatch(_get__('identifyUserStart')());
            _get__('api').checkUser().then(function (data) {
              return dispatch(_get__('identifyUserSuccess')(data));
            }).then(function () {
              return dispatch(_get__('loadRoot'))();
            }).then(function () {
              return dispatch(_get__('fetchUponLogin'))();
            })
            // in case user came after strong authentication we fetch originally selected path
            .then(function () {
              return dispatch(_get__('fetchPathAfterLogin'))();
            })
            // if user came after bank auth being in self paid path, load path localizations as pathconfig is not loaded second time
            .then(function () {
              return new Promise(function (resolve) {
                if (booking.pathNamespace) {
                  _get__('loadPathNamespace')(booking.pathNamespace, null).then(function () {
                    return resolve();
                  });
                } else {
                  resolve();
                }
              });
            }).then(function () {
              return dispatch(_get__('configurationLoaded')());
            })['catch'](function () {
              dispatch(_get__('checkUserFailure')('User is not logged in.'));
              dispatch(_get__('loadRoot'))();
              dispatch(_get__('configurationLoaded')());
            });
          });
        })['catch'](function () {
          dispatch(_get__('configurationLoaded')());
          return dispatch(_get__('handleError'));
        });
      });
    };
  }

  return loadConfiguration;
}();

var triggerLoginOnlyBySsoView = exports.triggerLoginOnlyBySsoView = function () {
  function triggerLoginOnlyBySsoView(dispatch) {
    return function () {
      return dispatch(_get__('loginOnlyBySsoView')());
    };
  }

  return triggerLoginOnlyBySsoView;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'i18n':
      return _i18n2['default'];

    case 'languages':
      return languages;

    case 'api':
      return _api2['default'];

    case 'bankAuthenticationStarted':
      return _session.bankAuthenticationStarted;

    case 'bankAuthenticationLinkReceived':
      return _session.bankAuthenticationLinkReceived;

    case 'saveStateAndSelectionHandler':
      return _booking.saveStateAndSelectionHandler;

    case 'loadingConfiguration':
      return loadingConfiguration;

    case 'moment':
      return _moment2['default'];

    case 'fetchingLocalizations':
      return fetchingLocalizations;

    case 'organizationReceived':
      return _organization.organizationReceived;

    case 'getLocalizations':
      return getLocalizations;

    case 'localizationsFetched':
      return localizationsFetched;

    case 'identifyUserStart':
      return _session.identifyUserStart;

    case 'identifyUserSuccess':
      return _session.identifyUserSuccess;

    case 'loadRoot':
      return _booking.loadRoot;

    case 'fetchUponLogin':
      return _ehrResources.fetchUponLogin;

    case 'fetchPathAfterLogin':
      return _booking.fetchPathAfterLogin;

    case 'loadPathNamespace':
      return loadPathNamespace;

    case 'configurationLoaded':
      return configurationLoaded;

    case 'checkUserFailure':
      return _session.checkUserFailure;

    case 'handleError':
      return _errors.handleError;

    case 'loginOnlyBySsoView':
      return loginOnlyBySsoView;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case 'languages':
      return languages = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(fetchingLocalizations, 'fetchingLocalizations', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(loadingConfiguration, 'loadingConfiguration', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(configurationLoaded, 'configurationLoaded', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(localizationsFetched, 'localizationsFetched', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(loginOnlyBySsoView, 'loginOnlyBySsoView', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(languages, 'languages', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(getLocalizations, 'getLocalizations', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(requestAuthentication, 'requestAuthentication', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(loadPathNamespace, 'loadPathNamespace', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(loadConfiguration, 'loadConfiguration', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');

  __REACT_HOT_LOADER__.register(triggerLoginOnlyBySsoView, 'triggerLoginOnlyBySsoView', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/app.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _BookingPhase = __webpack_require__(1114);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('BookingPhase'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'BookingPhase':
      return _BookingPhase2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BookingPhase/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BookingPhase/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BookingPhase/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SimpleBox = function () {
  function SimpleBox(_ref) {
    var children = _ref.children,
        className = _ref.className;

    var classes = 'simple-box center-block ' + className;
    return _get__('React').createElement(
      'div',
      { className: classes },
      children
    );
  }

  return SimpleBox;
}();

_get__('SimpleBox').propTypes = {
  children: _get__('PropTypes').node.isRequired,
  className: _get__('PropTypes').string
};

_get__('SimpleBox').defaultProps = {
  className: ''
};

var _default = _get__('SimpleBox');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'SimpleBox':
      return SimpleBox;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof SimpleBox === 'undefined' ? 'undefined' : _typeof(SimpleBox);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(SimpleBox, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(SimpleBox)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SimpleBox, 'SimpleBox', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SimpleBox/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SimpleBox/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(10);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(78);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(79);
var global = __webpack_require__(15);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(121) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(50);
var SPECIES = __webpack_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    eq = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(291),
    arrayIncludes = __webpack_require__(293),
    arrayIncludesWith = __webpack_require__(426),
    arrayMap = __webpack_require__(36),
    baseUnary = __webpack_require__(84),
    cacheHas = __webpack_require__(300);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(234),
    castPath = __webpack_require__(127),
    isIndex = __webpack_require__(128),
    isObject = __webpack_require__(39),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    getPrototype = __webpack_require__(305),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _IdentificationForm = __webpack_require__(1158);

var _IdentificationForm2 = _interopRequireDefault(_IdentificationForm);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      loginFailed: state.session.loginFailed,
      loginFailedMessage: state.session.loginFailedMessage,
      requiresEmployer: state.session.requiresEmployer,
      createUserIfNotExists: state.session.createUserIfNotExists,
      relaxedSotuVerificationEnabled: state.organization.relaxedSotuVerificationEnabled
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      identifyUser: dispatch(_get__('identifyUser'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('IdentificationForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'identifyUser':
      return _session.identifyUser;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'IdentificationForm':
      return _IdentificationForm2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/IdentificationForm/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/IdentificationForm/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/IdentificationForm/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(73);
var toLength = __webpack_require__(29);
var toAbsoluteIndex = __webpack_require__(144);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(64);
var redefineAll = __webpack_require__(142);
var meta = __webpack_require__(122);
var forOf = __webpack_require__(137);
var anInstance = __webpack_require__(136);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var $iterDetect = __webpack_require__(267);
var setToStringTag = __webpack_require__(179);
var inheritIfRequired = __webpack_require__(368);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(602);
var redefine = __webpack_require__(64);
var hide = __webpack_require__(63);
var fails = __webpack_require__(18);
var defined = __webpack_require__(93);
var wks = __webpack_require__(28);
var regexpExec = __webpack_require__(376);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(78);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(20);
var cof = __webpack_require__(78);
var MATCH = __webpack_require__(28)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(28)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(121) || !__webpack_require__(18)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(15)[K];
});


/***/ }),
/* 269 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(177);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(50);
var ctx = __webpack_require__(80);
var forOf = __webpack_require__(137);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(4);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(82);
var defined = __webpack_require__(93);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var hide = __webpack_require__(63);
var uid = __webpack_require__(145);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1780),
    listCacheDelete = __webpack_require__(1781),
    listCacheGet = __webpack_require__(1782),
    listCacheHas = __webpack_require__(1783),
    listCacheSet = __webpack_require__(1784);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(425),
    setCacheAdd = __webpack_require__(1799),
    setCacheHas = __webpack_require__(1800);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(290),
    stackClear = __webpack_require__(1802),
    stackDelete = __webpack_require__(1803),
    stackGet = __webpack_require__(1804),
    stackHas = __webpack_require__(1805),
    stackSet = __webpack_require__(1806);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(192);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(86);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    castPath = __webpack_require__(127),
    last = __webpack_require__(87),
    parent = __webpack_require__(732),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1725),
    isObjectLike = __webpack_require__(34);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndexBy = __webpack_require__(439),
    identity = __webpack_require__(114),
    isSymbol = __webpack_require__(116);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !isSymbol(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return baseSortedIndexBy(array, value, identity, retHighest);
}

module.exports = baseSortedIndex;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83);

/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

module.exports = baseWhile;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(1704),
    baseAggregator = __webpack_require__(1712),
    baseIteratee = __webpack_require__(13),
    isArray = __webpack_require__(16);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(191),
    isObject = __webpack_require__(39);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(314);

/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = toNumber(value);
      other = toNumber(other);
    }
    return operator(value, other);
  };
}

module.exports = createRelationalOperation;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1776);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(730);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(692);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isArray = __webpack_require__(16),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIteratee = __webpack_require__(13),
    baseMap = __webpack_require__(685),
    isArray = __webpack_require__(16);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'assign': __webpack_require__(1815),
  'assignIn': __webpack_require__(742),
  'assignInWith': __webpack_require__(456),
  'assignWith': __webpack_require__(1816),
  'at': __webpack_require__(1817),
  'create': __webpack_require__(1833),
  'defaults': __webpack_require__(1836),
  'defaultsDeep': __webpack_require__(1837),
  'entries': __webpack_require__(1848),
  'entriesIn': __webpack_require__(1849),
  'extend': __webpack_require__(1852),
  'extendWith': __webpack_require__(1853),
  'findKey': __webpack_require__(1857),
  'findLastKey': __webpack_require__(1859),
  'forIn': __webpack_require__(1868),
  'forInRight': __webpack_require__(1869),
  'forOwn': __webpack_require__(1870),
  'forOwnRight': __webpack_require__(1871),
  'functions': __webpack_require__(1873),
  'functionsIn': __webpack_require__(1874),
  'get': __webpack_require__(458),
  'has': __webpack_require__(1878),
  'hasIn': __webpack_require__(459),
  'invert': __webpack_require__(1885),
  'invertBy': __webpack_require__(1886),
  'invoke': __webpack_require__(1887),
  'keys': __webpack_require__(46),
  'keysIn': __webpack_require__(58),
  'mapKeys': __webpack_require__(1916),
  'mapValues': __webpack_require__(1917),
  'merge': __webpack_require__(1921),
  'mergeWith': __webpack_require__(757),
  'omit': __webpack_require__(1928),
  'omitBy': __webpack_require__(1929),
  'pick': __webpack_require__(1939),
  'pickBy': __webpack_require__(759),
  'result': __webpack_require__(1953),
  'set': __webpack_require__(1957),
  'setWith': __webpack_require__(1958),
  'toPairs': __webpack_require__(765),
  'toPairsIn': __webpack_require__(766),
  'transform': __webpack_require__(1991),
  'unset': __webpack_require__(2004),
  'update': __webpack_require__(2005),
  'updateWith': __webpack_require__(2006),
  'values': __webpack_require__(201),
  'valuesIn': __webpack_require__(2009)
};


/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _app = __webpack_require__(217);

var _BankSelection = __webpack_require__(1111);

var _BankSelection2 = _interopRequireDefault(_BankSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      createUserIfNotExists: state.session.createUserIfNotExists
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      requestAuthentication: dispatch(_get__('requestAuthentication'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('BankSelection'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'requestAuthentication':
      return _app.requestAuthentication;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'BankSelection':
      return _BankSelection2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localStorage = __webpack_require__(250);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _constants = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClientStorage = function () {
  function ClientStorage() {
    _classCallCheck(this, ClientStorage);
  }

  _createClass(ClientStorage, null, [{
    key: 'getPersistedState',
    value: function () {
      function getPersistedState() {
        try {
          var serializedState = _get__('ls').get('state');
          if (serializedState === null) {
            return null;
          }
          return JSON.parse(serializedState);
        } catch (err) {
          return undefined;
        }
      }

      return getPersistedState;
    }()
  }, {
    key: 'setPersistedState',
    value: function () {
      function setPersistedState(store) {
        try {
          var filteredState = this.getFilteredState(store.getState());
          var serializedState = JSON.stringify(filteredState);
          //      sessionStorage.setItem('state', serializedState);
        } catch (err) {
          // Ignore write errors.
        }
      }

      return setPersistedState;
    }()
  }, {
    key: 'getFilteredState',
    value: function () {
      function getFilteredState(state) {
        var groups = state.groups,
            resources = state.resources,
            units = state.units;

        return {
          session: _extends({}, state.session, {
            loginFailed: false,
            sessionCleared: false
          }),
          booking: {
            selectedOptionIds: state.booking.selectedOptionIds,
            additionalDiscussionChecked: state.booking.additionalDiscussionChecked
          },
          groups: groups,
          resources: resources,
          units: units
        };
      }

      return getFilteredState;
    }()
  }, {
    key: 'clearState',
    value: function () {
      function clearState() {
        try {
          sessionStorage.clear();
          console.log('Local store cleared successfully.');
        } catch (err) {
          // for now we do not do anything here
          console.log('Local store was not cleared successfully.');
        }
      }

      return clearState;
    }()
  }, {
    key: 'setAppBuildTimestamp',
    value: function () {
      function setAppBuildTimestamp(appBuildTimestamp) {
        sessionStorage.setItem(_get__('APP_UPDATE_HEADER_NAME'), appBuildTimestamp);
      }

      return setAppBuildTimestamp;
    }()
  }, {
    key: 'getAppBuildTimestamp',
    value: function () {
      function getAppBuildTimestamp() {
        return sessionStorage.getItem(_get__('APP_UPDATE_HEADER_NAME'));
      }

      return getAppBuildTimestamp;
    }()
  }, {
    key: 'removeAppBuildTimestamp',
    value: function () {
      function removeAppBuildTimestamp() {
        sessionStorage.removeItem(_get__('APP_UPDATE_HEADER_NAME'));
      }

      return removeAppBuildTimestamp;
    }()
  }, {
    key: 'setAppUpdateInProgress',
    value: function () {
      function setAppUpdateInProgress() {
        sessionStorage.setItem('UpdateInProgress', '1');
      }

      return setAppUpdateInProgress;
    }()
  }, {
    key: 'isAppUpdateInProgress',
    value: function () {
      function isAppUpdateInProgress() {
        return sessionStorage.getItem('UpdateInProgress');
      }

      return isAppUpdateInProgress;
    }()
  }, {
    key: 'clearAppUpdateInProgress',
    value: function () {
      function clearAppUpdateInProgress() {
        sessionStorage.removeItem('UpdateInProgress');
      }

      return clearAppUpdateInProgress;
    }()
  }]);

  return ClientStorage;
}();

var _default = ClientStorage;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ls':
      return _localStorage2['default'];

    case 'APP_UPDATE_HEADER_NAME':
      return _constants.APP_UPDATE_HEADER_NAME;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof ClientStorage === 'undefined' ? 'undefined' : _typeof(ClientStorage);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(ClientStorage, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ClientStorage)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ClientStorage, 'ClientStorage', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/ClientStorage.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/ClientStorage.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(273)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(144);
var toLength = __webpack_require__(29);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1238);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(33);
var createDesc = __webpack_require__(141);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(15).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(28)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(15).document;
module.exports = document && document.documentElement;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var setPrototypeOf = __webpack_require__(377).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(178);
var ITERATOR = __webpack_require__(28)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(138);
var descriptor = __webpack_require__(141);
var setToStringTag = __webpack_require__(179);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(63)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(121);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(64);
var hide = __webpack_require__(63);
var Iterators = __webpack_require__(178);
var $iterCreate = __webpack_require__(370);
var setToStringTag = __webpack_require__(179);
var getPrototypeOf = __webpack_require__(72);
var ITERATOR = __webpack_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var macrotask = __webpack_require__(382).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(78)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(50);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(222);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(10);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(80)(Function.call, __webpack_require__(71).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(225)('keys');
var uid = __webpack_require__(145);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(266);
var defined = __webpack_require__(93);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(82);
var defined = __webpack_require__(93);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(80);
var invoke = __webpack_require__(580);
var html = __webpack_require__(367);
var cel = __webpack_require__(364);
var global = __webpack_require__(15);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(78)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(31);
var LIBRARY = __webpack_require__(121);
var $typed = __webpack_require__(274);
var hide = __webpack_require__(63);
var redefineAll = __webpack_require__(142);
var fails = __webpack_require__(18);
var anInstance = __webpack_require__(136);
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(29);
var toIndex = __webpack_require__(599);
var gOPN = __webpack_require__(139).f;
var dP = __webpack_require__(33).f;
var arrayFill = __webpack_require__(361);
var setToStringTag = __webpack_require__(179);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var core = __webpack_require__(79);
var LIBRARY = __webpack_require__(121);
var wksExt = __webpack_require__(600);
var defineProperty = __webpack_require__(33).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(177);
var ITERATOR = __webpack_require__(28)('iterator');
var Iterators = __webpack_require__(178);
module.exports = __webpack_require__(79).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(120);
var step = __webpack_require__(583);
var Iterators = __webpack_require__(178);
var toIObject = __webpack_require__(73);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(371)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(191),
    baseLodash = __webpack_require__(434);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(191),
    baseLodash = __webpack_require__(434);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157),
    root = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1785),
    mapCacheDelete = __webpack_require__(1786),
    mapCacheGet = __webpack_require__(1787),
    mapCacheHas = __webpack_require__(1788),
    mapCacheSet = __webpack_require__(1789);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 426 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 427 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(709);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(681),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    isFunction = __webpack_require__(115);

/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return arrayFilter(props, function(key) {
    return isFunction(object[key]);
  });
}

module.exports = baseFunctions;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(291),
    arrayIncludes = __webpack_require__(293),
    arrayIncludesWith = __webpack_require__(426),
    arrayMap = __webpack_require__(36),
    baseUnary = __webpack_require__(84),
    cacheHas = __webpack_require__(300);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    baseIsEqual = __webpack_require__(297);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(237),
    nativeKeys = __webpack_require__(1792);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 434 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    assignMergeValue = __webpack_require__(674),
    baseFor = __webpack_require__(428),
    baseMergeDeep = __webpack_require__(1732),
    isObject = __webpack_require__(39),
    keysIn = __webpack_require__(58),
    safeGet = __webpack_require__(734);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 436 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIndexOf = __webpack_require__(192),
    baseIndexOfWith = __webpack_require__(1720),
    baseUnary = __webpack_require__(84),
    copyArray = __webpack_require__(85);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = copyArray(values);
  }
  if (iteratee) {
    seen = arrayMap(array, baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

module.exports = basePullAll;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(116);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  var low = 0,
      high = array == null ? 0 : array.length;
  if (high === 0) {
    return 0;
  }

  value = iteratee(value);
  var valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = isSymbol(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = isSymbol(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return nativeMin(high, MAX_ARRAY_INDEX);
}

module.exports = baseSortedIndexBy;


/***/ }),
/* 440 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    last = __webpack_require__(87),
    parent = __webpack_require__(732),
    toKey = __webpack_require__(100);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(235),
    baseFlatten = __webpack_require__(51),
    baseUniq = __webpack_require__(154);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(57);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(668);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    arrayMap = __webpack_require__(36),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22),
    baseUnary = __webpack_require__(84),
    flatRest = __webpack_require__(156);

/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return flatRest(function(iteratees) {
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    return baseRest(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return apply(iteratee, thisArg, args);
      });
    });
  });
}

module.exports = createOver;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(694),
    baseToString = __webpack_require__(111),
    castSlice = __webpack_require__(155),
    hasUnicode = __webpack_require__(195),
    stringSize = __webpack_require__(197),
    stringToArray = __webpack_require__(129);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(682),
    getSymbolsIn = __webpack_require__(723),
    keysIn = __webpack_require__(58);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(729),
    noop = __webpack_require__(462);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(727),
    keys = __webpack_require__(46);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    stubArray = __webpack_require__(463);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(16),
    isSymbol = __webpack_require__(116);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 454 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1738),
    shortOut = __webpack_require__(737);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    createAssigner = __webpack_require__(193),
    keysIn = __webpack_require__(58);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1719),
    hasPath = __webpack_require__(724);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34),
    isPlainObject = __webpack_require__(238);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1727),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(314);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    arrayMap = __webpack_require__(36),
    baseProperty = __webpack_require__(436),
    baseTimes = __webpack_require__(440),
    isArrayLikeObject = __webpack_require__(57);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = arrayFilter(array, function(group) {
    if (isArrayLikeObject(group)) {
      length = nativeMax(group.length, length);
      return true;
    }
  });
  return baseTimes(length, function(index) {
    return arrayMap(array, baseProperty(index));
  });
}

module.exports = unzip;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(710);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.getPreviousMonth = exports.getInitialMonths = exports.cancelAndRemoveFromReservations = exports.historyFailed = exports.removeAppointmentFromHistory = exports.historyLoadCompleted = exports.historyLoadStart = exports.historyInitialLoadCompleted = exports.historyInitialLoadStart = undefined;

var _reduxActions = __webpack_require__(38);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _cancelling = __webpack_require__(103);

var _errors = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var historyInitialLoadStart = exports.historyInitialLoadStart = _get__('makeActionCreator')('HISTORY_INITIAL_LOAD_START');
var historyInitialLoadCompleted = exports.historyInitialLoadCompleted = _get__('makeActionCreator')('HISTORY_INITIAL_LOAD_COMPLETED');
var historyLoadStart = exports.historyLoadStart = _get__('makeActionCreator')('HISTORY_LOAD_START');
var historyLoadCompleted = exports.historyLoadCompleted = _get__('makeActionCreator')('HISTORY_LOAD_COMPLETED');
var removeAppointmentFromHistory = exports.removeAppointmentFromHistory = _get__('makeActionCreator')('HISTORY_REMOVE_APPOINTMENT');
var historyFailed = exports.historyFailed = _get__('makeActionCreator')('HISTORY_GET_FAILED');

var cancelAndRemoveFromReservations = exports.cancelAndRemoveFromReservations = function () {
  function cancelAndRemoveFromReservations(dispatch) {
    return function (reservationId) {
      new Promise(function (resolve) {
        dispatch(_get__('cancelReservation'))(reservationId, resolve);
      }).then(function () {
        return dispatch(_get__('removeAppointmentFromHistory')(reservationId));
      });
    };
  }

  return cancelAndRemoveFromReservations;
}();

var getInitialMonths = exports.getInitialMonths = function () {
  function getInitialMonths(dispatch) {
    return function (from) {
      dispatch(_get__('historyInitialLoadStart')());
      _get__('api').requestReservations(from).then(function (reservations) {
        dispatch(_get__('historyInitialLoadCompleted')(reservations));
      })['catch'](function (error) {
        dispatch(_get__('historyFailed')());
        dispatch(_get__('handleError'))(error);
      });
    };
  }

  return getInitialMonths;
}();

var getPreviousMonth = exports.getPreviousMonth = function () {
  function getPreviousMonth(dispatch) {
    return function (from, to) {
      dispatch(_get__('historyLoadStart')());
      _get__('api').requestReservations(from, to).then(function (reservations) {
        dispatch(_get__('historyLoadCompleted')(reservations));
      })['catch'](function (error) {
        dispatch(_get__('historyFailed')());
        dispatch(_get__('handleError'))(error);
      });
    };
  }

  return getPreviousMonth;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'cancelReservation':
      return _cancelling.cancelReservation;

    case 'removeAppointmentFromHistory':
      return removeAppointmentFromHistory;

    case 'historyInitialLoadStart':
      return historyInitialLoadStart;

    case 'api':
      return _api2['default'];

    case 'historyInitialLoadCompleted':
      return historyInitialLoadCompleted;

    case 'historyFailed':
      return historyFailed;

    case 'handleError':
      return _errors.handleError;

    case 'historyLoadStart':
      return historyLoadStart;

    case 'historyLoadCompleted':
      return historyLoadCompleted;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(historyInitialLoadStart, 'historyInitialLoadStart', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(historyInitialLoadCompleted, 'historyInitialLoadCompleted', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(historyLoadStart, 'historyLoadStart', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(historyLoadCompleted, 'historyLoadCompleted', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(removeAppointmentFromHistory, 'removeAppointmentFromHistory', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(historyFailed, 'historyFailed', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(cancelAndRemoveFromReservations, 'cancelAndRemoveFromReservations', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(getInitialMonths, 'getInitialMonths', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');

  __REACT_HOT_LOADER__.register(getPreviousMonth, 'getPreviousMonth', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/history.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.fetchOrganization = exports.organizationReceived = undefined;

var _reduxActions = __webpack_require__(38);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _errors = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var organizationReceived = exports.organizationReceived = _get__('makeActionCreator')('ORGANIZATION_RECEIVED');

var fetchOrganization = exports.fetchOrganization = function () {
  function fetchOrganization(dispatch) {
    return function () {
      console.log('Fetching organization');
      _get__('api').requestOrganization().then(function (organizationData) {
        dispatch(_get__('organizationReceived')(organizationData));
      })['catch'](dispatch(_get__('handleError')));
    };
  }

  return fetchOrganization;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'api':
      return _api2['default'];

    case 'organizationReceived':
      return organizationReceived;

    case 'handleError':
      return _errors.handleError;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(organizationReceived, 'organizationReceived', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/organization.js');

  __REACT_HOT_LOADER__.register(fetchOrganization, 'fetchOrganization', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/organization.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.selectTicket = exports.getTickets = exports.ticketFailed = exports.ticketSelected = exports.ticketsLoaded = exports.ticketsLoading = undefined;

var _reduxActions = __webpack_require__(38);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _booking = __webpack_require__(68);

var _errors = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ticketsLoading = exports.ticketsLoading = _get__('makeActionCreator')('TICKETS_LOADING');
var ticketsLoaded = exports.ticketsLoaded = _get__('makeActionCreator')('TICKETS_LOADED');
var ticketSelected = exports.ticketSelected = _get__('makeActionCreator')('TICKET_SELECTED');
var ticketFailed = exports.ticketFailed = _get__('makeActionCreator')('TICKET_FAILED');

var getTickets = exports.getTickets = function () {
  function getTickets(dispatch) {
    return function () {
      dispatch(_get__('ticketsLoading')());
      _get__('api').requestTickets().then(function (tickets) {
        dispatch(_get__('ticketsLoaded')(tickets));
      })['catch'](function (error) {
        dispatch(_get__('ticketFailed')());
        dispatch(_get__('handleError'))(error);
      });
    };
  }

  return getTickets;
}();

var selectTicket = exports.selectTicket = function () {
  function selectTicket(dispatch) {
    return function (ticket) {
      var activationDate = _get__('moment')(ticket.activationDate, 'YYYY-MM-DD');
      var isActive = activationDate.isSameOrBefore(_get__('moment')());
      if (!isActive) {
        return;
      }
      dispatch(_get__('selectedOptionsChanged')([]));
      dispatch(_get__('ticketSelected')(ticket));
    };
  }

  return selectTicket;
}();

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'makeActionCreator':
      return _reduxActions.createAction;

    case 'ticketsLoading':
      return ticketsLoading;

    case 'api':
      return _api2['default'];

    case 'ticketsLoaded':
      return ticketsLoaded;

    case 'ticketFailed':
      return ticketFailed;

    case 'handleError':
      return _errors.handleError;

    case 'moment':
      return _moment2['default'];

    case 'selectedOptionsChanged':
      return _booking.selectedOptionsChanged;

    case 'ticketSelected':
      return ticketSelected;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ticketsLoading, 'ticketsLoading', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');

  __REACT_HOT_LOADER__.register(ticketsLoaded, 'ticketsLoaded', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');

  __REACT_HOT_LOADER__.register(ticketSelected, 'ticketSelected', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');

  __REACT_HOT_LOADER__.register(ticketFailed, 'ticketFailed', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');

  __REACT_HOT_LOADER__.register(getTickets, 'getTickets', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');

  __REACT_HOT_LOADER__.register(selectTicket, 'selectTicket', '/Users/hannum/work/sources/mbooking/src/frontend/src/actions/ticket.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var styleDiv = {
  height: '100%',
  width: '100%',
  position: 'relative'
};

var styleImg = {
  maxHeight: '100%',
  maxWidth: '100%',
  position: 'absolute',
  top: '0',
  bottom: '0',
  left: '0',
  right: '0',
  margin: 'auto'
};

var CenteredImage = function () {
  function CenteredImage(_ref) {
    var containerHeight = _ref.containerHeight,
        containerWidth = _ref.containerWidth,
        src = _ref.src,
        className = _ref.className,
        alt = _ref.alt;
    return _get__('React').createElement(
      'div',
      { className: className, style: { height: containerHeight, width: containerWidth } },
      _get__('React').createElement(
        'div',
        { style: _get__('styleDiv') },
        _get__('React').createElement('img', { style: _get__('styleImg'), src: src, alt: alt })
      )
    );
  }

  return CenteredImage;
}();

_get__('CenteredImage').propTypes = {
  containerHeight: _get__('PropTypes').string.isRequired,
  containerWidth: _get__('PropTypes').string.isRequired,
  src: _get__('PropTypes').string.isRequired,
  className: _get__('PropTypes').string,
  alt: _get__('PropTypes').string
};

_get__('CenteredImage').defaultProps = {
  className: '',
  alt: ''
};

var _default = _get__('CenteredImage');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'styleDiv':
      return styleDiv;

    case 'styleImg':
      return styleImg;

    case 'CenteredImage':
      return CenteredImage;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof CenteredImage === 'undefined' ? 'undefined' : _typeof(CenteredImage);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(CenteredImage, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(CenteredImage)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(styleDiv, 'styleDiv', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CenteredImage.jsx');

  __REACT_HOT_LOADER__.register(styleImg, 'styleImg', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CenteredImage.jsx');

  __REACT_HOT_LOADER__.register(CenteredImage, 'CenteredImage', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CenteredImage.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CenteredImage.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InfoBox = function () {
  function InfoBox(_ref) {
    var content = _ref.content;
    return _get__('React').createElement(
      'div',
      { className: 'container-fluid' },
      _get__('React').createElement(
        _get__('Alert'),
        { bsStyle: 'info' },
        _get__('React').createElement(_get__('InnerHtmlContent'), { content: content })
      )
    );
  }

  return InfoBox;
}();

_get__('InfoBox').propTypes = {
  content: _get__('PropTypes').string.isRequired
};

var _default = _get__('InfoBox');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'InfoBox':
      return InfoBox;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'Alert':
      return _reactBootstrap.Alert;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof InfoBox === 'undefined' ? 'undefined' : _typeof(InfoBox);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(InfoBox, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(InfoBox)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InfoBox, 'InfoBox', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/InfoBox/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/InfoBox/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(11);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _fi = __webpack_require__(1515);

var _fi2 = _interopRequireDefault(_fi);

var _gb = __webpack_require__(1516);

var _gb2 = _interopRequireDefault(_gb);

var _se = __webpack_require__(1525);

var _se2 = _interopRequireDefault(_se);

var _ru = __webpack_require__(1523);

var _ru2 = _interopRequireDefault(_ru);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageSelector = function (_get__2) {
  _inherits(LanguageSelector, _get__2);

  function LanguageSelector(props) {
    _classCallCheck(this, LanguageSelector);

    var _this = _possibleConstructorReturn(this, (LanguageSelector.__proto__ || Object.getPrototypeOf(LanguageSelector)).call(this, props));

    _this.onLanguageSelect = _this.onLanguageSelect.bind(_this);
    _this.getName = _this.getName.bind(_this);
    _this.getFlag = _this.getFlag.bind(_this);
    _this.state = {
      activeLanguage: _get__('i18n').language
    };
    return _this;
  }

  _createClass(LanguageSelector, [{
    key: 'onLanguageSelect',
    value: function () {
      function onLanguageSelect(language) {
        _get__('moment').locale(language);
        _get__('i18n').changeLanguage(language);
        this.state.activeLanguage = language;
      }

      return onLanguageSelect;
    }()
  }, {
    key: 'getName',
    value: function () {
      function getName(code) {
        var map = {
          fi: 'Suomi',
          sv: 'Svenska',
          en: 'English',
          ru: 'Русский'
        };
        return map[code];
      }

      return getName;
    }()
  }, {
    key: 'getFlag',
    value: function () {
      function getFlag(code) {
        var map = {
          fi: _get__('fiFlagImage'),
          sv: _get__('svFlagImage'),
          en: _get__('enFlagImage'),
          ru: _get__('ruFlagImage')
        };
        return map[code];
      }

      return getFlag;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            languages = _props.languages,
            t = _props.t;
        var activeLanguage = this.state.activeLanguage;

        return _get__('React').createElement(
          'div',
          { id: 'language-selector-container' },
          _get__('React').createElement(
            _get__('ButtonGroup'),
            null,
            Object.keys(languages).filter(function (key) {
              return activeLanguage !== languages[key];
            }).map(function (key) {
              return _get__('React').createElement(
                _get__('Button'),
                { bsStyle: 'default', key: key, onClick: function () {
                    function onClick() {
                      return _this2.onLanguageSelect(languages[key]);
                    }

                    return onClick;
                  }() },
                _get__('React').createElement(_get__('Image'), { alt: t('ariaLabels.flagImage'), src: _this2.getFlag(languages[key]), className: 'flag-image' }),
                _this2.getName(languages[key])
              );
            })
          )
        );
      }

      return render;
    }()
  }]);

  return LanguageSelector;
}(_get__('Component'));

_get__('LanguageSelector').propTypes = {
  languages: _get__('PropTypes').array.isRequired,
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(['common'])(_get__('LanguageSelector'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18n2['default'];

    case 'moment':
      return _moment2['default'];

    case 'fiFlagImage':
      return _fi2['default'];

    case 'svFlagImage':
      return _se2['default'];

    case 'enFlagImage':
      return _gb2['default'];

    case 'ruFlagImage':
      return _ru2['default'];

    case 'Component':
      return _react.Component;

    case 'LanguageSelector':
      return LanguageSelector;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'ButtonGroup':
      return _reactBootstrap.ButtonGroup;

    case 'Button':
      return _reactBootstrap.Button;

    case 'Image':
      return _reactBootstrap.Image;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LanguageSelector, 'LanguageSelector', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LanguageSelector/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LanguageSelector/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _OptionButton = __webpack_require__(1130);

var _OptionButton2 = _interopRequireDefault(_OptionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('OptionButton'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'OptionButton':
      return _OptionButton2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionButton/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionButton/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionButton/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

__webpack_require__(391);

var _IdentificationForm = __webpack_require__(253);

var _IdentificationForm2 = _interopRequireDefault(_IdentificationForm);

var _BankSelection = __webpack_require__(350);

var _BankSelection2 = _interopRequireDefault(_BankSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LoginComponent = function () {
  function LoginComponent(props) {
    var loginType = props.loginType;

    if (loginType === 'STRONG') {
      return _get__('React').createElement(_get__('BankSelection'), { showBackButton: false });
    }
    return _get__('React').createElement(_get__('IdentificationForm'), null);
  }

  return LoginComponent;
}();

_get__('LoginComponent').propTypes = {
  loginType: _get__('PropTypes').string.isRequired
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return ['booking', props.pathNamespace];
}, { wait: true })(_get__('LoginComponent'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LoginComponent':
      return LoginComponent;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'BankSelection':
      return _BankSelection2['default'];

    case 'IdentificationForm':
      return _IdentificationForm2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoginComponent, 'LoginComponent', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/LoginComponent.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/LoginComponent.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _History = __webpack_require__(1157);

var _History2 = _interopRequireDefault(_History);

var _history = __webpack_require__(544);

var _cancelling = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      historyInitialLoading: state.history.historyInitialLoading,
      historyInitialLoaded: state.history.historyInitialLoaded,
      historyLoading: state.history.historyLoading,
      historyLoaded: state.history.historyLoaded,
      reservations: state.history.reservations,
      resources: state.resources,
      units: state.units,
      numberOfResults: state.history.numberOfResults,
      cancellingReservationError: state.cancelling.cancellingReservationError,
      reservationCancelled: state.cancelling.reservationCancelled
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      cancelAndRemoveFromReservations: dispatch(_get__('cancelAndRemoveFromReservations')),
      getInitialMonths: dispatch(_get__('getInitialMonths')),
      getPreviousMonth: dispatch(_get__('getPreviousMonth')),
      closeCancelReservationScreen: dispatch(_get__('triggerCloseCancelReservationScreen'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('History'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'cancelAndRemoveFromReservations':
      return _history.cancelAndRemoveFromReservations;

    case 'getInitialMonths':
      return _history.getInitialMonths;

    case 'getPreviousMonth':
      return _history.getPreviousMonth;

    case 'triggerCloseCancelReservationScreen':
      return _cancelling.triggerCloseCancelReservationScreen;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'History':
      return _History2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/History/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/History/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/History/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _UnitInfo = __webpack_require__(1173);

var _UnitInfo2 = _interopRequireDefault(_UnitInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state, ownProps) {
    var unitId = ownProps.unit.unit;
    var unit = state.units[unitId];
    var notes = unit && unit.info;
    return {
      pathNamespace: state.booking.pathNamespace,
      notes: notes
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('UnitInfo'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'UnitInfo':
      return _UnitInfo2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitInfo/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitInfo/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitInfo/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DefaultExportValue = {
  BY_TICKET: 'byTicket',
  OCCUPATIONAL: 'occupational',
  SELF_PAYING: 'selfPaying',
  HISTORY: 'history'
};
var _default = _DefaultExportValue;
exports['default'] = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/enums/pathTypes.js');
}();

;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _localStorage = __webpack_require__(250);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(117);

var SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER = 1;

var METHOD_PATH = 0;
var METHOD_CODE = 1;

var SelectionHandler = function () {
  function SelectionHandler(config, namespace) {
    _classCallCheck(this, SelectionHandler);

    // console.log('new SelectionHandler created!');
    var storedSelectionHandler = _get__('ls').get('selectionHandler');
    if (storedSelectionHandler) {
      var parsedSelectionHandler = JSON.parse(storedSelectionHandler);
      var configStored = parsedSelectionHandler.config,
          namespaceStored = parsedSelectionHandler.namespace,
          selections = parsedSelectionHandler.selections,
          currentMethod = parsedSelectionHandler.currentMethod,
          code = parsedSelectionHandler.code,
          byTicket = parsedSelectionHandler.byTicket,
          ticket = parsedSelectionHandler.ticket;

      this.config = configStored;
      this.namespace = namespaceStored;
      this.selections = selections;
      this.currentMethod = currentMethod;
      this.code = code;
      this.byTicket = byTicket;
      this.ticket = ticket;
      return this;
    }
    this.config = config;
    this.namespace = namespace;
    this.selections = [];
    this.currentMethod = _get__('METHOD_PATH');
    this.code = undefined;
    this.byTicket = false;
    this.ticket = undefined;
    this.dedicatedResources = null;
  }

  _createClass(SelectionHandler, [{
    key: 'checkOptionId',
    value: function () {
      function checkOptionId(optionId) {
        // Valid id's are in form of '1', '1.2', '2.1.3' etc.
        return (/^\d+(\.\d+)*$/.test(optionId)
        );
      }

      return checkOptionId;
    }()
  }, {
    key: 'useCode',
    value: function () {
      function useCode() {
        this.currentMethod = _get__('METHOD_CODE');
        this.selections = [];
      }

      return useCode;
    }()
  }, {
    key: 'setCode',
    value: function () {
      function setCode(code) {
        this.useCode();
        this.code = code;
      }

      return setCode;
    }()
  }, {
    key: 'setIsByTicket',
    value: function () {
      function setIsByTicket() {
        this.byTicket = true;
      }

      return setIsByTicket;
    }()
  }, {
    key: 'setTicket',
    value: function () {
      function setTicket(ticket) {
        this.ticket = ticket;
        this.dedicatedResources = null;
      }

      return setTicket;
    }()
  }, {
    key: 'removeByTicket',
    value: function () {
      function removeByTicket() {
        this.byTicket = false;
        this.ticket = undefined;
      }

      return removeByTicket;
    }()
  }, {
    key: 'isByTicket',
    value: function () {
      function isByTicket() {
        return this.byTicket && this.ticket;
      }

      return isByTicket;
    }()
  }, {
    key: 'hasCode',
    value: function () {
      function hasCode() {
        return this.code !== undefined;
      }

      return hasCode;
    }()
  }, {
    key: 'getCode',
    value: function () {
      function getCode() {
        return this.code;
      }

      return getCode;
    }()
  }, {
    key: 'usePath',
    value: function () {
      function usePath() {
        this.currentMethod = _get__('METHOD_PATH');
        this.code = undefined;
      }

      return usePath;
    }()
  }, {
    key: 'isUsingPath',
    value: function () {
      function isUsingPath() {
        return this.currentMethod === _get__('METHOD_PATH');
      }

      return isUsingPath;
    }()
  }, {
    key: 'isUsingCode',
    value: function () {
      function isUsingCode() {
        return this.currentMethod === _get__('METHOD_CODE');
      }

      return isUsingCode;
    }()
  }, {
    key: 'select',
    value: function () {
      function select(optionId) {
        var wasOptionSelected = false;
        if (this.checkOptionId(optionId)) {
          var level = optionId.split('.').length;
          var index = level - 1;
          if (this.getSelectedOptionIdOnLevel(level) !== optionId) {
            // TODO: Check that given optionId is among options of previous levels.
            this.selections[index] = this.getOptionData(optionId);
            this.selections.splice(index + 1);
            wasOptionSelected = true;
          }
        }
        return wasOptionSelected;
      }

      return select;
    }()
  }, {
    key: 'setSelectedOptionIds',
    value: function () {
      function setSelectedOptionIds(optionIds) {
        var _this = this;

        var success = false;
        if (_get__('_').isArray(optionIds)) {
          if (optionIds.length === 0) {
            this.selections = [];
            success = true;
          } else {
            success = _get__('_').every(optionIds, function (optionId) {
              return _this.select(optionId);
            });
          }
        }
        return success;
      }

      return setSelectedOptionIds;
    }()
  }, {
    key: 'getSelectedOptions',
    value: function () {
      function getSelectedOptions() {
        return this.isUsingPath() ? this.selections : [{ title: 'Koodi' }, { title: this.getCode() }];
      }

      return getSelectedOptions;
    }()
  }, {
    key: 'getSelectedOptionIds',
    value: function () {
      function getSelectedOptionIds() {
        return this.selections.map(function (option) {
          return option.id;
        });
      }

      return getSelectedOptionIds;
    }()
  }, {
    key: 'isFinalLevelReached',
    value: function () {
      function isFinalLevelReached() {
        var levels = this.selections.length;
        if (levels > 0) {
          var optionsForNextLevel = this.getOptionsForLevel(levels + 1);
          return optionsForNextLevel.length === 0;
        } else if (this.isByTicket() && this.ticket) {
          return true;
        }
        return false;
      }

      return isFinalLevelReached;
    }()
  }, {
    key: 'getTitleForPath',
    value: function () {
      function getTitleForPath() {
        return _get__('SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER') + '. ' + _get__('i18n').t(this.namespace + ':pathTitle', { defaultValue: '' });
      }

      return getTitleForPath;
    }()
  }, {
    key: 'getLocalizationForLevel',
    value: function () {
      function getLocalizationForLevel(level, key) {
        var translationKey = void 0;
        if (level === 1) {
          translationKey = this.namespace + ':pathConfig.' + key;
        } else if (this.isLevelSelected(level - 1)) {
          var option = this.getSelectedOptionOnLevel(level - 1);
          translationKey = this.namespace + ':pathConfig.' + option.id + '.' + key;
        }
        return _get__('i18n').t(translationKey, { defaultValue: '' });
      }

      return getLocalizationForLevel;
    }()
  }, {
    key: 'getPromptForLevel',
    value: function () {
      function getPromptForLevel(level) {
        return this.getLocalizationForLevel(level, 'prompt');
      }

      return getPromptForLevel;
    }()
  }, {
    key: 'getPromptTextForLevel',
    value: function () {
      function getPromptTextForLevel(level) {
        return this.getLocalizationForLevel(level, 'promptText');
      }

      return getPromptTextForLevel;
    }()
  }, {
    key: 'getInfoForLevel',
    value: function () {
      function getInfoForLevel(level) {
        return this.getLocalizationForLevel(level, 'info');
      }

      return getInfoForLevel;
    }()
  }, {
    key: 'getOptionsForLevel',
    value: function () {
      function getOptionsForLevel(level) {
        if (level === 1) {
          return this.config.options;
        } else if (this.isLevelSelected(level - 1)) {
          var previousOption = this.getSelectedOptionOnLevel(level - 1);
          return previousOption.options || [];
        }
        return [];
      }

      return getOptionsForLevel;
    }()
  }, {
    key: 'isLevelSelected',
    value: function () {
      function isLevelSelected(level) {
        return typeof this.selections[level - 1] !== 'undefined';
      }

      return isLevelSelected;
    }()
  }, {
    key: 'getLastSelectedOption',
    value: function () {
      function getLastSelectedOption() {
        var lastLevel = this.selections.length;
        return this.getSelectedOptionOnLevel(lastLevel);
      }

      return getLastSelectedOption;
    }()
  }, {
    key: 'getSelectedOptionOnLevel',
    value: function () {
      function getSelectedOptionOnLevel(level) {
        if (this.isByTicket() && this.ticket) {
          var _ticket = this.ticket,
              unit = _ticket.unit,
              group = _ticket.group,
              speciality = _ticket.speciality,
              timeSlotDefinitions = _ticket.timeSlotDefinitions;


          if (this.ticket.isMovendosTimeReservationTicket) {
            var _timeSlotDefinitions$ = timeSlotDefinitions[0],
                specialities = _timeSlotDefinitions$.specialities,
                inGroups = _timeSlotDefinitions$.inGroups,
                notInGroups = _timeSlotDefinitions$.notInGroups;
            var _timeSlotDefinitions$2 = timeSlotDefinitions[0],
                _resources = _timeSlotDefinitions$2.resources,
                inUnits = _timeSlotDefinitions$2.inUnits;


            var _ticketDataAsPathResource = _extends({
              type: 1,
              timeType: [this.ticket.timeSlotDefinitions[0].timeTypeDefinitions[0].timeType]
            }, inUnits.length && { inUnits: inUnits }, inGroups.length && { inGroups: inGroups }, notInGroups.length && { notInGroups: notInGroups }, specialities.length && { speciality: specialities }, _resources.length && { inResources: _resources });
            return {
              id: this.ticket.code,
              reservation: {
                resources: [_ticketDataAsPathResource],
                duration: this.ticket.timeSlotDefinitions[0].duration,
                fromTicketOpeningDate: _get__('moment')(this.ticket.openingDate, 'YYYY-MM-DD'),
                toTicketClosingDate: _get__('moment')(this.ticket.closingDate, 'YYYY-MM-DD')
              }
            };
          }
          var resources = this.ticket.resources;

          var ticketDataAsPathResource = _extends({
            type: 1,
            timeType: [this.ticket.timeType]
          }, unit && { inUnits: [unit] }, group && { inGroups: [group] }, speciality && { speciality: speciality }, resources && { inResources: resources });
          return {
            id: this.ticket.code,
            reservation: {
              resources: [ticketDataAsPathResource],
              duration: this.ticket.duration,
              fromTicketOpeningDate: _get__('moment')(this.ticket.openingDate, 'YYYY-MM-DD'),
              toTicketClosingDate: _get__('moment')(this.ticket.closingDate, 'YYYY-MM-DD')
            }
          };
        }
        return this.selections[level - 1] || false;
      }

      return getSelectedOptionOnLevel;
    }()
  }, {
    key: 'getSelectedOptionIdOnLevel',
    value: function () {
      function getSelectedOptionIdOnLevel(level) {
        return this.isLevelSelected(level) ? this.getSelectedOptionOnLevel(level).id : false;
      }

      return getSelectedOptionIdOnLevel;
    }()
  }, {
    key: 'getOptionData',
    value: function () {
      function getOptionData(optionId) {
        var optionData = void 0;
        if (this.checkOptionId(optionId)) {
          optionData = this.config;
          var optionIdParts = optionId.split('.');

          var _loop = function () {
            function _loop() {
              var options = optionData.options || [];
              var currentSelectionNumber = optionIdParts.shift();
              optionData = options.filter(function (option) {
                return option.id.split('.').pop() === currentSelectionNumber;
              })[0];
            }

            return _loop;
          }();

          do {
            _loop();
          } while (optionIdParts.length > 0);
        }
        return optionData;
      }

      return getOptionData;
    }()
  }]);

  return SelectionHandler;
}();

var _default = _get__('SelectionHandler');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ls':
      return _localStorage2['default'];

    case 'METHOD_PATH':
      return METHOD_PATH;

    case 'METHOD_CODE':
      return METHOD_CODE;

    case '_':
      return _;

    case 'SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER':
      return SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER;

    case 'i18n':
      return _i18n2['default'];

    case 'moment':
      return _moment2['default'];

    case 'SelectionHandler':
      return SelectionHandler;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof SelectionHandler === 'undefined' ? 'undefined' : _typeof(SelectionHandler);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(SelectionHandler, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(SelectionHandler)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER, 'SYMPTOM_SELECTION_PHASE_ORDINAL_NUMBER', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/SelectionHandler.js');

  __REACT_HOT_LOADER__.register(METHOD_PATH, 'METHOD_PATH', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/SelectionHandler.js');

  __REACT_HOT_LOADER__.register(METHOD_CODE, 'METHOD_CODE', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/SelectionHandler.js');

  __REACT_HOT_LOADER__.register(SelectionHandler, 'SelectionHandler', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/SelectionHandler.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/SelectionHandler.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(78);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(144);
var toLength = __webpack_require__(29);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(137);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(50);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(223);
var toLength = __webpack_require__(29);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(50);
var isObject = __webpack_require__(20);
var invoke = __webpack_require__(580);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(33).f;
var create = __webpack_require__(138);
var redefineAll = __webpack_require__(142);
var ctx = __webpack_require__(80);
var anInstance = __webpack_require__(136);
var forOf = __webpack_require__(137);
var $iterDefine = __webpack_require__(371);
var step = __webpack_require__(583);
var setSpecies = __webpack_require__(143);
var DESCRIPTORS = __webpack_require__(31);
var fastKey = __webpack_require__(122).fastKey;
var validate = __webpack_require__(146);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(177);
var from = __webpack_require__(572);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(142);
var getWeak = __webpack_require__(122).getWeak;
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var anInstance = __webpack_require__(136);
var forOf = __webpack_require__(137);
var createArrayMethod = __webpack_require__(92);
var $has = __webpack_require__(70);
var validate = __webpack_require__(146);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(265);
var isObject = __webpack_require__(20);
var toLength = __webpack_require__(29);
var ctx = __webpack_require__(80);
var IS_CONCAT_SPREADABLE = __webpack_require__(28)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(31) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(364)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 580 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(373);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 586 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(31);
var getKeys = __webpack_require__(140);
var gOPS = __webpack_require__(269);
var pIE = __webpack_require__(224);
var toObject = __webpack_require__(35);
var IObject = __webpack_require__(223);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var anObject = __webpack_require__(10);
var getKeys = __webpack_require__(140);

module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(73);
var gOPN = __webpack_require__(139).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(70);
var toIObject = __webpack_require__(73);
var arrayIndexOf = __webpack_require__(262)(false);
var IE_PROTO = __webpack_require__(378)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(31);
var getKeys = __webpack_require__(140);
var toIObject = __webpack_require__(73);
var isEnum = __webpack_require__(224).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(139);
var gOPS = __webpack_require__(269);
var anObject = __webpack_require__(10);
var Reflect = __webpack_require__(15).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(15).parseFloat;
var $trim = __webpack_require__(180).trim;

module.exports = 1 / $parseFloat(__webpack_require__(381) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(15).parseInt;
var $trim = __webpack_require__(180).trim;
var ws = __webpack_require__(381);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(375);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 597 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(29);
var repeat = __webpack_require__(380);
var defined = __webpack_require__(93);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(29);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(575);
var validate = __webpack_require__(146);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(263)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(376);
__webpack_require__(4)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(31) && /./g.flags != 'g') __webpack_require__(33).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(222)
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(575);
var validate = __webpack_require__(146);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(263)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var each = __webpack_require__(92)(0);
var redefine = __webpack_require__(64);
var meta = __webpack_require__(122);
var assign = __webpack_require__(587);
var weak = __webpack_require__(577);
var isObject = __webpack_require__(20);
var validate = __webpack_require__(146);
var NATIVE_WEAK_MAP = __webpack_require__(146);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(263)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157),
    root = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(45);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157),
    root = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(440),
    isArguments = __webpack_require__(199),
    isArray = __webpack_require__(16),
    isBuffer = __webpack_require__(158),
    isIndex = __webpack_require__(128),
    isTypedArray = __webpack_require__(200);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(692);

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

module.exports = arraySample;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    eq = __webpack_require__(86);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var get = __webpack_require__(458);

/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : get(object, paths[index]);
  }
  return result;
}

module.exports = baseAt;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

module.exports = baseConformsTo;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(429),
    createBaseEach = __webpack_require__(708);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

module.exports = baseEachRight;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(126);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(709);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(233),
    isArray = __webpack_require__(16);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 683 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(115),
    isMasked = __webpack_require__(1778),
    isObject = __webpack_require__(39),
    toSource = __webpack_require__(739);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(126),
    isArrayLike = __webpack_require__(56);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(432),
    getMatchData = __webpack_require__(451),
    matchesStrictComparable = __webpack_require__(728);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(297),
    get = __webpack_require__(458),
    hasIn = __webpack_require__(459),
    isKey = __webpack_require__(453),
    isStrictComparable = __webpack_require__(727),
    matchesStrictComparable = __webpack_require__(728),
    toKey = __webpack_require__(100);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var isIndex = __webpack_require__(128);

/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return isIndex(n, length) ? array[n] : undefined;
}

module.exports = baseNth;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseGet = __webpack_require__(153),
    baseIteratee = __webpack_require__(13),
    baseMap = __webpack_require__(685),
    baseSortBy = __webpack_require__(1741),
    baseUnary = __webpack_require__(84),
    compareMultiple = __webpack_require__(1746),
    identity = __webpack_require__(114),
    isArray = __webpack_require__(16);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153),
    baseSet = __webpack_require__(236),
    castPath = __webpack_require__(127);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(441),
    isIndex = __webpack_require__(128);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 693 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 694 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(114),
    metaMap = __webpack_require__(729);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(86);

/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

module.exports = baseSortedUniq;


/***/ }),
/* 697 */,
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153),
    baseSet = __webpack_require__(236);

/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return baseSet(object, path, updater(baseGet(object, path)), customizer);
}

module.exports = baseUpdate;


/***/ }),
/* 699 */
/***/ (function(module, exports) {

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

module.exports = baseZipObject;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(192);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(192);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(45);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(445);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(116);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 705 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(45);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(56);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(155),
    hasUnicode = __webpack_require__(195),
    stringToArray = __webpack_require__(129),
    toString = __webpack_require__(25);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    isArrayLike = __webpack_require__(56),
    keys = __webpack_require__(46);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(423),
    flatRest = __webpack_require__(156),
    getData = __webpack_require__(449),
    getFuncName = __webpack_require__(722),
    isArray = __webpack_require__(16),
    isLaziable = __webpack_require__(726);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(705),
    composeArgsRight = __webpack_require__(706),
    countHolders = __webpack_require__(1749),
    createCtor = __webpack_require__(302),
    createRecurry = __webpack_require__(716),
    getHolder = __webpack_require__(450),
    reorder = __webpack_require__(1798),
    replaceHolders = __webpack_require__(307),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(1721);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1735),
    isIterateeCall = __webpack_require__(66),
    toFinite = __webpack_require__(465);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(726),
    setData = __webpack_require__(735),
    setWrapToString = __webpack_require__(736);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(1742),
    getTag = __webpack_require__(113),
    mapToArray = __webpack_require__(454),
    setToPairs = __webpack_require__(1801);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(291),
    arraySome = __webpack_require__(427),
    cacheHas = __webpack_require__(300);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 720 */,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(682),
    getSymbols = __webpack_require__(452),
    keys = __webpack_require__(46);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1797);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(233),
    getPrototype = __webpack_require__(305),
    getSymbols = __webpack_require__(452),
    stubArray = __webpack_require__(463);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    isArguments = __webpack_require__(199),
    isArray = __webpack_require__(16),
    isIndex = __webpack_require__(128),
    isLength = __webpack_require__(310),
    toKey = __webpack_require__(100);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(191),
    getPrototype = __webpack_require__(305),
    isPrototype = __webpack_require__(237);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(422),
    getData = __webpack_require__(449),
    getFuncName = __webpack_require__(722),
    lodash = __webpack_require__(2011);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(39);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 728 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(669);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153),
    baseSlice = __webpack_require__(83);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(695),
    shortOut = __webpack_require__(737);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1765),
    insertWrapDetails = __webpack_require__(1774),
    setToString = __webpack_require__(455),
    updateWrapDetails = __webpack_require__(1813);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1790);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 739 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 740 */,
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'chunk': __webpack_require__(1822),
  'compact': __webpack_require__(1827),
  'concat': __webpack_require__(1828),
  'difference': __webpack_require__(1838),
  'differenceBy': __webpack_require__(1839),
  'differenceWith': __webpack_require__(1840),
  'drop': __webpack_require__(1841),
  'dropRight': __webpack_require__(1842),
  'dropRightWhile': __webpack_require__(1843),
  'dropWhile': __webpack_require__(1844),
  'fill': __webpack_require__(1854),
  'findIndex': __webpack_require__(747),
  'findLastIndex': __webpack_require__(748),
  'first': __webpack_require__(1860),
  'flatten': __webpack_require__(749),
  'flattenDeep': __webpack_require__(1864),
  'flattenDepth': __webpack_require__(1865),
  'fromPairs': __webpack_require__(1872),
  'head': __webpack_require__(752),
  'indexOf': __webpack_require__(1880),
  'initial': __webpack_require__(1881),
  'intersection': __webpack_require__(1882),
  'intersectionBy': __webpack_require__(1883),
  'intersectionWith': __webpack_require__(1884),
  'join': __webpack_require__(1908),
  'last': __webpack_require__(87),
  'lastIndexOf': __webpack_require__(1911),
  'nth': __webpack_require__(1926),
  'pull': __webpack_require__(1941),
  'pullAll': __webpack_require__(761),
  'pullAllBy': __webpack_require__(1942),
  'pullAllWith': __webpack_require__(1943),
  'pullAt': __webpack_require__(1944),
  'remove': __webpack_require__(1950),
  'reverse': __webpack_require__(1954),
  'slice': __webpack_require__(1961),
  'sortedIndex': __webpack_require__(1965),
  'sortedIndexBy': __webpack_require__(1966),
  'sortedIndexOf': __webpack_require__(1967),
  'sortedLastIndex': __webpack_require__(1968),
  'sortedLastIndexBy': __webpack_require__(1969),
  'sortedLastIndexOf': __webpack_require__(1970),
  'sortedUniq': __webpack_require__(1971),
  'sortedUniqBy': __webpack_require__(1972),
  'tail': __webpack_require__(1979),
  'take': __webpack_require__(1980),
  'takeRight': __webpack_require__(1981),
  'takeRightWhile': __webpack_require__(1982),
  'takeWhile': __webpack_require__(1983),
  'union': __webpack_require__(1997),
  'unionBy': __webpack_require__(1998),
  'unionWith': __webpack_require__(1999),
  'uniq': __webpack_require__(2000),
  'uniqBy': __webpack_require__(2001),
  'uniqWith': __webpack_require__(2002),
  'unzip': __webpack_require__(466),
  'unzipWith': __webpack_require__(768),
  'without': __webpack_require__(2010),
  'xor': __webpack_require__(2012),
  'xorBy': __webpack_require__(2013),
  'xorWith': __webpack_require__(2014),
  'zip': __webpack_require__(2015),
  'zipObject': __webpack_require__(2016),
  'zipObjectDeep': __webpack_require__(2017),
  'zipWith': __webpack_require__(2018)
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    createAssigner = __webpack_require__(193),
    keysIn = __webpack_require__(58);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function(object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    baseRest = __webpack_require__(22),
    isError = __webpack_require__(460);

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function(func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

module.exports = attempt;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25),
    upperFirst = __webpack_require__(467);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(1758),
    toString = __webpack_require__(25);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var escapeHtmlChar = __webpack_require__(1761),
    toString = __webpack_require__(25);

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(295),
    baseIteratee = __webpack_require__(13),
    toInteger = __webpack_require__(21);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(295),
    baseIteratee = __webpack_require__(13),
    toInteger = __webpack_require__(21);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = fromIndex < 0
      ? nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
}

module.exports = findLastIndex;


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    baseEach = __webpack_require__(126),
    castFunction = __webpack_require__(112),
    isArray = __webpack_require__(16);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEachRight = __webpack_require__(1705),
    baseEachRight = __webpack_require__(678),
    castFunction = __webpack_require__(112),
    isArray = __webpack_require__(16);

/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = isArray(collection) ? arrayEachRight : baseEachRight;
  return func(collection, castFunction(iteratee));
}

module.exports = forEachRight;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21);

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

module.exports = isInteger;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1726),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1728),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(435),
    createAssigner = __webpack_require__(193);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIteratee = __webpack_require__(13),
    basePickBy = __webpack_require__(690),
    getAllKeysIn = __webpack_require__(448);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(436),
    basePropertyDeep = __webpack_require__(1734),
    isKey = __webpack_require__(453),
    toKey = __webpack_require__(100);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(438);

/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values)
    : array;
}

module.exports = pullAll;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(746),
    reEscape = __webpack_require__(1795),
    reEvaluate = __webpack_require__(1796),
    reInterpolate = __webpack_require__(733);

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape }
  }
};

module.exports = templateSettings;


/***/ }),
/* 763 */,
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    toInteger = __webpack_require__(21);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
}

module.exports = toLength;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(717),
    keys = __webpack_require__(46);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(717),
    keysIn = __webpack_require__(58);

/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = createToPairs(keysIn);

module.exports = toPairsIn;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    keysIn = __webpack_require__(58);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    arrayMap = __webpack_require__(36),
    unzip = __webpack_require__(466);

/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = unzip(array);
  if (iteratee == null) {
    return result;
  }
  return arrayMap(result, function(group) {
    return apply(iteratee, undefined, group);
  });
}

module.exports = unzipWith;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(1711),
    hasUnicodeWord = __webpack_require__(1766),
    toString = __webpack_require__(25),
    unicodeWords = __webpack_require__(1812);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(23);

var _Root = __webpack_require__(1134);

var _Root2 = _interopRequireDefault(_Root);

__webpack_require__(1510);

var _store = __webpack_require__(1187);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var store = _get__('configureStore')();

_get__('render')(_get__('React').createElement(_get__('Root'), { store: _get__('store') }), document.getElementById('app-container'));

// This is for react-hot-loader, (should) update changes on the fly
if (false) {
  module.hot.accept('./components/Root', function () {
    var NextRoot = require('./components/Root')['default']; // eslint-disable-line
    _get__('render')(_get__('React').createElement(NextRoot, { store: _get__('store') }), document.getElementById('app-container'));
  });
}

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'configureStore':
      return _store2['default'];

    case 'render':
      return _reactDom.render;

    case 'store':
      return store;

    case 'React':
      return _react2['default'];

    case 'Root':
      return _Root2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
exports['default'] = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(store, 'store', '/Users/hannum/work/sources/mbooking/src/frontend/src/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1436);

__webpack_require__(1189);

__webpack_require__(1197);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _axios = __webpack_require__(501);

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(117);

var _lodash2 = _interopRequireDefault(_lodash);

var _ClientStorage = __webpack_require__(351);

var _ClientStorage2 = _interopRequireDefault(_ClientStorage);

var _helpers = __webpack_require__(119);

var _constants = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var acuteTimeFormat = 'YYYY-MM-DD';
var hashedTokenHeaderName = 'X-UIDH';

var getHashedHeader = function () {
  function getHashedHeader(hashedApiToken) {
    return Object.assign({}, { headers: _defineProperty({}, _get__('hashedTokenHeaderName'), hashedApiToken) });
  }

  return getHashedHeader;
}();

var checkForError = function () {
  function checkForError(response) {
    // check for updates
    _get__('checkAppUpdate')(response);
    if (response.status < 200 || response.status >= 300) {
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    }
    return response;
  }

  return checkForError;
}();

var updateResolver = void 0;
var triggerAppUpdate = function () {
  function triggerAppUpdate() {
    if (_get__('ClientStorage').getAppBuildTimestamp() && !_get__('ClientStorage').isAppUpdateInProgress()) {
      _get__('ClientStorage').setAppUpdateInProgress();
      document.cookie = _get__('APP_UPDATE_COOKIE_NAME') + '=;expires=' + _get__('APP_UPDATE_EXPIRE_TIME') + ';';
      // release the semaphore
      _get__('ClientStorage').removeAppBuildTimestamp();
      // clear the app update timestamp
      _get__('ClientStorage').clearAppUpdateInProgress();
      _assign__('updateResolver', new Promise(function (resolve, reject) {
        console.log('>>updating...<<');
        // set a timeout
        resolve(true);
      }));
      // Force a reload
      _get__('updateResolver').then(function () {
        // Force a reload
        window.location.reload(true);
      });
    }
  }

  return triggerAppUpdate;
}();

// const getData = response => response.data;
var getData = function () {
  function getData(response) {
    console.log('Received', response.data);
    _get__('triggerAppUpdate')();
    return response.data || [];
  }

  return getData;
}();

var getTS = function () {
  function getTS() {
    return _get__('moment')().unix();
  }

  return getTS;
}();

var addTS = function () {
  function addTS(url) {
    var ts = _get__('getTS')();
    return url.indexOf('?') === -1 ? url + '?ts=' + ts : url + '&ts=' + ts;
  }

  return addTS;
}();

var checkUser = function () {
  function checkUser() {
    return _get__('axios').get(_get__('addTS')('/api/v1/account/ehr')).then(_get__('checkForError')).then(_get__('getData')).then(function (user) {
      if (!user || !user.sotu) {
        throw new Error('Invalid user data!');
      }
      return user;
    });
  }

  return checkUser;
}();

var applyAcuteStagingConfigToConfig = function () {
  function applyAcuteStagingConfigToConfig(config, stagingConfig) {
    var modifiedConfig = config;
    var configStr = JSON.stringify(config);

    // Replace group data if exists
    if (stagingConfig.groups) {
      Object.entries(stagingConfig.groups).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        console.log(key, value);
        configStr = configStr.replace(new RegExp(key, 'g'), value);
      });
      modifiedConfig = JSON.parse(configStr);
    }

    return modifiedConfig;
  }

  return applyAcuteStagingConfigToConfig;
}();

var requestOrganization = _get__('axios').get(_get__('addTS')('/api/v1/anonymous/organization')).then(_get__('checkForError')).then(_get__('getData'));

var addSelectedEmployer = function () {
  function addSelectedEmployer(employerId, originalUrl) {
    if (employerId) {
      return originalUrl.indexOf('?') === -1 ? originalUrl + '?employer=' + employerId : originalUrl + '&employer=' + employerId;
    }
    return '' + originalUrl;
  }

  return addSelectedEmployer;
}();

var requestAllNamespaces = function () {
  function requestAllNamespaces(language, namespaces, employerId) {
    return new Promise(function (resolve, reject) {
      _get__('axios').all(namespaces.map(
      // new proposed format:
      // namespace => axios.get(addTS(`/api/v1/anonymous/resource?file=i18n/${language}/${namespace}.json`))
      // previous format:
      // namespace => axios.get(addTS(addSelectedEmployer(employerId, `/api/v1/anonymous/resource/i18n/${language}/${namespace}.json`)))
      function (namespace) {
        return _get__('axios').get(_get__('addTS')(_get__('addSelectedEmployer')(employerId, '/api/v1/anonymous/resource?file=i18n/' + language + '/' + namespace + '.json'))).then(_get__('checkForError')).then(_get__('getData')).then(function (namespaceData) {
          return Object.assign({ namespaceName: namespace, namespaceData: namespaceData });
        });
      })).then(_get__('axios').spread(function () {
        for (var _len = arguments.length, localizations = Array(_len), _key = 0; _key < _len; _key++) {
          localizations[_key] = arguments[_key];
        }

        resolve(localizations);
      }))['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestAllNamespaces;
}();

var requestAllNamespacesForLanguage = function () {
  function requestAllNamespacesForLanguage(language, namespaces, employerId) {
    return new Promise(function (resolve, reject) {
      _get__('requestAllNamespaces')(language, namespaces, employerId).then(function (namespaceMap) {
        return Object.assign({ language: language, namespaceMap: namespaceMap });
      }).then(function (localizationsByLanguage) {
        resolve(localizationsByLanguage);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestAllNamespacesForLanguage;
}();

var requestAllByLanguages = function () {
  function requestAllByLanguages(languages, namespaces, employerId) {
    return new Promise(function (resolve, reject) {
      Promise.all(languages.map(function (language) {
        return _get__('requestAllNamespacesForLanguage')(language, namespaces, employerId);
      })).then(function (localizationsByLanguage) {
        resolve(localizationsByLanguage);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestAllByLanguages;
}();

var getHashedApiToken = function () {
  function getHashedApiToken() {
    return _get__('axios').get(_get__('addTS')('/api/v1/hashed/request')).then(_get__('checkForError')).then(_get__('getData'));
  }

  return getHashedApiToken;
}();

// generic function to fetch from a url with custom headers
var requestPromise = function () {
  function requestPromise(url, headers) {
    return _get__('axios').get(_get__('addTS')(url), headers);
  }

  return requestPromise;
}();

// resources are EHR professionals
var requestResources = function () {
  function requestResources() {
    return new Promise(function (resolve, reject) {
      _get__('requestPromise')('/api/v1/resources', {}).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        return _get__('trimResourceNames')(data);
      }).then(function (data) {
        resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestResources;
}();

var requestResourcesThroughHashedApi = function () {
  function requestResourcesThroughHashedApi() {
    return new Promise(function (resolve, reject) {
      _get__('getHashedApiToken')().then(function (hashedApiToken) {
        _get__('requestPromise')('/api/v1/hashed/resources', _get__('getHashedHeader')(hashedApiToken)).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
          resolve(_get__('trimResourceNames')(data));
        })['catch'](function (error) {
          reject(error);
        });
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestResourcesThroughHashedApi;
}();

var getRequestResourcesWrapper = function () {
  function getRequestResourcesWrapper(userIdentified) {
    if (userIdentified) {
      return _get__('requestResources')();
    }
    return _get__('requestResourcesThroughHashedApi')();
  }

  return getRequestResourcesWrapper;
}();

// units are sites or specific where they give consultation or an organization unit
var requestUnits = function () {
  function requestUnits(legalEntity) {
    return new Promise(function (resolve, reject) {
      var urlPrefix = '/api/v1/units';
      var legalEntityParam = legalEntity ? '?legalEntity=' + legalEntity : '';
      _get__('requestPromise')('' + urlPrefix + legalEntityParam, {}).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestUnits;
}();

var requestUnitsThroughHashedApi = function () {
  function requestUnitsThroughHashedApi(legalEntity) {
    return new Promise(function (resolve, reject) {
      var urlPrefix = '/api/v1/hashed/units';
      var legalEntityParam = legalEntity ? '?legalEntity=' + legalEntity : '';
      _get__('getHashedApiToken')().then(function (hashedApiToken) {
        _get__('requestPromise')('' + urlPrefix + legalEntityParam, _get__('getHashedHeader')(hashedApiToken)).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
          resolve(data);
        })['catch'](function (error) {
          reject(error);
        });
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestUnitsThroughHashedApi;
}();

var getRequestUnitsWrapper = function () {
  function getRequestUnitsWrapper(userIdentified, legalEntity) {
    if (userIdentified) {
      return _get__('requestUnits')(legalEntity);
    }
    return _get__('requestUnitsThroughHashedApi')(legalEntity);
  }

  return getRequestUnitsWrapper;
}();

// request notes is actually info about the unit like address phone number, etc
var requestUnitInfo = function () {
  function requestUnitInfo(unit) {
    return new Promise(function (resolve, reject) {
      _get__('requestPromise')('/api/v1' + unit + '/notes', {}).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestUnitInfo;
}();

var requestUnitInfoThroughHashedApi = function () {
  function requestUnitInfoThroughHashedApi(unit) {
    return new Promise(function (resolve, reject) {
      _get__('getHashedApiToken')().then(function (hashedApiToken) {
        _get__('requestPromise')('/api/v1/hashed' + unit + '/notes', _get__('getHashedHeader')(hashedApiToken)).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
          resolve(data);
        })['catch'](function (error) {
          reject(error);
        });
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestUnitInfoThroughHashedApi;
}();

/**
 * The following code shows a lack of knowledge on ES6 features.
 * The code can be simplified and structured to follow the promise and resolve approach.
 * It can also benefit from the use of reduce, Object.assign, spread and rest features.
 *
const requestGroups = login
.then(() => axios.get('/api/v1/groups'))
.then(checkForError)
.then(getData)
.then((groups) => {
  const groupsMap = Object.create(null);
  console.log('Adding groups', groups);
  return axios.all(
    groups.map(
      group => axios.get(`/api/v1/resources?group=${group.group}`)
      .then(checkForError)
      .then(getData)
      .then((groupResources) => {
        console.log('Adding group', group, groupResources, 'to', groupsMap);
        groupsMap[group.group] = {};
        groupResources.forEach((resource) => {
          groupsMap[group.group][resource.resource] = resource.name;
        });
        return groupResources;
      })
      .catch((error) => {
        console.error(error);
      })
    )
  )
  .then(() => (groupsMap))
  .then((gMap) => {
    console.log('Fetched all groups', gMap);
    return gMap;
  });
});
*/

/**
 *
 * @type {moment.Moment}
 */
var groupsRetrievedAt = null;

/**
 *
 * @type {Promise<unknown>}
 */
var groupsPromise = null;

/**
 *
 * @type {Promise<unknown>}
 */
var hashedGroupsPromise = null;

/**
 *
 * @returns {Promise<unknown>}
 */
var requestGroups = function () {
  function requestGroups() {
    // Groups are valid if we fetched within one hour.
    var areGroupsStillValid = _get__('groupsRetrievedAt') && _get__('groupsRetrievedAt').diff(_get__('moment')(), 'hours', true) < 1;
    if (_get__('hashedGroupsPromise') && areGroupsStillValid) {
      return _get__('hashedGroupsPromise');
    }
    if (_get__('groupsPromise') && areGroupsStillValid) {
      return _get__('groupsPromise');
    }
    // If we reach this point then we must fetch the groups again.
    _assign__('groupsRetrievedAt', _get__('moment')());
    _assign__('groupsPromise', new Promise(function (resolve, reject) {
      var groupsUrl = '/api/v1/groups';

      _get__('axios').get(_get__('addTS')(groupsUrl), { params: { includeResources: true } }).then(function (response) {
        resolve(response.data);
      })['catch'](function (error) {
        return reject(error);
      });
    }));
    return _get__('groupsPromise');
  }

  return requestGroups;
}();

/**
 * Request the tickets for the logged in user.
 * @returns {Promise<any>}
 */
var requestTickets = function () {
  function requestTickets() {
    return new Promise(function (resolve, reject) {
      _get__('axios').get(_get__('addTS')('/api/v1/ticket'), {}).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestTickets;
}();

/**
 * Request the reservations for the logged in user.
 * @param from
 * @param to
 * @returns {Promise<any>}
 */
var requestReservations = function () {
  function requestReservations(from, to) {
    return new Promise(function (resolve, reject) {
      var url = '/api/v1/reservations/all';
      if (from || to) {
        url = url + '?';
      }
      if (from) {
        url = url + 'from=' + from + '&';
      }
      if (to) {
        url = url + 'to=' + to + '&';
      }
      if (url.charAt(url.length - 1) === '&') {
        url = url.substr(0, url.length - 1);
      }
      _get__('axios').get(_get__('addTS')(url), {}).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestReservations;
}();

/**
 *
 * @returns {Promise<unknown>}
 */
var requestGroupsThroughHashedApi = function () {
  function requestGroupsThroughHashedApi() {
    // Groups are valid if we fetched within one hour.
    var areGroupsStillValid = _get__('groupsRetrievedAt') && _get__('groupsRetrievedAt').diff(_get__('moment')(), 'hours', true) < 1;
    if (_get__('groupsPromise') && areGroupsStillValid) {
      return _get__('groupsPromise');
    }
    if (_get__('hashedGroupsPromise') && areGroupsStillValid) {
      return _get__('hashedGroupsPromise');
    }
    // If we reach this point then we must fetch the groups again.
    _assign__('groupsRetrievedAt', _get__('moment')());
    _assign__('hashedGroupsPromise', new Promise(function (resolve, reject) {
      var groupsUrl = '/api/v1/hashed/groups';

      _get__('getHashedApiToken')().then(function (hashedApiToken) {
        _get__('axios').get(_get__('addTS')(groupsUrl), { params: { includeResources: true }, headers: _defineProperty({}, _get__('hashedTokenHeaderName'), hashedApiToken) }).then(function (response) {
          resolve(response.data);
        })['catch'](function (error) {
          return reject(error);
        });
      })['catch'](function (error) {
        reject(error);
      });
    }));
    return _get__('hashedGroupsPromise');
  }

  return requestGroupsThroughHashedApi;
}();

var requestDedicatedResources = function () {
  function requestDedicatedResources(orgId) {
    return new Promise(function (resolve, reject) {
      _get__('axios').get(_get__('addTS')('/api/v1/dedicated?orgId=' + orgId)).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        return resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return requestDedicatedResources;
}();

var getMunicipalities = function () {
  function getMunicipalities() {
    return new Promise(function (resolve, reject) {
      _get__('axios').get('/api/v1/anonymous/municipalities').then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
        return resolve(data);
      })['catch'](function (error) {
        reject(error);
      });
    });
  }

  return getMunicipalities;
}();

var getRequestGroupsWrapper = function () {
  function getRequestGroupsWrapper(userIdentified) {
    if (userIdentified) {
      return _get__('requestGroups')();
    }
    return _get__('requestGroupsThroughHashedApi')();
  }

  return getRequestGroupsWrapper;
}();

var getTimeSlotsPromise = function () {
  function getTimeSlotsPromise(url) {
    if (url.indexOf('hashed') > -1) {
      return _get__('getHashedApiToken')().then(function (hashedApiToken) {
        return _get__('requestPromise')(url, _get__('getHashedHeader')(hashedApiToken));
      });
    }
    return _get__('requestPromise')(url, {});
  }

  return getTimeSlotsPromise;
}();

var getTimeSlots = function () {
  function getTimeSlots(params) {
    console.log('Retrieving time slots', params);
    var _params$resources = params.resources,
        resources = _params$resources === undefined ? [{}] : _params$resources,
        _params$from = params.from,
        from = _params$from === undefined ? _get__('moment')() : _params$from,
        _params$to = params.to,
        to = _params$to === undefined ? _get__('moment')().endOf('month') : _params$to,
        responsibleResources = params.responsibleResources,
        company = params.company,
        userIdentified = params.userIdentified,
        canAnonymousFetchTimes = params.canAnonymousFetchTimes,
        legalEntity = params.legalEntity;

    var dedicatedResources = {};

    if (responsibleResources.resources) {
      dedicatedResources = responsibleResources.resources;
    } else {
      responsibleResources.forEach(function (resource) {
        dedicatedResources[resource.resource] = resource.name;
      });
    }

    var firstResource = resources.length ? resources[0] : {};
    var specialityParam = '';
    if (resources[0].speciality && Array.isArray(resources[0].speciality)) {
      specialityParam = resources[0].speciality.map(function (s) {
        return '&speciality=' + s;
      }).join('');
    } else if (resources[0].speciality) {
      specialityParam = '&speciality=' + resources[0].speciality;
    }
    // const specialityParam = resources[0].speciality ? `&speciality=${resources[0].speciality}` : '';
    // const resourceParam = resources[0].resource ? `&resource=${resources[0].resource}` : ''; // could be a list of resources
    var companyParam = company ? '&company=' + company : '';
    var homeUnitKey = params.homeUnitId ? '/units/' + params.homeUnitId : null;
    var includedUnitsResources = void 0;
    var excludedUnitsResources = void 0;
    var includedGroupsResources = void 0;
    var excludedGroupsResources = void 0;
    var includedResources = void 0;
    // If there are multiple groups, we would need to perform multiple requests.
    // We'll rather do the filtering ourselves.
    var groupParam = resources[0].inGroups && resources[0].inGroups.length === 1 && resources[0].inGroups[0] !== 'dedicated' && resources[0].inGroups[0] ? '&group=' + resources[0].inGroups[0] : '';
    var unitParam = resources[0].inUnits && resources[0].inUnits.length === 1 && resources[0].inUnits[0] !== 'dedicated' ? '&units=' + resources[0].inUnits[0] : '';
    var resourcesParam = resources[0].inResources ? '&' + resources[0].inResources.map(function (res) {
      return 'resources=' + res;
    }).join('&') : '';

    var windowFrom = from;
    var windowTo = to;
    if (params.fromTicketOpeningDate && params.toTicketClosingDate) {
      if (params.fromTicketOpeningDate.isAfter(from)) {
        windowFrom = params.fromTicketOpeningDate;
      }
      if (params.toTicketClosingDate.isBefore(to)) {
        windowTo = params.toTicketClosingDate;
      }
    }
    /** To show the first available time then use this if statement...
    if (windowFrom.isAfter(windowTo)) {
      windowTo = windowFrom;
    }
    */
    var urlPrefix = '/api/v1/timeslots';
    if (canAnonymousFetchTimes) {
      urlPrefix = '/api/v1/hashed/timeslots';
    }
    if (userIdentified && legalEntity) {
      urlPrefix = '/api/v1/timeslots/transformed';
    }
    var legalEntityParam = legalEntity ? '&legalEntity=' + legalEntity : '';
    return _get__('getTimeSlotsPromise')(urlPrefix + '?showTimes=true&from=' + windowFrom.format(_get__('acuteTimeFormat')) + '&to=' + windowTo.format(_get__('acuteTimeFormat')) + specialityParam + groupParam + unitParam + companyParam + resourcesParam + legalEntityParam).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
      var promises = [];
      console.log('Checking units', resources, data);
      if (firstResource.inUnits && firstResource.inUnits.length > 0) {
        includedUnitsResources = {};
        var matchingUnit = {};
        promises.push(_get__('getRequestUnitsWrapper')(userIdentified, legalEntity).then(function (fetchedUnits) {
          firstResource.inUnits.forEach(function (unit) {
            // movendos ticket may have dedicated units
            if (unit === 'dedicated' && responsibleResources.units) {
              responsibleResources.units.forEach(function (rUnit) {
                matchingUnit = _get__('_').find(fetchedUnits, { unit: rUnit });
                includedUnitsResources = _extends({}, includedUnitsResources, _defineProperty({}, rUnit, matchingUnit));
              });
            } else if (unit === 'dedicated' && params.homeUnitId) {
              matchingUnit = _get__('_').find(fetchedUnits, { unit: homeUnitKey });
              includedUnitsResources = _extends({}, includedUnitsResources, _defineProperty({}, homeUnitKey, matchingUnit));
            } else {
              matchingUnit = _get__('_').find(fetchedUnits, { unit: unit });
              includedUnitsResources = _extends({}, includedUnitsResources, _defineProperty({}, unit, matchingUnit));
            }
          });
        })['catch'](function (error) {
          return console.error(error);
        }));
      }
      if (firstResource.notInUnits && firstResource.notInUnits.length > 0) {
        excludedUnitsResources = {};
        var _matchingUnit = {};
        promises.push(_get__('getRequestUnitsWrapper')(userIdentified, legalEntity).then(function (fetchedUnits) {
          firstResource.notInUnits.forEach(function (unit) {
            _matchingUnit = _get__('_').find(fetchedUnits, { unit: unit });
            excludedUnitsResources = _extends({}, excludedUnitsResources, _defineProperty({}, unit, _matchingUnit));
          });
        })['catch'](function (error) {
          return console.error(error);
        }));
      }
      // Fetch groups, if necessary. Then filter based on results
      console.log('Checking groups', resources, data);
      if (firstResource.inGroups && (firstResource.inGroups.length > 1 || firstResource.inGroups.length === 1 && firstResource.inGroups[0] === 'dedicated')) {
        includedGroupsResources = {};
        promises.push(_get__('getRequestGroupsWrapper')(userIdentified).then(function (fetchedGroups) {
          firstResource.inGroups.forEach(function (group) {
            if (group === 'dedicated' && dedicatedResources) {
              includedGroupsResources = Object.assign({}, includedGroupsResources, dedicatedResources);
            } else {
              includedGroupsResources = Object.assign({}, includedGroupsResources, fetchedGroups[group]);
            }
          });
        })['catch'](function (error) {
          console.error(error);
        }));
      }
      if (firstResource.notInGroups && firstResource.notInGroups.length) {
        excludedGroupsResources = {};
        promises.push(_get__('getRequestGroupsWrapper')(userIdentified).then(function (fetchedGroups) {
          firstResource.notInGroups.forEach(function (group) {
            if (group === 'dedicated' && dedicatedResources) {
              excludedGroupsResources = Object.assign({}, excludedGroupsResources, dedicatedResources);
            } else {
              excludedGroupsResources = Object.assign({}, excludedGroupsResources, fetchedGroups[group]);
            }
          });
        })['catch'](function (error) {
          console.error(error);
        }));
      }
      // check for specific resources in the path
      console.log('Checking resources', resources, data);
      if (firstResource.inResources && firstResource.inResources.length > 0) {
        includedResources = {};
        promises.push(_get__('getRequestResourcesWrapper')(userIdentified).then(function (fetchedResources) {
          firstResource.inResources.forEach(function (resource) {
            var selectedResource = _get__('_').find(fetchedResources, { resource: resource });
            includedResources = _extends({}, includedResources, selectedResource && _defineProperty({}, selectedResource.resource, selectedResource));
          });
        })['catch'](function (error) {
          console.error(error);
        }));
      }
      return Promise.all(promises).then(function () {
        return data;
      });
    }).then(function (data) {
      console.log('Filtering for timeType, unit and group', data, includedUnitsResources, includedGroupsResources, excludedUnitsResources, excludedGroupsResources, includedResources);
      var typeDoesNotMatch = function () {
        function typeDoesNotMatch(resourceType, timeSlotType) {
          return resourceType && timeSlotType && timeSlotType.indexOf && timeSlotType !== resourceType && timeSlotType.indexOf(resourceType + '-') === -1;
        }

        return typeDoesNotMatch;
      }();
      var resourceTimeType = firstResource.timeType;
      var selected = data.filter(function (d) {
        // Let's assume the speciality mathes now, if specified
        // let's check for what's easily available
        var negativeTypeMatch = Array.isArray(resourceTimeType) ? resourceTimeType.every(function (timeType) {
          return typeDoesNotMatch(timeType, d.type);
        }) : typeDoesNotMatch(resourceTimeType, d.type);
        if (negativeTypeMatch) {
          // Allow for company-specific time types, for instance ACU-123456
          return false;
        }
        if (includedUnitsResources && !includedUnitsResources[d.unit]) {
          return false;
        }
        if (includedGroupsResources && !includedGroupsResources[d.resource]) {
          return false;
        }
        if (includedResources && !includedResources[d.resource]) {
          return false;
        }
        if (excludedUnitsResources && excludedUnitsResources[d.unit]) {
          return false;
        }
        if (excludedGroupsResources && excludedGroupsResources[d.resource]) {
          return false;
        }
        return true;
      });
      console.log('Filtered', includedUnitsResources, includedGroupsResources, includedResources, excludedGroupsResources, selected);
      var mappedByDate = Object.create(null);
      selected.forEach(function (resource) {
        var timesByDate = Object.create(null);
        resource.times.forEach(function (time) {
          // Using the same as in files using the data. Should use a constant!
          var day = _get__('moment')(time).format('YYYY-MM-DD');
          if (!timesByDate[day]) {
            timesByDate[day] = [];
          }
          timesByDate[day].push(time);
        });
        Object.keys(timesByDate).forEach(function (date) {
          var resourceCopy = Object.assign({}, resource);
          resourceCopy.times = timesByDate[date];
          if (!mappedByDate[date]) {
            mappedByDate[date] = [];
          }
          mappedByDate[date].push(resourceCopy);
        });
      });
      console.log('Filtered and mapped by date', mappedByDate);
      if (Object.keys(mappedByDate).length === 0) {
        // No data found
        mappedByDate['2017-01-01'] = [];
      }
      return mappedByDate;
    });
  }

  return getTimeSlots;
}();

// previous format:
// const rootPath = '/api/v1/anonymous/resource/root.json';
// const patchPath = '/api/v1/anonymous/resource/staging_config.json';
// new proposed format:
var rootPath = '/api/v1/anonymous/resource?file=root.json';
var patchPath = '/api/v1/anonymous/resource?file=staging_config.json';
var api = {
  loadRoot: function () {
    function loadRoot() {
      return _get__('axios').get(_get__('addTS')('' + _get__('rootPath'))).then(_get__('checkForError')).then(_get__('getData'));
    }

    return loadRoot;
  }(),
  // Because Acute staging (koeajo) configs are different (especially groups IDs) override defined parameters from production settings for staging
  loadPath: function () {
    function loadPath(root, employerId) {
      var env = "prod";
      return new Promise(function (resolve, reject) {
        _get__('axios').get(_get__('addTS')(_get__('addSelectedEmployer')(employerId, root.url))).then(_get__('checkForError')).then(_get__('getData')).then(function (config) {
          // dev and staging require fetching the additional configuration
          if (env === 'dev' || env === 'staging') {
            _get__('axios').get(_get__('addTS')('' + _get__('patchPath'))).then(function (response) {
              if (response.status === 404) {
                // S3 localization file does not exist => keep fully the local one
                response.data = {};
                return response;
              }
              if (response.status < 200 || response.status >= 300) {
                var error = new Error(response.statusText);
                error.response = response;
                reject(error);
              }
              return response;
            }).then(_get__('getData')).then(function (stagingConfig) {
              console.log('Acute staging config fetched: ', stagingConfig);
              resolve(_get__('applyAcuteStagingConfigToConfig')(config, stagingConfig));
            });
          } else {
            // for production there is no need to fetch and apply another configuration
            resolve(config);
          }
        });
      });
    }

    return loadPath;
  }(),
  checkUser: _get__('checkUser'),
  identifyUser: function () {
    function identifyUser(payload) {
      console.log(payload);
      var firstName = payload.firstName,
          lastName = payload.lastName,
          personId = payload.personId,
          requiresEmployer = payload.requiresEmployer;

      var data = 'firstName=' + encodeURIComponent(firstName) + '&lastName=' + encodeURIComponent(lastName) + '&sotu=' + encodeURIComponent(personId) + '&requiresEmployer=' + encodeURIComponent(requiresEmployer);
      return _get__('axios').post('/login', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(_get__('checkForError')).then(_get__('getData'));
    }

    return identifyUser;
  }(),
  registerUser: function () {
    function registerUser(jsonBody) {
      return new Promise(function (resolve, reject) {
        _get__('getHashedApiToken')().then(function (hashedApiToken) {
          _get__('axios').post('api/v1/hashed/registration', jsonBody, _get__('getHashedHeader')(hashedApiToken)).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
            resolve(data);
          })['catch'](function (error) {
            reject(error);
          });
        })['catch'](function (error) {
          reject(error);
        });
      });
    }

    return registerUser;
  }(),
  updateUser: function () {
    function updateUser(jsonBody) {
      return new Promise(function (resolve, reject) {
        _get__('axios').post('/api/v1/account/ehr', jsonBody).then(_get__('checkForError')).then(_get__('getData')).then(function (data) {
          resolve(data);
        })['catch'](function (error) {
          reject(error);
        });
      });
    }

    return updateUser;
  }(),
  requestAuthentication: function () {
    function requestAuthentication(method, createUserIfNotExists) {
      var jsonData = { method: method, createUserIfNotExists: createUserIfNotExists };
      return _get__('axios').post('/api/v1/anonymous/authenticate/external', jsonData).then(_get__('checkForError')).then(_get__('getData'));
    }

    return requestAuthentication;
  }(),
  requestOrganization: function () {
    function requestOrganization() {
      return _get__('requestOrganization');
    }

    return requestOrganization;
  }(),
  requestAllByLanguages: _get__('requestAllByLanguages'),
  requestResources: _get__('requestResources'),
  requestUnits: function () {
    function requestUnits(legalEntity) {
      return _get__('requestUnits')(legalEntity);
    }

    return requestUnits;
  }(),
  requestUnitInfo: _get__('requestUnitInfo'),
  requestGroups: _get__('requestGroups'),
  requestTimeSlots: function () {
    function requestTimeSlots(params) {
      return _get__('getTimeSlots')(params);
    }

    return requestTimeSlots;
  }(),
  requestTickets: _get__('requestTickets'),
  requestReservations: _get__('requestReservations'),
  storeReservation: function () {
    function storeReservation(params) {
      console.log('Making a reservation', params);
      return _get__('axios').post('/api/v1/reservations', params).then(_get__('checkForError')).then(_get__('getData'));
    }

    return storeReservation;
  }(),
  fetchReservation: function () {
    function fetchReservation(_ref4) {
      var reservationCode = _ref4.reservationCode;
      return _get__('axios').get(_get__('addTS')('/api/v1/reservations?code=' + reservationCode)).then(_get__('checkForError')).then(_get__('getData'));
    }

    return fetchReservation;
  }(),
  cancelReservation: function () {
    function cancelReservation(_ref5) {
      var reservationId = _ref5.reservationId;
      return _get__('axios')['delete']('/api/v1' + reservationId).then(_get__('checkForError')).then(_get__('getData'));
    }

    return cancelReservation;
  }(),
  checkSession: function () {
    function checkSession() {
      return Promise.resolve(true);
    }

    return checkSession;
  }(),
  /*
  checkSession: () => axios.head('/api/v1/groups')
  .then((response) => {
    if (response.status === 401) {
      // Only react to status if it is explicitly 401.
      // Other network errors may occur, and don't mean the session is expired.
      const error = new Error('Login expired!');
      error.response = response;
      throw error;
    }
    return response;
  }),
  */
  clearSession: function () {
    function clearSession() {
      return _get__('axios').post('/logout', {}, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }

    return clearSession;
  }(),
  requestResourcesThroughHashedApi: _get__('requestResourcesThroughHashedApi'),
  requestUnitsThroughHashedApi: function () {
    function requestUnitsThroughHashedApi(legalEntity) {
      return _get__('requestUnitsThroughHashedApi')(legalEntity);
    }

    return requestUnitsThroughHashedApi;
  }(),
  requestUnitInfoThroughHashedApi: _get__('requestUnitInfoThroughHashedApi'),
  requestGroupsThroughHashedApi: _get__('requestGroupsThroughHashedApi'),
  requestDedicatedResources: _get__('requestDedicatedResources'),
  getMunicipalities: _get__('getMunicipalities')
};

var _default = _get__('api');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'checkAppUpdate':
      return _helpers.checkAppUpdate;

    case 'ClientStorage':
      return _ClientStorage2['default'];

    case 'APP_UPDATE_COOKIE_NAME':
      return _constants.APP_UPDATE_COOKIE_NAME;

    case 'APP_UPDATE_EXPIRE_TIME':
      return _constants.APP_UPDATE_EXPIRE_TIME;

    case 'updateResolver':
      return updateResolver;

    case 'triggerAppUpdate':
      return triggerAppUpdate;

    case 'moment':
      return _moment2['default'];

    case 'getTS':
      return getTS;

    case 'axios':
      return _axios2['default'];

    case 'addTS':
      return addTS;

    case 'checkForError':
      return checkForError;

    case 'getData':
      return getData;

    case 'addSelectedEmployer':
      return addSelectedEmployer;

    case 'requestAllNamespaces':
      return requestAllNamespaces;

    case 'requestAllNamespacesForLanguage':
      return requestAllNamespacesForLanguage;

    case 'requestPromise':
      return requestPromise;

    case 'trimResourceNames':
      return _helpers.trimResourceNames;

    case 'getHashedApiToken':
      return getHashedApiToken;

    case 'getHashedHeader':
      return getHashedHeader;

    case 'requestResources':
      return requestResources;

    case 'requestResourcesThroughHashedApi':
      return requestResourcesThroughHashedApi;

    case 'requestUnits':
      return requestUnits;

    case 'requestUnitsThroughHashedApi':
      return requestUnitsThroughHashedApi;

    case 'groupsRetrievedAt':
      return groupsRetrievedAt;

    case 'hashedGroupsPromise':
      return hashedGroupsPromise;

    case 'groupsPromise':
      return groupsPromise;

    case 'requestGroups':
      return requestGroups;

    case 'requestGroupsThroughHashedApi':
      return requestGroupsThroughHashedApi;

    case 'getTimeSlotsPromise':
      return getTimeSlotsPromise;

    case 'acuteTimeFormat':
      return acuteTimeFormat;

    case 'getRequestUnitsWrapper':
      return getRequestUnitsWrapper;

    case '_':
      return _lodash2['default'];

    case 'getRequestGroupsWrapper':
      return getRequestGroupsWrapper;

    case 'getRequestResourcesWrapper':
      return getRequestResourcesWrapper;

    case 'rootPath':
      return rootPath;

    case 'patchPath':
      return patchPath;

    case 'applyAcuteStagingConfigToConfig':
      return applyAcuteStagingConfigToConfig;

    case 'checkUser':
      return checkUser;

    case 'requestOrganization':
      return requestOrganization;

    case 'requestAllByLanguages':
      return requestAllByLanguages;

    case 'requestUnitInfo':
      return requestUnitInfo;

    case 'getTimeSlots':
      return getTimeSlots;

    case 'requestTickets':
      return requestTickets;

    case 'requestReservations':
      return requestReservations;

    case 'requestUnitInfoThroughHashedApi':
      return requestUnitInfoThroughHashedApi;

    case 'requestDedicatedResources':
      return requestDedicatedResources;

    case 'getMunicipalities':
      return getMunicipalities;

    case 'api':
      return api;

    case 'hashedTokenHeaderName':
      return hashedTokenHeaderName;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case 'updateResolver':
      return updateResolver = _value;

    case 'groupsRetrievedAt':
      return groupsRetrievedAt = _value;

    case 'groupsPromise':
      return groupsPromise = _value;

    case 'hashedGroupsPromise':
      return hashedGroupsPromise = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof api === 'undefined' ? 'undefined' : _typeof(api);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(api, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(api)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(acuteTimeFormat, 'acuteTimeFormat', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(hashedTokenHeaderName, 'hashedTokenHeaderName', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getHashedHeader, 'getHashedHeader', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(checkForError, 'checkForError', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(updateResolver, 'updateResolver', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(triggerAppUpdate, 'triggerAppUpdate', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getData, 'getData', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getTS, 'getTS', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(addTS, 'addTS', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(checkUser, 'checkUser', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(applyAcuteStagingConfigToConfig, 'applyAcuteStagingConfigToConfig', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestOrganization, 'requestOrganization', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(addSelectedEmployer, 'addSelectedEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestAllNamespaces, 'requestAllNamespaces', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestAllNamespacesForLanguage, 'requestAllNamespacesForLanguage', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestAllByLanguages, 'requestAllByLanguages', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getHashedApiToken, 'getHashedApiToken', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestPromise, 'requestPromise', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestResources, 'requestResources', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestResourcesThroughHashedApi, 'requestResourcesThroughHashedApi', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getRequestResourcesWrapper, 'getRequestResourcesWrapper', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestUnits, 'requestUnits', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestUnitsThroughHashedApi, 'requestUnitsThroughHashedApi', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getRequestUnitsWrapper, 'getRequestUnitsWrapper', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestUnitInfo, 'requestUnitInfo', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestUnitInfoThroughHashedApi, 'requestUnitInfoThroughHashedApi', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(groupsRetrievedAt, 'groupsRetrievedAt', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(groupsPromise, 'groupsPromise', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(hashedGroupsPromise, 'hashedGroupsPromise', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestGroups, 'requestGroups', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestTickets, 'requestTickets', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestReservations, 'requestReservations', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestGroupsThroughHashedApi, 'requestGroupsThroughHashedApi', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(requestDedicatedResources, 'requestDedicatedResources', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getMunicipalities, 'getMunicipalities', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getRequestGroupsWrapper, 'getRequestGroupsWrapper', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getTimeSlotsPromise, 'getTimeSlotsPromise', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(getTimeSlots, 'getTimeSlots', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(rootPath, 'rootPath', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(patchPath, 'patchPath', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(api, 'api', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/api/api.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AdditionalDiscussionCheckbox = function () {
  function AdditionalDiscussionCheckbox(_ref) {
    var checked = _ref.checked,
        onChange = _ref.onChange,
        t = _ref.t;
    return _get__('React').createElement(
      _get__('Checkbox'),
      {
        className: 'text-center',
        checked: checked,
        onChange: onChange
      },
      t('additional_discussion_checkbox_label')
    );
  }

  return AdditionalDiscussionCheckbox;
}();

_get__('AdditionalDiscussionCheckbox').propTypes = {
  checked: _get__('PropTypes').bool,
  onChange: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('AdditionalDiscussionCheckbox').defaultProps = {
  checked: false
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('AdditionalDiscussionCheckbox'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'AdditionalDiscussionCheckbox':
      return AdditionalDiscussionCheckbox;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Checkbox':
      return _reactBootstrap.Checkbox;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AdditionalDiscussionCheckbox, 'AdditionalDiscussionCheckbox', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AdditionalDiscussionCheckbox/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/AdditionalDiscussionCheckbox/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _Navigation = __webpack_require__(1129);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _GoogleTagManager = __webpack_require__(1118);

var _GoogleTagManager2 = _interopRequireDefault(_GoogleTagManager);

var _constants = __webpack_require__(76);

var _Footer = __webpack_require__(1117);

var _Footer2 = _interopRequireDefault(_Footer);

__webpack_require__(1500);

var _CenteredImage = __webpack_require__(547);

var _CenteredImage2 = _interopRequireDefault(_CenteredImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_get__2) {
  _inherits(App, _get__2);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        // it is fine to load configurations here according to sources like https://daveceddia.com/where-fetch-data-redux/
        this.props.loadInitialState();
        this.props.loadConfiguration();
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var isLoading = this.props.fetchingReservation || this.props.cancellingReservation || this.props.currentlyIdentifying || this.props.currentlyRegistering || this.props.pathLoading || this.props.rootLoading || this.props.requestingTimeSlots || this.props.storingReservation || this.props.loadingLocalizations || this.props.historyInitialLoading || this.props.historyLoading || this.props.loadingStaticData || this.props.bankRedirectingInProcess || this.props.loadingConfiguration;
        var _props = this.props,
            googleAnalyticsTrackingId = _props.googleAnalyticsTrackingId,
            googleTagManagerId = _props.googleTagManagerId,
            t = _props.t;

        var loadingClass = isLoading ? 'loading' : '';
        var showAlert = this.props.sessionTimeout;

        document.title = t('title');
        var versionStr = t('footerVersion') + ': ' + _get__('version');
        return _get__('React').createElement(
          'div',
          { className: 'app' },
          _get__('React').createElement(
            'div',
            { className: 'app-loader ' + loadingClass },
            _get__('React').createElement(_get__('CenteredImage'), { containerHeight: '150px', containerWidth: '300px', src: this.props.organizationLogoUrl, className: 'animated infinite pulse position-loading-indicator' })
          ),
          showAlert && !this.props.userIdentified && _get__('React').createElement(
            _get__('Alert'),
            { bsStyle: 'warning', onDismiss: this.props.resetAppState },
            _get__('React').createElement(
              'strong',
              null,
              t('sessionExpiredTitle')
            ),
            ' ',
            t('sessionExpiredText')
          ),
          _get__('React').createElement(_get__('Navigation'), null),
          this.props.children,
          _get__('React').createElement(_get__('Footer'), { version: versionStr, provider: t('footerProvider') }),
          googleAnalyticsTrackingId.length > 0 && googleTagManagerId.length > 0 && _get__('React').createElement(_get__('GoogleTagManager'), { googleAnalyticsTrackingId: googleAnalyticsTrackingId, googleTagManagerId: googleTagManagerId })
        );
      }

      return render;
    }()
  }]);

  return App;
}(_get__('Component'));

_get__('App').propTypes = {
  children: _get__('PropTypes').node.isRequired,
  fetchingReservation: _get__('PropTypes').bool,
  cancellingReservation: _get__('PropTypes').bool,
  currentlyIdentifying: _get__('PropTypes').bool,
  currentlyRegistering: _get__('PropTypes').bool,
  userIdentified: _get__('PropTypes').bool,
  rootLoading: _get__('PropTypes').bool,
  pathLoading: _get__('PropTypes').bool,
  requestingTimeSlots: _get__('PropTypes').bool,
  storingReservation: _get__('PropTypes').bool,
  sessionTimeout: _get__('PropTypes').bool,
  resetAppState: _get__('PropTypes').func.isRequired,
  organizationLogoUrl: _get__('PropTypes').string,
  loadConfiguration: _get__('PropTypes').func.isRequired,
  loadingStaticData: _get__('PropTypes').bool.isRequired,
  bankRedirectingInProcess: _get__('PropTypes').bool.isRequired,
  loadingLocalizations: _get__('PropTypes').bool.isRequired,
  loadingConfiguration: _get__('PropTypes').bool.isRequired,
  googleAnalyticsTrackingId: _get__('PropTypes').string,
  googleTagManagerId: _get__('PropTypes').string,
  historyInitialLoading: _get__('PropTypes').bool.isRequired,
  historyLoading: _get__('PropTypes').bool.isRequired,
  loadInitialState: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('App').defaultProps = {
  fetchingReservation: false,
  cancellingReservation: false,
  currentlyIdentifying: false,
  currentlyRegistering: false,
  userIdentified: false,
  rootLoading: false,
  pathLoading: false,
  historyPreviousLoading: false,
  requestingTimeSlots: false,
  storingReservation: false,
  sessionTimeout: false,
  organizationLogoUrl: '',
  loadingLocalizations: true,
  googleAnalyticsTrackingId: '',
  googleTagManagerId: ''
};

var _DefaultExportValue = _get__('translate')(['common'])(_get__('App'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'version':
      return _constants.version;

    case 'Component':
      return _react.Component;

    case 'App':
      return App;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'CenteredImage':
      return _CenteredImage2['default'];

    case 'Alert':
      return _reactBootstrap.Alert;

    case 'Navigation':
      return _Navigation2['default'];

    case 'Footer':
      return _Footer2['default'];

    case 'GoogleTagManager':
      return _GoogleTagManager2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(App, 'App', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/App/App.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/App/App.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _App = __webpack_require__(1109);

var _App2 = _interopRequireDefault(_App);

var _booking = __webpack_require__(68);

var _session = __webpack_require__(42);

var _app = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      organizationName: state.organization.name,
      organizationLogoUrl: state.organization.logoUrl,
      userIdentified: state.session.userIdentified,
      currentlyRegistering: state.session.currentlyRegistering,
      fetchingReservation: state.cancelling.fetchingReservation,
      cancellingReservation: state.cancelling.cancellingReservation,
      currentlyIdentifying: state.session.currentlyIdentifying,
      rootLoading: state.booking.rootLoading,
      pathLoading: state.booking.pathLoading,
      requestingTimeSlots: state.booking.requestingTimeSlots,
      storingReservation: state.booking.storingReservation,
      sessionTimeout: state.session.sessionTimeout,
      loadingLocalizations: state.app.loadingLocalizations,
      loadingConfiguration: state.app.loadingConfiguration,
      googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId,
      googleTagManagerId: state.organization.googleTagManagerId,
      historyInitialLoading: state.history.historyInitialLoading,
      historyLoading: state.history.historyLoading,
      loadingStaticData: state.app.loadingStaticData,
      bankRedirectingInProcess: state.session.bankRedirectingInProcess
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      loadConfiguration: dispatch(_get__('loadConfiguration')),
      resetAppState: dispatch(_get__('restoreApp')),
      loadInitialState: dispatch(_get__('restoreStateAndSelectionHandler'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('App'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'loadConfiguration':
      return _app.loadConfiguration;

    case 'restoreApp':
      return _session.restoreApp;

    case 'restoreStateAndSelectionHandler':
      return _booking.restoreStateAndSelectionHandler;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'App':
      return _App2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/App/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/App/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/App/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(14);

var _ImageCenter = __webpack_require__(1119);

var _ImageCenter2 = _interopRequireDefault(_ImageCenter);

__webpack_require__(1501);

var _methods = __webpack_require__(1113);

var _methods2 = _interopRequireDefault(_methods);

var _banksImages = __webpack_require__(1112);

var _banksImages2 = _interopRequireDefault(_banksImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankSelection = function (_get__2) {
  _inherits(BankSelection, _get__2);

  function BankSelection(props) {
    _classCallCheck(this, BankSelection);

    var _this = _possibleConstructorReturn(this, (BankSelection.__proto__ || Object.getPrototypeOf(BankSelection)).call(this, props));

    _this.state = {
      selected: ''
    };
    return _this;
  }

  _createClass(BankSelection, [{
    key: 'getBankImage',
    value: function () {
      function getBankImage(logo) {
        return _get__('banksImages')[logo];
      }

      return getBankImage;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            onBackButtonClicked = _props.onBackButtonClicked,
            requestAuthentication = _props.requestAuthentication,
            showBackButton = _props.showBackButton,
            createUserIfNotExists = _props.createUserIfNotExists,
            t = _props.t;

        return _get__('React').createElement(
          'div',
          { className: 'bank-selection-view mContent' },
          _get__('React').createElement(
            'h1',
            { tabIndex: 0, id: 'bank-selection-title' },
            t('bankSelection.title')
          ),
          _get__('React').createElement(
            'div',
            { className: 'info' },
            t('bankSelection.text')
          ),
          _get__('React').createElement(
            'div',
            { className: 'bank-selection' },
            _get__('authenticationMethods').map(function (bank) {
              return _get__('React').createElement(
                _get__('Button'),
                { className: 'mButtonBank', active: _this2.state.selected === bank.id, key: bank.id, onClick: function () {
                    function onClick() {
                      requestAuthentication(bank.method, createUserIfNotExists);_this2.setState({ selected: bank.id });
                    }

                    return onClick;
                  }() },
                _get__('React').createElement(
                  'div',
                  { className: 'logo' },
                  _get__('React').createElement(_get__('ImageCenter'), { alt: 'bank-selection-image', url: _this2.getBankImage(bank.logo) })
                ),
                _get__('React').createElement(
                  'div',
                  null,
                  bank.name
                )
              );
            })
          ),
          showBackButton && _get__('React').createElement(
            'div',
            { className: 'back-button' },
            _get__('React').createElement(
              _get__('Button'),
              { onClick: onBackButtonClicked },
              t('bankSelection.backButton')
            )
          )
        );
      }

      return render;
    }()
  }]);

  return BankSelection;
}(_get__('Component'));

_get__('BankSelection').propTypes = {
  onBackButtonClicked: _get__('PropTypes').func,
  requestAuthentication: _get__('PropTypes').func.isRequired,
  showBackButton: _get__('PropTypes').bool,
  createUserIfNotExists: _get__('PropTypes').bool.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('BankSelection').defaultProps = {
  onBackButtonClicked: function () {
    function onBackButtonClicked() {}

    return onBackButtonClicked;
  }(),
  showBackButton: true
};

var _DefaultExportValue = _get__('translate')(['identification'])(_get__('BankSelection'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'banksImages':
      return _banksImages2['default'];

    case 'authenticationMethods':
      return _methods2['default'];

    case 'Component':
      return _react.Component;

    case 'BankSelection':
      return BankSelection;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'ImageCenter':
      return _ImageCenter2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BankSelection, 'BankSelection', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/BankSelection.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/BankSelection.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _aktia = __webpack_require__(1511);

var _aktia2 = _interopRequireDefault(_aktia);

var _nordea = __webpack_require__(1519);

var _nordea2 = _interopRequireDefault(_nordea);

var _alandsbanken = __webpack_require__(1512);

var _alandsbanken2 = _interopRequireDefault(_alandsbanken);

var _danskebank = __webpack_require__(1514);

var _danskebank2 = _interopRequireDefault(_danskebank);

var _handelsbanken = __webpack_require__(1517);

var _handelsbanken2 = _interopRequireDefault(_handelsbanken);

var _omasaastopankki = __webpack_require__(1520);

var _omasaastopankki2 = _interopRequireDefault(_omasaastopankki);

var _osuuspankki = __webpack_require__(1521);

var _osuuspankki2 = _interopRequireDefault(_osuuspankki);

var _poppankki = __webpack_require__(1522);

var _poppankki2 = _interopRequireDefault(_poppankki);

var _saastopankki = __webpack_require__(1524);

var _saastopankki2 = _interopRequireDefault(_saastopankki);

var _spankki = __webpack_require__(1526);

var _spankki2 = _interopRequireDefault(_spankki);

var _mobiilivarmenne = __webpack_require__(1518);

var _mobiilivarmenne2 = _interopRequireDefault(_mobiilivarmenne);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var banksImages = {
  aktia: _get__('aktiaImage'),
  nordea: _get__('nordeaImage'),
  alandsbanken: _get__('alandsbankenImage'),
  danskebank: _get__('danskebankImage'),
  handelsbanken: _get__('handelsbankenImage'),
  omasaastopankki: _get__('omasaastopankkiImage'),
  osuuspankki: _get__('osuuspankkiImage'),
  poppankki: _get__('poppankkiImage'),
  saastopankki: _get__('saastopankkiImage'),
  spankki: _get__('spankkiImage'),
  mobiilivarmenne: _get__('mobiilivarmenneImage')
};

var _default = _get__('banksImages');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'aktiaImage':
      return _aktia2['default'];

    case 'nordeaImage':
      return _nordea2['default'];

    case 'alandsbankenImage':
      return _alandsbanken2['default'];

    case 'danskebankImage':
      return _danskebank2['default'];

    case 'handelsbankenImage':
      return _handelsbanken2['default'];

    case 'omasaastopankkiImage':
      return _omasaastopankki2['default'];

    case 'osuuspankkiImage':
      return _osuuspankki2['default'];

    case 'poppankkiImage':
      return _poppankki2['default'];

    case 'saastopankkiImage':
      return _saastopankki2['default'];

    case 'spankkiImage':
      return _spankki2['default'];

    case 'mobiilivarmenneImage':
      return _mobiilivarmenne2['default'];

    case 'banksImages':
      return banksImages;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof banksImages === 'undefined' ? 'undefined' : _typeof(banksImages);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(banksImages, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(banksImages)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(banksImages, 'banksImages', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/banksImages.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/banksImages.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
var authenticationMethods = [{
  id: 1,
  method: 'mobiilivarmenne-ftn',
  name: 'Mobiilivarmenne',
  logo: 'mobiilivarmenne'
}, {
  id: 2,
  method: 'ftn-nordea-auth',
  name: 'Nordea',
  logo: 'nordea'
}, {
  id: 3,
  method: 'ftn-danskebank-auth',
  name: 'Danske Bank',
  logo: 'danskebank'
}, {
  id: 4,
  method: 'ftn-op-auth',
  name: 'Osuuspankki',
  logo: 'osuuspankki'
}, {
  id: 5,
  method: 'ftn-spankki-auth',
  name: 'S-Pankki',
  logo: 'spankki'
}, {
  id: 6,
  method: 'ftn-aktia-auth',
  name: 'Aktia',
  logo: 'aktia'
}, {
  id: 7,
  method: 'ftn-alandsbanken-auth',
  name: 'Ålandsbanken',
  logo: 'alandsbanken'
}, {
  id: 8,
  method: 'ftn-handelsbanken-auth',
  name: 'Handelsbanken',
  logo: 'handelsbanken'
}, {
  id: 9,
  method: 'ftn-omasp-auth',
  name: 'Oma Säästöpankki',
  logo: 'omasaastopankki'
}, {
  id: 10,
  method: 'ftn-sp-auth',
  name: 'Säästöpankki',
  logo: 'saastopankki'
}, {
  id: 11,
  method: 'ftn-pop-auth',
  name: 'POP Pankki',
  logo: 'poppankki'
}];

var _default = _get__('authenticationMethods');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'authenticationMethods':
      return authenticationMethods;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof authenticationMethods === 'undefined' ? 'undefined' : _typeof(authenticationMethods);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(authenticationMethods, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(authenticationMethods)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(authenticationMethods, 'authenticationMethods', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/methods.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BankSelection/methods.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingPhase = function (_get__2) {
  _inherits(BookingPhase, _get__2);

  function BookingPhase() {
    _classCallCheck(this, BookingPhase);

    return _possibleConstructorReturn(this, (BookingPhase.__proto__ || Object.getPrototypeOf(BookingPhase)).apply(this, arguments));
  }

  _createClass(BookingPhase, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            id = _props.id,
            title = _props.title,
            visible = _props.visible,
            available = _props.available,
            t = _props.t;

        var visibleClasses = visible ? 'in' : '';
        var availableClasses = available ? '' : 'disabled';

        return _get__('React').createElement(
          'footer',
          { id: id, className: 'booking-phase collapse ' + visibleClasses + ' ' + availableClasses },
          _get__('React').createElement(
            'h2',
            {
              tabIndex: 0,
              id: id + '-title',
              'aria-label': t('common:ariaLabels.footerLabel'),
              className: 'booking-phase-title'
            },
            title
          ),
          _get__('React').createElement('hr', null),
          _get__('React').createElement(
            'div',
            { className: 'booking-phase-content' },
            this.props.children
          )
        );
      }

      return render;
    }()
  }]);

  return BookingPhase;
}(_get__('Component'));

_get__('BookingPhase').propTypes = {
  id: _get__('PropTypes').string.isRequired,
  title: _get__('PropTypes').string.isRequired,
  visible: _get__('PropTypes').bool,
  available: _get__('PropTypes').bool,
  children: _get__('PropTypes').node,
  t: _get__('PropTypes').func.isRequired
};

_get__('BookingPhase').defaultProps = {
  visible: true,
  available: true,
  children: null
};

var _DefaultExportValue = _get__('translate')(['common', 'booking'])(_get__('BookingPhase'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'BookingPhase':
      return BookingPhase;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BookingPhase, 'BookingPhase', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BookingPhase/BookingPhase.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/BookingPhase/BookingPhase.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(14);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CodeForm = function (_get__2) {
  _inherits(CodeForm, _get__2);

  function CodeForm(props) {
    _classCallCheck(this, CodeForm);

    var _this = _possibleConstructorReturn(this, (CodeForm.__proto__ || Object.getPrototypeOf(CodeForm)).call(this, props));

    _this.setShowForm = _this.setShowForm.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      showForm: false,
      value: '',
      isValid: false
    };
    return _this;
  }

  _createClass(CodeForm, [{
    key: 'setShowForm',
    value: function () {
      function setShowForm(showForm) {
        var _this2 = this;

        this.setState({ showForm: showForm }, function () {
          _this2.props.onToggle(showForm);
          if (showForm) {
            _this2.codeInput.focus();
          }
        });
      }

      return setShowForm;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(event) {
        var value = event.target.value;
        var isValid = value.length > 0;
        this.setState({
          value: value,
          isValid: isValid
        });
      }

      return handleChange;
    }()
  }, {
    key: 'handleSubmit',
    value: function () {
      function handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.value);
      }

      return handleSubmit;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var t = this.props.t;

        var formHidden = this.state.showForm ? '' : 'hidden';
        return _get__('React').createElement(
          'div',
          { id: 'codeForm' },
          _get__('React').createElement(
            'p',
            { className: 'code-form-title text-center' },
            _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('codeForm.infoText') }),
            ' ',
            !this.state.showForm && _get__('React').createElement(
              _get__('Button'),
              {
                bsStyle: 'link',
                className: 'basic-action-link action-link-among-text',
                onClick: function () {
                  function onClick(e) {
                    _this3.setShowForm(true);
                  }

                  return onClick;
                }()
              },
              t('codeForm.showCodeInputLink')
            )
          ),
          _get__('React').createElement(
            'form',
            { className: 'code-form ' + formHidden, onSubmit: function () {
                function onSubmit(e) {
                  return _this3.handleSubmit(e);
                }

                return onSubmit;
              }() },
            _get__('React').createElement(
              'p',
              { className: 'form-input-group text-center' },
              _get__('React').createElement('input', {
                id: 'code',
                ref: function () {
                  function ref(input) {
                    _this3.codeInput = input;
                  }

                  return ref;
                }(),
                className: 'code-input ' + (this.state.isValid ? 'is-valid' : ''),
                type: 'text',
                placeholder: t('codeForm.codePlaceholder'),
                onChange: this.handleChange
              }),
              _get__('React').createElement(
                _get__('Button'),
                {
                  className: 'action-btn-small send-code-btn',
                  type: 'submit',
                  disabled: !this.state.isValid
                },
                t('codeForm.submitButtonText')
              )
            ),
            _get__('React').createElement(
              'p',
              null,
              _get__('React').createElement(
                _get__('Button'),
                {
                  bsStyle: 'link',
                  className: 'basic-action-link close-code-form-link center-block',
                  onClick: function () {
                    function onClick(e) {
                      _this3.setShowForm(false);
                    }

                    return onClick;
                  }()
                },
                t('codeForm.closeCodeInputLink')
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return CodeForm;
}(_get__('PureComponent'));

_get__('CodeForm').propTypes = {
  onToggle: _get__('PropTypes').func.isRequired,
  onSubmit: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('CodeForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'PureComponent':
      return _react.PureComponent;

    case 'CodeForm':
      return CodeForm;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'Button':
      return _reactBootstrap.Button;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CodeForm, 'CodeForm', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CodeForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/CodeForm/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(1498);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntlTelInput = __webpack_require__(337);

var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

var _reactI18next = __webpack_require__(11);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _object = __webpack_require__(313);

var _reactBootstrap = __webpack_require__(14);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

var _constants = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmTimeSlotForm = function (_get__2) {
  _inherits(ConfirmTimeSlotForm, _get__2);

  function ConfirmTimeSlotForm(props) {
    _classCallCheck(this, ConfirmTimeSlotForm);

    var _this = _possibleConstructorReturn(this, (ConfirmTimeSlotForm.__proto__ || Object.getPrototypeOf(ConfirmTimeSlotForm)).call(this, props));

    _this.handleFormInputChange = _this.handleFormInputChange.bind(_this);
    _this.handleConfirm = _this.handleConfirm.bind(_this);
    _this.handlePhoneInputChange = _this.handlePhoneInputChange.bind(_this);
    _this.handleEmailInputChange = _this.handleEmailInputChange.bind(_this);
    _this.validateFields = _this.validateFields.bind(_this);
    _this.emailConfirmationEnabled = _this.emailConfirmationEnabled;
    _this.smsConfirmationEnabled = _this.smsConfirmationEnabled;
    _this.state = {
      submitButtonDisabled: true,
      reasonText: '',
      phone: '',
      email: '',
      isReasonTextValid: false,
      isPhoneValid: false,
      isEmailValid: false,
      showPhoneValidation: false,
      showEmailValidation: false
    };
    return _this;
  }

  _createClass(ConfirmTimeSlotForm, [{
    key: 'isPhoneValid',
    value: function () {
      function isPhoneValid(phone) {
        var telUtils = window.intlTelInputUtils;

        var numberType = phone && telUtils.getNumberType(phone);
        var telUtilsValidation = phone && telUtils.isValidNumber(phone) && (numberType === telUtils.numberType.MOBILE || numberType === telUtils.numberType.FIXED_LINE_OR_MOBILE);
        var specialCase = phone && phone.replace(/\s/g, '').startsWith('+358299') && phone.replace(/\s/g, '').length > 9;
        return !!(!this.props.smsConfirmationEnabled || telUtilsValidation || specialCase);
      }

      return isPhoneValid;
    }()
  }, {
    key: 'isEmailValid',
    value: function () {
      function isEmailValid(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !!(!this.props.emailConfirmationEnabled || email && re.test(String(email).toLowerCase()));
      }

      return isEmailValid;
    }()
  }, {
    key: 'handlePhoneInputChange',
    value: function () {
      function handlePhoneInputChange(status, inputVal, countryData, number) {
        var fieldName = 'phone';
        var value = number.replace(/\s/g, '');
        this.setState(_defineProperty({}, fieldName, value), this.validateFields);

        var isPhoneValid = this.isPhoneValid(number);
        var showPhoneValidation = !isPhoneValid && inputVal.length > 0;
        this.setState({ showPhoneValidation: showPhoneValidation });
      }

      return handlePhoneInputChange;
    }()
  }, {
    key: 'handleFormInputChange',
    value: function () {
      function handleFormInputChange(event) {
        var _event$target = event.target,
            fieldName = _event$target.id,
            value = _event$target.value;

        this.setState(_defineProperty({}, fieldName, value), this.validateFields);
      }

      return handleFormInputChange;
    }()
  }, {
    key: 'handleEmailInputChange',
    value: function () {
      function handleEmailInputChange(event) {
        var _event$target2 = event.target,
            fieldName = _event$target2.id,
            value = _event$target2.value;

        var isEmailValid = this.isEmailValid(value);
        var showEmailValidation = !isEmailValid && value.length > 0;
        this.setState({ showEmailValidation: showEmailValidation });
        this.setState(_defineProperty({}, fieldName, value), this.validateFields);
      }

      return handleEmailInputChange;
    }()
  }, {
    key: 'handleConfirm',
    value: function () {
      function handleConfirm() {
        // prevent multiple clicks
        this.state.submitButtonDisabled = true;
        var formValues = _get__('pick')(this.state, ['reasonText', 'phone', 'email']);
        this.props.onConfirm(this.props.timeSlot, formValues);
      }

      return handleConfirm;
    }()
  }, {
    key: 'isEmptyField',
    value: function () {
      function isEmptyField(string) {
        return !string || string.trim() === '';
      }

      return isEmptyField;
    }()
  }, {
    key: 'validateFields',
    value: function () {
      function validateFields() {
        // TODO: Validations.
        var _state = this.state,
            reasonText = _state.reasonText,
            phone = _state.phone,
            email = _state.email;
        var _props = this.props,
            optionalReservationText = _props.optionalReservationText,
            smsConfirmationEnabled = _props.smsConfirmationEnabled,
            emailConfirmationEnabled = _props.emailConfirmationEnabled;

        var isReasonTextValid = optionalReservationText || reasonText.length > 0;
        var isPhoneValid = this.isPhoneValid(phone);
        var isEmailValid = this.isEmailValid(email);
        var submitButtonDisabled = true;

        // validate with OR logic but check is there validation errors if both fields used
        if (smsConfirmationEnabled && emailConfirmationEnabled) {
          // either phone or email are valid, if both field are filled, then both should be valid
          var emailIsValidOrEmpty = this.isEmptyField(email) || isEmailValid;
          var phoneIsValidOrEmpty = this.isEmptyField(phone) || isPhoneValid;
          submitButtonDisabled = !isReasonTextValid || !(isPhoneValid && emailIsValidOrEmpty || isEmailValid && phoneIsValidOrEmpty);
        } else if (smsConfirmationEnabled && !emailConfirmationEnabled) {
          submitButtonDisabled = !isReasonTextValid || !isPhoneValid;
        } else if (!smsConfirmationEnabled && emailConfirmationEnabled) {
          submitButtonDisabled = !isReasonTextValid || !isEmailValid;
        } else if (!smsConfirmationEnabled && !emailConfirmationEnabled) {
          // phone and email are not shown, check reasonTextValidation only
          submitButtonDisabled = !isReasonTextValid;
        }

        this.setState({
          isReasonTextValid: isReasonTextValid,
          isPhoneValid: isPhoneValid,
          isEmailValid: isEmailValid,
          submitButtonDisabled: submitButtonDisabled
        });
      }

      return validateFields;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            t = _props2.t,
            optionalReservationText = _props2.optionalReservationText,
            smsConfirmationEnabled = _props2.smsConfirmationEnabled,
            emailConfirmationEnabled = _props2.emailConfirmationEnabled;

        var checkForPhone = this.state.isPhoneValid && smsConfirmationEnabled;
        var checkForEmail = this.state.isEmailValid && emailConfirmationEnabled;
        return _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(
            'form',
            { className: 'confirm-form', onSubmit: function () {
                function onSubmit(e) {
                  e.preventDefault();
                }

                return onSubmit;
              }() },
            _get__('React').createElement(
              _get__('Grid'),
              { fluid: true },
              _get__('React').createElement(
                _get__('Row'),
                null,
                _get__('React').createElement(
                  _get__('Col'),
                  { xs: 12, sm: 6, md: 6, lg: 6, className: 'reservation-reason-text-container' },
                  _get__('React').createElement(
                    'div',
                    null,
                    _get__('React').createElement(
                      'label',
                      { htmlFor: 'reasonText', className: optionalReservationText ? '' : 'is-required' },
                      t('confirmForm.reasonTextLabel', { maxLength: _get__('reservationReasonTextMaxLength') })
                    ),
                    _get__('React').createElement('textarea', {
                      id: 'reasonText',
                      className: 'reservation-reason ' + (!optionalReservationText && this.state.isReasonTextValid ? 'is-valid' : ''),
                      maxLength: _get__('reservationReasonTextMaxLength'),
                      rows: 2,
                      placeholder: t('confirmForm.reasonTextPlaceholder'),
                      onChange: this.handleFormInputChange
                    })
                  )
                ),
                _get__('React').createElement(
                  _get__('Col'),
                  { xs: 12, sm: 6, md: 6, lg: 6, className: 'reservation-phone-number-container' },
                  smsConfirmationEnabled && _get__('React').createElement(
                    'div',
                    null,
                    _get__('React').createElement(
                      'label',
                      { htmlFor: 'phone', className: 'is-required' },
                      t('confirmForm.phoneNumberLabel')
                    ),
                    _get__('React').createElement(_get__('IntlTelInput'), {
                      fieldId: 'visiblePhone',
                      numberType: 'MOBILE',
                      preferredCountries: ['fi', 'se', 'ee'],
                      style: { width: '100%' },
                      onPhoneNumberChange: this.handlePhoneInputChange,
                      onPhoneNumberBlur: this.handlePhoneInputChange,
                      useMobileFullscreenDropdown: false,
                      placeholder: t('confirmForm.phoneNumberPlaceholder'),
                      inputClassName: 'form-control ' + (this.state.isPhoneValid ? 'is-valid' : '')
                    })
                  ),
                  smsConfirmationEnabled && _get__('React').createElement(
                    'div',
                    { className: 'is-required ' + (this.state.showPhoneValidation && (this.state.phone.length > 5 || checkForEmail) ? '' : 'hidden') },
                    t('confirmForm.phoneNotValid')
                  ),
                  emailConfirmationEnabled && _get__('React').createElement(
                    'div',
                    { style: { marginTop: '1em' } },
                    _get__('React').createElement(
                      'label',
                      { className: 'is-required', htmlFor: 'email' },
                      t('reservationDone.emailLabel')
                    ),
                    _get__('React').createElement('input', {
                      id: 'email',
                      type: 'text',
                      placeholder: t('reservationDone.emailPlaceholder'),
                      onChange: this.handleEmailInputChange,
                      inputClassName: 'form-control ' + (this.state.isEmailValid ? 'is-valid' : '')
                    })
                  ),
                  emailConfirmationEnabled && _get__('React').createElement(
                    'div',
                    { className: 'is-required ' + (this.state.showEmailValidation && (this.state.email.length > 5 || checkForPhone) ? '' : 'hidden') },
                    t('confirmForm.emailNotValid')
                  )
                )
              ),
              !optionalReservationText && _get__('React').createElement(
                _get__('Row'),
                { className: '' + (this.state.isEmailValid || this.props.smsConfirmationEnabled ? 'hidden' : '') },
                _get__('React').createElement(
                  _get__('Col'),
                  { xs: 12, sm: 6, md: 6, lg: 6 },
                  _get__('React').createElement(
                    'p',
                    { className: 'is-required' },
                    t('requiredFieldInfo')
                  )
                ),
                _get__('React').createElement(
                  _get__('Col'),
                  { className: '' + (!this.state.isEmailValid && !this.props.smsConfirmationEnabled ? 'hidden' : ''), xs: 12, sm: 6, md: 6, lg: 6 },
                  _get__('React').createElement(
                    'p',
                    { className: 'is-required' },
                    t('requiredFieldInfo')
                  )
                )
              )
            )
          ),
          _get__('React').createElement(_get__('TimeSlotCard'), {
            large: true,
            disabled: this.state.submitButtonDisabled,
            timeSlot: this.props.timeSlot,
            unit: this.props.unit,
            onClick: this.handleConfirm,
            actionElement: _get__('React').createElement(
              'span',
              { className: 'time-slot-action-text' },
              t('confirmForm.confirm')
            )
          }),
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'basic-action-link cancel-confirm-link center-block',
              onClick: this.props.onCancel
            },
            t('confirmForm.cancel')
          )
        );
      }

      return render;
    }()
  }]);

  return ConfirmTimeSlotForm;
}(_get__('PureComponent'));

_get__('ConfirmTimeSlotForm').propTypes = {
  timeSlot: _get__('PropTypes').shape({
    timeMoment: _get__('PropTypes').instanceOf(_get__('moment')).isRequired,
    unit: _get__('PropTypes').string.isRequired,
    resourceName: _get__('PropTypes').string.isRequired,
    resourceType: _get__('PropTypes').string
  }).isRequired,
  onConfirm: _get__('PropTypes').func.isRequired,
  onCancel: _get__('PropTypes').func.isRequired,
  emailConfirmationEnabled: _get__('PropTypes').bool.isRequired,
  smsConfirmationEnabled: _get__('PropTypes').bool.isRequired,
  t: _get__('PropTypes').func.isRequired,
  unit: _get__('PropTypes').shape({
    name: _get__('PropTypes').string.isRequired,
    address: _get__('PropTypes').string.isRequired,
    info: _get__('PropTypes').string
  }).isRequired,
  optionalReservationText: _get__('PropTypes').bool.isRequired
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('ConfirmTimeSlotForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'pick':
      return _object.pick;

    case 'reservationReasonTextMaxLength':
      return _constants.reservationReasonTextMaxLength;

    case 'PureComponent':
      return _react.PureComponent;

    case 'ConfirmTimeSlotForm':
      return ConfirmTimeSlotForm;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'moment':
      return _moment2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'IntlTelInput':
      return _reactIntlTelInput2['default'];

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];

    case 'Button':
      return _reactBootstrap.Button;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ConfirmTimeSlotForm, 'ConfirmTimeSlotForm', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ConfirmTimeSlotForm/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ConfirmTimeSlotForm/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Footer = function () {
  function Footer(_ref) {
    var version = _ref.version,
        provider = _ref.provider;
    return _get__('React').createElement(
      'footer',
      { className: 'footer' },
      _get__('React').createElement(
        'span',
        { className: 'footer-version' },
        version
      ),
      _get__('React').createElement(
        'span',
        { className: 'footer-provider' },
        provider
      )
    );
  }

  return Footer;
}();

_get__('Footer').propTypes = {
  version: _get__('PropTypes').string.isRequired,
  provider: _get__('PropTypes').string.isRequired
};

var _default = _get__('Footer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Footer':
      return Footer;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof Footer === 'undefined' ? 'undefined' : _typeof(Footer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(Footer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Footer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Footer, 'Footer', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Footer.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Footer.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactGoogleTagManager = __webpack_require__(507);

var _reactGoogleTagManager2 = _interopRequireDefault(_reactGoogleTagManager);

var _reactGa = __webpack_require__(336);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-eval: 0 */


var GoogleTagManager = function (_get__$Component) {
  _inherits(GoogleTagManager, _get__$Component);

  function GoogleTagManager() {
    _classCallCheck(this, GoogleTagManager);

    return _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).apply(this, arguments));
  }

  _createClass(GoogleTagManager, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var dataLayerName = this.props.dataLayerName || 'dataLayer';
        var scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

        if (!window[dataLayerName]) {
          var gtmScriptNode = document.getElementById(scriptId);
          eval(gtmScriptNode.textContent);
          var script = document.createElement('script');
          var _props$googleAnalytic = this.props.googleAnalyticsTrackingId,
              googleAnalyticsTrackingId = _props$googleAnalytic.googleAnalyticsTrackingId,
              googleTagManagerId = _props$googleAnalytic.googleTagManagerId;

          script.src = 'https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsTrackingId;
          script.async = true;
          gtmScriptNode.appendChild(script);
          _get__('ReactGA').initialize(googleAnalyticsTrackingId, {
            titleCase: false,
            gaOptions: {
              allowLinker: true
            }
          });
          _get__('ReactGA').pageview(window.location.pathname);
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            dataLayerName = _props.dataLayerName,
            additionalEvents = _props.additionalEvents,
            previewVariables = _props.previewVariables,
            googleTagManagerId = _props.googleTagManagerId;

        var gtm = _get__('gtmParts')({
          id: googleTagManagerId,
          dataLayerName: dataLayerName,
          additionalEvents: additionalEvents,
          previewVariables: previewVariables
        });

        return _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(
            'div',
            null,
            gtm.noScriptAsReact()
          ),
          _get__('React').createElement(
            'div',
            { id: this.props.scriptId || 'react-google-tag-manager-gtm' },
            gtm.scriptAsReact()
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleTagManager;
}(_get__('React').Component);

_get__('GoogleTagManager').propTypes = {
  googleAnalyticsTrackingId: _get__('PropTypes').string.isRequired,
  googleTagManagerId: _get__('PropTypes').string.isRequired,
  dataLayerName: _get__('PropTypes').string,
  additionalEvents: _get__('PropTypes').object,
  previewVariables: _get__('PropTypes').bool,
  scriptId: _get__('PropTypes').string
};

_get__('GoogleTagManager').defaultProps = {
  dataLayerName: 'dataLayer',
  additionalEvents: {},
  previewVariables: false,
  scriptId: 'react-google-tag-manager-gtm'
};

var _default = _get__('GoogleTagManager');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ReactGA':
      return _reactGa2['default'];

    case 'gtmParts':
      return _reactGoogleTagManager2['default'];

    case 'React':
      return _react2['default'];

    case 'GoogleTagManager':
      return GoogleTagManager;

    case 'PropTypes':
      return _propTypes2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof GoogleTagManager === 'undefined' ? 'undefined' : _typeof(GoogleTagManager);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(GoogleTagManager, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(GoogleTagManager)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(GoogleTagManager, 'GoogleTagManager', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/GoogleTagManager/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/GoogleTagManager/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(1502);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * The only true button.
 */
var ImageCenter = function () {
  function ImageCenter(_ref) {
    var url = _ref.url,
        _ref$align = _ref.align,
        align = _ref$align === undefined ? '' : _ref$align,
        alt = _ref.alt;
    return _get__('React').createElement(
      'div',
      { className: 'component-image-center ' + align },
      _get__('React').createElement('img', { src: url, alt: alt })
    );
  }

  return ImageCenter;
}();

_get__('ImageCenter').propTypes = {
  url: _get__('PropTypes').string.isRequired,
  align: _get__('PropTypes').string,
  alt: _get__('PropTypes').string
};

_get__('ImageCenter').defaultProps = {
  align: '',
  alt: ''
};

var _default = _get__('ImageCenter');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ImageCenter':
      return ImageCenter;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof ImageCenter === 'undefined' ? 'undefined' : _typeof(ImageCenter);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(ImageCenter, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ImageCenter)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ImageCenter, 'ImageCenter', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ImageCenter/ImageCenter.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ImageCenter/ImageCenter.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingError = function (_get__2) {
  _inherits(LoadingError, _get__2);

  function LoadingError(props) {
    _classCallCheck(this, LoadingError);

    var _this = _possibleConstructorReturn(this, (LoadingError.__proto__ || Object.getPrototypeOf(LoadingError)).call(this, props));

    _this.onCloseErrorModal = _this.onCloseErrorModal.bind(_this);
    return _this;
  }

  _createClass(LoadingError, [{
    key: 'onCloseErrorModal',
    value: function () {
      function onCloseErrorModal() {
        window.location.href = '/ajanvaraus';
      }

      return onCloseErrorModal;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        if (!this.props.rootLoaded) {
          return null;
        }
        var _props = this.props,
            routingParams = _props.routingParams,
            show = _props.show,
            t = _props.t;
        var location = routingParams.location;
        var query = location.query;

        var message = '';
        if (query.sso && query.code) {
          switch (query.code) {
            case 'signicatError':
              message = _get__('React').createElement(
                'strong',
                null,
                t('bankLoginError')
              );
              break;
            case 'platformError':
              message = _get__('React').createElement(
                'strong',
                null,
                t('platformError')
              );
              break;
            case 'USER_WITH_SOTU_NOT_FOUND':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedUserWithSotuNotFound')
              );
              break;
            case 'MULTIPLE_USERS_WITH_SOTU':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedMultipleUsersWithSotu')
              );
              break;
            case 'ORGANIZATION_DOES_NOT_ALLOW_CLIENT_WITHOUT_EMPLOYER':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedOrganizationDoesNotAllowClientWithoutEmployer')
              );
              break;
            case 'USER_WITHOUT_CREDIT_CHECK':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedUserWithoutCreditCheck')
              );
              break;
            case 'PATH_REQUIRES_EMPLOYER_BUT_NOT_FOUND':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedPathRequiresEmployerButNotFound')
              );
              break;
            case 'USER_WITH_SOTU_NOT_FOUND_AND_FAKE_SOTU':
              message = _get__('React').createElement(
                'strong',
                null,
                t('loginFailedAndRegisterProhibited')
              );
              break;
            default:
              message = _get__('React').createElement(
                'strong',
                null,
                t('loadingAppError')
              );
              break;
          }
        } else if (query.sso) {
          message = _get__('React').createElement(
            'strong',
            null,
            t('ssoLoginError')
          );
        } else {
          message = _get__('React').createElement(
            'strong',
            null,
            t('loadingAppError')
          );
        }
        return _get__('React').createElement(
          _get__('Modal'),
          {
            className: 'error generic-error',
            show: show,
            backdrop: 'static',
            keyboard: false
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: this.onCloseErrorModal
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          _get__('React').createElement(
            _get__('ErrorMessage'),
            { isVisible: true },
            message
          )
        );
      }

      return render;
    }()
  }]);

  return LoadingError;
}(_get__('Component'));

_get__('LoadingError').propTypes = {
  routingParams: _get__('PropTypes').object.isRequired,
  show: _get__('PropTypes').bool.isRequired,
  rootLoaded: _get__('PropTypes').bool,
  t: _get__('PropTypes').func.isRequired
};

_get__('LoadingError').defaultProps = {
  show: true,
  rootLoaded: false
};

var _DefaultExportValue = _get__('translate')(['common'], { wait: true })(_get__('LoadingError'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'LoadingError':
      return LoadingError;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'Button':
      return _reactBootstrap.Button;

    case 'AppIcon':
      return _AppIcon2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoadingError, 'LoadingError', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoadingError/LoadingError.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoadingError/LoadingError.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _LoadingError = __webpack_require__(1120);

var _LoadingError2 = _interopRequireDefault(_LoadingError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      rootLoaded: state.booking.rootLoaded
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('LoadingError'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'LoadingError':
      return _LoadingError2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoadingError/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoadingError/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoadingError/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

__webpack_require__(1503);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginOnlyBySso = function (_get__2) {
  _inherits(LoginOnlyBySso, _get__2);

  function LoginOnlyBySso() {
    _classCallCheck(this, LoginOnlyBySso);

    return _possibleConstructorReturn(this, (LoginOnlyBySso.__proto__ || Object.getPrototypeOf(LoginOnlyBySso)).apply(this, arguments));
  }

  _createClass(LoginOnlyBySso, [{
    key: 'render',
    value: function () {
      function render() {
        var t = this.props.t;

        return _get__('React').createElement(
          'div',
          { className: 'login-only-by-sso-container' },
          _get__('React').createElement(
            _get__('Grid'),
            { fluid: true },
            _get__('React').createElement(
              _get__('Row'),
              null,
              _get__('React').createElement(
                _get__('Col'),
                { className: 'login-only-by-sso' },
                _get__('React').createElement(
                  'div',
                  null,
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('loginOnlyBySso.note') })
                )
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return LoginOnlyBySso;
}(_get__('Component'));

_get__('LoginOnlyBySso').propTypes = {
  t: _get__('PropTypes').func.isRequired
};

_get__('LoginOnlyBySso').defaultProps = {
  options: []
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('LoginOnlyBySso'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'LoginOnlyBySso':
      return LoginOnlyBySso;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoginOnlyBySso, 'LoginOnlyBySso', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoginOnlyBySso/LoginOnlyBySso.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoginOnlyBySso/LoginOnlyBySso.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _LoginOnlyBySso = __webpack_require__(1122);

var _LoginOnlyBySso2 = _interopRequireDefault(_LoginOnlyBySso);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('LoginOnlyBySso'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'LoginOnlyBySso':
      return _LoginOnlyBySso2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoginOnlyBySso/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoginOnlyBySso/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/LoginOnlyBySso/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactScroll = __webpack_require__(213);

var _reactI18next = __webpack_require__(11);

var _LanguageSelector = __webpack_require__(549);

var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);

var _constants = __webpack_require__(76);

var _IdentificationForm = __webpack_require__(253);

var _IdentificationForm2 = _interopRequireDefault(_IdentificationForm);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

var _index = __webpack_require__(350);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainLogin = function (_get__2) {
  _inherits(MainLogin, _get__2);

  function MainLogin(props) {
    _classCallCheck(this, MainLogin);

    var _this = _possibleConstructorReturn(this, (MainLogin.__proto__ || Object.getPrototypeOf(MainLogin)).call(this, props));

    _this.onManagementClicked = _this.onManagementClicked.bind(_this);
    _this.onPathClicked = _this.onPathClicked.bind(_this);
    _this.onBackButtonClicked = _this.onBackButtonClicked.bind(_this);
    _this.onLoginClicked = _this.onLoginClicked.bind(_this);
    _this.state = {
      bankLoginShow: false
    };
    return _this;
  }

  _createClass(MainLogin, [{
    key: 'onManagementClicked',
    value: function () {
      function onManagementClicked() {
        var _props = this.props,
            managementSelected = _props.managementSelected,
            setManagementOptionWithSinglePath = _props.setManagementOptionWithSinglePath,
            triggerInitialScroll = _props.triggerInitialScroll;

        if (managementSelected) {
          triggerInitialScroll(false);
          return;
        }
        setManagementOptionWithSinglePath();
      }

      return onManagementClicked;
    }()
  }, {
    key: 'onPathClicked',
    value: function () {
      function onPathClicked() {
        this.props.triggerInitialScroll(true);
      }

      return onPathClicked;
    }()
  }, {
    key: 'onBackButtonClicked',
    value: function () {
      function onBackButtonClicked() {
        this.setState({
          bankLoginShow: false
        });
      }

      return onBackButtonClicked;
    }()
  }, {
    key: 'onLoginClicked',
    value: function () {
      function onLoginClicked() {
        this.setState({
          bankLoginShow: true
        });
      }

      return onLoginClicked;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            showLoginForm = _props2.showLoginForm,
            uniquePath = _props2.uniquePath,
            languages = _props2.languages,
            userIdentified = _props2.userIdentified,
            fetchPathAfterLogin = _props2.fetchPathAfterLogin,
            viaSso = _props2.viaSso,
            loginPolicyType = _props2.loginPolicyType,
            t = _props2.t;

        var hideArrow = !userIdentified && fetchPathAfterLogin;
        var rightColumnContent = showLoginForm ? _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(
            'div',
            { className: 'box-header' },
            _get__('React').createElement(
              'h1',
              { tabIndex: 0, id: 'intro-box-left-header' },
              t('login.title')
            )
          ),
          loginPolicyType === 'STRONG' && _get__('React').createElement(
            _get__('Button'),
            { className: 'action-btn center-block login-button', onClick: this.onLoginClicked },
            t('identification:identificationForm.submitButtonText')
          ),
          loginPolicyType !== 'STRONG' && _get__('React').createElement(_get__('IdentificationForm'), null)
        ) : _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(
            _get__('Button'),
            {
              onClick: this.onPathClicked,
              className: 'basic-action start-reservation-link center-block'
            },
            t('booking:continueReservationButton')
          )
        );
        var rightColumnWrapper = _get__('React').createElement(
          'div',
          null,
          rightColumnContent,
          uniquePath && _get__('React').createElement(
            _get__('Button'),
            {
              onClick: this.onManagementClicked,
              bsStyle: 'link',
              className: 'basic-action-link start-cancel-reservation-link center-block'
            },
            viaSso || loginPolicyType === 'STRONG' ? t('booking:sectionTitles.history') : t('booking:cancelReservation.startCancelling')
          )
        );
        return _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(
            'div',
            { className: 'main-login-top' },
            _get__('React').createElement(
              _get__('Grid'),
              { fluid: true, className: 'intro-box intro-box-left' },
              this.state.bankLoginShow && _get__('React').createElement(_get__('BankSelection'), { onBackButtonClicked: this.onBackButtonClicked }),
              !this.state.bankLoginShow && _get__('React').createElement(
                _get__('Row'),
                null,
                _get__('React').createElement(
                  _get__('Col'),
                  { className: 'intro-box-left', xs: 12, sm: 12, md: 7, lg: 7 },
                  _get__('React').createElement(
                    'div',
                    null,
                    _get__('React').createElement(
                      'div',
                      { className: 'box-header' },
                      _get__('React').createElement(
                        'h1',
                        null,
                        t('login.title')
                      ),
                      _get__('React').createElement(
                        'p',
                        null,
                        _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('login.info') })
                      ),
                      _get__('React').createElement(
                        'p',
                        null,
                        _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('login.info2') })
                      ),
                      uniquePath && _get__('React').createElement(_get__('LanguageSelector'), {
                        languages: languages
                      })
                    )
                  )
                ),
                _get__('React').createElement(
                  _get__('Col'),
                  { className: 'intro-box-right', xs: 12, sm: 12, md: 5, lg: 5 },
                  rightColumnWrapper
                )
              )
            ),
            !hideArrow && _get__('React').createElement(
              _get__('Link'),
              {
                className: 'arrow-down',
                to: 'booking-phase-symptoms',
                duration: _get__('scrollDuration'),
                delay: _get__('scrollDelay'),
                offset: _get__('scrollOffset'),
                smooth: true
              },
              _get__('React').createElement(_get__('AppIcon'), { iconName: 'ARROW_DOWN' })
            )
          )
        );
      }

      return render;
    }()
  }]);

  return MainLogin;
}(_get__('Component'));

_get__('MainLogin').propTypes = {
  triggerInitialScroll: _get__('PropTypes').func.isRequired,
  showLoginForm: _get__('PropTypes').bool.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  setManagementOptionWithSinglePath: _get__('PropTypes').func.isRequired,
  managementSelected: _get__('PropTypes').bool,
  viaSso: _get__('PropTypes').bool.isRequired,
  uniquePath: _get__('PropTypes').bool.isRequired,
  languages: _get__('PropTypes').array.isRequired,
  fetchPathAfterLogin: _get__('PropTypes').bool.isRequired,
  loginPolicyType: _get__('PropTypes').string,
  t: _get__('PropTypes').func.isRequired
};

_get__('MainLogin').defaultProps = {
  uniquePath: false,
  managementSelected: false,
  loginPolicyType: 'ONLY_SSN'
};

var _DefaultExportValue = _get__('translate')(['common', 'booking'], { wait: true })(_get__('MainLogin'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'scrollDuration':
      return _constants.scrollDuration;

    case 'scrollDelay':
      return _constants.scrollDelay;

    case 'scrollOffset':
      return _constants.scrollOffset;

    case 'Component':
      return _react.Component;

    case 'MainLogin':
      return MainLogin;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'IdentificationForm':
      return _IdentificationForm2['default'];

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'BankSelection':
      return _index2['default'];

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'LanguageSelector':
      return _LanguageSelector2['default'];

    case 'Link':
      return _reactScroll.Link;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MainLogin, 'MainLogin', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainLogin/MainLogin.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainLogin/MainLogin.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _MainLogin = __webpack_require__(1124);

var _MainLogin2 = _interopRequireDefault(_MainLogin);

var _cancelling = __webpack_require__(103);

var _booking = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      viaSso: state.session.viaSso,
      pathBasedBooking: state.booking.pathBasedBooking,
      uniquePath: state.booking.uniquePath,
      pathToLoadAfterLogin: state.booking.pathToLoadAfterLogin,
      fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
      managementSelected: state.booking.managementSelected,
      languages: state.organization.languages,
      loginPolicyType: state.organization.loginPolicyType
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      openCancelReservationScreen: function () {
        function openCancelReservationScreen() {
          dispatch(_get__('openCancelReservationScreen')());
        }

        return openCancelReservationScreen;
      }(),

      setManagementOptionWithSinglePath: dispatch(_get__('setManagementOptionWithSinglePath'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('MainLogin'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'openCancelReservationScreen':
      return _cancelling.openCancelReservationScreen;

    case 'setManagementOptionWithSinglePath':
      return _booking.setManagementOptionWithSinglePath;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'MainLogin':
      return _MainLogin2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainLogin/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainLogin/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainLogin/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactScroll = __webpack_require__(213);

var _reactI18next = __webpack_require__(11);

var _constants = __webpack_require__(76);

var _Booking = __webpack_require__(1148);

var _Booking2 = _interopRequireDefault(_Booking);

var _LoginNotAllowed = __webpack_require__(1160);

var _LoginNotAllowed2 = _interopRequireDefault(_LoginNotAllowed);

var _ContinueConfirmation = __webpack_require__(1156);

var _ContinueConfirmation2 = _interopRequireDefault(_ContinueConfirmation);

var _CancelReservation = __webpack_require__(1152);

var _CancelReservation2 = _interopRequireDefault(_CancelReservation);

var _RootSelection = __webpack_require__(1166);

var _RootSelection2 = _interopRequireDefault(_RootSelection);

var _SelectEmployerDepartment = __webpack_require__(1168);

var _SelectEmployerDepartment2 = _interopRequireDefault(_SelectEmployerDepartment);

var _AppointmentManagement = __webpack_require__(1144);

var _AppointmentManagement2 = _interopRequireDefault(_AppointmentManagement);

var _SelectionHandler = __webpack_require__(555);

var _SelectionHandler2 = _interopRequireDefault(_SelectionHandler);

var _LoginOnlyBySso = __webpack_require__(1123);

var _LoginOnlyBySso2 = _interopRequireDefault(_LoginOnlyBySso);

var _BookingPhase = __webpack_require__(218);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainPage = function (_get__2) {
  _inherits(MainPage, _get__2);

  function MainPage(props) {
    _classCallCheck(this, MainPage);

    var _this = _possibleConstructorReturn(this, (MainPage.__proto__ || Object.getPrototypeOf(MainPage)).call(this, props));

    _this.scroll = _this.scroll.bind(_this);
    _this.getScrollTarget = _this.getScrollTarget.bind(_this);
    _this.getLogicState = _this.getLogicState.bind(_this);
    _this.scrollTimeout = null;
    _this.triggerScroll = _this.triggerScroll.bind(_this);
    return _this;
  }

  _createClass(MainPage, [{
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var _getLogicState = this.getLogicState(prevProps),
            pathRecentlyLoaded = _getLogicState.pathRecentlyLoaded,
            userRecentlyLoggedIn = _getLogicState.userRecentlyLoggedIn,
            managementRecentlySelected = _getLogicState.managementRecentlySelected,
            wasHistoryInitiallyLoaded = _getLogicState.wasHistoryInitiallyLoaded,
            showLoginBySsoView = _getLogicState.showLoginBySsoView,
            fetchPathAfterLogin = _getLogicState.fetchPathAfterLogin;
        // The organization restricts access to the system to users authenticated only via SSO


        if (showLoginBySsoView) {
          this.props.triggerLoginOnlyBySsoView();
          return;
        }
        // Scrolling through this method happens when three conditions have met.
        if (pathRecentlyLoaded || userRecentlyLoggedIn || managementRecentlySelected || wasHistoryInitiallyLoaded || fetchPathAfterLogin) {
          var scrollTarget = this.getScrollTarget(prevProps);
          this.scroll(scrollTarget);
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'getLogicState',
    value: function () {
      function getLogicState(prevProps) {
        var _props = this.props,
            userIdentified = _props.userIdentified,
            viaSso = _props.viaSso,
            pathLoaded = _props.pathLoaded,
            loginFirst = _props.loginFirst,
            historyInitialLoading = _props.historyInitialLoading,
            historyInitialLoaded = _props.historyInitialLoaded,
            managementSelected = _props.managementSelected,
            uniquePath = _props.uniquePath,
            loginOnlyBySso = _props.loginOnlyBySso,
            doneIdentifying = _props.doneIdentifying,
            user = _props.user,
            selectedDepartment = _props.selectedDepartment,
            hasEmployer = _props.hasEmployer,
            showCancelReservationScreen = _props.showCancelReservationScreen,
            fetchPathAfterLogin = _props.fetchPathAfterLogin,
            selectedEmployer = _props.selectedEmployer;

        var userIsLoggedInWithoutSso = userIdentified && !viaSso;
        var pathRecentlyLoaded = pathLoaded && !prevProps.pathLoaded;
        var userRecentlyLoggedIn = userIdentified && !prevProps.userIdentified && loginFirst;
        var managementRecentlySelected = managementSelected && !prevProps.managementSelected;
        var wasHistoryInitiallyLoaded = !historyInitialLoading && historyInitialLoaded;
        var wasPathRecentlySelected = pathLoaded !== prevProps.pathLoaded;
        var wasManagementUnselected = !managementSelected && prevProps.managementSelected;
        var cancellationScrollView = managementSelected && !viaSso;
        var scrollToSelectedPath = pathLoaded && wasPathRecentlySelected && !uniquePath;
        var showLoginBySsoView = loginOnlyBySso && doneIdentifying && (userIsLoggedInWithoutSso || !userIdentified);
        var hasDepartments = userIdentified && selectedEmployer > -1 && Reflect.has(user.employers[selectedEmployer], 'departments') && user.employers[selectedEmployer].departments.length > 0;
        var hasDepartmentSelected = selectedDepartment > -1;
        var showSelectDepartmentModal = userIdentified && hasEmployer && hasDepartments && !showCancelReservationScreen && !hasDepartmentSelected;
        // if the condition is true we render info box in ServiceInfoBox component
        var serviceInfoBoxExists = _get__('i18n').exists('common:serviceInfo.title') || _get__('i18n').exists('common:serviceInfo.content');
        return {
          pathRecentlyLoaded: pathRecentlyLoaded,
          userRecentlyLoggedIn: userRecentlyLoggedIn,
          managementRecentlySelected: managementRecentlySelected,
          wasHistoryInitiallyLoaded: wasHistoryInitiallyLoaded,
          wasPathRecentlySelected: wasPathRecentlySelected,
          cancellationScrollView: cancellationScrollView,
          scrollToSelectedPath: scrollToSelectedPath,
          showLoginBySsoView: showLoginBySsoView,
          showSelectDepartmentModal: showSelectDepartmentModal,
          fetchPathAfterLogin: fetchPathAfterLogin,
          wasManagementUnselected: wasManagementUnselected,
          serviceInfoBoxExists: serviceInfoBoxExists
        };
      }

      return getLogicState;
    }()
  }, {
    key: 'getScrollTarget',
    value: function () {
      function getScrollTarget(prevProps) {
        if (!prevProps) {
          return 'main-page-booking-start';
        }
        // get the necessary variables from the props
        var _props2 = this.props,
            loginFirst = _props2.loginFirst,
            userIdentified = _props2.userIdentified,
            showCancelReservationScreen = _props2.showCancelReservationScreen,
            selectionHandler = _props2.selectionHandler,
            triggerInitialScroll = _props2.triggerInitialScroll,
            viaSso = _props2.viaSso;
        // Do not attempt any scrolling if the user needs to select a department first

        var _getLogicState2 = this.getLogicState(prevProps),
            wasHistoryInitiallyLoaded = _getLogicState2.wasHistoryInitiallyLoaded,
            cancellationScrollView = _getLogicState2.cancellationScrollView,
            scrollToSelectedPath = _getLogicState2.scrollToSelectedPath,
            showSelectDepartmentModal = _getLogicState2.showSelectDepartmentModal,
            fetchPathAfterLogin = _getLogicState2.fetchPathAfterLogin,
            wasManagementUnselected = _getLogicState2.wasManagementUnselected,
            serviceInfoBoxExists = _getLogicState2.serviceInfoBoxExists;

        if (showSelectDepartmentModal) {
          return null;
        }
        if (wasManagementUnselected) {
          return 'main-page-booking-start';
        }
        if (wasHistoryInitiallyLoaded || showCancelReservationScreen || cancellationScrollView) {
          return 'main-page-management-start';
        }
        // if something was selected do not scroll here
        if (selectionHandler.getSelectedOptionIds()) {
          var selectedOptionIds = selectionHandler.getSelectedOptionIds();
          var selectedLevels = selectedOptionIds.length;
          if (selectedLevels) {
            return null;
          }
        }
        // if a path is selected and the user is not logged in and the path has login first
        // show the login form, if there is no service info box
        if (fetchPathAfterLogin && !serviceInfoBoxExists || loginFirst && scrollToSelectedPath && !userIdentified) {
          return 'intro-box-login';
        }
        // if the user is authenticated go straight to the booking start
        if (loginFirst && scrollToSelectedPath && userIdentified) {
          return 'main-page-booking-start';
        }
        // if selected option go straight to log in box (MBOOK-372)
        if (loginFirst && !scrollToSelectedPath && !userIdentified) {
          return 'intro-box-login';
        }
        // otherwise if the path has just been selected or changed and it is not a login first
        // scroll to the top of the booking page
        if (!loginFirst && scrollToSelectedPath) {
          return 'main-page-booking-start';
        }
        if (!viaSso && !prevProps.triggerInitialScroll && triggerInitialScroll) {
          return 'main-page-booking-start';
        }
        return null;
      }

      return getScrollTarget;
    }()
  }, {
    key: 'scroll',
    value: function () {
      function scroll(scrollTarget) {
        var extraSettings = {};
        if (scrollTarget !== null) {
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = setTimeout(function () {
            _get__('scroller').scrollTo(scrollTarget, _extends({}, _get__('scrollSettings'), extraSettings));
          }, 250);
        }
      }

      return scroll;
    }()
  }, {
    key: 'triggerScroll',
    value: function () {
      function triggerScroll(wasPathClicked) {
        var _props3 = this.props,
            uniquePath = _props3.uniquePath,
            viaSso = _props3.viaSso,
            managementSelected = _props3.managementSelected,
            unsetManagementOptionWithSinglePath = _props3.unsetManagementOptionWithSinglePath;

        if (wasPathClicked && viaSso && uniquePath && managementSelected) {
          // unset the managementSelected state
          unsetManagementOptionWithSinglePath();
        }
        this.scroll(this.getScrollTarget(null));
      }

      return triggerScroll;
    }()
  }, {
    key: 'shouldContinueConfirmation',
    value: function () {
      function shouldContinueConfirmation() {
        var _props4 = this.props,
            requireContinueConfirmation = _props4.requireContinueConfirmation,
            userConfirmedContinue = _props4.userConfirmedContinue;

        return requireContinueConfirmation && !userConfirmedContinue;
      }

      return shouldContinueConfirmation;
    }()
  }, {
    key: 'shouldSelectEmployerDepartment',
    value: function () {
      function shouldSelectEmployerDepartment() {
        var _props5 = this.props,
            userIdentified = _props5.userIdentified,
            hasEmployer = _props5.hasEmployer,
            showCancelReservationScreen = _props5.showCancelReservationScreen,
            user = _props5.user,
            selectedDepartment = _props5.selectedDepartment,
            selectedEmployer = _props5.selectedEmployer,
            shouldSelectEmployer = _props5.shouldSelectEmployer;

        var hasEmployerBeenSelected = selectedEmployer > -1;
        var hasEmployers = user && user.employers && user.employers.length > 0;
        var employer = hasEmployers && selectedEmployer > -1 ? user.employers[selectedEmployer] : {};
        var hasDepartments = 'departments' in employer && employer.departments.length > 0;
        var hasDepartmentSelected = selectedDepartment > -1;
        return shouldSelectEmployer || hasEmployerBeenSelected && userIdentified && hasEmployer && hasDepartments && !showCancelReservationScreen && !hasDepartmentSelected;
      }

      return shouldSelectEmployerDepartment;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props6 = this.props,
            rootLoaded = _props6.rootLoaded,
            showCancelReservationScreen = _props6.showCancelReservationScreen,
            pathLoaded = _props6.pathLoaded,
            roots = _props6.roots,
            loginFailedNotAllowedByEmployer = _props6.loginFailedNotAllowedByEmployer,
            loginFailedNotDueToMultipleEmployers = _props6.loginFailedNotDueToMultipleEmployers,
            messageLocalizationKey = _props6.messageLocalizationKey,
            managementSelected = _props6.managementSelected,
            showLoginOnlyBySsoView = _props6.showLoginOnlyBySsoView,
            uniquePath = _props6.uniquePath,
            userIdentified = _props6.userIdentified,
            hasEmployer = _props6.hasEmployer,
            requiresEmployer = _props6.requiresEmployer,
            configurationLoaded = _props6.configurationLoaded,
            t = _props6.t;

        if (!rootLoaded) {
          return null;
        }
        var preventContinuePathEmployerRequired = pathLoaded && requiresEmployer && userIdentified && !hasEmployer;
        var hideLoadedContent = uniquePath && managementSelected;
        var showSelectDepartmentModal = this.shouldSelectEmployerDepartment();
        var continueConfirmation = this.shouldContinueConfirmation();
        var bookingPhaseFooter = _get__('React').createElement(
          _get__('BookingPhase'),
          { id: 'booking-footer-info', title: t('booking:footer_info_title') },
          _get__('React').createElement(
            _get__('Grid'),
            { fluid: true },
            _get__('React').createElement(
              _get__('Row'),
              null,
              _get__('React').createElement(
                _get__('Col'),
                { xs: 12, sm: 12, md: 6, lg: 6, mdPush: 6, lgPush: 6 },
                _get__('React').createElement(
                  'p',
                  null,
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('booking:footer_info_p1') })
                ),
                _get__('React').createElement(
                  'p',
                  null,
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('booking:footer_info_p2') })
                )
              ),
              _get__('React').createElement(
                _get__('Col'),
                {
                  xs: 12, sm: 12, md: 6, lg: 6, mdPull: 6, lgPull: 6,
                  className: 'footer-phone-wrapper'
                },
                _get__('React').createElement(_get__('AppIcon'), { iconName: 'PHONE', containerClass: 'footer-phone-image' }),
                _get__('React').createElement(
                  'div',
                  { className: 'footer-phone-box' },
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('booking:footer_info_tel_no'), elementClass: 'footer-phone-number' }),
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('booking:footer_info_tel_no_info'), elementClass: 'footer-phone-info' }),
                  _get__('React').createElement(
                    'div',
                    { className: 'footer-email-info' },
                    _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('booking:footer_info_email_info') })
                  )
                )
              )
            )
          )
        );
        var body = showLoginOnlyBySsoView ? _get__('React').createElement(_get__('LoginOnlyBySso'), null) : _get__('React').createElement(
          'div',
          { id: 'main-page-start', role: 'main' },
          _get__('React').createElement(_get__('RootSelection'), { options: roots, triggerInitialScroll: this.triggerScroll, goTo: this.props.route.goTo }),
          _get__('React').createElement(
            'div',
            { id: 'main-page-booking-start' },
            _get__('React').createElement(
              _get__('Collapse'),
              { 'in': pathLoaded && !hideLoadedContent && configurationLoaded, unmountOnExit: true },
              _get__('React').createElement(
                _get__('Grid'),
                { fluid: true },
                _get__('React').createElement(_get__('Booking'), null)
              )
            )
          ),
          _get__('React').createElement(
            'div',
            { id: 'main-page-management-start' },
            _get__('React').createElement(
              _get__('Collapse'),
              { 'in': managementSelected, unmountOnExit: true },
              _get__('React').createElement(
                _get__('Grid'),
                { fluid: true },
                _get__('React').createElement(_get__('AppointmentManagement'), null)
              )
            )
          ),
          bookingPhaseFooter
        );

        return _get__('React').createElement(
          'div',
          { className: 'main-page' },
          _get__('React').createElement(
            'div',
            { className: 'modals' },
            _get__('React').createElement(_get__('LoginNotAllowed'), {
              show: loginFailedNotAllowedByEmployer || loginFailedNotDueToMultipleEmployers || preventContinuePathEmployerRequired,
              messageLocalizationKey: preventContinuePathEmployerRequired ? 'errorEmployerRequired' : messageLocalizationKey
            }),
            _get__('React').createElement(_get__('CancelReservation'), { show: showCancelReservationScreen }),
            _get__('React').createElement(_get__('SelectEmployerDepartment'), { show: showSelectDepartmentModal }),
            _get__('React').createElement(_get__('ContinueConfirmation'), { show: continueConfirmation })
          ),
          body
        );
      }

      return render;
    }()
  }]);

  return MainPage;
}(_get__('Component'));

_get__('MainPage').propTypes = {
  rootLoaded: _get__('PropTypes').bool,
  pathLoaded: _get__('PropTypes').bool,
  managementSelected: _get__('PropTypes').bool,
  userIdentified: _get__('PropTypes').bool.isRequired,
  doneIdentifying: _get__('PropTypes').bool.isRequired,
  loginOnlyBySso: _get__('PropTypes').bool.isRequired,
  showLoginOnlyBySsoView: _get__('PropTypes').bool.isRequired,
  hasEmployer: _get__('PropTypes').bool.isRequired,
  requireContinueConfirmation: _get__('PropTypes').bool.isRequired,
  messageLocalizationKey: _get__('PropTypes').string.isRequired,
  loginFailedNotAllowedByEmployer: _get__('PropTypes').bool.isRequired,
  loginFailedNotDueToMultipleEmployers: _get__('PropTypes').bool.isRequired,
  userConfirmedContinue: _get__('PropTypes').bool.isRequired,
  showCancelReservationScreen: _get__('PropTypes').bool,
  roots: _get__('PropTypes').array.isRequired,
  loginFirst: _get__('PropTypes').bool.isRequired,
  user: _get__('PropTypes').shape({
    employers: _get__('PropTypes').array.isRequired
  }).isRequired,
  selectedDepartment: _get__('PropTypes').number.isRequired,
  uniquePath: _get__('PropTypes').bool.isRequired,
  selectionHandler: _get__('PropTypes').object.isRequired,
  triggerInitialScroll: _get__('PropTypes').bool.isRequired,
  viaSso: _get__('PropTypes').bool.isRequired,
  fetchPathAfterLogin: _get__('PropTypes').bool.isRequired,
  historyInitialLoading: _get__('PropTypes').bool.isRequired,
  historyInitialLoaded: _get__('PropTypes').bool.isRequired,
  triggerLoginOnlyBySsoView: _get__('PropTypes').func.isRequired,
  selectedEmployer: _get__('PropTypes').number.isRequired,
  shouldSelectEmployer: _get__('PropTypes').bool.isRequired,
  unsetManagementOptionWithSinglePath: _get__('PropTypes').func.isRequired,
  requiresEmployer: _get__('PropTypes').bool.isRequired,
  configurationLoaded: _get__('PropTypes').bool.isRequired,
  t: _get__('PropTypes').func.isRequired,
  route: _get__('PropTypes').object.isRequired
};

_get__('MainPage').defaultProps = {
  roots: [],
  managementSelected: false,
  rootLoaded: false,
  pathLoaded: false,
  pathSelected: -1,
  uniquePath: false,
  showCancelReservationScreen: false,
  organizationBackgroundImageUrl: '',
  loginFirst: true,
  user: { employers: [] },
  selectedDepartment: -1,
  selectionHandler: new (_get__('SelectionHandler'))(),
  triggerInitialScroll: false,
  requiresEmployer: false,
  viaSso: false
};

var _DefaultExportValue = _get__('translate')(['common', 'booking'], { wait: true })(_get__('MainPage'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18n2['default'];

    case 'scroller':
      return _reactScroll.scroller;

    case 'scrollSettings':
      return _constants.scrollSettings;

    case 'Component':
      return _react.Component;

    case 'MainPage':
      return MainPage;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'SelectionHandler':
      return _SelectionHandler2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'BookingPhase':
      return _BookingPhase2['default'];

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'AppIcon':
      return _AppIcon2['default'];

    case 'LoginOnlyBySso':
      return _LoginOnlyBySso2['default'];

    case 'RootSelection':
      return _RootSelection2['default'];

    case 'Collapse':
      return _reactBootstrap.Collapse;

    case 'Booking':
      return _Booking2['default'];

    case 'AppointmentManagement':
      return _AppointmentManagement2['default'];

    case 'LoginNotAllowed':
      return _LoginNotAllowed2['default'];

    case 'CancelReservation':
      return _CancelReservation2['default'];

    case 'SelectEmployerDepartment':
      return _SelectEmployerDepartment2['default'];

    case 'ContinueConfirmation':
      return _ContinueConfirmation2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MainPage, 'MainPage', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainPage/MainPage.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainPage/MainPage.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _MainPage = __webpack_require__(1126);

var _MainPage2 = _interopRequireDefault(_MainPage);

var _app = __webpack_require__(217);

var _booking = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      rootLoaded: state.booking.rootLoaded,
      pathLoaded: state.booking.pathLoaded,
      managementSelected: state.booking.managementSelected,
      userIdentified: state.session.userIdentified,
      doneIdentifying: state.session.doneIdentifying,
      loginOnlyBySso: state.organization.loginOnlyBySso,
      shouldSelectEmployer: state.booking.shouldSelectEmployer,
      showLoginOnlyBySsoView: state.app.showLoginOnlyBySsoView,
      hasEmployer: state.session.hasEmployer,
      requireContinueConfirmation: state.session.requireContinueConfirmation,
      loginFailedNotAllowedByEmployer: state.session.loginFailedNotAllowedByEmployer,
      loginFailedNotDueToMultipleEmployers: state.session.loginFailedNotDueToMultipleEmployers,
      userConfirmedContinue: state.session.userConfirmedContinue,
      showCancelReservationScreen: state.cancelling.showCancelReservationScreen,
      roots: state.booking.roots,
      loginFirst: state.booking.loginFirst,
      uniquePath: state.booking.uniquePath,
      user: state.session.user,
      selectedDepartment: state.session.selectedDepartment,
      selectionHandler: state.booking.selectionHandler,
      messageLocalizationKey: state.session.messageLocalizationKey,
      triggerInitialScroll: state.session.triggerInitialScroll,
      viaSso: state.session.viaSso,
      fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
      historyInitialLoading: state.history.historyInitialLoading,
      historyInitialLoaded: state.history.historyInitialLoaded,
      selectedEmployer: state.session.selectedEmployer,
      requiresEmployer: state.session.requiresEmployer,
      configurationLoaded: state.app.configurationLoaded
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      triggerLoginOnlyBySsoView: dispatch(_get__('triggerLoginOnlyBySsoView')),
      unsetManagementOptionWithSinglePath: dispatch(_get__('unsetManagementOptionWithSinglePath'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('MainPage'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'triggerLoginOnlyBySsoView':
      return _app.triggerLoginOnlyBySsoView;

    case 'unsetManagementOptionWithSinglePath':
      return _booking.unsetManagementOptionWithSinglePath;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'MainPage':
      return _MainPage2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainPage/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainPage/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/MainPage/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _UserInfo = __webpack_require__(1176);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _CenteredImage = __webpack_require__(547);

var _CenteredImage2 = _interopRequireDefault(_CenteredImage);

__webpack_require__(1504);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navigation = function (_get__2) {
  _inherits(Navigation, _get__2);

  function Navigation(props) {
    _classCallCheck(this, Navigation);

    // eslint-disable-line
    return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));
  }

  _createClass(Navigation, [{
    key: 'changeLanguage',
    value: function () {
      function changeLanguage(newLanguage) {
        _get__('i18n').changeLanguage(newLanguage);
      }

      return changeLanguage;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            userIdentified = _props.userIdentified,
            openCancelReservationScreen = _props.openCancelReservationScreen,
            logout = _props.logout,
            viaSso = _props.viaSso,
            t = _props.t;

        var logoSize = {
          height: '60px',
          width: '150px'
        };
        var handleLogout = function () {
          function handleLogout() {
            logout(viaSso);
          }

          return handleLogout;
        }();

        return _get__('React').createElement(
          _get__('Navbar'),
          { fixedTop: true, fluid: true },
          _get__('React').createElement(
            _get__('Navbar').Header,
            null,
            _get__('React').createElement(
              _get__('Navbar').Brand,
              null,
              _get__('React').createElement(_get__('CenteredImage'), { alt: t('common:ariaLabels.brandImage'), containerHeight: logoSize.height, containerWidth: logoSize.width, src: this.props.organizationLogoUrl })
            ),
            userIdentified && _get__('React').createElement(_get__('Navbar').Toggle, null)
          ),
          userIdentified && _get__('React').createElement(
            _get__('Navbar').Collapse,
            null,
            _get__('React').createElement(
              _get__('Nav'),
              { pullRight: true, 'aria-label': t('common:ariaLabels.navBarRight') },
              _get__('React').createElement(
                _get__('NavDropdown'),
                {
                  className: 'menu-item',
                  eventKey: 2,
                  title: _get__('React').createElement(_get__('UserInfo'), null),
                  id: 'user-dropdown'
                },
                _get__('React').createElement(
                  _get__('MenuItem'),
                  { onSelect: openCancelReservationScreen },
                  t('booking:cancelReservation.startCancelling')
                )
              ),
              _get__('React').createElement(
                _get__('NavItem'),
                { className: 'logout-button menu-item', onSelect: handleLogout },
                t('menuItems.account.logout')
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return Navigation;
}(_get__('Component'));

_get__('Navigation').propTypes = {
  userIdentified: _get__('PropTypes').bool.isRequired,
  organizationLogoUrl: _get__('PropTypes').string.isRequired,
  openCancelReservationScreen: _get__('PropTypes').func.isRequired,
  logout: _get__('PropTypes').func.isRequired,
  viaSso: _get__('PropTypes').bool.isRequired,
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(['menu', 'common'], { wait: true })(_get__('Navigation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18n2['default'];

    case 'Component':
      return _react.Component;

    case 'Navigation':
      return Navigation;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Navbar':
      return _reactBootstrap.Navbar;

    case 'CenteredImage':
      return _CenteredImage2['default'];

    case 'Nav':
      return _reactBootstrap.Nav;

    case 'NavDropdown':
      return _reactBootstrap.NavDropdown;

    case 'UserInfo':
      return _UserInfo2['default'];

    case 'MenuItem':
      return _reactBootstrap.MenuItem;

    case 'NavItem':
      return _reactBootstrap.NavItem;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Navigation, 'Navigation', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Navigation/Navigation.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Navigation/Navigation.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _Navigation = __webpack_require__(1128);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _cancelling = __webpack_require__(103);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      organizationLogoUrl: state.organization.logoUrl,
      viaSso: state.session.viaSso
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      openCancelReservationScreen: function () {
        function openCancelReservationScreen() {
          dispatch(_get__('openCancelReservationScreen')());
        }

        return openCancelReservationScreen;
      }(),

      logout: function () {
        function logout(viaSso) {
          dispatch(_get__('clearSession'))(viaSso);
        }

        return logout;
      }()
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Navigation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'openCancelReservationScreen':
      return _cancelling.openCancelReservationScreen;

    case 'clearSession':
      return _session.clearSession;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'Navigation':
      return _Navigation2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Navigation/index.jsx');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Navigation/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Navigation/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(14);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var OptionButton = function () {
  function OptionButton(_ref) {
    var active = _ref.active,
        _onClick = _ref.onClick,
        option = _ref.option,
        prefix = _ref.prefix,
        namespace = _ref.namespace,
        disabled = _ref.disabled,
        t = _ref.t;
    return _get__('React').createElement(
      _get__('Button'),
      {
        className: 'booking-option-btn',
        active: active,
        onClick: function () {
          function onClick() {
            return _onClick(option.id);
          }

          return onClick;
        }(),
        block: true,
        bsStyle: 'default',
        bsSize: 'large',
        disabled: disabled
      },
      _get__('React').createElement(
        'span',
        { className: 'booking-option-btn-title' },
        _get__('React').createElement(_get__('InnerHtmlContent'), { content: t(prefix + '.' + option.id + '.title') })
      ),
      _get__('React').createElement(
        'span',
        { className: 'booking-option-btn-info' },
        _get__('React').createElement(_get__('InnerHtmlContent'), { content: t(prefix + '.' + option.id + '.subTitle', { defaultValue: '' }) })
      )
    );
  }

  return OptionButton;
}();

_get__('OptionButton').propTypes = {
  t: _get__('PropTypes').func.isRequired,
  active: _get__('PropTypes').bool.isRequired,
  onClick: _get__('PropTypes').func.isRequired,
  option: _get__('PropTypes').object.isRequired,
  prefix: _get__('PropTypes').string.isRequired,
  namespace: _get__('PropTypes').string.isRequired,
  disabled: _get__('PropTypes').bool
};

_get__('OptionButton').defaultProps = {
  disabled: false
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return props.namespace;
}, { wait: true })(_get__('OptionButton'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'OptionButton':
      return OptionButton;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OptionButton, 'OptionButton', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionButton/OptionButton.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionButton/OptionButton.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _InfoBox = __webpack_require__(548);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

var _OptionButton = __webpack_require__(550);

var _OptionButton2 = _interopRequireDefault(_OptionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionGroup = function (_get__2) {
  _inherits(OptionGroup, _get__2);

  function OptionGroup() {
    _classCallCheck(this, OptionGroup);

    return _possibleConstructorReturn(this, (OptionGroup.__proto__ || Object.getPrototypeOf(OptionGroup)).apply(this, arguments));
  }

  _createClass(OptionGroup, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            options = _props.options,
            prompt = _props.prompt,
            selected = _props.selected,
            onSelect = _props.onSelect,
            info = _props.info,
            level = _props.level,
            prefix = _props.prefix,
            namespace = _props.namespace;


        var optionButtons = options.map(function (option) {
          return _get__('React').createElement(
            _get__('Col'),
            { key: option.id, xs: 12, sm: 6, md: 4, lg: 4 },
            _get__('React').createElement(_get__('OptionButton'), {
              active: selected === option.id,
              onClick: onSelect,
              option: option,
              prefix: prefix,
              namespace: namespace
            })
          );
        });

        return _get__('React').createElement(
          'div',
          { className: 'option-group', id: level >= 0 ? 'optionGroup' + level : null },
          _get__('React').createElement(
            _get__('FormGroup'),
            null,
            _get__('React').createElement(
              _get__('Grid'),
              { fluid: true },
              _get__('React').createElement(
                _get__('Row'),
                null,
                optionButtons
              )
            )
          ),
          info && _get__('React').createElement(_get__('InfoBox'), { content: info })
        );
      }

      return render;
    }()
  }]);

  return OptionGroup;
}(_get__('Component'));

_get__('OptionGroup').propTypes = {
  prompt: _get__('PropTypes').string,
  info: _get__('PropTypes').string,
  level: _get__('PropTypes').number,
  options: _get__('PropTypes').array.isRequired,
  selected: _get__('PropTypes').oneOfType([_get__('PropTypes').number, _get__('PropTypes').string, _get__('PropTypes').bool]),
  onSelect: _get__('PropTypes').func.isRequired,
  prefix: _get__('PropTypes').string,
  namespace: _get__('PropTypes').string
};

_get__('OptionGroup').defaultProps = {
  prompt: null,
  info: null,
  level: -1,
  options: [],
  selected: false,
  prefix: 'pathConfig',
  namespace: ''
};

var _default = _get__('OptionGroup');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'OptionGroup':
      return OptionGroup;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'Col':
      return _reactBootstrap.Col;

    case 'OptionButton':
      return _OptionButton2['default'];

    case 'FormGroup':
      return _reactBootstrap.FormGroup;

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'InfoBox':
      return _InfoBox2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof OptionGroup === 'undefined' ? 'undefined' : _typeof(OptionGroup);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(OptionGroup, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(OptionGroup)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(OptionGroup, 'OptionGroup', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionGroup/OptionGroup.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionGroup/OptionGroup.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _OptionGroup = __webpack_require__(1131);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('OptionGroup'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'OptionGroup':
      return _OptionGroup2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionGroup/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/OptionGroup/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _string = __webpack_require__(160);

var _reactI18next = __webpack_require__(11);

__webpack_require__(1505);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PastReservationCard = function () {
  function PastReservationCard(_ref) {
    var t = _ref.t,
        timeSlot = _ref.timeSlot,
        unit = _ref.unit;

    var duration = Object.prototype.hasOwnProperty.call(timeSlot.duration, timeSlot.type) ? timeSlot.duration[timeSlot.type] : timeSlot.duration;
    var dateFormat = 'dd D.M.YYYY';
    var timeFormat = 'H.mm';
    return _get__('React').createElement(
      'div',
      { className: 'past-reservation-card' },
      _get__('React').createElement(
        'div',
        { className: 'reservation-date' },
        _get__('React').createElement(
          'span',
          { 'aria-label': '' + t('common:ariaLabels.reservationDate') + _get__('capitalize')(timeSlot.timeMoment.format(dateFormat)) + ', ' + t('atTime') + ' ' + timeSlot.timeMoment.format('H.mm') + ' to ' + timeSlot.timeMoment.clone().add(duration, 'minutes').format(timeFormat) },
          _get__('capitalize')(timeSlot.timeMoment.format(dateFormat)) + ' Klo ' + timeSlot.timeMoment.format('H.mm') + '-' + timeSlot.timeMoment.clone().add(duration, 'minutes').format(timeFormat)
        )
      ),
      _get__('React').createElement(
        'div',
        { className: 'reservation-resource' },
        _get__('React').createElement(
          'span',
          { className: 'resource-name' },
          timeSlot.resourceName
        ),
        timeSlot.resourceType && _get__('React').createElement(
          'span',
          { className: 'resource-name' },
          ', ',
          timeSlot.resourceType
        )
      ),
      _get__('React').createElement(
        'div',
        { className: 'reservation-unit' },
        _get__('React').createElement(
          'div',
          { className: 'unit-name' },
          unit.name
        ),
        _get__('React').createElement(
          'div',
          { className: 'unit-address' },
          unit.address + ', ' + unit.city
        )
      )
    );
  }

  return PastReservationCard;
}();

_get__('PastReservationCard').propTypes = {
  timeSlot: _get__('PropTypes').shape({
    timeMoment: _get__('PropTypes').instanceOf(_get__('moment')).isRequired,
    unitName: _get__('PropTypes').string,
    resourceName: _get__('PropTypes').string.isRequired,
    resourceType: _get__('PropTypes').string,
    hasResponsible: _get__('PropTypes').bool,
    reservation: _get__('PropTypes').string
  }).isRequired,
  unit: _get__('PropTypes').shape({
    name: _get__('PropTypes').string.isRequired,
    address: _get__('PropTypes').string.isRequired,
    city: _get__('PropTypes').string.isRequired,
    info: _get__('PropTypes').string
  }).isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('PastReservationCard').defaultProps = {
  unit: undefined
};

var _DefaultExportValue = _get__('translate')('common')(_get__('PastReservationCard'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'capitalize':
      return _string.capitalize;

    case 'PastReservationCard':
      return PastReservationCard;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'moment':
      return _moment2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PastReservationCard, 'PastReservationCard', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/PastReservatioCard/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/PastReservatioCard/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(12);

var _reactRouter = __webpack_require__(508);

var _reactI18next = __webpack_require__(11);

var _reactHotLoader = __webpack_require__(2137);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _App = __webpack_require__(1110);

var _App2 = _interopRequireDefault(_App);

var _MainPage = __webpack_require__(1127);

var _MainPage2 = _interopRequireDefault(_MainPage);

var _LoadingError = __webpack_require__(1121);

var _LoadingError2 = _interopRequireDefault(_LoadingError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// import RootSelection from '../../containers/RootSelection/RootSelection';
// eslint-disable-line

var Root = function () {
  function Root(_ref) {
    var store = _ref.store;
    return _get__('React').createElement(
      _get__('AppContainer'),
      null,
      _get__('React').createElement(
        _get__('I18nextProvider'),
        { i18n: _get__('i18n') },
        _get__('React').createElement(
          _get__('Provider'),
          { store: store },
          _get__('React').createElement(
            _get__('Router'),
            { history: _get__('browserHistory') },
            _get__('React').createElement(_get__('Redirect'), { from: '/', to: 'ajanvaraus' }),
            _get__('React').createElement(
              _get__('Route'),
              { path: '/', component: _get__('App') },
              _get__('React').createElement(_get__('Route'), { path: 'ajanvaraus', component: _get__('MainPage') }),
              _get__('React').createElement(_get__('Route'), { path: 'tiketti', component: _get__('MainPage'), goTo: 'byTicket' }),
              _get__('React').createElement(_get__('Route'), { path: 'error', component: function () {
                  function component(params) {
                    return _get__('React').createElement(_get__('LoadingError'), { routingParams: params });
                  }

                  return component;
                }() })
            )
          )
        )
      )
    );
  }

  return Root;
}();

_get__('Root').propTypes = {
  store: _get__('PropTypes').object.isRequired
};

var _default = _get__('Root');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18n2['default'];

    case 'browserHistory':
      return _reactRouter.browserHistory;

    case 'App':
      return _App2['default'];

    case 'MainPage':
      return _MainPage2['default'];

    case 'Root':
      return Root;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'AppContainer':
      return _reactHotLoader.AppContainer;

    case 'I18nextProvider':
      return _reactI18next.I18nextProvider;

    case 'Provider':
      return _reactRedux.Provider;

    case 'Router':
      return _reactRouter.Router;

    case 'Redirect':
      return _reactRouter.Redirect;

    case 'Route':
      return _reactRouter.Route;

    case 'LoadingError':
      return _LoadingError2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof Root === 'undefined' ? 'undefined' : _typeof(Root);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(Root, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Root)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Root, 'Root', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Root/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/Root/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _OptionButton = __webpack_require__(550);

var _OptionButton2 = _interopRequireDefault(_OptionButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RootOptionGroup = function (_get__2) {
  _inherits(RootOptionGroup, _get__2);

  function RootOptionGroup() {
    _classCallCheck(this, RootOptionGroup);

    return _possibleConstructorReturn(this, (RootOptionGroup.__proto__ || Object.getPrototypeOf(RootOptionGroup)).apply(this, arguments));
  }

  _createClass(RootOptionGroup, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            options = _props.options,
            prompt = _props.prompt,
            selected = _props.selected,
            onSelect = _props.onSelect,
            prefix = _props.prefix,
            namespace = _props.namespace,
            userIdentified = _props.userIdentified,
            hasEmployer = _props.hasEmployer;


        var optionButtons = options.map(function (option) {
          return _get__('React').createElement(_get__('OptionButton'), {
            key: option.id,
            active: selected === option.id,
            onClick: onSelect,
            option: option,
            prefix: prefix,
            namespace: namespace,
            disabled: userIdentified && !hasEmployer && option.requiresEmployer
          });
        });

        return _get__('React').createElement(
          'div',
          { className: 'option-group' },
          _get__('React').createElement(
            _get__('FormGroup'),
            null,
            _get__('React').createElement(
              _get__('Grid'),
              { fluid: true },
              optionButtons
            )
          )
        );
      }

      return render;
    }()
  }]);

  return RootOptionGroup;
}(_get__('Component'));

_get__('RootOptionGroup').propTypes = {
  prompt: _get__('PropTypes').string,
  options: _get__('PropTypes').array.isRequired,
  selected: _get__('PropTypes').oneOfType([_get__('PropTypes').number, _get__('PropTypes').string, _get__('PropTypes').bool]),
  onSelect: _get__('PropTypes').func.isRequired,
  prefix: _get__('PropTypes').string,
  namespace: _get__('PropTypes').string,
  userIdentified: _get__('PropTypes').bool.isRequired,
  hasEmployer: _get__('PropTypes').bool.isRequired
};

_get__('RootOptionGroup').defaultProps = {
  prompt: null,
  options: [],
  selected: false,
  prefix: 'pathConfig',
  namespace: '',
  userIdentified: false,
  hasEmployer: false
};

var _default = _get__('RootOptionGroup');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'RootOptionGroup':
      return RootOptionGroup;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'OptionButton':
      return _OptionButton2['default'];

    case 'FormGroup':
      return _reactBootstrap.FormGroup;

    case 'Grid':
      return _reactBootstrap.Grid;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof RootOptionGroup === 'undefined' ? 'undefined' : _typeof(RootOptionGroup);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(RootOptionGroup, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(RootOptionGroup)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RootOptionGroup, 'RootOptionGroup', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/RootOptionGroup/RootOptionGroup.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/RootOptionGroup/RootOptionGroup.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _RootOptionGroup = __webpack_require__(1135);

var _RootOptionGroup2 = _interopRequireDefault(_RootOptionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      hasEmployer: state.session.hasEmployer
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('RootOptionGroup'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'RootOptionGroup':
      return _RootOptionGroup2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/RootOptionGroup/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/RootOptionGroup/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/RootOptionGroup/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SelectionPathInfo = function () {
  function SelectionPathInfo(_ref) {
    var namespace = _ref.namespace,
        prefix = _ref.prefix,
        path = _ref.path,
        t = _ref.t;

    if (path.length > 0) {
      // We probably do not need the divider, the &#124 is the pipe character '|'
      var divider = _get__('React').createElement(
        'div',
        { className: 'path-details' },
        _get__('React').createElement(
          'span',
          { className: 'path-details-option-title' },
          '|'
        )
      );
      var list = path.map(function (element) {
        return _get__('React').createElement(
          _get__('Col'),
          { className: 'path-details', key: element.id, xs: 12, sm: 6, md: 6, lg: 6 },
          _get__('React').createElement(
            'span',
            { className: 'path-details-option-title' },
            t(prefix + '.' + element.id + '.title'),
            ' '
          ),
          _get__('React').createElement(
            'span',
            { className: 'path-details-option-desc' },
            t(prefix + '.' + element.id + '.subTitle', { defaultValue: '' })
          )
        );
      });
      // const view = list.reduce((prev, curr) => [prev, divider, curr]);
      var lastLevel = path[path.length - 1];
      return _get__('React').createElement(
        'div',
        { className: 'selection-path-info-box' },
        _get__('React').createElement(
          _get__('Grid'),
          { fluid: true, className: 'path-selection-wrapper' },
          _get__('React').createElement(
            _get__('Row'),
            null,
            list
          )
        ),
        t(prefix + '.' + lastLevel.id + '.instructions') !== prefix + '.' + lastLevel.id + '.instructions' ? _get__('React').createElement(
          'div',
          { className: 'selection-path-info-text' },
          _get__('React').createElement(_get__('AppIcon'), { iconName: 'INFO', containerClass: 'info-icon' }),
          _get__('React').createElement(
            'p',
            null,
            _get__('React').createElement(_get__('InnerHtmlContent'), { content: t(prefix + '.instructions') }),
            _get__('React').createElement(_get__('InnerHtmlContent'), { content: t(prefix + '.' + lastLevel.id + '.instructions', { defaultValue: '' }) })
          ),
          _get__('React').createElement('div', { className: 'clearfix' })
        ) : null
      );
    }
    return _get__('React').createElement('div', null);
  }

  return SelectionPathInfo;
}();

_get__('SelectionPathInfo').propTypes = {
  namespace: _get__('PropTypes').string.isRequired,
  prefix: _get__('PropTypes').string.isRequired,
  path: _get__('PropTypes').array.isRequired,
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return props.namespace;
})(_get__('SelectionPathInfo'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'SelectionPathInfo':
      return SelectionPathInfo;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Col':
      return _reactBootstrap.Col;

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'AppIcon':
      return _AppIcon2['default'];

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectionPathInfo, 'SelectionPathInfo', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SelectionPathInfo/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SelectionPathInfo/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ServiceInfoBox = function (_get__$Component) {
  _inherits(ServiceInfoBox, _get__$Component);

  function ServiceInfoBox(props, context) {
    _classCallCheck(this, ServiceInfoBox);

    var _this = _possibleConstructorReturn(this, (ServiceInfoBox.__proto__ || Object.getPrototypeOf(ServiceInfoBox)).call(this, props, context));

    _this.handleDismiss = _this.handleDismiss.bind(_this);
    _this.handleShow = _this.handleShow.bind(_this);

    _this.state = {
      show: true
    };
    return _this;
  }

  _createClass(ServiceInfoBox, [{
    key: 'handleDismiss',
    value: function () {
      function handleDismiss() {
        this.setState({ show: false });
      }

      return handleDismiss;
    }()
  }, {
    key: 'handleShow',
    value: function () {
      function handleShow() {
        this.setState({ show: true });
      }

      return handleShow;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var t = this.props.t;

        var title = t('serviceInfo.title');
        var content = t('serviceInfo.content');
        var hasTitle = _get__('i18n').exists('serviceInfo.title');
        var hasContent = _get__('i18n').exists('serviceInfo.content');

        if (this.state.show && (hasTitle || hasContent)) {
          return _get__('React').createElement(
            'div',
            { className: 'service-info-box' },
            _get__('React').createElement(
              _get__('Alert'),
              { bsStyle: 'warning', onDismiss: this.handleDismiss },
              title.length > 0 && _get__('React').createElement(
                'h4',
                { className: 'title' },
                _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('serviceInfo.title') })
              ),
              content.length > 0 && _get__('React').createElement(
                'p',
                { className: 'content' },
                _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('serviceInfo.content') })
              )
            )
          );
        }
        return null;
      }

      return render;
    }()
  }]);

  return ServiceInfoBox;
}(_get__('React').Component);

_get__('ServiceInfoBox').propTypes = {
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(['common'], { wait: true })(_get__('ServiceInfoBox'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'i18n':
      return _i18n2['default'];

    case 'React':
      return _react2['default'];

    case 'ServiceInfoBox':
      return ServiceInfoBox;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'Alert':
      return _reactBootstrap.Alert;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ServiceInfoBox, 'ServiceInfoBox', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ServiceInfoBox/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/ServiceInfoBox/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(14);

var _collection = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SingleSelectButton = function (_get__2) {
  _inherits(SingleSelectButton, _get__2);

  function SingleSelectButton(props) {
    _classCallCheck(this, SingleSelectButton);

    var _this = _possibleConstructorReturn(this, (SingleSelectButton.__proto__ || Object.getPrototypeOf(SingleSelectButton)).call(this, props));

    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.state = {
      selectedItem: _this.props.activeItem
    };
    return _this;
  }

  _createClass(SingleSelectButton, [{
    key: 'handleSelect',
    value: function () {
      function handleSelect(clickedItem) {
        this.setState({ selectedItem: clickedItem });
        this.props.onSelect(this.props.id, clickedItem);
      }

      return handleSelect;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            id = _props.id,
            label = _props.label,
            className = _props.className,
            items = _props.items,
            disabled = _props.disabled;


        var menuItems = _get__('map')(items, function (item) {
          return _get__('React').createElement(
            _get__('MenuItem'),
            {
              key: item.id,
              eventKey: item.id,
              active: item.id === _this2.props.activeItem
            },
            item.name
          );
        });

        // const activeItem = find(items, item => (item.id === this.state.selectedItem));
        var activeItem = _get__('find')(items, function (item) {
          return item.id === _this2.props.activeItem;
        });
        var dropDownButton = _get__('React').createElement(
          _get__('DropdownButton'),
          {
            className: 'single-select-button',
            id: id,
            title: activeItem ? activeItem.name : '',
            onSelect: function () {
              function onSelect(eventKey) {
                _this2.handleSelect(eventKey);
              }

              return onSelect;
            }(),
            disabled: disabled
          },
          menuItems
        );

        return label ? _get__('React').createElement(
          _get__('FormGroup'),
          { className: 'filter-single-select ' + className },
          _get__('React').createElement(
            _get__('ControlLabel'),
            { htmlFor: id },
            label
          ),
          dropDownButton
        ) : dropDownButton;
      }

      return render;
    }()
  }]);

  return SingleSelectButton;
}(_get__('Component'));

_get__('SingleSelectButton').propTypes = {
  id: _get__('PropTypes').string.isRequired,
  label: _get__('PropTypes').string,
  className: _get__('PropTypes').string,
  items: _get__('PropTypes').array.isRequired,
  activeItem: _get__('PropTypes').oneOfType([_get__('PropTypes').number, _get__('PropTypes').string]).isRequired,
  onSelect: _get__('PropTypes').func.isRequired,
  disabled: _get__('PropTypes').bool
};

_get__('SingleSelectButton').defaultProps = {
  label: '',
  className: '',
  disabled: false
};

var _DefaultExportValue = _get__('translate')(['common'], { wait: true })(_get__('SingleSelectButton'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'map':
      return _collection.map;

    case 'find':
      return _collection.find;

    case 'Component':
      return _react.Component;

    case 'SingleSelectButton':
      return SingleSelectButton;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'MenuItem':
      return _reactBootstrap.MenuItem;

    case 'DropdownButton':
      return _reactBootstrap.DropdownButton;

    case 'FormGroup':
      return _reactBootstrap.FormGroup;

    case 'ControlLabel':
      return _reactBootstrap.ControlLabel;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SingleSelectButton, 'SingleSelectButton', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SingleSelectButton/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SingleSelectButton/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SymptomLevel = function (_get__2) {
  _inherits(SymptomLevel, _get__2);

  function SymptomLevel() {
    _classCallCheck(this, SymptomLevel);

    return _possibleConstructorReturn(this, (SymptomLevel.__proto__ || Object.getPrototypeOf(SymptomLevel)).apply(this, arguments));
  }

  _createClass(SymptomLevel, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            title = _props.title,
            text = _props.text,
            level = _props.level,
            visible = _props.visible,
            available = _props.available;

        var visibleClasses = visible ? 'in' : '';
        var availableClasses = available ? '' : 'disabled';

        return _get__('React').createElement(
          'div',
          { id: 'booking-phase-symptoms-' + level, className: 'symptom-level collapse ' + visibleClasses + ' ' + availableClasses },
          title && _get__('React').createElement(
            'div',
            null,
            _get__('React').createElement(
              'h2',
              { tabIndex: 0, id: 'booking-phase-symptoms-' + level + '-title', className: 'symptom-level-title' },
              title
            ),
            _get__('React').createElement('hr', null)
          ),
          text && _get__('React').createElement(
            'div',
            { className: 'symptom-level-text' },
            _get__('React').createElement(
              'p',
              null,
              text
            )
          ),
          _get__('React').createElement(
            'div',
            { className: 'symptom-content' },
            this.props.children
          )
        );
      }

      return render;
    }()
  }]);

  return SymptomLevel;
}(_get__('Component'));

_get__('SymptomLevel').propTypes = {
  title: _get__('PropTypes').string.isRequired,
  text: _get__('PropTypes').string,
  level: _get__('PropTypes').number.isRequired,
  visible: _get__('PropTypes').bool,
  available: _get__('PropTypes').bool,
  children: _get__('PropTypes').node
};

_get__('SymptomLevel').defaultProps = {
  text: null,
  visible: true,
  available: true,
  children: null
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('SymptomLevel'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'SymptomLevel':
      return SymptomLevel;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SymptomLevel, 'SymptomLevel', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SymptomLevel/SymptomLevel.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SymptomLevel/SymptomLevel.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _SymptomLevel = __webpack_require__(1140);

var _SymptomLevel2 = _interopRequireDefault(_SymptomLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('SymptomsLevel'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'SymptomsLevel':
      return _SymptomLevel2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SymptomLevel/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SymptomLevel/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/SymptomLevel/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _string = __webpack_require__(160);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _anchorme = __webpack_require__(500);

var _anchorme2 = _interopRequireDefault(_anchorme);

__webpack_require__(1506);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TicketCard = function () {
  function TicketCard(_ref) {
    var selectedTicketCode = _ref.selectedTicketCode,
        ticket = _ref.ticket,
        unit = _ref.unit,
        allResources = _ref.allResources,
        allGroups = _ref.allGroups,
        allUnits = _ref.allUnits,
        _onClick = _ref.onClick,
        t = _ref.t;

    var asMoment = function () {
      function asMoment(date) {
        return _get__('moment')(date, 'YYYY-MM-DD');
      }

      return asMoment;
    }();
    var createdDate = asMoment(ticket.createdDate);
    var openingDate = asMoment(ticket.openingDate);
    var closingDate = asMoment(ticket.closingDate);
    var activationDate = asMoment(ticket.activationDate);
    var isActive = activationDate.isSameOrBefore(_get__('moment')());
    var clientNotes = ticket.clientNotes;

    var translatedClientNotes = t(clientNotes);
    var filteredClientNotes = _get__('anchorme')(translatedClientNotes, {
      attributes: [{
        name: 'target',
        value: '_blank'
      }] });
    var active = selectedTicketCode === ticket.code && isActive;
    var resources = ticket.resources,
        group = ticket.group;

    var timeSlotDefinitions = ticket.timeSlotDefinitions ? ticket.timeSlotDefinitions[0] : null;
    var groupResources = [];
    var resourcesAsObject = allGroups[group];
    var hasValidGroup = group && Object.hasOwnProperty.call(allGroups, group);
    var hasInvalidGroup = group && !Object.hasOwnProperty.call(allGroups, group);
    var disabled = !isActive || hasInvalidGroup;
    var disabledCardClass = disabled ? 'disabled-card time-slot-card' : '';
    if (hasValidGroup) {
      Object.keys(resourcesAsObject).forEach(function (res) {
        return groupResources.push(resourcesAsObject[res]);
      });
    }
    return _get__('React').createElement(
      'div',
      { className: 'ticket-card-container' },
      _get__('React').createElement(
        _get__('Button'),
        {
          className: 'ticket-card ' + disabledCardClass,
          active: active,
          onClick: function () {
            function onClick() {
              _onClick(ticket);
            }

            return onClick;
          }(),
          block: true,
          bsStyle: 'default',
          bsSize: 'large',
          disabled: hasInvalidGroup
        },
        _get__('React').createElement(
          'div',
          { className: 'ticket-card-left' },
          _get__('React').createElement(
            'div',
            { className: 'ticket-card-main' },
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-date' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-duration-label' },
                t('ticket.validPeriod'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data' },
                _get__('capitalize')(openingDate.format('D.M.YYYY')),
                ' \u2013 ',
                _get__('capitalize')(closingDate.format('D.M.YYYY'))
              )
            ),
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-duration' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-duration-label' },
                t('ticket.duration'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data' },
                (ticket.duration ? ticket.duration : timeSlotDefinitions.duration) + ' ' + t('ticket.minutes') + ' '
              )
            ),
            _get__('React').createElement(
              'div',
              { className: 'ticket-created' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-created-label' },
                t('ticket.created'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data' },
                _get__('capitalize')(createdDate.format('D.M.YYYY'))
              )
            )
          ),
          _get__('React').createElement(
            'div',
            { className: 'ticket-card-variables' },
            ticket.speciality && _get__('React').createElement(
              'div',
              { className: 'ticket-card-speciality' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-speciality-label' },
                t('ticket.professionals'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data' },
                t('ticket.specialities.' + ticket.speciality)
              )
            ),
            timeSlotDefinitions && timeSlotDefinitions.specialities && timeSlotDefinitions.specialities.length > 0 && _get__('React').createElement(
              'div',
              { className: 'ticket-card-speciality' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-speciality-label' },
                t('ticket.professionals'),
                ': '
              ),
              timeSlotDefinitions.specialities.map(function (s) {
                return _get__('React').createElement(
                  'div',
                  { key: s, className: 'ticket-card-data' },
                  t('ticket.specialities.' + s)
                );
              })
            ),
            unit && _get__('React').createElement(
              'div',
              { className: 'ticket-card-unit' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-unit-label' },
                t('ticket.unit'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data ticket-card-unit-name' },
                unit.name
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data ticket-card-unit-address' },
                unit.address,
                ', ',
                unit.city
              )
            ),
            timeSlotDefinitions && timeSlotDefinitions.inUnits && timeSlotDefinitions.inUnits.length > 0 && _get__('React').createElement(
              'div',
              null,
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-unit-label' },
                t('ticket.unit'),
                ': '
              ),
              timeSlotDefinitions.inUnits.map(function (u) {
                return allUnits[u];
              }).map(function (timeslotUnit) {
                return timeslotUnit && _get__('React').createElement(
                  'div',
                  { className: 'ticket-card-unit', key: timeslotUnit.name },
                  _get__('React').createElement(
                    'div',
                    { className: 'ticket-card-data ticket-card-unit-name' },
                    timeslotUnit.name
                  ),
                  _get__('React').createElement(
                    'div',
                    { className: 'ticket-card-data ticket-card-unit-address' },
                    timeslotUnit.address,
                    ', ',
                    timeslotUnit.city
                  )
                );
              })
            ),
            resources && resources.length > 0 && _get__('React').createElement(
              'div',
              { className: 'ticket-card-resource' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-resource-name-label' },
                t('ticket.professionals'),
                ': '
              ),
              resources.map(function (r) {
                return allResources[r];
              }).map(function (res) {
                return _get__('React').createElement(
                  'div',
                  { key: res.resource, className: 'ticket-card-data ticket-card-resource-name' },
                  res.name
                );
              })
            ),
            group && hasValidGroup && _get__('React').createElement(
              'div',
              { className: 'ticket-card-resource' },
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-resource-name-label' },
                t('ticket.professionals'),
                ': '
              ),
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-data ticket-card-resource-name' },
                groupResources.join(', ')
              )
            ),
            timeSlotDefinitions && timeSlotDefinitions.inGroups && timeSlotDefinitions.inGroups.length > 0 && _get__('React').createElement(
              'div',
              null,
              _get__('React').createElement(
                'div',
                { className: 'ticket-card-label ticket-card-resource-name-label' },
                t('ticket.professionals'),
                ': '
              ),
              timeSlotDefinitions.inGroups.map(function (u) {
                return allGroups[u];
              }).map(function (timeslotGroup, i) {
                return timeslotGroup && _get__('React').createElement(
                  'div',
                  { key: new Date().getTime(), className: 'ticket-card-data ticket-card-resource-name' },
                  Object.values(timeslotGroup).join(', ')
                );
              })
            )
          ),
          filteredClientNotes && filteredClientNotes.length > 1 && _get__('React').createElement(
            'div',
            { className: 'ticket-notes' },
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-label ticket-card-notes-label' },
              t('ticket.notes'),
              ':'
            ),
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-data' },
              _get__('React').createElement(_get__('InnerHtmlContent'), { content: filteredClientNotes })
            )
          )
        ),
        _get__('React').createElement(
          'div',
          { className: 'ticket-card-right' },
          hasInvalidGroup && null,
          isActive && !hasInvalidGroup && _get__('React').createElement(
            'div',
            { className: 'ticket-card-action-text' },
            t('time_slot_call_to_action')
          ),
          !isActive && _get__('React').createElement(
            'div',
            { className: 'ticket-activation' },
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-label ticket-card-activation-label' },
              t('ticket.activates')
            ),
            _get__('React').createElement(
              'div',
              { className: 'ticket-card-data' },
              _get__('capitalize')(activationDate.format('D.M.YYYY'))
            )
          )
        )
      ),
      hasInvalidGroup && _get__('React').createElement(
        'span',
        { className: 'ticket-card-label ticket-card-resource-name-label' },
        t('ticket.invalidTicket')
      )
    );
  }

  return TicketCard;
}();

_get__('TicketCard').propTypes = {
  t: _get__('PropTypes').func.isRequired,
  selectedTicketCode: _get__('PropTypes').string.isRequired,
  ticket: _get__('PropTypes').shape({
    openingDate: _get__('PropTypes').string.isRequired,
    closingDate: _get__('PropTypes').string.isRequired,
    activationDate: _get__('PropTypes').string.isRequired,
    code: _get__('PropTypes').string,
    cancelled: _get__('PropTypes').bool.isRequired,
    timeType: _get__('PropTypes').string,
    clientNotes: _get__('PropTypes').string.isRequired,
    duration: _get__('PropTypes').number.isRequired,
    title: _get__('PropTypes').string
  }).isRequired,
  unit: _get__('PropTypes').shape({
    name: _get__('PropTypes').string.isRequired,
    address: _get__('PropTypes').string.isRequired,
    city: _get__('PropTypes').string.isRequired,
    info: _get__('PropTypes').string
  }),
  allResources: _get__('PropTypes').object.isRequired,
  allGroups: _get__('PropTypes').object.isRequired,
  allUnits: _get__('PropTypes').object.isRequired,
  onClick: _get__('PropTypes').func
};

_get__('TicketCard').defaultProps = {
  unit: undefined,
  group: undefined,
  onClick: function () {
    function onClick() {}

    return onClick;
  }()
};

var _default = _get__('TicketCard');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'moment':
      return _moment2['default'];

    case 'anchorme':
      return _anchorme2['default'];

    case 'capitalize':
      return _string.capitalize;

    case 'TicketCard':
      return TicketCard;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof TicketCard === 'undefined' ? 'undefined' : _typeof(TicketCard);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(TicketCard, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(TicketCard)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TicketCard, 'TicketCard', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/TicketCard/index.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/components/TicketCard/index.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _CancelReservationAsDiv = __webpack_require__(1154);

var _CancelReservationAsDiv2 = _interopRequireDefault(_CancelReservationAsDiv);

var _History = __webpack_require__(552);

var _History2 = _interopRequireDefault(_History);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppointmentManagement = function (_get__2) {
  _inherits(AppointmentManagement, _get__2);

  function AppointmentManagement() {
    _classCallCheck(this, AppointmentManagement);

    return _possibleConstructorReturn(this, (AppointmentManagement.__proto__ || Object.getPrototypeOf(AppointmentManagement)).apply(this, arguments));
  }

  _createClass(AppointmentManagement, [{
    key: 'render',
    value: function () {
      function render() {
        var viaSso = this.props.viaSso;

        var manager = viaSso ? _get__('React').createElement(_get__('History'), null) : _get__('React').createElement(_get__('CancelReservationAsDiv'), null);
        return _get__('React').createElement(
          'div',
          null,
          manager
        );
      }

      return render;
    }()
  }]);

  return AppointmentManagement;
}(_get__('Component'));

_get__('AppointmentManagement').propTypes = {
  viaSso: _get__('PropTypes').bool.isRequired
};

_get__('AppointmentManagement').defaultProps = {};

var _DefaultExportValue = _get__('translate')(['common', 'booking'], { wait: true })(_get__('AppointmentManagement'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'AppointmentManagement':
      return AppointmentManagement;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'History':
      return _History2['default'];

    case 'CancelReservationAsDiv':
      return _CancelReservationAsDiv2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(AppointmentManagement, 'AppointmentManagement', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/AppointmentManagement/AppointmentManagement.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/AppointmentManagement/AppointmentManagement.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _AppointmentManagement = __webpack_require__(1143);

var _AppointmentManagement2 = _interopRequireDefault(_AppointmentManagement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      viaSso: state.session.viaSso
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('AppointmentManagement'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'AppointmentManagement':
      return _AppointmentManagement2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/AppointmentManagement/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/AppointmentManagement/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/AppointmentManagement/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(249);

var _jquery2 = _interopRequireDefault(_jquery);

var _reactBootstrap = __webpack_require__(14);

var _reactScroll = __webpack_require__(213);

var _lang = __webpack_require__(159);

var _collection = __webpack_require__(198);

var _object = __webpack_require__(313);

var _array = __webpack_require__(741);

var _util = __webpack_require__(2008);

var _reactCalendar = __webpack_require__(506);

var _reactCalendar2 = _interopRequireDefault(_reactCalendar);

__webpack_require__(1497);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(11);

var _lodash = __webpack_require__(117);

var _lodash2 = _interopRequireDefault(_lodash);

var _UnitInfo = __webpack_require__(553);

var _UnitInfo2 = _interopRequireDefault(_UnitInfo);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

__webpack_require__(391);

var _AdditionalDiscussionCheckbox = __webpack_require__(1108);

var _AdditionalDiscussionCheckbox2 = _interopRequireDefault(_AdditionalDiscussionCheckbox);

var _BookingPhase = __webpack_require__(218);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

var _SymptomLevel = __webpack_require__(1141);

var _SymptomLevel2 = _interopRequireDefault(_SymptomLevel);

var _CodeForm = __webpack_require__(1115);

var _CodeForm2 = _interopRequireDefault(_CodeForm);

var _SimpleBox = __webpack_require__(219);

var _SimpleBox2 = _interopRequireDefault(_SimpleBox);

var _RegistrationForm = __webpack_require__(1164);

var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);

var _InfoBox = __webpack_require__(548);

var _InfoBox2 = _interopRequireDefault(_InfoBox);

var _OptionGroup = __webpack_require__(1132);

var _OptionGroup2 = _interopRequireDefault(_OptionGroup);

var _SingleSelectButton = __webpack_require__(1139);

var _SingleSelectButton2 = _interopRequireDefault(_SingleSelectButton);

var _MultiSelectButton = __webpack_require__(1162);

var _MultiSelectButton2 = _interopRequireDefault(_MultiSelectButton);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _TimeSlots = __webpack_require__(1172);

var _TimeSlots2 = _interopRequireDefault(_TimeSlots);

var _SelectionPathInfo = __webpack_require__(1137);

var _SelectionPathInfo2 = _interopRequireDefault(_SelectionPathInfo);

var _ConfirmTimeSlotForm = __webpack_require__(1116);

var _ConfirmTimeSlotForm2 = _interopRequireDefault(_ConfirmTimeSlotForm);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _UnitInfoContainer = __webpack_require__(1147);

var _UnitInfoContainer2 = _interopRequireDefault(_UnitInfoContainer);

var _constants = __webpack_require__(76);

var _helpers = __webpack_require__(119);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _unitHelper = __webpack_require__(1188);

var _unitHelper2 = _interopRequireDefault(_unitHelper);

var _pathTypes = __webpack_require__(554);

var _pathTypes2 = _interopRequireDefault(_pathTypes);

var _ByTicket = __webpack_require__(1150);

var _ByTicket2 = _interopRequireDefault(_ByTicket);

var _History = __webpack_require__(552);

var _History2 = _interopRequireDefault(_History);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

var _LoginFormSelector = __webpack_require__(1146);

var _LoginFormSelector2 = _interopRequireDefault(_LoginFormSelector);

var _LoginComponent = __webpack_require__(551);

var _LoginComponent2 = _interopRequireDefault(_LoginComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { SingleDatePicker } from 'react-dates';
// import 'react-dates/lib/css/_datepicker.css';


var timeMomentSort = function () {
  function timeMomentSort(a, b) {
    return a.timeMoment.isBefore(b.timeMoment) ? -1 : 1;
  }

  return timeMomentSort;
}();

var Booking = function (_get__2) {
  _inherits(Booking, _get__2);

  /*
  Bind needed methods to the instance of component, define default values and state
   */
  function Booking(props) {
    _classCallCheck(this, Booking);

    var _this = _possibleConstructorReturn(this, (Booking.__proto__ || Object.getPrototypeOf(Booking)).call(this, props));

    _this.onCloseErrorModal = _this.onCloseErrorModal.bind(_this);
    _this.toggleUseCode = _this.toggleUseCode.bind(_this);
    _this.requestTimeSlotsUsingCode = _this.requestTimeSlotsUsingCode.bind(_this);
    _this.requestTimeSlotsHandler = _this.requestTimeSlotsHandler.bind(_this);
    _this.additionalDiscussionValueChanged = _this.additionalDiscussionValueChanged.bind(_this);
    _this.select = _this.select.bind(_this);
    _this.selectDate = _this.selectDate.bind(_this);
    _this.activateModifyTimeSlotParams = _this.activateModifyTimeSlotParams.bind(_this);
    _this.modifyTimeSlotParams = _this.modifyTimeSlotParams.bind(_this);
    _this.updateFilters = _this.updateFilters.bind(_this);
    _this.updateStartTimeFilter = _this.updateStartTimeFilter.bind(_this);
    _this.useFilters = _this.useFilters.bind(_this);
    _this.selectTimeSlot = _this.selectTimeSlot.bind(_this);
    _this.confirmTimeSlot = _this.confirmTimeSlot.bind(_this);
    _this.resetBookingState = _this.resetBookingState.bind(_this);
    _this.cancelConfirm = _this.cancelConfirm.bind(_this);
    _this.getSelection = _this.getSelection.bind(_this);
    _this.emailConfirmationEnabled = _this.emailConfirmationEnabled;
    _this.smsConfirmationEnabled = _this.smsConfirmationEnabled;
    _this.onDateChange = _this.onDateChange.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.initialState = {
      useCode: false,
      modifyTimeSlotParamsActivated: false,
      modifiedTimeSlotParams: {},
      userClickedRequestTimeSlots: false,
      date: _get__('moment')(),
      filters: {
        unit: [],
        resource: []
      },
      isMobile: window.innerWidth < 768,
      startTimeFilter: _get__('DEFAULT_START_TIME'),
      filteredTimeSlotsByDate: {},
      showMobileDatePicker: false,
      selectedTimeSlot: {},
      reset: false,
      targetLevel: 1,
      dedicatedResources: {},
      ownCareTeamSelected: false,
      showingTimesForCareTeam: false
    };

    _this.state = _this.initialState;

    var selectedStoredTimeSlot = props.selectedStoredTimeSlot,
        restoredState = props.restoredState;

    var processedSelectedStoredTimeslot = void 0;
    if (Object.keys(selectedStoredTimeSlot).indexOf('timeMoment') !== -1) {
      processedSelectedStoredTimeslot = _extends({}, selectedStoredTimeSlot, {
        timeMoment: _get__('moment')(selectedStoredTimeSlot.timeMoment)
      });
    }

    _this.filtersConfig = {
      unit: {
        label: 'Toimipiste',
        items: _this.props.units
      },
      resource: {
        label: 'Asiantuntija',
        items: {}
      }
    };
    _this.startTimeItems = _get__('range')(24).map(function (hour) {
      return {
        id: hour,
        name: _get__('moment')({ hour: hour, minute: 0 }).format('LT')
      };
    });
    if (processedSelectedStoredTimeslot && Object.keys(processedSelectedStoredTimeslot).length !== 0 && restoredState) {
      _this.state = _extends({}, _this.initialState, {
        date: processedSelectedStoredTimeslot.timeMoment,
        selectedTimeSlot: processedSelectedStoredTimeslot
      });
      _this.props.unsetSelectedTimeslotToStore();
    }
    return _this;
  }

  _createClass(Booking, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _props = this.props,
            restoredState = _props.restoredState,
            timeSlots = _props.timeSlots,
            requiresEmployer = _props.requiresEmployer;

        window.addEventListener('resize', this.handleResize);
        if (restoredState && !requiresEmployer) {
          this.useFilters(timeSlots, false);
        }
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var userJustLoggedOut = this.props.userIdentified && !nextProps.userIdentified;
        // if user just logged out reset the state of booking and scroll to top of the page
        if (userJustLoggedOut) {
          console.log('userJustLoggedOut -> Booking.initialState');
          this.setState(this.initialState, function () {
            _get__('animateScroll').scrollToTop(_get__('scrollSettings'));
          });
          this.toggleUseCode(this.initialState.useCode);
          // user has requested timeslots or changed filters set up
        } else if (!_get__('isEmpty')(nextProps.timeSlots) && nextProps.timeSlots !== this.props.timeSlots) {
          var state = {};
          // udpate units and resources if changed
          if (nextProps.units !== this.props.units) {
            console.log('Updating unit filter config!');
            state.filtersConfig.unit.items = this.props.units;
          }
          if (nextProps.resources !== this.props.resources) {
            console.log('Updating resource filter config!');
            state.filtersConfig.resource.items = this.props.resources;
          }
          // if user requested timeslots, process filters to further apply to timeslots
          this.setState(state, function () {
            if (_this2.state.userClickedRequestTimeSlots) {
              _this2.initializeFilters();
            }
            _this2.useFilters(nextProps.timeSlots);
          });
        }
        var selectionHandler = this.props.selectionHandler;
        var byTicket = nextProps.selectedPathType === _get__('pathTypes').BY_TICKET;
        // set path type in selectoin handler according to used path type
        if (byTicket) {
          selectionHandler.setIsByTicket();
        } else {
          selectionHandler.removeByTicket();
        }
        // NOTE: here we react when the selected ticket has changed
        if (byTicket && nextProps.hasSelectedTicket && !_get__('_').isEqual(this.props.selectedTicket, nextProps.selectedTicket)) {
          // set the handler to the new ticket
          selectionHandler.setTicket(nextProps.selectedTicket);
          // de-select the time slot and reset dedicated resources
          this.setState({
            selectedTimeSlot: {},
            dedicatedResources: {}
          });
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        // if user is requesting timeslots and he has selected employer department, request timeslots
        // once again with home unit filter
        if (this.state.userClickedRequestTimeSlots) {
          var userJustSelectedEmployerDepartment = prevProps.selectedEmployer !== this.props.selectedEmployer && this.props.selectedEmployer >= 0;
          if (userJustSelectedEmployerDepartment) {
            var timeSlotParams = this.getCurrentTimeSlotParams();
            var user = this.props.user;

            if (user && user.homeUnitId) {
              timeSlotParams.homeUnitId = user.homeUnitId;
            }
            this.props.requestTimeSlots(timeSlotParams);
            return;
          }
        }
        var selectionHandler = this.props.selectionHandler;
        var selectedOptionIds = selectionHandler.getSelectedOptionIds();
        var selectedLevels = selectedOptionIds.length;
        var finalLevelReached = selectionHandler.isFinalLevelReached();
        var finalOption = selectionHandler.getLastSelectedOption();
        var targetLevel = this.state.targetLevel;

        var scrollElement = void 0;
        // indentify where to scroll (if needed) after component update
        var extraSettings = {};
        if (prevState.showMobileDatePicker !== this.state.showMobileDatePicker) {
          // Don't scroll if showMobileDatePicker changed.
        } else if (this.props.requestingTimeSlots) {
          // Don't scroll while loading time slots.
        } else if (this.props.currentlyIdentifying) {
          // Don't scroll while identifying.
        } else if (this.props.currentlyRegistering) {
          // Don't scroll while registering.
        } else if (this.props.storingReservation) {
          // Don't scroll while storing the reservation.
        } else if (this.props.reservationDone) {
          scrollElement = 'booking-phase-reservation-done';
        } else if (!_get__('isEqual')(prevState.modifiedTimeSlotParams, this.state.modifiedTimeSlotParams)) {
          // Don't scroll if modifiedTimeSlotParams changed.
        } else if (!_get__('isEmpty')(this.state.selectedTimeSlot)) {
          scrollElement = 'booking-phase-confirm-container';
        } else if (this.state.userClickedRequestTimeSlots || !_get__('isEmpty')(this.props.timeSlots)) {
          scrollElement = 'booking-phase-select-time-container';
        } else if (finalLevelReached && (finalOption.reservation || finalOption.external)) {
          scrollElement = null;
          var element = '#anchor-scroll-target';
          if (_get__('isElementVisible')(element)) {
            return;
          }
          var target = _get__('$')(element).offset().top - (_get__('$')(window).height() - _get__('$')(element).height());
          _get__('animateScroll').scrollTo(target + 10, _extends({}, _get__('scrollSettings'), extraSettings));
        } else if (selectedLevels) {
          scrollElement = 'booking-phase-symptoms-' + (targetLevel + 1);
        }
        // if scroll element was defined, scroll there
        if (scrollElement) {
          console.log('scrolling to: ' + scrollElement);
          _get__('scroller').scrollTo(scrollElement, _extends({}, _get__('scrollSettings'), extraSettings));
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }

      return componentWillUnmount;
    }()

    // after closing error message, reload the page

  }, {
    key: 'onCloseErrorModal',
    value: function () {
      function onCloseErrorModal() {
        window.location.reload();
      }

      return onCloseErrorModal;
    }()
  }, {
    key: 'onDateChange',
    value: function () {
      function onDateChange(date) {
        var momentDate = _get__('moment')(date);
        this.setState({ date: momentDate });
      }

      return onDateChange;
    }()
  }, {
    key: 'getCurrentTimeSlotParams',
    value: function () {
      function getCurrentTimeSlotParams() {
        var timeSlotParams = {};
        var selectionHandler = this.props.selectionHandler;
        if (selectionHandler.isUsingPath()) {
          var finalLevelReached = selectionHandler.isFinalLevelReached();
          if (finalLevelReached) {
            var finalOption = selectionHandler.getLastSelectedOption();
            if (finalOption.reservation) {
              timeSlotParams = Object.assign({}, finalOption.reservation);
              // add additional discussion needed time to timeslot duration
              if (this.props.additionalDiscussionChecked) {
                if (_typeof(timeSlotParams.duration) === 'object') {
                  // if timeslot duration has defined type
                  Object.keys(timeSlotParams.duration).forEach(function (type) {
                    timeSlotParams.duration[type] += _get__('EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION');
                  });
                } else {
                  // if timeslot duration is a number
                  timeSlotParams.duration += _get__('EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION');
                }
              }
            }
          }
        } else if (selectionHandler.isUsingCode()) {
          //  we need to map the groups' name to groups' codes to find if there is a special group for timeslots provided with a code
          var groups = this.props.groups;

          var code = selectionHandler.getCode();
          var regex = new RegExp('^VARAUS-KOODILLA:' + code + '$');
          var codeGroup = Object.keys(groups).filter(function (key) {
            return groups[key].name.match(regex);
          });
          var codeGroupParam = codeGroup.length ? codeGroup[0] : null;
          var resources = { timeType: code };
          if (codeGroupParam) {
            resources.inGroups = [codeGroupParam];
          }
          timeSlotParams = {
            resources: [resources]
          };
        } else if (selectionHandler.isByTicket()) {
          console.log('reservation by ticket');
        }
        var utilizeEmployerInformation = this.props.utilizeEmployerInformation;

        timeSlotParams.responsibleResources = [];

        // add employer infromation and responsible resources to timeslot params if needed
        if (utilizeEmployerInformation) {
          var userEmployer = this.getUserEmployer();
          if (userEmployer) {
            timeSlotParams.company = userEmployer.company;
            timeSlotParams.responsibleResources = this.getResponsibleResources();
          }
        }
        // change duration and specialty in case those parameters were changed in new timeslot params
        if (this.state.modifiedTimeSlotParams) {
          if (this.state.modifiedTimeSlotParams.duration) {
            timeSlotParams.duration = this.state.modifiedTimeSlotParams.duration;
          }
          if (this.state.modifiedTimeSlotParams.speciality) {
            timeSlotParams.resources[0].speciality = this.state.modifiedTimeSlotParams.speciality;
          }
        }
        timeSlotParams.userIdentified = this.props.userIdentified;
        timeSlotParams.legalEntity = this.props.legalEntity;
        timeSlotParams.canAnonymousFetchTimes = this.props.canAnonymousFetchTimes;
        return timeSlotParams;
      }

      return getCurrentTimeSlotParams;
    }()
  }, {
    key: 'getUserEmployer',
    value: function () {
      function getUserEmployer() {
        var userEmployer = {};
        var user = this.props.user;
        if (user.employers && user.employers.length) {
          userEmployer = user.employers[this.props.selectedEmployer] || {};
        }
        return userEmployer;
      }

      return getUserEmployer;
    }()

    // get all responsible resourses from user's employer

  }, {
    key: 'getResponsibleResources',
    value: function () {
      function getResponsibleResources() {
        // if ticket has dedicated resources, use those instead of user employer.
        if (this.state.dedicatedResources && this.state.dedicatedResources.resources) {
          var resources = [];
          var timeSlotDefinitions = this.props.selectionHandler.ticket.timeSlotDefinitions[0];
          if (timeSlotDefinitions && timeSlotDefinitions.inGroups) {
            var isDedicatedResources = _get__('_').find(timeSlotDefinitions.inGroups, 'dedicated');
            if (isDedicatedResources !== -1) {
              Object.entries(this.state.dedicatedResources.resources).forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                resources.push({ 'resource': key, 'name': value });
              });
              return _get__('trimResourceNames')(resources);
            }
          }
        }
        var responsibleResources = [];
        var userEmployer = this.getUserEmployer();
        if (this.props.hasDepartment) {
          var departments = userEmployer.departments || [];
          var userDepartment = departments[this.props.selectedDepartment];
          if (userDepartment && userDepartment.resources && userDepartment.resources.length) {
            responsibleResources = userDepartment.resources;
          }
        } else {
          responsibleResources = userEmployer.resources || [];
        }
        return _get__('trimResourceNames')(responsibleResources);
      }

      return getResponsibleResources;
    }()

    // get responsible resources based on selected speciality

  }, {
    key: 'getCurrentResponsibleResources',
    value: function () {
      function getCurrentResponsibleResources() {
        var currentResponsibleResources = [];
        var selectionHandler = this.props.selectionHandler;
        if (selectionHandler.isUsingPath()) {
          var timeSlotParams = this.getCurrentTimeSlotParams();
          var requestedSpeciality = _get__('get')(timeSlotParams, 'resources[0].speciality');
          currentResponsibleResources = this.getResponsibleResources().filter(function (r) {
            if (Array.isArray(requestedSpeciality)) {
              return requestedSpeciality.indexOf(r.speciality) > -1;
            }
            return requestedSpeciality === r.speciality;
          });
        }
        console.log('getCurrentResponsibleResources', currentResponsibleResources);
        return currentResponsibleResources;
      }

      return getCurrentResponsibleResources;
    }()
  }, {
    key: 'getTimeSlotsForSelectedDay',
    value: function () {
      function getTimeSlotsForSelectedDay() {
        var formattedDay = this.state.date.format(_get__('DATE_FORMAT_SYSTEM'));
        return this.state.filteredTimeSlotsByDate[formattedDay] ? this.state.filteredTimeSlotsByDate[formattedDay] : [];
      }

      return getTimeSlotsForSelectedDay;
    }()
  }, {
    key: 'getSelectedFilters',
    value: function () {
      function getSelectedFilters(filterId) {
        return this.state.filters[filterId] || [];
      }

      return getSelectedFilters;
    }()
  }, {
    key: 'getUnitData',
    value: function () {
      function getUnitData(unitId) {
        return this.props.units[unitId];
      }

      return getUnitData;
    }()

    // get last selected option in path

  }, {
    key: 'getSelection',
    value: function () {
      function getSelection() {
        var selectedPath = this.props.selectionHandler.getSelectedOptions();
        if (selectedPath && selectedPath.length) {
          return selectedPath[selectedPath.length - 1];
        }
        return null;
      }

      return getSelection;
    }()

    // build a sentence for requesting time slots section labeol

  }, {
    key: 'getSentenceForTimeSlotParams',
    value: function () {
      function getSentenceForTimeSlotParams(modifyTimeSlotParamsActivated) {
        var _props2 = this.props,
            pathNamespace = _props2.pathNamespace,
            selectionHandler = _props2.selectionHandler,
            t = _props2.t;

        var selectedPath = selectionHandler.getSelectedOptions();
        var selectedLastLevel = selectedPath.length > 0 ? selectedPath[selectedPath.length - 1] : null;
        var specialityTextKey = null;
        if (selectedLastLevel && selectedLastLevel.reservation && selectedLastLevel.reservation.specialityTextKey) {
          specialityTextKey = selectedLastLevel.reservation.specialityTextKey;
        }
        var sentence = void 0;
        var durationUnit = t('duration_unit');
        var getDurationLabel = function () {
          function getDurationLabel(d) {
            return isNaN(d) ? '' : d + ' ' + durationUnit;
          }

          return getDurationLabel;
        }();
        var getSpecialityLabel = function () {
          function getSpecialityLabel(s) {
            return t(pathNamespace + ':for_specialist_' + s, { defaultValue: '' });
          }

          return getSpecialityLabel;
        }();
        var timeSlotParams = this.getCurrentTimeSlotParams();
        var speciality = timeSlotParams.resources[0].speciality;

        // if duration or speciality can be modified

        if (modifyTimeSlotParamsActivated) {
          var durationFilterId = 'duration';
          var specialityFilterId = 'speciality';
          var durationFilterItems = [];
          var specialityFilterItems = [];
          if (timeSlotParams.options) {
            // Use only items that are defined in config for current path.
            if (timeSlotParams.options.duration) {
              durationFilterItems = timeSlotParams.options.duration.map(function (d) {
                return { id: d, name: getDurationLabel(d) };
              });
            }
          } else {
            durationFilterItems = [{ id: 5, name: getDurationLabel(5) }, { id: 10, name: getDurationLabel(10) }, { id: 15, name: getDurationLabel(15) }, { id: 20, name: getDurationLabel(20) }, { id: 30, name: getDurationLabel(30) }, { id: 45, name: getDurationLabel(45) }, { id: 60, name: getDurationLabel(60) }, { id: 70, name: getDurationLabel(70) }, { id: 75, name: getDurationLabel(75) }];
            specialityFilterItems = [{ id: '/specialities/2', name: getSpecialityLabel('/specialities/2') }, { id: '/specialities/14', name: getSpecialityLabel('/specialities/14') }, { id: '/specialities/20', name: getSpecialityLabel('/specialities/20') }, { id: '/specialities/27', name: getSpecialityLabel('/specialities/27') }];
          }
          var sentenceParams = {
            resourceType: t('for_resourceType_' + timeSlotParams.resources[0].type, { defaultValue: '' }),
            time: t(('time_type_' + timeSlotParams.resources[0].timeType).replace('.', '*'), { defaultValue: t('time_type_default') })
          };
          if (!_get__('isEmpty')(durationFilterItems)) {
            sentenceParams.duration = _get__('React').createElement(_get__('SingleSelectButton'), {
              id: durationFilterId,
              items: durationFilterItems,
              activeItem: timeSlotParams.duration,
              onSelect: this.modifyTimeSlotParams,
              disabled: this.state.userClickedRequestTimeSlots
            });
          } else {
            sentenceParams.duration = getDurationLabel(timeSlotParams.duration);
          }
          if (!_get__('isEmpty')(specialityFilterItems)) {
            sentenceParams.specialist = _get__('React').createElement(_get__('SingleSelectButton'), {
              id: specialityFilterId,
              items: specialityFilterItems,
              activeItem: Array.isArray(speciality) ? speciality[0] : speciality,
              onSelect: this.modifyTimeSlotParams,
              disabled: this.state.userClickedRequestTimeSlots
            });
            sentenceParams.time += ' ';
          } else {
            sentenceParams.specialist = specialityTextKey ? t(pathNamespace + ':specialtyTexts.' + specialityTextKey) : getSpecialityLabel(Array.isArray(speciality) ? speciality[0] : speciality);
          }
          sentence = _get__('React').createElement(_get__('Interpolate'), _extends({
            i18nKey: 'request_time_slots_info'
          }, sentenceParams));
        } else {
          // if there is no modification for speciality or duration of timeslot
          var _sentenceParams = {
            duration: getDurationLabel(timeSlotParams.duration),
            resourceType: t('for_resourceType_' + timeSlotParams.resources[0].type, { defaultValue: '' }),
            specialist: specialityTextKey ? t(pathNamespace + ':specialtyTexts.' + specialityTextKey) : getSpecialityLabel(Array.isArray(speciality) ? speciality[0] : speciality),
            time: t(('time_type_' + timeSlotParams.resources[0].timeType).replace('.', '*'), { defaultValue: t('time_type_default') })
          };
          sentence = t('request_time_slots_info', _sentenceParams);
        }
        return sentence;
      }

      return getSentenceForTimeSlotParams;
    }()

    // get login component depending on authentication policy

  }, {
    key: 'getLoginForm',
    value: function () {
      function getLoginForm(t) {
        var loginPolicyType = this.props.loginPolicyType;


        return _get__('React').createElement(_get__('LoginFormSelector'), { loginPolicyType: loginPolicyType, t: t });
      }

      return getLoginForm;
    }()
  }, {
    key: 'isUserSotuTemporary',
    value: function () {
      function isUserSotuTemporary() {
        return this.props.user.sotu.substring(7, 8) === '9';
      }

      return isUserSotuTemporary;
    }()
  }, {
    key: 'handleResize',
    value: function () {
      function handleResize() {
        this.setState({ isMobile: window.innerWidth < 768 });
      }

      return handleResize;
    }()
  }, {
    key: 'populateResourceFilter',
    value: function () {
      function populateResourceFilter(resources) {
        this.setState({ showingTimesForCareTeam: !this.state.showingTimesForCareTeam });
        var items = _get__('map')(resources, function (r) {
          return r.resource;
        });
        var itemKeys = _get__('keys')(this.filtersConfig.resource.items);
        items = _get__('filter')(items, function (item) {
          return _get__('includes')(itemKeys, item);
        });
        this.updateFilters('resource', items);
      }

      return populateResourceFilter;
    }()
  }, {
    key: 'applyDefaultFilter',
    value: function () {
      function applyDefaultFilter(resources) {
        this.setState({ ownCareTeamSelected: true, showingTimesForCareTeam: true });
        this.populateResourceFilter(resources);
      }

      return applyDefaultFilter;
    }()
  }, {
    key: 'filterByDuration',
    value: function () {
      function filterByDuration(duration, timeSlots) {
        var _this3 = this;

        var filteredTimeSlots = [];
        var now = _get__('moment')();
        var _props3 = this.props,
            pathNamespace = _props3.pathNamespace,
            units = _props3.units,
            resources = _props3.resources,
            t = _props3.t;
        // console.log('units', units);

        timeSlots.forEach(function (timeSlot) {
          var consequtiveSlotsRequired = duration ? duration / timeSlot.duration - 1 : 0;
          var speciality = timeSlot.speciality;

          var resourceType = t('resources.time_type_' + timeSlot.type.replace('.', '*'), { defaultValue: t(pathNamespace + ':resources.' + (Array.isArray(speciality) ? speciality[0] : speciality), { defaultValue: '' }) });
          timeSlot.times.forEach(function (item, index, array) {
            // check that the time is immediately after this one.
            // Check that there are enough many times to cover the whole duration
            // Add starting time to times.
            var timeMoment = _get__('moment')(item);
            if (timeMoment.isBefore(now)) {
              // A time in the past
              return;
            }
            if (consequtiveSlotsRequired) {
              if (consequtiveSlotsRequired < 1) {
                // the time slot is longer than what we require, let's not try to book a part of it
                return;
              }
              if (index + consequtiveSlotsRequired >= array.length) {
                // Not enough consequtive times in the array after this one
                // (No need to parse times beyond this, would be more efficient to break a for loop...)
                return;
              }
              if (-timeMoment.diff(array[index + consequtiveSlotsRequired], 'minutes') !== timeSlot.duration * consequtiveSlotsRequired) {
                // Not enough times next to each other
                return;
              }
            }
            var timeSlotUnitExists = Object.prototype.hasOwnProperty.call(units, timeSlot.unit);
            var timeSlotResourceExists = Object.prototype.hasOwnProperty.call(resources, timeSlot.resource);
            // there is enough time
            if (timeSlotUnitExists && timeSlotResourceExists) {
              filteredTimeSlots.push(_extends({}, timeSlot, {
                timeMoment: timeMoment,
                duration: duration,
                unitName: units[timeSlot.unit].name,
                unitAddress: units[timeSlot.unit].address,
                resourceName: resources[timeSlot.resource].name,
                resourceType: resourceType
              }));
            } else {
              // Correct time slot exists, BUT timeslot unit OR resource does not exist any more
              console.log('ERROR: Timeslot resource OR unit did not exist:');
              console.log('Units:', _this3.props.units);
              console.log('Resources:', _this3.props.resources);
              console.log('timeSlot:', timeSlot);
            }
          });
        });
        console.log('Filtered time slots by duration', timeSlots, duration, filteredTimeSlots);
        return filteredTimeSlots;
      }

      return filterByDuration;
    }()
  }, {
    key: 'filterForReservationByCode',
    value: function () {
      function filterForReservationByCode(timeSlots) {
        var _this4 = this;

        var filteredTimeSlots = [];
        var now = _get__('moment')();
        var pathNamespace = this.props.pathNamespace;

        timeSlots.forEach(function (timeSlot) {
          var speciality = timeSlot.speciality;

          var resourceType = _this4.props.t('resources.time_type_' + timeSlot.type.replace('.', '*'), { defaultValue: _this4.props.t(pathNamespace + ':resources.' + (Array.isArray(speciality) ? speciality[0] : speciality), { defaultValue: '' }) });
          timeSlot.times.forEach(function (item) {
            var timeMoment = _get__('moment')(item);
            if (timeMoment.isBefore(now)) {
              // A time in the past
              return;
            }
            filteredTimeSlots.push(_extends({}, timeSlot, {
              timeMoment: timeMoment,
              unitName: _this4.props.units[timeSlot.unit].name,
              unitAddress: _this4.props.units[timeSlot.unit].address,
              resourceName: _this4.props.resources[timeSlot.resource].name,
              resourceType: resourceType
            }));
          });
        });
        console.log('Filtered time slots for reservations by code', timeSlots, filteredTimeSlots);
        return filteredTimeSlots;
      }

      return filterForReservationByCode;
    }()

    // return timeslots after a selected hour in a day in filters

  }, {
    key: 'filterByStartTime',
    value: function () {
      function filterByStartTime(startTimeHour, timeSlots) {
        if (timeSlots.length) {
          return _get__('filter')(timeSlots, function (timeSlot) {
            var startTimeMoment = timeSlot.timeMoment.clone().hour(startTimeHour).minute(0);
            return timeSlot.timeMoment.isSameOrAfter(startTimeMoment);
          });
        }
        return timeSlots;
      }

      return filterByStartTime;
    }()
  }, {
    key: 'hasFreeTimesForDay',
    value: function () {
      function hasFreeTimesForDay(day) {
        var dateObj = _get__('moment')(day ? new Date(day) : {});
        var formattedDay = dateObj.format(_get__('DATE_FORMAT_SYSTEM'));
        var timeSlots = this.state.filteredTimeSlotsByDate[formattedDay];
        return !!(timeSlots && timeSlots.length);
      }

      return hasFreeTimesForDay;
    }()

    // set path or code based booking type in selectoin handler with reset of the state

  }, {
    key: 'toggleUseCode',
    value: function () {
      function toggleUseCode(useCode) {
        var selectionHandler = this.props.selectionHandler;
        if (useCode) {
          selectionHandler.useCode();
        } else {
          selectionHandler.usePath();
        }
        this.setState({
          useCode: useCode,
          modifyTimeSlotParamsActivated: false,
          modifiedTimeSlotParams: this.initialState.modifiedTimeSlotParams,
          userClickedRequestTimeSlots: false,
          filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
          selectedTimeSlot: this.initialState.selectedTimeSlot
        });
        this.props.selectedOptionsChanged([]);
      }

      return toggleUseCode;
    }()
  }, {
    key: 'requestTimeSlotsUsingCode',
    value: function () {
      function requestTimeSlotsUsingCode(code) {
        var selectionHandler = this.props.selectionHandler;
        selectionHandler.setCode(code);
        this.requestTimeSlotsHandler();
      }

      return requestTimeSlotsUsingCode;
    }()
  }, {
    key: 'requestTimeSlotsHandler',
    value: function () {
      function requestTimeSlotsHandler(params) {
        var _this5 = this;

        var timeSlotParams = this.getCurrentTimeSlotParams();
        var date = void 0;
        if (params && params.month) {
          console.log('setting calendar', params, this.state.date);
          date = params.month;
          timeSlotParams.from = date.clone().startOf('month');
          timeSlotParams.to = date.clone().endOf('month');
        } else {
          // Reset calendar view to current month
          date = _get__('moment')();
        }
        var dateString = new Date(date);
        this.setState({
          userClickedRequestTimeSlots: true,
          filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
          selectedTimeSlot: this.initialState.selectedTimeSlot,
          date: date
        });
        if (this.props.userIdentified || this.props.canAnonymousFetchTimes) {
          var user = this.props.user;

          if (user && user.homeUnitId) {
            timeSlotParams.homeUnitId = user.homeUnitId;
          }
          var selectionHandler = this.props.selectionHandler;
          if (selectionHandler.isByTicket() && selectionHandler.ticket && selectionHandler.ticket.isMovendosTimeReservationTicket && selectionHandler.ticket.orgIdForDedicated) {
            timeSlotParams.company = selectionHandler.ticket.orgIdForDedicated;
            timeSlotParams.orgIdForDedicated = selectionHandler.ticket.orgIdForDedicated;

            _get__('api').requestDedicatedResources(selectionHandler.ticket.orgIdForDedicated).then(function (resources) {
              timeSlotParams.responsibleResources = resources;
              // store dedicated resources for filters
              _this5.state.dedicatedResources = resources;
              _this5.props.requestTimeSlots(timeSlotParams);
            });
          } else {
            this.props.requestTimeSlots(timeSlotParams);
          }
        }
      }

      return requestTimeSlotsHandler;
    }()

    // change the value of need in additional discussion and reset the state as needed time changes

  }, {
    key: 'additionalDiscussionValueChanged',
    value: function () {
      function additionalDiscussionValueChanged(event) {
        this.setState({
          userClickedRequestTimeSlots: false,
          filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
          selectedTimeSlot: this.initialState.selectedTimeSlot
        });
        this.props.additionalDiscussionChanged(event.target.checked);
      }

      return additionalDiscussionValueChanged;
    }()

    // select path option and reset app state to options selection

  }, {
    key: 'select',
    value: function () {
      function select(selectionId) {
        var selectionHandler = this.props.selectionHandler;
        if (selectionHandler.select(selectionId)) {
          this.setState({
            modifyTimeSlotParamsActivated: false,
            modifiedTimeSlotParams: this.initialState.modifiedTimeSlotParams,
            userClickedRequestTimeSlots: false,
            filters: this.initialState.filters,
            filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
            selectedTimeSlot: this.initialState.selectedTimeSlot,
            ownCareTeamSelected: false,
            showingTimesForCareTeam: false
          });

          this.props.selectedOptionsChanged(selectionHandler.getSelectedOptionIds());
        }
      }

      return select;
    }()

    // allow user modifying timeslot params and drop selected timeslot

  }, {
    key: 'activateModifyTimeSlotParams',
    value: function () {
      function activateModifyTimeSlotParams() {
        this.setState({
          modifyTimeSlotParamsActivated: true,
          userClickedRequestTimeSlots: false,
          filteredTimeSlotsByDate: this.initialState.filteredTimeSlotsByDate,
          selectedTimeSlot: this.initialState.selectedTimeSlot,
          ownCareTeamSelected: false,
          showingTimesForCareTeam: false
        });
        this.props.clearTimeSlots();
      }

      return activateModifyTimeSlotParams;
    }()

    // modify timeslot param by given filter key and a new value for a filter

  }, {
    key: 'modifyTimeSlotParams',
    value: function () {
      function modifyTimeSlotParams(filterId, itemId) {
        this.setState({
          modifiedTimeSlotParams: _extends({}, this.state.modifiedTimeSlotParams, _defineProperty({}, filterId, itemId))
        });
      }

      return modifyTimeSlotParams;
    }()
  }, {
    key: 'selectDate',
    value: function () {
      function selectDate(date) {
        var momentDate = _get__('moment')(date);
        this.setState({
          date: momentDate,
          selectedTimeSlot: this.initialState.selectedTimeSlot,
          showMobileDatePicker: false
        });
      }

      return selectDate;
    }()
  }, {
    key: 'initializeFilters',
    value: function () {
      function initializeFilters() {
        var params = this.getCurrentTimeSlotParams().resources[0];
        var units = this.props.units;
        var groups = this.props.groups || [];
        var resources = this.props.resources;
        var resourceItems = {};
        var dedicated = {};
        var dedicatedUnits = void 0;
        this.getResponsibleResources().forEach(function (resource) {
          dedicated[resource.resource] = resource.name;
        });
        var isInGroup = function () {
          function isInGroup(resource, group) {
            if (group === 'dedicated') {
              if (dedicated[resource.resource]) {
                return true;
              }
            } else if (groups && groups[group] && groups[group][resource.resource]) {
              // in this if we must make sure that all the attributes are not undefined
              return true;
            }
            return false;
          }

          return isInGroup;
        }();
        /**
         * This is a pile of crap made by Vincit.
         * It iterates through all of the resources which are a JSON.
         * So they iterate them by the keys and then if the given resource
         * matches the criteria defined in the params then it is added.
         * The if statements here are checking if the param is defined or not.
         * If it is not then do not use it to exclude the resource.
         */
        Object.keys(resources).forEach(function (key) {
          var resource = resources[key];
          if (!resource || !resource.resource) {
            return;
          }
          if (params.type && resource.type !== params.type) {
            return;
          }
          // if speciality is an array then check if the resource.speciality is NOT contained in the params.speciality array
          if (params.speciality && Array.isArray(params.speciality) && params.speciality.indexOf(resource.speciality) === -1) {
            return;
          }
          // if speciality is not an array then it is a string and we should just compare it to resource.speciality
          if (params.speciality && !Array.isArray(params.speciality) && resource.speciality !== params.speciality) {
            return;
          }
          if (params.inGroups && !params.inGroups.some(function (group) {
            return isInGroup(resource, group);
          })) {
            return;
          }
          if (params.notInGroups && params.notInGroups.some(function (group) {
            return isInGroup(resource, group);
          })) {
            return;
          }
          // The inResources parameter is usually there but the length is zero if there are no resources to search for.
          if (params.inResources && params.inResources.length > 0 && params.inResources.indexOf(resource.resource) === -1) {
            return;
          }
          resourceItems[resource.resource] = resource;
        });

        if (this.state.dedicatedResources && this.state.dedicatedResources.units) {
          dedicatedUnits = this.state.dedicatedResources.units;
        }
        this.filtersConfig.resource.items = resourceItems;
        this.filtersConfig.unit.items = _get__('unitHelper').unitFiltering(params, this.props.user, units, this.props.canAnonymousFetchTimes, this.props.legalEntity, dedicatedUnits);

        if (this.props.utilizeEmployerInformation && this.props.showOwnTeamByDefault && !this.state.ownCareTeamSelected) {
          var responsibleSpecialists = this.getCurrentResponsibleResources();
          this.applyDefaultFilter(responsibleSpecialists);
        }
      }

      return initializeFilters;
    }()
  }, {
    key: 'updateFilters',
    value: function () {
      function updateFilters(filterId, items) {
        console.log('Updating filters', filterId, items);
        var filters = _extends({}, this.state.filters, _defineProperty({}, filterId, items));

        this.setState({
          filters: filters,
          selectedTimeSlot: this.initialState.selectedTimeSlot
        }, this.useFilters);
      }

      return updateFilters;
    }()
  }, {
    key: 'updateStartTimeFilter',
    value: function () {
      function updateStartTimeFilter(filterId, startTimeFilter) {
        var _this6 = this;

        this.setState({
          startTimeFilter: startTimeFilter
        }, function () {
          _this6.useFilters(null, false);
        });
      }

      return updateStartTimeFilter;
    }()

    // apply all needed filters defined above

  }, {
    key: 'useFilters',
    value: function () {
      function useFilters(initialTimeSlots) {
        var _this7 = this;

        var selectFirstDayWithTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var timeSlotsByDate = void 0;
        var firstDayWithTimes = void 0;
        // timeslots can be supplied from the next coming props to component
        if (initialTimeSlots) {
          console.log('*** useFilters: initialTimeSlots ***', initialTimeSlots);
          timeSlotsByDate = initialTimeSlots;
        } else {
          console.log('*** useFilters: props.timeSlots ***', this.props.timeSlots);
          timeSlotsByDate = this.props.timeSlots;
        }

        var filteredTimeSlotsByDate = {};
        var duration = this.getCurrentTimeSlotParams().duration;
        var today = _get__('moment')();

        _get__('each')(timeSlotsByDate, function (timeSlots, date) {
          var filteredTimeSlots = void 0;
          if (_this7.state.useCode) {
            filteredTimeSlots = _this7.filterForReservationByCode(timeSlots);
          } else {
            filteredTimeSlots = _this7.filterByDuration(duration, timeSlots);
          }
          filteredTimeSlots = _this7.filterByStartTime(_this7.state.startTimeFilter, filteredTimeSlots);
          console.log('Using filters', _this7.state.filters, timeSlots, filteredTimeSlots);

          filteredTimeSlotsByDate[date] = filteredTimeSlots.filter(function (timeSlot) {
            var allFiltersPassed = _get__('every')(_this7.state.filters, function (filterItems, filterId) {
              // For every selected filter
              if (filterItems.length && !_get__('includes')(filterItems, timeSlot[filterId])) {
                return false;
              }
              return true;
            });
            return allFiltersPassed;
          }).sort(_get__('timeMomentSort'));

          // define first day with times. If the day in this iteration has timeslots and it's earlier than previous set
          // first day with time, update it
          if (filteredTimeSlotsByDate[date].length) {
            var m = _get__('moment')(date);
            if (m.isSameOrAfter(today, 'day') && (!firstDayWithTimes || m.isBefore(firstDayWithTimes))) {
              firstDayWithTimes = m;
            }
          }
        });
        var newState = { filteredTimeSlotsByDate: filteredTimeSlotsByDate };
        if (selectFirstDayWithTimes && firstDayWithTimes) {
          newState.date = firstDayWithTimes;
        }
        this.setState(newState);
      }

      return useFilters;
    }()
  }, {
    key: 'selectTimeSlot',
    value: function () {
      function selectTimeSlot(timeSlot) {
        console.log('Time slot selected', timeSlot);
        // start fetching unit info if it's not fetched already
        if (!this.props.units[timeSlot.unit].info) {
          this.props.fetchUnitInfo(timeSlot.unit, this.props.userIdentified);
        }
        this.setState({
          selectedTimeSlot: timeSlot
        });
        this.props.setSelectedTimeslotToStore(_extends({}, timeSlot, {
          timeMoment: timeSlot.timeMoment.format('YYYY-MM-DDTHH:mm:ss')
        }));
      }

      return selectTimeSlot;
    }()
  }, {
    key: 'resetBookingState',
    value: function () {
      function resetBookingState() {
        console.log('Reset booking...');
        var selectionHandler = this.props.selectionHandler;
        selectionHandler.usePath();
        this.setState({
          useCode: false,
          reset: true
        });
        this.props.bookAgain();
      }

      return resetBookingState;
    }()

    // set timeslot duration depending whether duration is object or a plane value

  }, {
    key: 'formatTimeSlotDuration',
    value: function () {
      function formatTimeSlotDuration(selectedTimeSlot) {
        if (Object.keys(selectedTimeSlot).length === 0 && selectedTimeSlot.constructor === Object) {
          return selectedTimeSlot;
        }
        var type = selectedTimeSlot.type;
        var configDuration = selectedTimeSlot.duration;
        var duration = Object.prototype.hasOwnProperty.call(configDuration, type) ? configDuration[type] : configDuration;
        return Object.assign(selectedTimeSlot, { duration: duration });
      }

      return formatTimeSlotDuration;
    }()
  }, {
    key: 'confirmTimeSlot',
    value: function () {
      function confirmTimeSlot(preFormattedTimeSlot, formValues) {
        var _props4 = this.props,
            t = _props4.t,
            selectionHandler = _props4.selectionHandler,
            pathNamespace = _props4.pathNamespace,
            defaultLocale = _props4.defaultLocale;

        var defaultLocaleCode = defaultLocale.split('_')[0];
        var timeSlot = this.formatTimeSlotDuration(preFormattedTimeSlot);
        var reasonText = formValues.reasonText,
            phoneNumber = formValues.phone,
            email = formValues.email;
        var _props5 = this.props,
            user = _props5.user,
            utilizeEmployerInformation = _props5.utilizeEmployerInformation,
            selectedPathType = _props5.selectedPathType,
            googleAnalyticsTrackingId = _props5.googleAnalyticsTrackingId,
            selectedTicketCode = _props5.selectedTicketCode;
        var reservationReasonCode = this.props.reservationReasonCode;

        var selectedPathTitles = selectionHandler.getSelectedOptionIds().map(function (optionId) {
          return t(pathNamespace + ':pathConfig.' + optionId + '.title', { lng: defaultLocaleCode });
        });
        var phoneNote = phoneNumber ? 'Puh: ' + phoneNumber + '\n' : '';
        var notes = selectedPathTitles.length > 0 ? '' + phoneNote + reasonText + '\n' + selectedPathTitles.join(' => ') : '' + phoneNote + reasonText;

        var _getUserEmployer = this.getUserEmployer(),
            company = _getUserEmployer.company,
            employer = _getUserEmployer.employer;

        var selectedOptions = selectionHandler.getSelectedOptions();
        var finalOption = _get__('last')(selectedOptions);
        var reservationTicketId = void 0;
        var smsConfirmationTextKey = _get__('get')(finalOption, 'reservation.smsConfirmationTextKey', 'smsConfirmationText');
        var emailConfirmationTextKey = _get__('get')(finalOption, 'reservation.emailConfirmationTextKey', 'emailConfirmationText');
        var emailReminderTextKey = _get__('get')(finalOption, 'reservation.emailReminderTextKey', 'emailReminderText');
        var emailLocalisationKeyTitle = _get__('get')(finalOption, 'reservation.emailLocalisationKeyTitle', 'emailLocalisationKeyTitle');
        var smsReminderTextKey = _get__('get')(finalOption, 'reservation.smsReminderTextKey', 'smsReminderText');
        var emailFooterText = _get__('get')(finalOption, 'reservation.emailFooterText', 'emailFooterText');
        var selectionMethod = void 0;
        var reasonToPost = reservationReasonCode;
        if (selectionHandler.isByTicket()) {
          selectionMethod = 'TICKET';

          if (selectionHandler.ticket.isMovendosTimeReservationTicket) {
            reservationTicketId = selectionHandler.ticket.id;
            smsConfirmationTextKey = selectionHandler.ticket.smsConfirmationTextKey;
            smsReminderTextKey = selectionHandler.ticket.smsReminderTextKey;
            emailLocalisationKeyTitle = selectionHandler.ticket.emailLocalisationKeyTitle;
            emailReminderTextKey = selectionHandler.ticket.emailReminderTextKey;
            reasonToPost = selectionHandler.ticket.ehrReservationReason;
            notes = selectionHandler.ticket.ehrReservationText + '\n' + notes;
            if (selectionHandler.ticket.orgIdForDedicated) {
              employer = undefined;
              company = selectionHandler.ticket.orgIdForDedicated;
            }
          } else {
            var ticketConfirmationKey = 'ticket.smsConfirmationTexts.' + selectionHandler.ticket.timeType.replace('.', '*');
            var ticketReminderKey = 'ticket.smsReminderTexts.' + selectionHandler.ticket.timeType.replace('.', '*');
            smsConfirmationTextKey = t(ticketConfirmationKey) === ticketConfirmationKey ? smsConfirmationTextKey : ticketConfirmationKey;
            smsReminderTextKey = t(ticketReminderKey) === ticketReminderKey ? smsReminderTextKey : ticketReminderKey;
            emailLocalisationKeyTitle = t(ticketConfirmationKey) === ticketConfirmationKey ? emailLocalisationKeyTitle : ticketConfirmationKey;
            emailConfirmationTextKey = t(ticketConfirmationKey) === ticketConfirmationKey ? emailConfirmationTextKey : ticketConfirmationKey;
            emailReminderTextKey = t(ticketReminderKey) === ticketReminderKey ? emailReminderTextKey : ticketReminderKey;
          }
        } else if (selectionHandler.isUsingCode()) {
          selectionMethod = 'CODE';
          var codeConfirmationKey = 'code.smsConfirmationTexts.' + selectionHandler.code.replace('.', '*');
          var codeReminderKey = 'code.smsReminderTexts.' + selectionHandler.code.replace('.', '*');
          smsConfirmationTextKey = t(codeConfirmationKey) === codeConfirmationKey ? smsConfirmationTextKey : codeConfirmationKey;
          smsReminderTextKey = t(codeReminderKey) === codeReminderKey ? smsReminderTextKey : codeReminderKey;
          emailLocalisationKeyTitle = t(codeConfirmationKey) === codeConfirmationKey ? emailLocalisationKeyTitle : codeConfirmationKey;
          emailConfirmationTextKey = t(codeConfirmationKey) === codeConfirmationKey ? emailConfirmationTextKey : codeConfirmationKey;
          emailReminderTextKey = t(codeReminderKey) === codeReminderKey ? emailReminderTextKey : codeReminderKey;
        } else if (selectionHandler.isUsingPath()) {
          selectionMethod = 'SYMPTOM';
          if (finalOption.reservation.reservationReason) {
            this.props.setReservationReasonCode(finalOption.reservation.reservationReason);
            reasonToPost = finalOption.reservation.reservationReason;
          }
        } else {
          selectionMethod = null;
        }
        // get the language
        var language = _get__('i18n').language;
        // construct confirmation text with relevant info

        if (this.isUserSotuTemporary()) {
          var smsConfirmationTextWithTmpSotuKey = smsConfirmationTextKey + '_userWithTmpSOTU';
          var emailLocalisationKeyTitleWithTmpSotuKey = emailLocalisationKeyTitle + '_userWithTmpSOTU';
          var smsReminderTextWithTmpSotuKey = smsReminderTextKey + '_userWithTmpSOTU';
          var emailReminderTextWithTmpSotuKey = emailReminderTextKey + '_userWithTmpSOTU';
          var emailConfirmationTextKeyWithSotuKey = emailConfirmationTextKey + '_userWithTmpSOTU';

          // if localization key for temporary SOTU cases exist, use those
          if (t(smsConfirmationTextWithTmpSotuKey) !== smsConfirmationTextWithTmpSotuKey) {
            smsConfirmationTextKey = smsConfirmationTextWithTmpSotuKey;
            emailConfirmationTextKey = emailConfirmationTextKeyWithSotuKey;
            emailLocalisationKeyTitle = emailLocalisationKeyTitleWithTmpSotuKey;
          }
          if (t(smsReminderTextWithTmpSotuKey) !== smsReminderTextWithTmpSotuKey) {
            smsReminderTextKey = smsReminderTextWithTmpSotuKey;
          }
          if (t(emailReminderTextWithTmpSotuKey) !== emailReminderTextWithTmpSotuKey) {
            emailReminderTextKey = emailReminderTextWithTmpSotuKey;
          }
        }
        var confirmationTextParameters = {
          time: timeSlot.timeMoment.locale(language).format('lll'),
          date: timeSlot.timeMoment.locale(language).format('LL'),
          unitAddress: this.props.units[timeSlot.unit].address,
          unitCity: this.props.units[timeSlot.unit].city,
          reservationCode: '{{reservationCode}}',
          resourceName: this.props.resources[timeSlot.resource].name
        };
        // Note: react-i18next insists on escaping HTML, need to unescape it back
        var smsText = _get__('htmlDecode')(t(smsConfirmationTextKey, confirmationTextParameters));
        var emailConfirmationSubject = _get__('htmlDecode')(t('' + emailLocalisationKeyTitle));
        var emailConfirmationBody = _get__('htmlDecode')(t(emailConfirmationTextKey, confirmationTextParameters));
        var footer = _get__('htmlDecode')(t('' + emailFooterText));
        console.log('Storing reservation', timeSlot, formValues);
        // post reservation to backend with email template and SMS text
        this.props.storeReservation(timeSlot, Object.assign({
          client: '/clients/' + user.ehrId,
          unit: timeSlot.unit,
          unitChangedToLegalUnit: timeSlot.unitChangedToLegalUnit,
          resource: timeSlot.resource,
          start: timeSlot.timeMoment.format('YYYY-MM-DD[T]HH:mm:ss'),
          duration: timeSlot.duration,
          notes: notes,
          selectedPathString: selectedPathTitles.join(' => '),
          selectionMethod: selectionMethod,
          phoneNumber: phoneNumber,
          smsText: smsText,
          emailFooterText: footer,
          email: email,
          emailReminderTextKey: emailReminderTextKey,
          emailConfirmationTextKey: emailConfirmationTextKey,
          emailConfirmationBody: emailConfirmationBody,
          emailConfirmationSubject: emailConfirmationSubject,
          smsReminderTextKey: smsReminderTextKey,
          language: language,
          selectedPathType: selectedPathType,
          googleAnalyticsTrackingId: googleAnalyticsTrackingId,
          rootSelection: pathNamespace,
          reservationReasonCode: reasonToPost,
          reservationTicketId: reservationTicketId
        }, utilizeEmployerInformation ? { employer: employer } : {}, utilizeEmployerInformation ? { company: company } : {}, selectedTicketCode !== '' ? { code: selectedTicketCode } : {}), selectedOptions);
      }

      return confirmTimeSlot;
    }()
  }, {
    key: 'cancelConfirm',
    value: function () {
      function cancelConfirm() {
        this.setState({
          selectedTimeSlot: this.initialState.selectedTimeSlot
        });
      }

      return cancelConfirm;
    }()

    // open link in a new browser window

  }, {
    key: 'openLink',
    value: function () {
      function openLink(url) {
        var win = window.open(url, '_blank');
        win.focus();
      }

      return openLink;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this8 = this;

        //    console.log('Booking.render start!');
        var _props6 = this.props,
            errorOccurred = _props6.errorOccurred,
            errors = _props6.errors,
            userIdentified = _props6.userIdentified,
            canAnonymousFetchTimes = _props6.canAnonymousFetchTimes,
            selectedOptionIds = _props6.selectedOptionIds,
            additionalDiscussionChecked = _props6.additionalDiscussionChecked,
            prepareUserRegistration = _props6.prepareUserRegistration,
            pathNamespace = _props6.pathNamespace,
            reservationByCodeEnabled = _props6.reservationByCodeEnabled,
            pathReservationByCodeEnabled = _props6.pathReservationByCodeEnabled,
            utilizeEmployerInformation = _props6.utilizeEmployerInformation,
            selectionHandler = _props6.selectionHandler,
            selectedPathType = _props6.selectedPathType,
            pathBasedBooking = _props6.pathBasedBooking,
            viaSso = _props6.viaSso,
            selectedTicket = _props6.selectedTicket,
            hasSelectedTicket = _props6.hasSelectedTicket,
            selectedTicketCode = _props6.selectedTicketCode,
            configurationLoaded = _props6.configurationLoaded,
            loginPolicyType = _props6.loginPolicyType,
            creationIncomplete = _props6.creationIncomplete,
            t = _props6.t;

        var isReservationByTicket = selectedPathType === _get__('pathTypes').BY_TICKET;
        var isReservationHistory = selectedPathType === _get__('pathTypes').HISTORY;
        if (!userIdentified && !canAnonymousFetchTimes) {}
        // We can return null here if we want users to identify before making any selections.


        // show modal in case of error instead of content
        if (errorOccurred) {
          // Object.keys(errors).map(i => errors[i]).reduce((acc, i) => acc + i)
          var errorFromServer = Object.keys(errors).map(function (i) {
            return errors[i];
          }).reduce(function (acc, i) {
            return acc + i;
          });
          return _get__('React').createElement(
            _get__('Modal'),
            {
              className: 'error generic-error',
              show: true,
              backdrop: 'static',
              keyboard: false
            },
            _get__('React').createElement(
              _get__('Button'),
              {
                bsStyle: 'link',
                className: 'close-link basic-action-link',
                onClick: this.onCloseErrorModal
              },
              _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
            ),
            _get__('React').createElement(
              _get__('ErrorMessage'),
              { isVisible: true },
              _get__('React').createElement(
                'strong',
                null,
                errorFromServer.indexOf('EHR Timeout') > -1 ? t('ehrTimeoutErrorMessage') : t('genericErrorMessage')
              )
            )
          );
        }

        selectionHandler.setSelectedOptionIds(selectedOptionIds);

        /**
         * Create code form, reservations history and ticket booking component in case those are enabled and user can see them
         */
        var reservationByCode = _get__('React').createElement(
          'div',
          null,
          reservationByCodeEnabled && pathReservationByCodeEnabled ? _get__('React').createElement(_get__('CodeForm'), { onToggle: this.toggleUseCode, onSubmit: this.requestTimeSlotsUsingCode }) : null
        );

        var reservationHistory = isReservationHistory && userIdentified && viaSso ? _get__('React').createElement(_get__('History'), null) : null;
        var reservationByTicket = isReservationByTicket && userIdentified ? _get__('React').createElement(_get__('ByTicket'), { reservationByCode: reservationByCode }) : null;

        var bookingPhaseSymptoms = [];
        var requestTimeSlots = void 0;
        var identificationSection = void 0;
        var bookingPhaseInfoBox = void 0;
        var bookingPhaseSelectTime = void 0;

        var readyToRequestTimeSlots = false;

        if (selectionHandler.isUsingCode()) {
          readyToRequestTimeSlots = true;
        } else {
          // Using path selection.
          var levelCount = selectionHandler.getSelectedOptionIds().length;
          var level = 0;
          // render symptoms options for every available level
          while (level <= levelCount) {
            level += 1;
            var nextOptions = selectionHandler.getOptionsForLevel(level);
            if (nextOptions.length > 0) {
              bookingPhaseSymptoms.push(_get__('React').createElement(
                _get__('SymptomLevel'),
                { key: 'booking-phase-symptoms-' + level, title: selectionHandler.getPromptForLevel(level), text: selectionHandler.getPromptTextForLevel(level), level: level },
                _get__('React').createElement(_get__('OptionGroup'), {
                  onSelect: this.select,
                  options: nextOptions,
                  selected: selectionHandler.getSelectedOptionIdOnLevel(level),
                  prompt: level > 1 ? selectionHandler.getPromptForLevel(level) : '',
                  level: level,
                  info: selectionHandler.getInfoForLevel(level),
                  key: 'option-group-' + level,
                  namespace: pathNamespace
                })
              ));
            } else {
              console.log('no options for level -- ' + level);
            }
            this.state.targetLevel = level > 1 ? level - 1 : 1;
          }

          var finalLevelReached = selectionHandler.isFinalLevelReached();
          if (finalLevelReached) {
            var finalOption = selectionHandler.getLastSelectedOption();
            var finalOptionInfo = selectionHandler.getInfoForLevel(level);
            // if final level has additional information, show info message with it
            if (finalOptionInfo) {
              bookingPhaseInfoBox = _get__('React').createElement(_get__('InfoBox'), { content: finalOptionInfo });
            }
            // if user has selected all levels of symptoms and can select a timeslot
            if (finalOption.reservation) {
              console.log(JSON.stringify(finalOption.reservation));
              var showModifyTimeSlotParamsButton = _get__('letUserModifyTimeSlotParams') && (!this.state.modifyTimeSlotParamsActivated || this.props.timeSlotsRequested);
              requestTimeSlots = _get__('React').createElement(
                'div',
                { id: 'request-time-slots' },
                _get__('showAdditionalDiscussionCheckbox') && _get__('React').createElement(_get__('AdditionalDiscussionCheckbox'), {
                  checked: additionalDiscussionChecked,
                  onChange: this.additionalDiscussionValueChanged
                }),
                _get__('React').createElement(
                  'div',
                  { className: 'request-time-slots-info text-center' },
                  this.getSentenceForTimeSlotParams(this.state.modifyTimeSlotParamsActivated || this.getCurrentTimeSlotParams().options),
                  showModifyTimeSlotParamsButton && _get__('React').createElement(
                    _get__('Button'),
                    {
                      className: 'activate-time-slot-params-btn center-block',
                      onClick: this.activateModifyTimeSlotParams
                    },
                    t('activateTimeSlotParamsButton')
                  )
                ),
                _get__('React').createElement(
                  'p',
                  { className: 'text-center' },
                  t('requestTimeSlotsAdditionalInfo')
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn center-block',
                    onClick: this.requestTimeSlotsHandler
                  },
                  t('show_time_slots_button')
                )
              );
              readyToRequestTimeSlots = true;
            }
            // if final option is to go to external service
            if (finalOption.external) {
              var linkButtonText = selectionHandler.getLocalizationForLevel(level, 'linkButtonText');
              requestTimeSlots = _get__('React').createElement(
                'div',
                { id: 'request-time-slots' },
                _get__('React').createElement(
                  _get__('Button'),
                  { className: 'action-btn center-block', onClick: function () {
                      function onClick() {
                        return _this8.openLink(finalOption.external);
                      }

                      return onClick;
                    }() },
                  t(linkButtonText)
                )
              );
            }
          }
        }

        if (readyToRequestTimeSlots) {
          // if user is not logged in and path doesn't allow ananymous users to fetch times, prompt authentication
          if (!userIdentified && this.state.userClickedRequestTimeSlots && !canAnonymousFetchTimes) {
            identificationSection = this.getLoginForm(t);
          }

          if (userIdentified || canAnonymousFetchTimes) {
            // prepare timeslots and calendar views
            if (!this.props.requestingTimeSlots && this.props.timeSlotsRequested) {
              var timeSlotsForDay = this.getTimeSlotsForSelectedDay() || [];
              console.log('Rendering time slots...', timeSlotsForDay, this.state);
              var onFocusChange = function () {
                function onFocusChange(focused) {
                  if (focused === _this8.state.showMobileDatePicker) {
                    _this8.setState({ showMobileDatePicker: focused });
                  }
                }

                return onFocusChange;
              }();
              var onActiveStartDateChangeHandler = function () {
                function onActiveStartDateChangeHandler(_ref3) {
                  var activeStartDate = _ref3.activeStartDate;

                  var momentDate = _get__('moment')(activeStartDate);
                  _this8.requestTimeSlotsHandler({ month: momentDate });
                  _this8.setState({
                    showMobileDatePicker: false
                  });
                }

                return onActiveStartDateChangeHandler;
              }();
              var nextMonthClickHandler = function () {
                function nextMonthClickHandler() {
                  console.log('Requesting time slots for next month', _this8.state.date);
                  var month = _this8.state.date.clone().add(1, 'months');
                  _this8.requestTimeSlotsHandler({ month: month });
                }

                return nextMonthClickHandler;
              }();
              var responsibleSpecialistsElement = void 0;
              var responsibleSpecialists = this.getCurrentResponsibleResources();
              // build a string with responsible specialist(s) name(s)
              if (responsibleSpecialists.length) {
                var responsibleSpecialistsNames = _get__('map')(responsibleSpecialists, function (r) {
                  return r.name;
                });
                var namesText = void 0;
                if (responsibleSpecialistsNames.length === 1) {
                  namesText = responsibleSpecialistsNames[0];
                } else {
                  var allNamesButLast = responsibleSpecialistsNames.slice(0, -1).join(', ');
                  var lastName = _get__('last')(responsibleSpecialistsNames);
                  namesText = allNamesButLast + ' ' + t('and') + ' ' + lastName;
                }

                var selectedLastLevel = this.getSelection();
                var pathSpecificRespKey = selectedLastLevel && selectedLastLevel.id ? pathNamespace + ':pathConfig.' + selectedLastLevel.id + '.responsibleResourcesInfo' : '';
                var responsibleTextKey = pathSpecificRespKey !== '' && _get__('i18n').exists(pathSpecificRespKey) ? pathSpecificRespKey : 'responsibleResourcesInfo';
                var responsibleSpecialistsText = t(responsibleTextKey, {
                  count: responsibleSpecialistsNames.length,
                  names: namesText
                });
                console.log('Translating names', { namesText: namesText, responsibleSpecialistsText: responsibleSpecialistsText });
                responsibleSpecialistsElement = null;
                // if employer info is utilized, create a button to show timeslots for responsible specialists
                if (utilizeEmployerInformation) {
                  responsibleSpecialistsElement = _get__('React').createElement(
                    'p',
                    { className: 'responsible-specialists-text' },
                    _get__('React').createElement(_get__('AppIcon'), { iconName: 'STAR', containerClass: 'resp-image' }),
                    _get__('React').createElement(_get__('InnerHtmlContent'), { content: responsibleSpecialistsText }),
                    ' ',
                    _get__('React').createElement(
                      _get__('Button'),
                      {
                        bsStyle: 'link',
                        className: 'basic-action-link action-link-among-text',
                        onClick: function () {
                          function onClick(e) {
                            _this8.populateResourceFilter(_this8.state.showingTimesForCareTeam ? [] : responsibleSpecialists);
                          }

                          return onClick;
                        }()
                      },
                      t(this.state.showingTimesForCareTeam ? 'showTimesForallResources' : 'showTimesForResponsibleResources')
                    )
                  );
                }
              }

              // component for units filter and specialists filter
              var makeMultiSelectFilter = function () {
                function makeMultiSelectFilter(filterId) {
                  return _get__('React').createElement(_get__('MultiSelectButton'), {
                    id: filterId,
                    label: t('filters.' + filterId),
                    className: filterId + '-filter-group',
                    items: _this8.filtersConfig[filterId].items,
                    activeItems: _this8.getSelectedFilters(filterId),
                    onSelect: _this8.updateFilters
                  });
                }

                return makeMultiSelectFilter;
              }();
              var makeStartTimeFilter = function () {
                function makeStartTimeFilter() {
                  return _get__('React').createElement(_get__('SingleSelectButton'), {
                    id: 'startTime',
                    label: t('filters.startTime'),
                    className: 'start-time-group',
                    items: _this8.startTimeItems,
                    activeItem: _this8.state.startTimeFilter,
                    onSelect: _this8.updateStartTimeFilter
                  });
                }

                return makeStartTimeFilter;
              }();
              bookingPhaseSelectTime = _get__('React').createElement(
                _get__('BookingPhase'),
                { id: 'booking-phase-select-time', title: t('sectionTitles.selectTime') },
                _get__('React').createElement(
                  _get__('Grid'),
                  { fluid: true },
                  _get__('React').createElement(
                    _get__('Row'),
                    null,
                    _get__('React').createElement(
                      _get__('Col'),
                      { xs: 12, sm: 12, md: 12, lg: 12, className: 'time-slot-filters-col' },
                      _get__('React').createElement(
                        'div',
                        { className: 'time-slot-filters text-center' },
                        _get__('React').createElement(
                          'div',
                          null,
                          makeMultiSelectFilter('unit'),
                          makeMultiSelectFilter('resource')
                        ),
                        _get__('React').createElement(
                          'div',
                          null,
                          _get__('React').createElement(
                            _get__('FormGroup'),
                            { className: 'mobile-calendar-group' },
                            _get__('React').createElement(
                              _get__('ControlLabel'),
                              null,
                              t('filters.date')
                            ),
                            _get__('React').createElement(
                              _get__('Button'),
                              {
                                className: 'show-mobile-calendar-btn',
                                onClick: function () {
                                  function onClick() {
                                    _this8.setState({ showMobileDatePicker: !_this8.state.showMobileDatePicker });
                                  }

                                  return onClick;
                                }()
                              },
                              this.state.date.format('l'),
                              ' ',
                              _get__('React').createElement(_get__('AppIcon'), { iconName: 'CALENDAR', containerClass: 'calendar-icon' })
                            )
                          ),
                          makeStartTimeFilter()
                        )
                      )
                    )
                  ),
                  _get__('React').createElement(
                    _get__('Row'),
                    null,
                    _get__('React').createElement(
                      _get__('Col'),
                      { xs: 12, sm: 12, md: 12, lg: 12, className: 'text-center responsible-specialists-container' },
                      responsibleSpecialistsElement
                    )
                  ),
                  _get__('React').createElement(
                    _get__('Row'),
                    null,
                    _get__('React').createElement(
                      _get__('Col'),
                      { md: 5, lg: 5, className: 'date-input' },
                      (!this.state.isMobile || this.state.showMobileDatePicker) && _get__('React').createElement(
                        'div',
                        {
                          tabIndex: 0,
                          onFocus: function () {
                            function onFocus() {
                              return onFocusChange(true);
                            }

                            return onFocus;
                          }(),
                          onBlur: function () {
                            function onBlur() {
                              return onFocusChange(false);
                            }

                            return onBlur;
                          }()
                        },
                        _get__('React').createElement(_get__('Calendar'), {
                          id: 'date-input',
                          value: new Date(this.state.date),
                          navigationAriaLabel: t('common:ariaLabels.navigationAriaLabel'),
                          nextAriaLabel: t('common:ariaLabels.nextAriaLabel'),
                          prevAriaLabel: t('common:ariaLabels.prevAriaLabel'),
                          prev2Label: null,
                          next2Label: null,
                          locale: _get__('i18n').language,
                          tileDisabled: function () {
                            function tileDisabled(_ref4) {
                              var date = _ref4.date,
                                  view = _ref4.view;
                              return view === 'month' && !_this8.hasFreeTimesForDay(date);
                            }

                            return tileDisabled;
                          }(),
                          onClickDay: this.selectDate,
                          onActiveStartDateChange: function () {
                            function onActiveStartDateChange(_ref5) {
                              var activeStartDate = _ref5.activeStartDate,
                                  view = _ref5.view;
                              return view === 'month' && onActiveStartDateChangeHandler({ activeStartDate: activeStartDate });
                            }

                            return onActiveStartDateChange;
                          }()
                        })
                      )
                    ),
                    _get__('React').createElement(
                      _get__('Col'),
                      { xs: 12, sm: 12, md: 7, lg: 7, className: 'time-slots-col' },
                      _get__('isEmpty')(timeSlotsForDay) ? _get__('React').createElement(
                        _get__('ErrorMessage'),
                        { isVisible: true },
                        _get__('React').createElement(
                          'strong',
                          null,
                          t('timeSlotsNotFoundErrorTitle')
                        ),
                        _get__('React').createElement(
                          'p',
                          null,
                          t('timeSlotsNotFoundErrorMessage')
                        ),
                        _get__('React').createElement(
                          _get__('Button'),
                          {
                            className: 'action-btn-small next-month-btn',
                            onClick: function () {
                              function onClick(e) {
                                nextMonthClickHandler();
                              }

                              return onClick;
                            }()
                          },
                          t('timeSlotsNotFoundNextMonthLink')
                        )
                      ) : _get__('React').createElement(_get__('TimeSlots'), {
                        timeSlots: timeSlotsForDay,
                        units: this.props.units,
                        selectedTimeSlot: this.formatTimeSlotDuration(this.state.selectedTimeSlot),
                        onClick: this.selectTimeSlot
                      })
                    )
                  )
                )
              );
            }
          }
        }

        // If we have reached this point and the user is not logged in,
        // then it means that canAnonymousFetchTimes must be true.
        var selectedTimeSlot = !_get__('isEmpty')(this.state.selectedTimeSlot);
        var showConfirmationDuringRegistration = selectedTimeSlot && !userIdentified && canAnonymousFetchTimes;
        var identificationAndRegistrationPhase = '';
        // user must either log in, sign up or fill up missing information
        if (showConfirmationDuringRegistration || selectedTimeSlot && creationIncomplete) {
          identificationAndRegistrationPhase = _get__('React').createElement(
            _get__('BookingPhase'),
            { id: 'booking-phase-identify-late', title: t('lateLoginPhaseTitle') },
            _get__('React').createElement(
              _get__('Collapse'),
              { 'in': !userIdentified || creationIncomplete, unmountOnExit: true },
              _get__('React').createElement(
                _get__('SimpleBox'),
                { className: 'registration' },
                _get__('React').createElement(
                  'div',
                  { className: 'box-header' },
                  _get__('React').createElement(
                    'h1',
                    null,
                    !prepareUserRegistration && !creationIncomplete ? t('lateLoginBookingPhaseHeading') : t('registrationBookingPhaseHeading')
                  ),
                  !prepareUserRegistration && !creationIncomplete && t('lateLoginBookingPhaseInfo'),
                  _get__('React').createElement(
                    _get__('Collapse'),
                    { 'in': !prepareUserRegistration && !creationIncomplete, unmountOnExit: true },
                    _get__('React').createElement(_get__('LoginComponent'), { loginType: loginPolicyType })
                  ),
                  _get__('React').createElement(
                    _get__('Collapse'),
                    { 'in': prepareUserRegistration || creationIncomplete, unmountOnExit: true },
                    _get__('React').createElement(_get__('RegistrationForm'), null)
                  )
                )
              )
            )
          );
        }

        // The confirmation phase requires the user to be logged in.
        var bookingPhaseConfirm = '';
        var isUsingPath = selectionHandler.isUsingPath() && selectionHandler.getSelectedOptions().length > 0;
        if (selectedTimeSlot && userIdentified && !creationIncomplete) {
          bookingPhaseConfirm = _get__('React').createElement(
            _get__('BookingPhase'),
            { id: 'booking-phase-confirm', title: t('sectionTitles.confirmReservation') },
            _get__('React').createElement(
              'div',
              { className: 'booking-phase-centered-content' },
              _get__('React').createElement(
                _get__('Collapse'),
                { 'in': isUsingPath, unmountOnExit: true },
                _get__('React').createElement(_get__('SelectionPathInfo'), { path: selectionHandler.getSelectedOptions(), prefix: 'pathConfig', namespace: pathNamespace })
              ),
              _get__('React').createElement(
                _get__('Collapse'),
                { 'in': userIdentified, unmountOnExit: true },
                _get__('React').createElement(_get__('ConfirmTimeSlotForm'), {
                  timeSlot: this.formatTimeSlotDuration(this.state.selectedTimeSlot),
                  ticketCode: this.props.selectedTicketCode,
                  onConfirm: this.confirmTimeSlot,
                  onCancel: this.cancelConfirm,
                  smsConfirmationEnabled: this.props.smsConfirmationEnabled,
                  emailConfirmationEnabled: this.props.emailConfirmationEnabled,
                  unit: this.props.units[this.state.selectedTimeSlot.unit],
                  optionalReservationText: this.props.optionalReservationText
                })
              )
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(_get__('UnitInfoContainer'), { unit: this.getUnitData(this.state.selectedTimeSlot.unit) })
          );
        }

        var showSelectionPathUsingProps = this.props.reservation && this.props.reservation.selectionPath && this.props.reservation.selectionPath.length > 0;
        var bookingPhaseReservationDone = '';
        // show confirmation message if reservation was done
        if (this.props.reservationDone) {
          var confirmationInfo = null;
          var pathSpecificConfInfo = '';
          var _selectedLastLevel = this.getSelection();
          if (_selectedLastLevel && _selectedLastLevel.id) {
            pathSpecificConfInfo = pathNamespace + ':pathConfig.' + _selectedLastLevel.id + '.confirmationInfo';
            confirmationInfo = _get__('i18n').exists(pathSpecificConfInfo) ? t(pathSpecificConfInfo) : null;
          }
          bookingPhaseReservationDone = !this.props.reservationDone ? '' : _get__('React').createElement(
            _get__('BookingPhase'),
            { id: 'booking-phase-reservation-done', title: t('reservationDone.title') },
            _get__('React').createElement(
              'div',
              { className: 'booking-phase-centered-content center-block text-center' },
              _get__('React').createElement(
                'p',
                { className: 'large-text' },
                t('reservationDone.info1', { reservationCode: this.props.reservation.data.code })
              ),
              _get__('React').createElement('br', null),
              _get__('React').createElement(
                'p',
                { className: 'large-text' },
                this.props.selectedTicketCode ? this.props.selectedTicket.clientNotes : t(pathNamespace + ':reservationDone.info2')
              )
            ),
            confirmationInfo && _get__('React').createElement(
              'div',
              null,
              _get__('React').createElement(
                _get__('Alert'),
                { bsStyle: 'info' },
                _get__('React').createElement(_get__('InnerHtmlContent'), { content: confirmationInfo })
              )
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(
              'div',
              { className: 'booking-phase-centered-content reservation-details' },
              _get__('React').createElement(
                _get__('Collapse'),
                { 'in': showSelectionPathUsingProps && isUsingPath, unmountOnExit: true },
                _get__('React').createElement(_get__('SelectionPathInfo'), { path: this.props.reservation.selectionPath, prefix: 'pathConfig', namespace: pathNamespace })
              ),
              _get__('React').createElement(_get__('TimeSlotCard'), {
                large: true,
                timeSlot: this.props.reservation.timeSlot,
                unit: this.props.units[this.props.reservation.timeSlot.unit],
                actionElement: _get__('React').createElement(_get__('AppIcon'), { iconName: 'CHECKMARK', containerClass: 'booking-done-image' })
              }),
              _get__('React').createElement(
                'div',
                { className: 'reservation-done-action-buttons' },
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'booking-done-logout-link center-block',
                    onClick: function () {
                      function onClick() {
                        _this8.props.logout(_this8.props.viaSso);
                      }

                      return onClick;
                    }()
                  },
                  t('logoutButton')
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'booking-done-reserve-new-time-link center-block',
                    onClick: this.resetBookingState
                  },
                  t('reservationDone.bookAgain')
                )
              )
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(
              'div',
              { className: 'booking-phase-centered-content' },
              _get__('React').createElement(_get__('UnitInfo'), { unit: this.getUnitData(this.props.reservation.timeSlot.unit) })
            )
          );
        }

        //    console.log('Booking.render end!');

        return _get__('React').createElement(
          'div',
          { className: 'booking' },
          !this.props.reservationDone && this.props.pathLoaded &&
          // needed to not show path for uesrs in occupational path without employer
          _get__('React').createElement(
            _get__('Collapse'),
            { 'in': configurationLoaded },
            _get__('React').createElement(
              'div',
              null,
              pathBasedBooking && _get__('React').createElement(
                'div',
                null,
                _get__('React').createElement(
                  'h2',
                  { className: 'test booking-phase-title' },
                  selectionHandler.getTitleForPath()
                ),
                _get__('React').createElement('hr', null),
                reservationByCode,
                bookingPhaseSymptoms
              ),
              reservationByTicket,
              reservationHistory,
              bookingPhaseInfoBox,
              _get__('React').createElement(
                'div',
                { id: 'request-time-slots-container' },
                requestTimeSlots
              ),
              _get__('React').createElement('div', { id: 'anchor-scroll-target' }),
              _get__('React').createElement(
                'div',
                { id: 'booking-phase-select-time-container' },
                identificationSection,
                bookingPhaseSelectTime
              ),
              _get__('React').createElement(
                'div',
                { id: 'booking-phase-confirm-container' },
                identificationAndRegistrationPhase,
                bookingPhaseConfirm
              )
            )
          ),
          bookingPhaseReservationDone
        );
      }

      return render;
    }()
  }]);

  return Booking;
}(_get__('Component'));

_get__('Booking').propTypes = {
  userIdentified: _get__('PropTypes').bool.isRequired,
  canAnonymousFetchTimes: _get__('PropTypes').bool.isRequired,
  user: _get__('PropTypes').shape({
    ehrId: _get__('PropTypes').string,
    sotu: _get__('PropTypes').string,
    employers: _get__('PropTypes').array.isRequired
  }),
  errorOccurred: _get__('PropTypes').bool,
  errors: _get__('PropTypes').shape({}),
  selectedEmployer: _get__('PropTypes').number.isRequired,
  hasDepartment: _get__('PropTypes').bool.isRequired,
  selectedDepartment: _get__('PropTypes').number.isRequired,
  selectedOptionIds: _get__('PropTypes').array.isRequired,
  selectedOptionsChanged: _get__('PropTypes').func.isRequired,
  fetchUnitInfo: _get__('PropTypes').func.isRequired,
  additionalDiscussionChanged: _get__('PropTypes').func.isRequired,
  additionalDiscussionChecked: _get__('PropTypes').bool,
  requestTimeSlots: _get__('PropTypes').func.isRequired,
  requestingTimeSlots: _get__('PropTypes').bool,
  timeSlotsRequested: _get__('PropTypes').bool,
  smsConfirmationEnabled: _get__('PropTypes').bool.isRequired,
  emailConfirmationEnabled: _get__('PropTypes').bool.isRequired,
  clearTimeSlots: _get__('PropTypes').func.isRequired,
  resources: _get__('PropTypes').shape({}),
  groups: _get__('PropTypes').shape({}),
  units: _get__('PropTypes').shape({}),
  timeSlots: _get__('PropTypes').shape({}),
  storeReservation: _get__('PropTypes').func.isRequired,
  reservation: _get__('PropTypes').shape({
    selectionPath: _get__('PropTypes').array,
    timeSlot: _get__('PropTypes').shape({
      unit: _get__('PropTypes').string.isRequired
    }),
    data: _get__('PropTypes').shape({
      code: _get__('PropTypes').string.isRequired
    })
  }),
  reservationDone: _get__('PropTypes').bool,
  reservationByCodeEnabled: _get__('PropTypes').bool.isRequired,
  logout: _get__('PropTypes').func.isRequired,
  bookAgain: _get__('PropTypes').func.isRequired,
  prepareUserRegistration: _get__('PropTypes').bool.isRequired,
  pathNamespace: _get__('PropTypes').string.isRequired,
  currentlyIdentifying: _get__('PropTypes').bool.isRequired,
  currentlyRegistering: _get__('PropTypes').bool.isRequired,
  storingReservation: _get__('PropTypes').bool.isRequired,
  pathReservationByCodeEnabled: _get__('PropTypes').bool.isRequired,
  utilizeEmployerInformation: _get__('PropTypes').bool.isRequired,
  selectionHandler: _get__('PropTypes').object.isRequired,
  pathLoaded: _get__('PropTypes').bool.isRequired,
  selectedPathType: _get__('PropTypes').string,
  googleAnalyticsTrackingId: _get__('PropTypes').string,
  viaSso: _get__('PropTypes').bool.isRequired,
  pathBasedBooking: _get__('PropTypes').bool.isRequired,
  selectedTicket: _get__('PropTypes').object.isRequired,
  hasSelectedTicket: _get__('PropTypes').bool.isRequired,
  selectedTicketCode: _get__('PropTypes').string.isRequired,
  optionalReservationText: _get__('PropTypes').bool.isRequired,
  legalEntity: _get__('PropTypes').string.isRequired,
  defaultLocale: _get__('PropTypes').string.isRequired,
  reservationReasonCode: _get__('PropTypes').number,
  t: _get__('PropTypes').func.isRequired,
  setReservationReasonCode: _get__('PropTypes').func.isRequired,
  loginPolicyType: _get__('PropTypes').string.isRequired,
  configurationLoaded: _get__('PropTypes').bool.isRequired,
  restoredState: _get__('PropTypes').bool.isRequired,
  setSelectedTimeslotToStore: _get__('PropTypes').func.isRequired,
  unsetSelectedTimeslotToStore: _get__('PropTypes').func.isRequired,
  selectedStoredTimeSlot: _get__('PropTypes').object.isRequired,
  requiresEmployer: _get__('PropTypes').bool.isRequired,
  creationIncomplete: _get__('PropTypes').bool.isRequired,
  showOwnTeamByDefault: _get__('PropTypes').bool.isRequired
};

_get__('Booking').defaultProps = {
  canAnonymousFetchTimes: false,
  additionalDiscussionChecked: false,
  errorOccurred: false,
  errors: {},
  requestingTimeSlots: false,
  timeSlotsRequested: false,
  reservation: {},
  reservationDone: false,
  prepareUserRegistration: false,
  currentlyIdentifying: false,
  currentlyRegistering: false,
  storingReservation: false,
  resources: {},
  groups: {},
  units: {},
  user: {},
  timeSlots: {},
  pathNamespace: '',
  pathReservationByCodeEnabled: false,
  utilizeEmployerInformation: false,
  selectionHandler: null,
  pathLoaded: false,
  selectedPathType: '',
  googleAnalyticsTrackingId: '',
  selectedTicket: {},
  selectedTicketCode: '',
  legalEntity: '',
  defaultLocale: '',
  reservationReasonCode: null,
  showOwnTeamByDefault: false
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return ['booking', props.pathNamespace];
}, { wait: true })(_get__('Booking'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'moment':
      return _moment2['default'];

    case 'DEFAULT_START_TIME':
      return _constants.DEFAULT_START_TIME;

    case 'range':
      return _util.range;

    case 'animateScroll':
      return _reactScroll.animateScroll;

    case 'scrollSettings':
      return _constants.scrollSettings;

    case 'isEmpty':
      return _lang.isEmpty;

    case 'pathTypes':
      return _pathTypes2['default'];

    case '_':
      return _lodash2['default'];

    case 'isEqual':
      return _lang.isEqual;

    case 'isElementVisible':
      return _helpers.isElementVisible;

    case '$':
      return _jquery2['default'];

    case 'scroller':
      return _reactScroll.scroller;

    case 'EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION':
      return _constants.EXTENDED_TIME_FOR_ADDITIONAL_DISCUSSION;

    case 'trimResourceNames':
      return _helpers.trimResourceNames;

    case 'get':
      return _object.get;

    case 'DATE_FORMAT_SYSTEM':
      return _constants.DATE_FORMAT_SYSTEM;

    case 'map':
      return _collection.map;

    case 'keys':
      return _object.keys;

    case 'filter':
      return _collection.filter;

    case 'includes':
      return _collection.includes;

    case 'api':
      return _api2['default'];

    case 'unitHelper':
      return _unitHelper2['default'];

    case 'each':
      return _collection.each;

    case 'every':
      return _collection.every;

    case 'timeMomentSort':
      return timeMomentSort;

    case 'last':
      return _array.last;

    case 'i18n':
      return _i18n2['default'];

    case 'htmlDecode':
      return _helpers.htmlDecode;

    case 'letUserModifyTimeSlotParams':
      return _constants.letUserModifyTimeSlotParams;

    case 'showAdditionalDiscussionCheckbox':
      return _constants.showAdditionalDiscussionCheckbox;

    case 'Component':
      return _react.Component;

    case 'Booking':
      return Booking;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'SingleSelectButton':
      return _SingleSelectButton2['default'];

    case 'Interpolate':
      return _reactI18next.Interpolate;

    case 'LoginFormSelector':
      return _LoginFormSelector2['default'];

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'Button':
      return _reactBootstrap.Button;

    case 'AppIcon':
      return _AppIcon2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'CodeForm':
      return _CodeForm2['default'];

    case 'History':
      return _History2['default'];

    case 'ByTicket':
      return _ByTicket2['default'];

    case 'SymptomLevel':
      return _SymptomLevel2['default'];

    case 'OptionGroup':
      return _OptionGroup2['default'];

    case 'InfoBox':
      return _InfoBox2['default'];

    case 'AdditionalDiscussionCheckbox':
      return _AdditionalDiscussionCheckbox2['default'];

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'MultiSelectButton':
      return _MultiSelectButton2['default'];

    case 'BookingPhase':
      return _BookingPhase2['default'];

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'FormGroup':
      return _reactBootstrap.FormGroup;

    case 'ControlLabel':
      return _reactBootstrap.ControlLabel;

    case 'Calendar':
      return _reactCalendar2['default'];

    case 'TimeSlots':
      return _TimeSlots2['default'];

    case 'Collapse':
      return _reactBootstrap.Collapse;

    case 'SimpleBox':
      return _SimpleBox2['default'];

    case 'LoginComponent':
      return _LoginComponent2['default'];

    case 'RegistrationForm':
      return _RegistrationForm2['default'];

    case 'SelectionPathInfo':
      return _SelectionPathInfo2['default'];

    case 'ConfirmTimeSlotForm':
      return _ConfirmTimeSlotForm2['default'];

    case 'UnitInfoContainer':
      return _UnitInfoContainer2['default'];

    case 'Alert':
      return _reactBootstrap.Alert;

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];

    case 'UnitInfo':
      return _UnitInfo2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(timeMomentSort, 'timeMomentSort', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/Booking.jsx');

  __REACT_HOT_LOADER__.register(Booking, 'Booking', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/Booking.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/Booking.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

__webpack_require__(391);

var _BookingPhase = __webpack_require__(218);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

var _LoginComponent = __webpack_require__(551);

var _LoginComponent2 = _interopRequireDefault(_LoginComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LoginFormSelector = function () {
  function LoginFormSelector(props) {
    var loginPolicyType = props.loginPolicyType,
        t = props.t;

    return _get__('React').createElement(
      _get__('BookingPhase'),
      { id: 'booking-phase-identify-late', title: t('lateLoginPhaseTitle') },
      _get__('React').createElement(
        'div',
        { className: 'center-block late-login-content' },
        _get__('React').createElement(
          'div',
          { className: 'box-header late-login-heading' },
          _get__('React').createElement(
            'h1',
            null,
            t('lateLoginPhaseHeading')
          )
        ),
        _get__('React').createElement(_get__('LoginComponent'), { loginType: loginPolicyType })
      )
    );
  }

  return LoginFormSelector;
}();

_get__('LoginFormSelector').propTypes = {
  loginPolicyType: _get__('PropTypes').string.isRequired,
  t: _get__('PropTypes').object.isRequired
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return ['booking', props.pathNamespace];
}, { wait: true })(_get__('LoginFormSelector'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LoginFormSelector':
      return LoginFormSelector;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'BookingPhase':
      return _BookingPhase2['default'];

    case 'LoginComponent':
      return _LoginComponent2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LoginFormSelector, 'LoginFormSelector', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/LoginFormSelector.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/LoginFormSelector.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _UnitInfo = __webpack_require__(553);

var _UnitInfo2 = _interopRequireDefault(_UnitInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var UnitInfoContainer = function () {
  function UnitInfoContainer(_ref) {
    var unit = _ref.unit;
    return _get__('React').createElement(
      'div',
      { className: 'booking-phase-centered-content booking-unit-info-section' },
      _get__('React').createElement(
        'div',
        { className: 'unit-info-content' },
        _get__('React').createElement(_get__('UnitInfo'), { unit: unit })
      )
    );
  }

  return UnitInfoContainer;
}();

_get__('UnitInfoContainer').propTypes = {
  unit: _get__('PropTypes').shape({})
};

_get__('UnitInfoContainer').defaultProps = {
  unit: {}
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('UnitInfoContainer'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'UnitInfoContainer':
      return UnitInfoContainer;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'UnitInfo':
      return _UnitInfo2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UnitInfoContainer, 'UnitInfoContainer', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/UnitInfoContainer.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/UnitInfoContainer.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _Booking = __webpack_require__(1145);

var _Booking2 = _interopRequireDefault(_Booking);

var _booking = __webpack_require__(68);

var _ehrResources = __webpack_require__(174);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    var units = state.units,
        unitInfos = state.unitInfos;

    Object.keys(unitInfos).forEach(function (key) {
      if (units[key]) {
        units[key].info = unitInfos[key];
      }
    });

    return {
      userIdentified: state.session.userIdentified,
      canAnonymousFetchTimes: state.booking.canAnonymousFetchTimes,
      user: state.session.user,
      hasDepartment: state.session.hasDepartment,
      selectedEmployer: state.session.selectedEmployer,
      selectedDepartment: state.session.selectedDepartment,
      selectedOptionIds: state.booking.selectedOptionIds,
      additionalDiscussionChecked: state.booking.additionalDiscussionChecked,
      requestingTimeSlots: state.booking.requestingTimeSlots,
      timeSlotsRequested: state.booking.timeSlotsRequested,
      resources: state.resources,
      groups: state.groups,
      units: units,
      timeSlots: state.booking.timeSlots,
      storingReservation: state.booking.storingReservation,
      reservation: state.booking.reservation,
      reservationDone: state.booking.reservationDone,
      errorOccurred: !!Object.keys(state.errors).length,
      errors: state.errors,
      reservationByCodeEnabled: state.organization.reservationByCodeEnabled,
      prepareUserRegistration: state.session.prepareUserRegistration,
      pathNamespace: state.booking.pathNamespace,
      currentlyIdentifying: state.session.currentlyIdentifying,
      currentlyRegistering: state.session.currentlyRegistering,
      pathReservationByCodeEnabled: state.booking.pathReservationByCodeEnabled,
      utilizeEmployerInformation: state.booking.utilizeEmployerInformation,
      selectionHandler: state.booking.selectionHandler,
      pathLoaded: state.booking.pathLoaded,
      googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId,
      selectedPathType: state.booking.selectedPathType,
      viaSso: state.session.viaSso,
      pathBasedBooking: state.booking.pathBasedBooking,
      selectedTicket: state.ticket.selectedTicket,
      hasSelectedTicket: state.ticket.hasSelectedTicket,
      selectedTicketCode: state.ticket.selectedTicketCode,
      optionalReservationText: state.organization.optionalReservationText,
      defaultLocale: state.organization.defaultLocale,
      legalEntity: state.booking.legalEntity,
      reservationReasonCode: state.booking.reservationReasonCode,
      loginPolicyType: state.organization.loginPolicyType,
      configurationLoaded: state.app.configurationLoaded,
      restoredState: state.booking.restoredState,
      selectedStoredTimeSlot: state.booking.selectedStoredTimeSlot,
      requiresEmployer: state.session.requiresEmployer,
      creationIncomplete: state.session.creationIncomplete,
      showOwnTeamByDefault: state.organization.showOwnTeamByDefault,
      smsConfirmationEnabled: state.organization.smsConfirmationEnabled,
      emailConfirmationEnabled: state.organization.emailConfirmationEnabled
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      selectedOptionsChanged: function () {
        function selectedOptionsChanged(selectedOptionIds) {
          dispatch(_get__('selectedOptionsChanged')(selectedOptionIds));
        }

        return selectedOptionsChanged;
      }(),
      additionalDiscussionChanged: function () {
        function additionalDiscussionChanged(value) {
          dispatch(_get__('additionalDiscussionChanged')(value));
        }

        return additionalDiscussionChanged;
      }(),

      fetchUnitInfo: dispatch(_get__('fetchUnitInfo')),
      requestTimeSlots: dispatch(_get__('requestTimeSlots')),
      clearTimeSlots: function () {
        function clearTimeSlots() {
          dispatch(_get__('clearTimeSlots')());
        }

        return clearTimeSlots;
      }(),

      storeReservation: dispatch(_get__('storeReservation')),
      logout: dispatch(_get__('clearSession')),
      bookAgain: dispatch(_get__('resetBookingState')),
      setReservationReasonCode: dispatch(_get__('setReservationReasonCode')),
      setSelectedTimeslotToStore: function () {
        function setSelectedTimeslotToStore(timeslot) {
          dispatch(_get__('setSelectedTimeslot')(timeslot));
        }

        return setSelectedTimeslotToStore;
      }(),
      unsetSelectedTimeslotToStore: function () {
        function unsetSelectedTimeslotToStore() {
          dispatch(_get__('unsetSelectedTimeslot')());
        }

        return unsetSelectedTimeslotToStore;
      }()
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Booking'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'selectedOptionsChanged':
      return _booking.selectedOptionsChanged;

    case 'additionalDiscussionChanged':
      return _booking.additionalDiscussionChanged;

    case 'fetchUnitInfo':
      return _ehrResources.fetchUnitInfo;

    case 'requestTimeSlots':
      return _booking.requestTimeSlots;

    case 'clearTimeSlots':
      return _booking.clearTimeSlots;

    case 'storeReservation':
      return _booking.storeReservation;

    case 'clearSession':
      return _session.clearSession;

    case 'resetBookingState':
      return _booking.resetBookingState;

    case 'setReservationReasonCode':
      return _booking.setReservationReasonCode;

    case 'setSelectedTimeslot':
      return _booking.setSelectedTimeslot;

    case 'unsetSelectedTimeslot':
      return _booking.unsetSelectedTimeslot;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'Booking':
      return _Booking2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/Booking/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(11);

var _BookingPhase = __webpack_require__(218);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

var _TicketCard = __webpack_require__(1142);

var _TicketCard2 = _interopRequireDefault(_TicketCard);

__webpack_require__(1507);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ByTicket = function (_get__2) {
  _inherits(ByTicket, _get__2);

  function ByTicket() {
    _classCallCheck(this, ByTicket);

    return _possibleConstructorReturn(this, (ByTicket.__proto__ || Object.getPrototypeOf(ByTicket)).apply(this, arguments));
  }

  _createClass(ByTicket, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var _props = this.props,
            ticketsLoaded = _props.ticketsLoaded,
            ticketsLoading = _props.ticketsLoading,
            getTickets = _props.getTickets;

        if (!ticketsLoaded && !ticketsLoading) {
          getTickets();
        }
      }

      return componentWillMount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            reservationByCode = _props2.reservationByCode,
            tickets = _props2.tickets,
            selectTicket = _props2.selectTicket,
            selectedTicketCode = _props2.selectedTicketCode,
            units = _props2.units,
            resources = _props2.resources,
            groups = _props2.groups,
            t = _props2.t;


        var ticketsForBooking = tickets.filter(function (ticket) {
          return !ticket.reservation;
        });
        var asMoment = function () {
          function asMoment(date) {
            return _get__('moment')(date, 'YYYY-MM-DD');
          }

          return asMoment;
        }();
        ticketsForBooking.sort(function (a, b) {
          return asMoment(a.openingDate).valueOf() - asMoment(b.openingDate).valueOf();
        });
        var reservationByCodeDiv = reservationByCode ? _get__('React').createElement(
          'div',
          null,
          ' ',
          reservationByCode,
          ' ',
          _get__('React').createElement('hr', null),
          ' '
        ) : null;
        return _get__('React').createElement(
          'div',
          { className: 'reserve-by-ticket' },
          _get__('React').createElement(_get__('BookingPhase'), { title: t('sectionTitles.selectATicket'), id: 'byTicket' }),
          reservationByCode && reservationByCodeDiv,
          _get__('React').createElement(
            'div',
            { className: 'ticket-instructions' },
            t('ticket.instructions')
          ),
          ticketsForBooking.length === 0 && _get__('React').createElement(
            'div',
            { className: 'ticket-container-no-tickets' },
            t('ticket.noTickets')
          ),
          ticketsForBooking.length > 0 && _get__('React').createElement(
            'div',
            { className: 'ticket-container' },
            ticketsForBooking.map(function (ticket) {
              return _get__('React').createElement(
                'div',
                { key: ticket.code || ticket.id },
                _get__('React').createElement(_get__('TicketCard'), {
                  ticket: ticket,
                  onClick: selectTicket,
                  selectedTicketCode: selectedTicketCode,
                  unit: ticket.unit ? units[ticket.unit] : null,
                  allResources: resources,
                  allGroups: groups,
                  allUnits: units,
                  t: t
                })
              );
            })
          )
        );
      }

      return render;
    }()
  }]);

  return ByTicket;
}(_get__('Component'));

_get__('ByTicket').propTypes = {
  tickets: _get__('PropTypes').array.isRequired,
  ticketsLoading: _get__('PropTypes').bool.isRequired,
  ticketsLoaded: _get__('PropTypes').bool.isRequired,
  getTickets: _get__('PropTypes').func.isRequired,
  selectTicket: _get__('PropTypes').func.isRequired,
  selectedTicketCode: _get__('PropTypes').string.isRequired,
  units: _get__('PropTypes').object.isRequired,
  resources: _get__('PropTypes').object.isRequired,
  groups: _get__('PropTypes').object.isRequired,
  t: _get__('PropTypes').func.isRequired,
  reservationByCode: _get__('PropTypes').element.isRequired
};

_get__('ByTicket').defaultProps = {
  tickets: [],
  ticketsLoaded: false,
  ticketsLoading: false,
  selectedTicketCode: '',
  units: {},
  reservationByCode: null
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('ByTicket'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'moment':
      return _moment2['default'];

    case 'Component':
      return _react.Component;

    case 'ByTicket':
      return ByTicket;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'BookingPhase':
      return _BookingPhase2['default'];

    case 'TicketCard':
      return _TicketCard2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ByTicket, 'ByTicket', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ByTicket/ByTicket.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ByTicket/ByTicket.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _ByTicket = __webpack_require__(1149);

var _ByTicket2 = _interopRequireDefault(_ByTicket);

var _ticket = __webpack_require__(546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      tickets: state.ticket.tickets,
      ticketsLoading: state.ticket.ticketsLoading,
      ticketsLoaded: state.ticket.ticketsLoaded,
      selectedTicketCode: state.ticket.selectedTicketCode,
      units: state.units,
      resources: state.resources,
      groups: state.groups
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      getTickets: dispatch(_get__('getTickets')),
      selectTicket: dispatch(_get__('selectTicket'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('ByTicket'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'getTickets':
      return _ticket.getTickets;

    case 'selectTicket':
      return _ticket.selectTicket;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'ByTicket':
      return _ByTicket2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ByTicket/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ByTicket/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ByTicket/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _lang = __webpack_require__(159);

var _reactI18next = __webpack_require__(11);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _IdentificationForm = __webpack_require__(253);

var _IdentificationForm2 = _interopRequireDefault(_IdentificationForm);

var _SimpleBox = __webpack_require__(219);

var _SimpleBox2 = _interopRequireDefault(_SimpleBox);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _helpers = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelReservation = function (_get__2) {
  _inherits(CancelReservation, _get__2);

  function CancelReservation(props) {
    _classCallCheck(this, CancelReservation);

    var _this = _possibleConstructorReturn(this, (CancelReservation.__proto__ || Object.getPrototypeOf(CancelReservation)).call(this, props));

    _this.onHideModal = _this.onHideModal.bind(_this);
    _this.handleFormInputChange = _this.handleFormInputChange.bind(_this);
    _this.sendReservationCode = _this.sendReservationCode.bind(_this);
    _this.confirmCancelling = _this.confirmCancelling.bind(_this);
    _this.initialState = {
      formValues: {},
      sendReservationCodeButtonDisabled: true
    };
    _this.state = _this.initialState;
    return _this;
  }

  _createClass(CancelReservation, [{
    key: 'onHideModal',
    value: function () {
      function onHideModal() {
        this.setState(this.initialState);
        this.props.closeCancelReservationScreen();
      }

      return onHideModal;
    }()
  }, {
    key: 'sendReservationCode',
    value: function () {
      function sendReservationCode(event) {
        event.preventDefault();
        this.props.fetchReservation(this.state.formValues.reservationCode);
      }

      return sendReservationCode;
    }()
  }, {
    key: 'handleFormInputChange',
    value: function () {
      function handleFormInputChange(event) {
        var _event$target = event.target,
            fieldName = _event$target.id,
            value = _event$target.value;

        this.setState({
          formValues: _extends({}, this.state.formValues, _defineProperty({}, fieldName, value))
        }, this.validateFields);
      }

      return handleFormInputChange;
    }()
  }, {
    key: 'validateFields',
    value: function () {
      function validateFields() {
        var reservationCode = this.state.formValues.reservationCode;

        var allFieldsValid = reservationCode.length > 0;
        this.setState({ sendReservationCodeButtonDisabled: !allFieldsValid });
      }

      return validateFields;
    }()
  }, {
    key: 'confirmCancelling',
    value: function () {
      function confirmCancelling() {
        this.props.cancelReservation(this.props.reservation.reservation);
      }

      return confirmCancelling;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            show = _props.show,
            userIdentified = _props.userIdentified,
            fetchingReservationError = _props.fetchingReservationError,
            reservation = _props.reservation,
            reservationCancelled = _props.reservationCancelled,
            cancellingReservationError = _props.cancellingReservationError,
            t = _props.t;


        var currentPhase = void 0;
        var textKey = void 0;

        if (!userIdentified) {
          currentPhase = _get__('React').createElement(
            _get__('SimpleBox'),
            null,
            _get__('React').createElement(
              'div',
              { className: 'box-header' },
              _get__('React').createElement(
                'h1',
                null,
                t('cancelReservation.loginFirstTitle')
              ),
              _get__('React').createElement(
                'p',
                null,
                t('cancelReservation.loginFirstText')
              )
            ),
            _get__('React').createElement(_get__('IdentificationForm'), null)
          );
        } else if (_get__('isEmpty')(reservation)) {
          currentPhase = _get__('React').createElement(
            _get__('SimpleBox'),
            null,
            _get__('React').createElement(
              'div',
              { className: 'box-header' },
              _get__('React').createElement(
                'h1',
                null,
                t('cancelReservation.insertReservationCodeTitle')
              )
            ),
            _get__('React').createElement(
              'div',
              null,
              _get__('React').createElement(
                'form',
                { className: 'reservation-number-form', onSubmit: this.sendReservationCode },
                _get__('React').createElement(
                  'div',
                  { className: 'form-input-group' },
                  _get__('React').createElement('input', {
                    id: 'reservationCode',
                    type: 'text',
                    placeholder: t('cancelReservation.reservationCodePlaceholder'),
                    onChange: this.handleFormInputChange
                  })
                ),
                _get__('React').createElement(
                  _get__('ErrorMessage'),
                  { isVisible: !_get__('isEmpty')(fetchingReservationError) },
                  _get__('React').createElement(
                    'strong',
                    null,
                    t('cancelReservation.' + fetchingReservationError)
                  ),
                  _get__('React').createElement(
                    'p',
                    null,
                    t('cancelReservation.checkReservationCodeMessage')
                  )
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn center-block',
                    type: 'submit',
                    disabled: this.state.sendReservationCodeButtonDisabled
                  },
                  t('cancelReservation.searchForReservationButton')
                )
              )
            )
          );
        } else if (!reservationCancelled) {
          console.log('Inserting unit', this.props.units, this.props.reservation.unit);
          currentPhase = _get__('React').createElement(
            _get__('SimpleBox'),
            null,
            _get__('React').createElement(
              'div',
              { className: 'text-center' },
              _get__('React').createElement(
                'div',
                { className: 'box-header' },
                _get__('React').createElement(
                  'h1',
                  null,
                  t('cancelReservation.confirmCancellingTitle')
                )
              ),
              _get__('React').createElement(_get__('TimeSlotCard'), {
                timeSlot: _get__('transformReservationsToTimeSlot')(reservation, this.props.resources, t),
                onClick: reservation.canBeCancelled ? this.confirmCancelling : null,
                disabled: !reservation.canBeCancelled,
                unit: this.props.units[this.props.reservation.unit],
                actionElement: reservation.canBeCancelled ? _get__('React').createElement(
                  'span',
                  { className: 'time-slot-action-text' },
                  t('cancelReservation.cancelButton')
                ) : _get__('React').createElement('p', null)
              }),
              !reservation.canBeCancelled && _get__('React').createElement(
                'span',
                null,
                t('cancelReservation.notCancelableReason')
              ),
              _get__('React').createElement(
                _get__('ErrorMessage'),
                { isVisible: !_get__('isEmpty')(cancellingReservationError) },
                _get__('React').createElement(
                  'strong',
                  null,
                  _get__('i18n').exists('cancelReservation.' + cancellingReservationError) ? t('cancelReservation.' + cancellingReservationError) : t('genericErrorMessage')
                )
              )
            )
          );
        } else {
          textKey = this.props.reservationWasAlreadyCancelled ? 'alreadyCancelled' : 'reservationCancelledTitle';
          currentPhase = _get__('React').createElement(
            _get__('SimpleBox'),
            null,
            _get__('React').createElement(
              'div',
              { className: 'reservation-cancelled-phase text-center' },
              _get__('React').createElement(
                'div',
                { className: 'box-header' },
                _get__('React').createElement(
                  'h1',
                  null,
                  t('cancelReservation.' + textKey)
                )
              ),
              _get__('React').createElement(
                'div',
                { className: 'reservation-cancelled-actions' },
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn action-btn-logout',
                    onClick: this.props.logout
                  },
                  t('logoutButton')
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn action-btn-back',
                    onClick: this.onHideModal
                  },
                  t('cancelReservation.backToBooking')
                )
              )
            )
          );
        }

        return _get__('React').createElement(
          _get__('Modal'),
          {
            className: 'cancel-reservation-screen',
            show: show,
            backdrop: 'static',
            keyboard: false,
            onHide: function () {
              function onHide() {
                _this2.onHideModal();
              }

              return onHide;
            }()
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: function () {
                function onClick() {
                  _this2.onHideModal();
                }

                return onClick;
              }()
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          currentPhase
        );
      }

      return render;
    }()
  }]);

  return CancelReservation;
}(_get__('Component'));

_get__('CancelReservation').propTypes = {
  show: _get__('PropTypes').bool.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  closeCancelReservationScreen: _get__('PropTypes').func.isRequired,
  fetchReservation: _get__('PropTypes').func.isRequired,
  fetchingReservationError: _get__('PropTypes').string,
  reservation: _get__('PropTypes').object,
  cancelReservation: _get__('PropTypes').func.isRequired,
  cancellingReservationError: _get__('PropTypes').string,
  reservationCancelled: _get__('PropTypes').bool,
  reservationWasAlreadyCancelled: _get__('PropTypes').bool,
  logout: _get__('PropTypes').func.isRequired,
  resources: _get__('PropTypes').shape({}),
  t: _get__('PropTypes').func.isRequired,
  units: _get__('PropTypes').shape({})
};

_get__('CancelReservation').defaultProps = {
  fetchingReservationError: '',
  reservation: {},
  cancellingReservationError: '',
  reservationCancelled: false,
  resources: {},
  units: {},
  user: {},
  reservationWasAlreadyCancelled: false
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('CancelReservation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'isEmpty':
      return _lang.isEmpty;

    case 'transformReservationsToTimeSlot':
      return _helpers.transformReservationsToTimeSlot;

    case 'i18n':
      return _i18n2['default'];

    case 'Component':
      return _react.Component;

    case 'CancelReservation':
      return CancelReservation;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'SimpleBox':
      return _SimpleBox2['default'];

    case 'IdentificationForm':
      return _IdentificationForm2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CancelReservation, 'CancelReservation', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservation/CancelReservation.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservation/CancelReservation.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _CancelReservation = __webpack_require__(1151);

var _CancelReservation2 = _interopRequireDefault(_CancelReservation);

var _cancelling = __webpack_require__(103);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      fetchingReservationError: state.cancelling.fetchingReservationError,
      reservation: state.cancelling.reservation,
      cancellingReservationError: state.cancelling.cancellingReservationError,
      reservationCancelled: state.cancelling.reservationCancelled,
      resources: state.resources,
      units: state.units,
      reservationWasAlreadyCancelled: state.cancelling.reservationAlreadyCancelled
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      closeCancelReservationScreen: function () {
        function closeCancelReservationScreen() {
          dispatch(_get__('closeCancelReservationScreen')());
        }

        return closeCancelReservationScreen;
      }(),

      fetchReservation: dispatch(_get__('fetchReservation')),
      cancelReservation: dispatch(_get__('cancelReservation')),
      logout: dispatch(_get__('clearSession'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('CancelReservation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'closeCancelReservationScreen':
      return _cancelling.closeCancelReservationScreen;

    case 'fetchReservation':
      return _cancelling.fetchReservation;

    case 'cancelReservation':
      return _cancelling.cancelReservation;

    case 'clearSession':
      return _session.clearSession;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'CancelReservation':
      return _CancelReservation2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservation/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservation/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservation/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _lang = __webpack_require__(159);

var _reactI18next = __webpack_require__(11);

var _IdentificationForm = __webpack_require__(253);

var _IdentificationForm2 = _interopRequireDefault(_IdentificationForm);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

var _helpers = __webpack_require__(119);

__webpack_require__(1508);

var _BankSelection = __webpack_require__(350);

var _BankSelection2 = _interopRequireDefault(_BankSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelReservationAsDiv = function (_get__2) {
  _inherits(CancelReservationAsDiv, _get__2);

  function CancelReservationAsDiv(props) {
    _classCallCheck(this, CancelReservationAsDiv);

    var _this = _possibleConstructorReturn(this, (CancelReservationAsDiv.__proto__ || Object.getPrototypeOf(CancelReservationAsDiv)).call(this, props));

    _this.handleFormInputChange = _this.handleFormInputChange.bind(_this);
    _this.sendReservationCode = _this.sendReservationCode.bind(_this);
    _this.confirmCancelling = _this.confirmCancelling.bind(_this);
    _this.initialState = {
      formValues: {},
      sendReservationCodeButtonDisabled: true
    };
    _this.state = _this.initialState;
    return _this;
  }

  _createClass(CancelReservationAsDiv, [{
    key: 'sendReservationCode',
    value: function () {
      function sendReservationCode(event) {
        event.preventDefault();
        this.props.fetchReservation(this.state.formValues.reservationCode);
      }

      return sendReservationCode;
    }()
  }, {
    key: 'handleFormInputChange',
    value: function () {
      function handleFormInputChange(event) {
        var _event$target = event.target,
            fieldName = _event$target.id,
            value = _event$target.value;

        this.setState({
          formValues: _extends({}, this.state.formValues, _defineProperty({}, fieldName, value))
        }, this.validateFields);
      }

      return handleFormInputChange;
    }()
  }, {
    key: 'validateFields',
    value: function () {
      function validateFields() {
        var reservationCode = this.state.formValues.reservationCode;

        var allFieldsValid = reservationCode.length > 0;
        this.setState({ sendReservationCodeButtonDisabled: !allFieldsValid });
      }

      return validateFields;
    }()
  }, {
    key: 'confirmCancelling',
    value: function () {
      function confirmCancelling() {
        this.props.cancelReservation(this.props.reservation.reservation);
      }

      return confirmCancelling;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            userIdentified = _props.userIdentified,
            fetchingReservationError = _props.fetchingReservationError,
            reservation = _props.reservation,
            reservationCancelled = _props.reservationCancelled,
            cancellingReservationError = _props.cancellingReservationError,
            loginPolicyType = _props.loginPolicyType,
            t = _props.t;


        var currentPhase = void 0;
        var textKey = void 0;

        if (!userIdentified) {
          var loginComponent = loginPolicyType === 'STRONG' ? _get__('React').createElement(
            'div',
            { className: 'intro-box intro-box-left container-fluid' },
            _get__('React').createElement(_get__('BankSelection'), { showBackButton: false })
          ) : _get__('React').createElement(_get__('IdentificationForm'), null);
          currentPhase = _get__('React').createElement(
            'div',
            { className: 'text-center' },
            _get__('React').createElement(
              'h2',
              { className: 'test booking-phase-title' },
              t('cancelReservation.loginFirstTitle')
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(
              'div',
              { className: 'cancellation-body-div' },
              _get__('React').createElement(
                'p',
                null,
                t('cancelReservation.loginFirstText')
              ),
              loginComponent
            )
          );
        } else if (_get__('isEmpty')(reservation)) {
          currentPhase = _get__('React').createElement(
            'div',
            { className: 'text-center' },
            _get__('React').createElement(
              'h2',
              { className: 'test booking-phase-title', tabIndex: 0 },
              t('cancelReservation.insertReservationCodeTitle')
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(
              'div',
              { className: 'cancellation-body-div' },
              _get__('React').createElement(
                'form',
                { className: 'reservation-number-form', onSubmit: this.sendReservationCode },
                _get__('React').createElement(
                  'div',
                  { className: 'form-input-group cancellation-reservation-form-div' },
                  _get__('React').createElement('input', {
                    id: 'reservationCode',
                    type: 'text',
                    placeholder: t('cancelReservation.reservationCodePlaceholder'),
                    className: 'cancellation-reservation-code-input',
                    onChange: this.handleFormInputChange
                  })
                ),
                _get__('React').createElement(
                  _get__('ErrorMessage'),
                  { isVisible: !_get__('isEmpty')(fetchingReservationError) },
                  _get__('React').createElement(
                    'strong',
                    null,
                    t('cancelReservation.' + fetchingReservationError)
                  ),
                  _get__('React').createElement(
                    'p',
                    null,
                    t('cancelReservation.checkReservationCodeMessage')
                  )
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn center-block',
                    type: 'submit',
                    disabled: this.state.sendReservationCodeButtonDisabled
                  },
                  t('cancelReservation.searchForReservationButton')
                )
              )
            )
          );
        } else if (!reservationCancelled) {
          console.log('Inserting unit', this.props.units, this.props.reservation.unit);
          currentPhase = _get__('React').createElement(
            'div',
            { className: 'text-center' },
            _get__('React').createElement(
              'h2',
              { className: 'test booking-phase-title', tabIndex: 0 },
              t('cancelReservation.confirmCancellingTitle')
            ),
            _get__('React').createElement('hr', null),
            _get__('React').createElement(
              'div',
              { className: 'cancellation-body-div' },
              _get__('React').createElement(_get__('TimeSlotCard'), {
                timeSlot: _get__('transformReservationsToTimeSlot')(reservation, this.props.resources, t),
                onClick: reservation.canBeCancelled ? this.confirmCancelling : null,
                disabled: !reservation.canBeCancelled,
                unit: this.props.units[this.props.reservation.unit],
                actionElement: reservation.canBeCancelled ? _get__('React').createElement(
                  'span',
                  { className: 'time-slot-action-text' },
                  t('cancelReservation.cancelButton')
                ) : _get__('React').createElement('p', null)
              }),
              !reservation.canBeCancelled && _get__('React').createElement(
                'span',
                null,
                t('cancelReservation.notCancelableReason')
              ),
              _get__('React').createElement(
                _get__('ErrorMessage'),
                { isVisible: !_get__('isEmpty')(cancellingReservationError) },
                _get__('React').createElement(
                  'strong',
                  null,
                  t('cancelReservation.' + cancellingReservationError)
                )
              )
            )
          );
        } else {
          textKey = this.props.reservationWasAlreadyCancelled ? 'alreadyCancelled' : 'reservationCancelledTitle';
          currentPhase = _get__('React').createElement(
            'div',
            { className: 'reservation-cancelled-phase text-center' },
            _get__('React').createElement(
              'div',
              { className: 'reservation-cancelled-actions' },
              _get__('React').createElement(
                'h2',
                { className: 'test booking-phase-title', tabIndex: 0 },
                t('cancelReservation.' + textKey)
              ),
              _get__('React').createElement('hr', null),
              _get__('React').createElement(
                'div',
                { className: 'cancellation-body-div' },
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn action-btn-logout',
                    onClick: this.props.logout
                  },
                  t('logoutButton')
                ),
                _get__('React').createElement(
                  _get__('Button'),
                  {
                    className: 'action-btn action-btn-back',
                    onClick: this.props.closeCancelReservationScreen
                  },
                  t('cancelReservation.backToBooking')
                )
              )
            )
          );
        }

        return currentPhase;
      }

      return render;
    }()
  }]);

  return CancelReservationAsDiv;
}(_get__('Component'));

_get__('CancelReservationAsDiv').propTypes = {
  userIdentified: _get__('PropTypes').bool.isRequired,
  fetchReservation: _get__('PropTypes').func.isRequired,
  fetchingReservationError: _get__('PropTypes').string,
  reservation: _get__('PropTypes').object,
  cancelReservation: _get__('PropTypes').func.isRequired,
  closeCancelReservationScreen: _get__('PropTypes').func.isRequired,
  cancellingReservationError: _get__('PropTypes').string,
  reservationCancelled: _get__('PropTypes').bool,
  reservationWasAlreadyCancelled: _get__('PropTypes').bool,
  logout: _get__('PropTypes').func.isRequired,
  resources: _get__('PropTypes').shape({}),
  t: _get__('PropTypes').func.isRequired,
  loginPolicyType: _get__('PropTypes').string,
  units: _get__('PropTypes').shape({})
};

_get__('CancelReservationAsDiv').defaultProps = {
  fetchingReservationError: '',
  reservation: {},
  cancellingReservationError: '',
  reservationCancelled: false,
  resources: {},
  units: {},
  user: {},
  reservationWasAlreadyCancelled: false,
  loginPolicyType: 'ONLY_SSN'
};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('CancelReservationAsDiv'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'isEmpty':
      return _lang.isEmpty;

    case 'transformReservationsToTimeSlot':
      return _helpers.transformReservationsToTimeSlot;

    case 'Component':
      return _react.Component;

    case 'CancelReservationAsDiv':
      return CancelReservationAsDiv;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'BankSelection':
      return _BankSelection2['default'];

    case 'IdentificationForm':
      return _IdentificationForm2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CancelReservationAsDiv, 'CancelReservationAsDiv', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservationAsDiv/CancelReservationAsDiv.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservationAsDiv/CancelReservationAsDiv.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _CancelReservationAsDiv = __webpack_require__(1153);

var _CancelReservationAsDiv2 = _interopRequireDefault(_CancelReservationAsDiv);

var _cancelling = __webpack_require__(103);

var _session = __webpack_require__(42);

var _booking = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      fetchingReservationError: state.cancelling.fetchingReservationError,
      reservation: state.cancelling.reservation,
      cancellingReservationError: state.cancelling.cancellingReservationError,
      reservationCancelled: state.cancelling.reservationCancelled,
      resources: state.resources,
      units: state.units,
      reservationWasAlreadyCancelled: state.cancelling.reservationAlreadyCancelled,
      loginPolicyType: state.organization.loginPolicyType
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      closeCancelReservationScreen: function () {
        function closeCancelReservationScreen() {
          dispatch(_get__('closeCancelReservationScreen')());
          dispatch(_get__('resetBooking')());
        }

        return closeCancelReservationScreen;
      }(),

      fetchReservation: dispatch(_get__('fetchReservation')),
      cancelReservation: dispatch(_get__('cancelReservation')),
      logout: dispatch(_get__('clearSession'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('CancelReservationAsDiv'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'closeCancelReservationScreen':
      return _cancelling.closeCancelReservationScreen;

    case 'resetBooking':
      return _booking.resetBooking;

    case 'fetchReservation':
      return _cancelling.fetchReservation;

    case 'cancelReservation':
      return _cancelling.cancelReservation;

    case 'clearSession':
      return _session.clearSession;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'CancelReservationAsDiv':
      return _CancelReservationAsDiv2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservationAsDiv/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservationAsDiv/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/CancelReservationAsDiv/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _SimpleBox = __webpack_require__(219);

var _SimpleBox2 = _interopRequireDefault(_SimpleBox);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContinueConfirmation = function (_get__2) {
  _inherits(ContinueConfirmation, _get__2);

  function ContinueConfirmation(props) {
    _classCallCheck(this, ContinueConfirmation);

    var _this = _possibleConstructorReturn(this, (ContinueConfirmation.__proto__ || Object.getPrototypeOf(ContinueConfirmation)).call(this, props));

    _this.onContinue = _this.onContinue.bind(_this);
    _this.onDeny = _this.onDeny.bind(_this);
    return _this;
  }

  _createClass(ContinueConfirmation, [{
    key: 'onContinue',
    value: function () {
      function onContinue() {
        this.props.confirmContinue();
      }

      return onContinue;
    }()
  }, {
    key: 'onDeny',
    value: function () {
      function onDeny() {
        this.props.logout();
      }

      return onDeny;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            show = _props.show,
            t = _props.t;


        var simpleBox = _get__('React').createElement(
          _get__('SimpleBox'),
          null,
          _get__('React').createElement(
            'div',
            { className: 'box-header' },
            _get__('React').createElement(
              'h1',
              null,
              t('continueConfirmation.title')
            ),
            _get__('React').createElement(
              'p',
              null,
              t('continueConfirmation.message')
            ),
            _get__('React').createElement(
              'div',
              { className: 'confirm-continue-actions' },
              _get__('React').createElement(
                _get__('Button'),
                {
                  className: 'action-btn',
                  onClick: function () {
                    function onClick() {
                      return _this2.onContinue();
                    }

                    return onClick;
                  }()
                },
                t('continueConfirmation.continueButton')
              ),
              _get__('React').createElement(
                _get__('Button'),
                {
                  className: 'action-btn',
                  onClick: function () {
                    function onClick() {
                      return _this2.onDeny();
                    }

                    return onClick;
                  }()
                },
                t('logoutButton')
              )
            )
          )
        );

        return _get__('React').createElement(
          _get__('Modal'),
          {
            className: 'continue-confirmation-screen',
            show: show,
            backdrop: 'static',
            keyboard: false
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: function () {
                function onClick() {
                  return _this2.onDeny();
                }

                return onClick;
              }()
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          simpleBox
        );
      }

      return render;
    }()
  }]);

  return ContinueConfirmation;
}(_get__('Component'));

_get__('ContinueConfirmation').propTypes = {
  show: _get__('PropTypes').bool.isRequired,
  confirmContinue: _get__('PropTypes').func.isRequired,
  logout: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('ContinueConfirmation').defaultProps = {};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('ContinueConfirmation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'ContinueConfirmation':
      return ContinueConfirmation;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'SimpleBox':
      return _SimpleBox2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ContinueConfirmation, 'ContinueConfirmation', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ContinueConfirmation/ContinueConfirmation.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ContinueConfirmation/ContinueConfirmation.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _ContinueConfirmation = __webpack_require__(1155);

var _ContinueConfirmation2 = _interopRequireDefault(_ContinueConfirmation);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      confirmContinue: function () {
        function confirmContinue() {
          dispatch(_get__('confirmContinue')());
        }

        return confirmContinue;
      }(),

      logout: dispatch(_get__('clearSession'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('ContinueConfirmation'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'confirmContinue':
      return _session.confirmContinue;

    case 'clearSession':
      return _session.clearSession;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'ContinueConfirmation':
      return _ContinueConfirmation2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ContinueConfirmation/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ContinueConfirmation/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/ContinueConfirmation/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _string = __webpack_require__(160);

var _lang = __webpack_require__(159);

var _BookingPhase = __webpack_require__(218);

var _BookingPhase2 = _interopRequireDefault(_BookingPhase);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

var _PastReservatioCard = __webpack_require__(1133);

var _PastReservatioCard2 = _interopRequireDefault(_PastReservatioCard);

var _helpers = __webpack_require__(119);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

__webpack_require__(1509);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_get__2) {
  _inherits(History, _get__2);

  function History(props, context) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, props, context));

    _this.handleShow = _this.handleShow.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.handleCancel = _this.handleCancel.bind(_this);
    _this.fetchPreviousMonth = _this.fetchPreviousMonth.bind(_this);
    _this.groupPastReservations = _this.groupPastReservations.bind(_this);
    _this.adjustInitialMonths = _this.adjustInitialMonths.bind(_this);
    // including the current month
    _this.initialMonthsToFetchInThePast = 3;
    // how many months do we go back in the past
    var monthsAgo = _get__('moment')().subtract(_this.initialMonthsToFetchInThePast - 1, 'months');
    var currentMonth = _get__('moment')();
    _this.state = {
      show: false,
      selectedReservation: null,
      from: monthsAgo.startOf('month'),
      to: currentMonth.endOf('month'),
      pastByMonth: {}
    };
    return _this;
  }

  _createClass(History, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var from = this.state.from;

        this.props.getInitialMonths(from.format('YYYY-MM-DD'));
        // this.props.getHistory();
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var initialLoadingReady = !prevProps.historyInitialLoaded && this.props.historyInitialLoaded;
        var additionalLoadingReady = !prevProps.historyLoaded && this.props.historyLoaded;
        var reservationsChanged = prevProps.reservations.length !== this.props.reservations.length;

        if (initialLoadingReady) {
          this.adjustInitialMonths();
        }

        if (initialLoadingReady || additionalLoadingReady || reservationsChanged) {
          this.groupPastReservations();
        }

        if (this.props.reservationCancelled) {
          this.handleClose();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'adjustInitialMonths',
    value: function () {
      function adjustInitialMonths() {
        var pastByMonth = this.state.pastByMonth;

        for (var monthIndex = 0; monthIndex < this.initialMonthsToFetchInThePast; monthIndex += 1) {
          var monthIterator = _get__('moment')().subtract(monthIndex, 'months').startOf('month').format('YYYY-MM-DD');
          if (!pastByMonth[monthIterator]) {
            pastByMonth[monthIterator] = [];
          }
        }
        this.setState({ pastByMonth: pastByMonth });
      }

      return adjustInitialMonths;
    }()
  }, {
    key: 'handleClose',
    value: function () {
      function handleClose() {
        this.setState({
          show: false,
          selectedReservation: null
        });
        this.props.closeCancelReservationScreen();
      }

      return handleClose;
    }()
  }, {
    key: 'handleShow',
    value: function () {
      function handleShow(reservation) {
        console.log('reservation', reservation);
        this.setState({
          show: true,
          selectedReservation: reservation
        });
      }

      return handleShow;
    }()
  }, {
    key: 'handleCancel',
    value: function () {
      function handleCancel() {
        var cancelAndRemoveFromReservations = this.props.cancelAndRemoveFromReservations;
        var selectedReservation = this.state.selectedReservation;

        cancelAndRemoveFromReservations(selectedReservation.reservation);
      }

      return handleCancel;
    }()
  }, {
    key: 'fetchPreviousMonth',
    value: function () {
      function fetchPreviousMonth() {
        var getPreviousMonth = this.props.getPreviousMonth;
        var _state = this.state,
            from = _state.from,
            pastByMonth = _state.pastByMonth;

        var previous = from.subtract(1, 'months');
        var pFrom = previous.clone().startOf('month');
        var pTo = previous.clone().endOf('month');
        getPreviousMonth(pFrom.format('YYYY-MM-DD'), pTo.format('YYYY-MM-DD'));
        pastByMonth[from.format('YYYY-MM-DD')] = []; // needed to show the title of the month

        this.setState({
          from: pFrom,
          to: pTo,
          pastByMonth: pastByMonth
        });
      }

      return fetchPreviousMonth;
    }()
  }, {
    key: 'groupPastReservations',
    value: function () {
      function groupPastReservations() {
        var _this2 = this;

        var reservations = this.props.reservations;
        var pastByMonth = this.state.pastByMonth;

        var now = _get__('moment')();
        var past = reservations.filter(function (reservation) {
          return _this2.props.resources[reservation.resource] && _this2.props.resources[reservation.resource].type === 1 && _get__('moment')(reservation.start).isBefore(now);
        });
        past.forEach(function (reservation) {
          var month = _get__('moment')(reservation.start).startOf('month').format('YYYY-MM-DD');
          if (!pastByMonth[month]) {
            pastByMonth[month] = [];
          }
          if (pastByMonth[month].filter(function (r) {
            return r.reservation === reservation.reservation;
          }).length === 0) {
            pastByMonth[month].push(reservation);
          }
        });
        // update the state
        this.setState({ pastByMonth: pastByMonth });
      }

      return groupPastReservations;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _props = this.props,
            reservations = _props.reservations,
            resources = _props.resources,
            units = _props.units,
            cancellingReservationError = _props.cancellingReservationError,
            t = _props.t;
        var _state2 = this.state,
            selectedReservation = _state2.selectedReservation,
            pastByMonth = _state2.pastByMonth;

        var now = _get__('moment')();
        // filter out those with resource type is person (resource.type === 1)
        var upcoming = reservations.filter(function (reservation) {
          return resources[reservation.resource] && resources[reservation.resource].type === 1 && _get__('moment')(reservation.start).isAfter(now);
        });
        var past = reservations.filter(function (reservation) {
          return resources[reservation.resource] && resources[reservation.resource].type === 1 && _get__('moment')(reservation.start).isBefore(now);
        });
        var language = _get__('i18n').language;

        var upcomingTitle = _get__('React').createElement(
          'div',
          { key: 'upcoming', className: 'upcoming-reservations-title' },
          _get__('React').createElement(
            'h3',
            null,
            t('history.upcoming')
          )
        );

        var pastTitle = _get__('React').createElement(
          'div',
          { key: 'past', className: 'past-reservations-title' },
          _get__('React').createElement(
            'h3',
            null,
            t('history.past')
          )
        );

        var cancellationModal = _get__('React').createElement(
          _get__('Modal'),
          {
            show: this.state.show,
            backdrop: 'static',
            keyboard: false,
            onHide: this.handleClose
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: this.handleClose
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          _get__('React').createElement(
            _get__('Modal').Header,
            null,
            _get__('React').createElement(
              _get__('Modal').Title,
              null,
              t('history.cancelModal.title')
            )
          ),
          _get__('React').createElement(
            _get__('Modal').Body,
            null,
            selectedReservation && _get__('React').createElement(_get__('TimeSlotCard'), {
              timeSlot: _get__('transformReservationsToTimeSlot')(selectedReservation, resources, t),
              disabled: true,
              unit: units[selectedReservation.unit],
              actionElement: _get__('React').createElement('p', null)
            }),
            _get__('React').createElement(
              _get__('ErrorMessage'),
              { isVisible: !_get__('isEmpty')(cancellingReservationError) },
              _get__('React').createElement(
                'strong',
                null,
                t('cancelReservation.cancellationFailed')
              )
            ),
            _get__('isEmpty')(cancellingReservationError) && _get__('React').createElement(
              'h4',
              null,
              t('history.cancelModal.confirmText')
            )
          ),
          _get__('React').createElement(
            _get__('Modal').Footer,
            null,
            _get__('isEmpty')(cancellingReservationError) && _get__('React').createElement(
              _get__('Button'),
              { bsStyle: 'primary', onClick: this.handleCancel },
              t('history.cancelModal.confirmButton')
            )
          )
        );
        console.log(pastByMonth);
        return _get__('React').createElement(
          'div',
          { className: 'history-container' },
          _get__('React').createElement(_get__('BookingPhase'), { title: t('sectionTitles.history'), id: 'history' }),
          _get__('React').createElement(
            'div',
            { className: 'history-items', key: 'historyDiv' },
            this.props.historyInitialLoaded && upcoming.length === 0 && past.length === 0 && _get__('React').createElement(
              'div',
              { className: 'no-reservation-data' },
              _get__('React').createElement(
                'h3',
                null,
                t('history.noReservationsNorHistory')
              )
            ),
            upcoming.length > 0 && upcomingTitle,
            upcoming.length > 0 && upcoming.sort(function (a, b) {
              return _get__('moment')(b.start).valueOf() - _get__('moment')(a.start).valueOf();
            }).map(function (reservation) {
              return _get__('React').createElement(
                'div',
                { key: reservation.code, className: 'upcoming-reservations-container' },
                _get__('React').createElement(_get__('TimeSlotCard'), {
                  timeSlot: _get__('transformReservationsToTimeSlot')(reservation, resources, t),
                  onClick: function () {
                    function onClick() {
                      if (reservation.canBeCancelled) {
                        _this3.handleShow(reservation);
                      }
                    }

                    return onClick;
                  }(),
                  disabled: !reservation.canBeCancelled,
                  unit: units[reservation.unit],
                  actionElement: reservation.canBeCancelled ? _get__('React').createElement(
                    'span',
                    { className: 'time-slot-action-text' },
                    t('cancelReservation.cancelButton')
                  ) : _get__('React').createElement('p', null)
                }),
                !reservation.canBeCancelled && _get__('React').createElement(
                  'span',
                  null,
                  t('cancelReservation.notCancelableReason')
                )
              );
            }),
            past.length > 0 && pastTitle,
            Object.keys(pastByMonth).sort(function (a, b) {
              return _get__('moment')(b).valueOf() - _get__('moment')(a).valueOf();
            }).map(function (month) {
              return _get__('React').createElement(
                'div',
                { key: month, className: 'past-reservations-container' },
                _get__('React').createElement(
                  'div',
                  { key: month + '-header', className: 'month-title' },
                  _get__('capitalize')(_get__('moment')(month).locale(language).format('MMMM YYYY') + ' (' + pastByMonth[month].length + ')')
                ),
                pastByMonth[month].length > 0 && pastByMonth[month].sort(function (a, b) {
                  return _get__('moment')(b.start).valueOf() - _get__('moment')(a.start).valueOf();
                }).map(function (reservation) {
                  return _get__('React').createElement(
                    'div',
                    { key: '' + reservation.reservation, className: 'past-reservation-card-container' },
                    _get__('React').createElement(_get__('PastReservationCard'), {
                      timeSlot: _get__('transformReservationsToTimeSlot')(reservation, resources, t),
                      unit: units[reservation.unit]
                    })
                  );
                })
              );
            }),
            _get__('React').createElement(
              'div',
              { className: 'next-month-button-container' },
              this.props.historyInitialLoaded && _get__('React').createElement(
                _get__('Button'),
                {
                  onClick: this.fetchPreviousMonth,
                  bsStyle: 'default',
                  bsSize: 'small'
                },
                _get__('React').createElement(
                  'span',
                  { className: 'next-month-button-text' },
                  t('history.getMoreButton')
                )
              )
            )
          ),
          cancellationModal
        );
      }

      return render;
    }()
  }]);

  return History;
}(_get__('Component'));

_get__('History').propTypes = {
  historyInitialLoaded: _get__('PropTypes').bool.isRequired,
  historyLoaded: _get__('PropTypes').bool.isRequired,
  reservations: _get__('PropTypes').array.isRequired,
  getInitialMonths: _get__('PropTypes').func.isRequired,
  getPreviousMonth: _get__('PropTypes').func.isRequired,
  resources: _get__('PropTypes').object.isRequired,
  units: _get__('PropTypes').object.isRequired,
  cancelAndRemoveFromReservations: _get__('PropTypes').func.isRequired,
  cancellingReservationError: _get__('PropTypes').string.isRequired,
  reservationCancelled: _get__('PropTypes').bool.isRequired,
  closeCancelReservationScreen: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('History').defaultProps = {
  historyInitialLoading: false,
  historyInitialLoaded: false,
  historyLoading: false,
  historyLoaded: false,
  historyPreviousLoaded: false,
  reservations: [],
  resources: {},
  units: {}
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('History'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'moment':
      return _moment2['default'];

    case 'i18n':
      return _i18n2['default'];

    case 'transformReservationsToTimeSlot':
      return _helpers.transformReservationsToTimeSlot;

    case 'isEmpty':
      return _lang.isEmpty;

    case 'capitalize':
      return _string.capitalize;

    case 'Component':
      return _react.Component;

    case 'History':
      return History;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'Button':
      return _reactBootstrap.Button;

    case 'AppIcon':
      return _AppIcon2['default'];

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'BookingPhase':
      return _BookingPhase2['default'];

    case 'PastReservationCard':
      return _PastReservatioCard2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(History, 'History', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/History/History.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/History/History.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _lang = __webpack_require__(159);

var _string = __webpack_require__(160);

var _finnishSsn = __webpack_require__(248);

var _finnishSsn2 = _interopRequireDefault(_finnishSsn);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _helpers = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentificationForm = function (_get__2) {
  _inherits(IdentificationForm, _get__2);

  function IdentificationForm(props) {
    _classCallCheck(this, IdentificationForm);

    var _this = _possibleConstructorReturn(this, (IdentificationForm.__proto__ || Object.getPrototypeOf(IdentificationForm)).call(this, props));

    _this.state = {
      allFieldsValid: false,
      firstName: '',
      lastName: '',
      personId: '',
      cyrillicLettersDetected: false,
      firstNameValid: false,
      lastNameValid: false,
      personIdValid: false,
      validationError: '',
      hideLoginError: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  _createClass(IdentificationForm, [{
    key: 'validateFields',
    value: function () {
      function validateFields() {
        var _state = this.state,
            firstName = _state.firstName,
            lastName = _state.lastName,
            personId = _state.personId;

        var firstNameValid = firstName.length > 0 && !_get__('cyrillicLetterScanner')(firstName);
        var lastNameValid = lastName.length > 0 && !_get__('cyrillicLetterScanner')(lastName);
        var SSN_SHORT_REGEX = /^([0-2][0-9]|(3)[0-1])(((0)[0-9])|((1)[0-2]))\d{2}$/;
        var personIdValid = this.props.relaxedSotuVerificationEnabled === true ? _get__('FinnishSSN').validate(personId.toUpperCase()) || personId.match(SSN_SHORT_REGEX) != null : _get__('FinnishSSN').validate(personId.toUpperCase());
        var cyrillicLettersDetected = _get__('cyrillicLetterScanner')(firstName) || _get__('cyrillicLetterScanner')(lastName) || _get__('cyrillicLetterScanner')(personId);
        var allFieldsValid = !cyrillicLettersDetected && firstNameValid && lastNameValid && personIdValid;
        this.setState({
          firstNameValid: firstNameValid,
          lastNameValid: lastNameValid,
          personIdValid: personIdValid,
          allFieldsValid: allFieldsValid,
          cyrillicLettersDetected: cyrillicLettersDetected,
          validationError: ''
        });
      }

      return validateFields;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(event) {
        var _event$target = event.target,
            fieldName = _event$target.id,
            value = _event$target.value;


        this.setState(_defineProperty({}, fieldName, _get__('trim')(value)), this.validateFields);
        if (this.props.loginFailed) {
          this.setState({ hideLoginError: true });
        }
      }

      return handleChange;
    }()
  }, {
    key: 'handleSubmit',
    value: function () {
      function handleSubmit(event) {
        event.preventDefault();
        var _state2 = this.state,
            firstName = _state2.firstName,
            lastName = _state2.lastName,
            personId = _state2.personId;
        var _props = this.props,
            requiresEmployer = _props.requiresEmployer,
            createUserIfNotExists = _props.createUserIfNotExists,
            relaxedSotuVerificationEnabled = _props.relaxedSotuVerificationEnabled;

        var formData = Object.assign({ firstName: firstName, lastName: lastName, personId: personId }, { requiresEmployer: requiresEmployer, createUserIfNotExists: createUserIfNotExists, relaxedSotuVerificationEnabled: relaxedSotuVerificationEnabled });
        console.log(formData);
        if (this.state.allFieldsValid) {
          this.props.identifyUser(formData);
          this.setState({ hideLoginError: false });
        } else if (this.state.cyrillicLettersDetected) {
          this.setState({ validationError: 'cyrillicLettersNotAllowed' });
        } else if (!this.state.firstNameValid) {
          this.setState({ validationError: 'firstNameMissing' });
        } else if (!this.state.lastNameValid) {
          this.setState({ validationError: 'lastNameMissing' });
        } else if (!this.state.personIdValid) {
          this.setState({ validationError: 'invalidPersonIdMessage' });
        }
      }

      return handleSubmit;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        if (this.props.userIdentified) {
          return null;
        }

        var _props2 = this.props,
            loginFailed = _props2.loginFailed,
            loginFailedMessage = _props2.loginFailedMessage,
            t = _props2.t;


        return _get__('React').createElement(
          'form',
          { className: 'identification-form login-form', onSubmit: function () {
              function onSubmit(e) {
                return _this2.handleSubmit(e);
              }

              return onSubmit;
            }() },
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'firstName',
              className: this.state.firstNameValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:identificationForm.firstNamePlaceholder'),
              onChange: this.handleChange
            })
          ),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'lastName',
              className: this.state.lastNameValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:identificationForm.lastNamePlaceholder'),
              onChange: this.handleChange
            })
          ),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'personId',
              className: this.state.personIdValid ? 'is-valid' : '',
              type: 'text',
              placeholder: this.props.relaxedSotuVerificationEnabled ? t('identification:identificationForm.personIdOrBirthdayPlaceholder') : t('identification:identificationForm.personIdPlaceholder'),
              onChange: this.handleChange
            }),
            this.props.relaxedSotuVerificationEnabled && _get__('React').createElement(
              'div',
              { className: 'date-of-birth-login-format-info' },
              ' (',
              t('identification:identificationForm.personIdRelaxedInfo'),
              ')'
            )
          ),
          _get__('React').createElement(
            _get__('ErrorMessage'),
            { isVisible: !_get__('isEmpty')(this.state.validationError) || this.state.cyrillicLettersDetected },
            _get__('React').createElement(
              'strong',
              null,
              this.state.cyrillicLettersDetected ? t('cyrillicLettersNotAllowed') : t(this.state.validationError)
            )
          ),
          _get__('React').createElement(
            _get__('ErrorMessage'),
            { isVisible: loginFailed && !this.state.hideLoginError },
            _get__('React').createElement(
              'strong',
              null,
              t('loginFailedTitle')
            ),
            loginFailedMessage && _get__('React').createElement(
              'p',
              null,
              t(loginFailedMessage)
            )
          ),
          _get__('React').createElement(
            _get__('Button'),
            {
              className: 'action-btn center-block login-button',
              type: 'submit'
            },
            t('identification:identificationForm.submitButtonText')
          )
        );
      }

      return render;
    }()
  }]);

  return IdentificationForm;
}(_get__('Component'));

_get__('IdentificationForm').propTypes = {
  identifyUser: _get__('PropTypes').func.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  loginFailed: _get__('PropTypes').bool.isRequired,
  loginFailedMessage: _get__('PropTypes').string,
  requiresEmployer: _get__('PropTypes').bool.isRequired,
  createUserIfNotExists: _get__('PropTypes').bool.isRequired,
  relaxedSotuVerificationEnabled: _get__('PropTypes').bool.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('IdentificationForm').defaultProps = {
  loginFailedMessage: null
};

var _DefaultExportValue = _get__('translate')(['common', 'identification'], { wait: true })(_get__('IdentificationForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'cyrillicLetterScanner':
      return _helpers.cyrillicLetterScanner;

    case 'FinnishSSN':
      return _finnishSsn2['default'];

    case 'trim':
      return _string.trim;

    case 'isEmpty':
      return _lang.isEmpty;

    case 'Component':
      return _react.Component;

    case 'IdentificationForm':
      return IdentificationForm;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'Button':
      return _reactBootstrap.Button;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(IdentificationForm, 'IdentificationForm', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/IdentificationForm/IdentificationForm.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/IdentificationForm/IdentificationForm.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _SimpleBox = __webpack_require__(219);

var _SimpleBox2 = _interopRequireDefault(_SimpleBox);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  confirmContinueActions: {
    textAlign: 'center'
  }
};

var LoginNotAllowed = function (_get__2) {
  _inherits(LoginNotAllowed, _get__2);

  function LoginNotAllowed(props) {
    _classCallCheck(this, LoginNotAllowed);

    var _this = _possibleConstructorReturn(this, (LoginNotAllowed.__proto__ || Object.getPrototypeOf(LoginNotAllowed)).call(this, props));

    _this.onOk = _this.onOk.bind(_this);
    return _this;
  }

  _createClass(LoginNotAllowed, [{
    key: 'onOk',
    value: function () {
      function onOk() {
        this.props.clearSession();
        this.props.close();
      }

      return onOk;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            show = _props.show,
            messageLocalizationKey = _props.messageLocalizationKey,
            t = _props.t;

        var title = t(messageLocalizationKey + '.title');
        var message = t(messageLocalizationKey + '.message');
        var buttonText = t(messageLocalizationKey + '.buttonText');

        var simpleBox = _get__('React').createElement(
          _get__('SimpleBox'),
          null,
          _get__('React').createElement(
            'div',
            { className: 'box-header' },
            _get__('React').createElement(
              'h1',
              null,
              title
            ),
            _get__('React').createElement(
              'p',
              null,
              message
            ),
            _get__('React').createElement(
              'div',
              { style: _get__('styles').confirmContinueActions, className: 'confirm-continue-actions' },
              _get__('React').createElement(
                _get__('Button'),
                {
                  className: 'action-btn login-reject-button',
                  onClick: function () {
                    function onClick() {
                      return _this2.onOk();
                    }

                    return onClick;
                  }()
                },
                buttonText
              )
            )
          )
        );

        return _get__('React').createElement(
          _get__('Modal'),
          {
            className: 'continue-confirmation-screen',
            show: show,
            backdrop: 'static',
            keyboard: false
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: function () {
                function onClick() {
                  return _this2.onOk();
                }

                return onClick;
              }()
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          simpleBox
        );
      }

      return render;
    }()
  }]);

  return LoginNotAllowed;
}(_get__('Component'));

_get__('LoginNotAllowed').propTypes = {
  show: _get__('PropTypes').bool.isRequired,
  messageLocalizationKey: _get__('PropTypes').string.isRequired,
  clearSession: _get__('PropTypes').func.isRequired,
  close: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('LoginNotAllowed').defaultProps = {};

var _DefaultExportValue = _get__('translate')(['common'])(_get__('LoginNotAllowed'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'styles':
      return styles;

    case 'Component':
      return _react.Component;

    case 'LoginNotAllowed':
      return LoginNotAllowed;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'SimpleBox':
      return _SimpleBox2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(styles, 'styles', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/LoginNotAllowed.jsx');

  __REACT_HOT_LOADER__.register(LoginNotAllowed, 'LoginNotAllowed', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/LoginNotAllowed.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/LoginNotAllowed.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _LoginNotAllowed = __webpack_require__(1159);

var _LoginNotAllowed2 = _interopRequireDefault(_LoginNotAllowed);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      clearSession: dispatch(_get__('clearSession')),
      close: function () {
        function close() {
          dispatch(_get__('identifyUserFailureAccessNotAllowedByEmployerUserNoted')());
        }

        return close;
      }()
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('LoginNotAllowed'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'clearSession':
      return _session.clearSession;

    case 'identifyUserFailureAccessNotAllowedByEmployerUserNoted':
      return _session.identifyUserFailureAccessNotAllowedByEmployerUserNoted;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'LoginNotAllowed':
      return _LoginNotAllowed2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/LoginNotAllowed/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactBootstrap = __webpack_require__(14);

var _collection = __webpack_require__(198);

var _lang = __webpack_require__(159);

var _object = __webpack_require__(313);

var _array = __webpack_require__(741);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiSelectButton = function (_get__2) {
  _inherits(MultiSelectButton, _get__2);

  function MultiSelectButton(props) {
    _classCallCheck(this, MultiSelectButton);

    var _this = _possibleConstructorReturn(this, (MultiSelectButton.__proto__ || Object.getPrototypeOf(MultiSelectButton)).call(this, props));

    _this.handleSelect = _this.handleSelect.bind(_this);
    var selectedItems = _get__('isArray')(_this.props.activeItems) ? _this.props.activeItems : [];
    _this.state = { selectedItems: selectedItems };
    return _this;
  }

  _createClass(MultiSelectButton, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var itemKeys = _get__('keys')(this.props.items);
        if (!itemKeys.length && nextProps.items) {
          itemKeys = _get__('keys')(nextProps.items);
        }
        var selectedItems = _get__('filter')(nextProps.activeItems, function (item) {
          return _get__('includes')(itemKeys, item);
        });
        this.setState({ selectedItems: selectedItems });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'handleSelect',
    value: function () {
      function handleSelect(clickedItem) {
        var newSelectedItems = clickedItem !== 0 ? _get__('xor')(this.state.selectedItems, [clickedItem]) : [];
        this.setState({ selectedItems: newSelectedItems });
        this.props.onSelect(this.props.id, newSelectedItems);
      }

      return handleSelect;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            id = _props.id,
            label = _props.label,
            className = _props.className,
            items = _props.items,
            t = _props.t;

        var itemArray = Object.keys(items).map(function (key) {
          return Object.assign({}, items[key], { id: key });
        }).sort(function (a, b) {
          return a.name > b.name ? 1 : -1;
        });

        var menuItems = itemArray.map(function (item) {
          return _get__('React').createElement(
            _get__('MenuItem'),
            {
              key: item.id,
              eventKey: item.id,
              active: _get__('includes')(_this2.state.selectedItems, item.id)
            },
            item.name
          );
        });
        var menuItemComponent = menuItems.length > 1 ? _get__('React').createElement(
          _get__('MenuItem'),
          {
            key: 0,
            eventKey: 0,
            active: _get__('includes')(this.state.selectedItems, 0)
          },
          t('filters.select'),
          _get__('React').createElement(_get__('MenuItem'), {
            divider: true, 'aria-label': t('common:ariaLabels.divider')
          })
        ) : null;
        var activeItems = itemArray.filter(function (item) {
          return _get__('includes')(_this2.state.selectedItems, item.id);
        });

        var theTitle = t('filters.select');
        if (activeItems.length === 1) {
          theTitle = activeItems[0].name;
        } else if (activeItems.length > 1) {
          theTitle = activeItems.length + ' valittu';
        }

        return _get__('React').createElement(
          _get__('FormGroup'),
          { className: 'filter-multi-select ' + className },
          _get__('React').createElement(
            _get__('ControlLabel'),
            { htmlFor: id },
            label
          ),
          _get__('React').createElement(
            _get__('DropdownButton'),
            {
              className: 'filter-multi-select-btn',
              'aria-label': t('common:ariaLabels.dropdownButton') + '-' + theTitle,
              id: id,
              title: theTitle,
              onSelect: function () {
                function onSelect(eventKey) {
                  _this2.handleSelect(eventKey);
                }

                return onSelect;
              }()
            },
            menuItemComponent,
            menuItems
          )
        );
      }

      return render;
    }()
  }]);

  return MultiSelectButton;
}(_get__('Component'));

_get__('MultiSelectButton').propTypes = {
  id: _get__('PropTypes').string.isRequired,
  className: _get__('PropTypes').string,
  label: _get__('PropTypes').string.isRequired,
  items: _get__('PropTypes').object.isRequired,
  activeItems: _get__('PropTypes').array,
  onSelect: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('MultiSelectButton').defaultProps = {
  className: '',
  activeItems: []
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('MultiSelectButton'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'isArray':
      return _lang.isArray;

    case 'keys':
      return _object.keys;

    case 'filter':
      return _collection.filter;

    case 'includes':
      return _collection.includes;

    case 'xor':
      return _array.xor;

    case 'Component':
      return _react.Component;

    case 'MultiSelectButton':
      return MultiSelectButton;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'MenuItem':
      return _reactBootstrap.MenuItem;

    case 'FormGroup':
      return _reactBootstrap.FormGroup;

    case 'ControlLabel':
      return _reactBootstrap.ControlLabel;

    case 'DropdownButton':
      return _reactBootstrap.DropdownButton;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(MultiSelectButton, 'MultiSelectButton', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/MultiSelectButton/MultiSelectButton.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/MultiSelectButton/MultiSelectButton.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _MultiSelectButton = __webpack_require__(1161);

var _MultiSelectButton2 = _interopRequireDefault(_MultiSelectButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {};
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('MultiSelectButton'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'MultiSelectButton':
      return _MultiSelectButton2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/MultiSelectButton/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/MultiSelectButton/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/MultiSelectButton/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _lang = __webpack_require__(159);

var _string = __webpack_require__(160);

var _reactIntlTelInput = __webpack_require__(337);

var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);

var _finnishSsn = __webpack_require__(248);

var _finnishSsn2 = _interopRequireDefault(_finnishSsn);

var _reactSelect = __webpack_require__(509);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _ErrorMessage = __webpack_require__(133);

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

var _helpers = __webpack_require__(119);

var _api = __webpack_require__(75);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Custom styles used by react-select 
var customStyles = {
  control: function () {
    function control(base) {
      return _extends({}, base, {
        height: 42,
        minHeight: 42,
        marginTop: '10px',
        borderRadius: 0,
        paddingLeft: '6px'
      });
    }

    return control;
  }(),
  menu: function () {
    function menu(base) {
      return _extends({}, base, {
        zIndex: 2
      });
    }

    return menu;
  }()
};

var RegistrationForm = function (_get__2) {
  _inherits(RegistrationForm, _get__2);

  function RegistrationForm(props) {
    _classCallCheck(this, RegistrationForm);

    var _this = _possibleConstructorReturn(this, (RegistrationForm.__proto__ || Object.getPrototypeOf(RegistrationForm)).call(this, props));

    _this.timeoutPhoneInputChange = null;

    var sotuIsValid = _get__('FinnishSSN').validate(_this.props.personId);
    var withoutSotu = props.relaxedSotuVerificationEnabled && !sotuIsValid;

    _this.state = {
      allFieldsValid: false,
      address: '',
      postcode: '',
      city: '',
      phone: '',
      email: '',
      municipality: '',
      acceptedTerms: false,
      language: _get__('i18n').language,
      addressValid: false,
      postcodeValid: false,
      cityValid: false,
      phoneValid: false,
      emailValid: false,
      acceptedTermsValid: false,
      municipalityValid: false,
      validationError: '',
      cyrillicLettersDetected: false,
      exclusiveData: {},
      exclusiveDataValid: [],
      sotuValid: sotuIsValid,
      municipalities: [],
      registrationExclusiveFieldsFiltered: props.registrationExclusiveFields.filter(function (field) {
        return field.registrationCase === 'ALWAYS' || withoutSotu && field.registrationCase === 'WITHOUT_SOTU' || !withoutSotu && field.registrationCase === 'WITH_SOTU';
      })
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);
    _this.handlePhoneInputChange = _this.handlePhoneInputChange.bind(_this);
    _this.handleExclusiveFieldChange = _this.handleExclusiveFieldChange.bind(_this);
    return _this;
  }

  _createClass(RegistrationForm, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        _get__('api').getMunicipalities().then(function (municipalities) {
          var municipalityList = [];
          municipalities.map(function (item) {
            return municipalityList.push({ label: item, value: item });
          });
          _this2.setState({ municipalities: municipalityList });
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'validateFields',
    value: function () {
      function validateFields() {
        var POSTAL_CODE_REGEX = /^\d{5}$/;
        var sotuValid = _get__('FinnishSSN').validate(this.props.personId);
        var _state = this.state,
            address = _state.address,
            postcode = _state.postcode,
            city = _state.city,
            phone = _state.phone,
            acceptedTerms = _state.acceptedTerms,
            email = _state.email,
            municipality = _state.municipality;

        var addressValid = !_get__('cyrillicLetterScanner')(address) && (!sotuValid || address.length > 0);
        var postcodeValid = !sotuValid || postcode.match(POSTAL_CODE_REGEX);
        var cityValid = city.length > 0 && !_get__('cyrillicLetterScanner')(city);
        var emailValid = sotuValid && !_get__('cyrillicLetterScanner')(email) && (email.length === 0 || this.isEmailValid(email)) || !sotuValid && this.isEmailValid(email);
        var acceptedTermsValid = acceptedTerms === true;
        var phoneValid = this.isPhoneValid(phone);
        var cyrillicLettersDetected = _get__('cyrillicLetterScanner')(address) || _get__('cyrillicLetterScanner')(city) || _get__('cyrillicLetterScanner')(email);
        var municipalityValid = municipality.length > 0;

        var allFieldsValid = !cyrillicLettersDetected && addressValid && postcodeValid && cityValid && phoneValid && emailValid && acceptedTermsValid && municipalityValid;
        this.setState({
          addressValid: addressValid,
          postcodeValid: postcodeValid,
          cityValid: cityValid,
          phoneValid: phoneValid,
          emailValid: emailValid,
          acceptedTermsValid: acceptedTermsValid,
          allFieldsValid: allFieldsValid,
          validationError: '',
          cyrillicLettersDetected: cyrillicLettersDetected,
          municipalityValid: municipalityValid
        });
      }

      return validateFields;
    }()
  }, {
    key: 'isPhoneValid',
    value: function () {
      function isPhoneValid(phone) {
        var telUtils = window.intlTelInputUtils;
        return telUtils.isValidNumber(phone) && (telUtils.getNumberType(phone) === telUtils.numberType.MOBILE || telUtils.getNumberType(phone) === telUtils.numberType.FIXED_LINE_OR_MOBILE);
      }

      return isPhoneValid;
    }()
  }, {
    key: 'isEmailValid',
    value: function () {
      function isEmailValid(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      return isEmailValid;
    }()
  }, {
    key: 'handlePhoneInputChange',
    value: function () {
      function handlePhoneInputChange(status, inputVal, countryData, number) {
        var phone = number.replace(/\s/g, '');
        this.setState({ phone: phone }, this.validateFields);
      }

      return handlePhoneInputChange;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(event) {
        var _event$target = event.target,
            fieldName = _event$target.id,
            value = _event$target.value;

        this.setState(_defineProperty({}, fieldName, _get__('trim')(value)), this.validateFields);
      }

      return handleChange;
    }()
  }, {
    key: 'handleExclusiveFieldChange',
    value: function () {
      function handleExclusiveFieldChange(event, index, validationPattern) {
        var _event$target2 = event.target,
            fieldName = _event$target2.id,
            value = _event$target2.value;


        var valid = true;
        if (validationPattern) {
          valid = value.match(validationPattern) != null;
        }
        this.state.exclusiveDataValid[index] = valid;

        var newExclusiveData = _extends({}, this.state.exclusiveData, _defineProperty({}, fieldName, value));
        this.setState({ exclusiveData: newExclusiveData });
      }

      return handleExclusiveFieldChange;
    }()
  }, {
    key: 'handleCheckboxChange',
    value: function () {
      function handleCheckboxChange(event) {
        this.setState({ acceptedTerms: event.target.checked }, this.validateFields);
      }

      return handleCheckboxChange;
    }()
  }, {
    key: 'handleSubmit',
    value: function () {
      function handleSubmit(event) {
        event.preventDefault();

        var allExclusiveFieldsValid = this.state.exclusiveDataValid.every(function (isValid) {
          return isValid === true;
        });

        if (this.state.allFieldsValid && allExclusiveFieldsValid) {
          var _state2 = this.state,
              address = _state2.address,
              postcode = _state2.postcode,
              city = _state2.city,
              phone = _state2.phone,
              acceptedTerms = _state2.acceptedTerms,
              language = _state2.language,
              email = _state2.email,
              municipality = _state2.municipality,
              exclusiveData = _state2.exclusiveData;
          var _props = this.props,
              firstName = _props.firstName,
              lastName = _props.lastName,
              personId = _props.personId;


          if (this.props.creationIncomplete) {
            this.props.updateUser({ address: address, postcode: postcode, city: city, phone: phone, acceptedTerms: acceptedTerms, email: email, municipality: municipality }, this.props.afterSuccess);
          } else {
            this.props.registerUser({ personId: personId, firstName: firstName, lastName: lastName, address: address, postcode: postcode, city: city, phone: phone, acceptedTerms: acceptedTerms, language: language, email: email, municipality: municipality, exclusiveData: exclusiveData }, this.props.afterSuccess);
          }
        } else if (this.state.cyrillicLettersDetected) {
          this.setState({ validationError: 'cyrillicLettersNotAllowed' });
        } else if (!this.state.addressValid) {
          this.setState({ validationError: 'addressMissing' });
        } else if (!this.state.postcodeValid) {
          this.setState({ validationError: 'postcodeMissing' });
        } else if (!this.state.cityValid) {
          this.setState({ validationError: 'cityMissing' });
        } else if (!this.state.phoneValid) {
          this.setState({ validationError: 'invalidPhone' });
        } else if (!this.state.emailValid) {
          this.setState({ validationError: 'invalidEmail' });
        } else if (!this.state.acceptedTermsValid) {
          this.setState({ validationError: 'invalidAcceptedTerms' });
        } else if (!this.state.municipalityValid) {
          this.setState({ validationError: 'invalidMunicipality' });
        } else if (!allExclusiveFieldsValid) {
          this.setState({ validationError: 'validation.pattern' });
        }
      }

      return handleSubmit;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        if (this.props.userIdentified && !this.props.creationIncomplete) {
          return null;
        }

        var _props2 = this.props,
            registrationFailed = _props2.registrationFailed,
            registrationFailedMessage = _props2.registrationFailedMessage,
            termsOfServiceUrl = _props2.termsOfServiceUrl,
            t = _props2.t;


        var registrationExclusiveFieldsItems = this.state.registrationExclusiveFieldsFiltered.map(function (field, index) {
          return _get__('React').createElement(
            'div',
            { className: 'form-input-group', key: field.ehrProfileProperty },
            _get__('React').createElement('input', {
              id: field.ehrProfileProperty,
              className: _this3.state.exclusiveDataValid[index] ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:registrationForm.exclusiveFields.' + field.localizationKey),
              onChange: function () {
                function onChange(e) {
                  return _this3.handleExclusiveFieldChange(e, index, field.validation);
                }

                return onChange;
              }()
            })
          );
        });

        return _get__('React').createElement(
          'form',
          { className: 'registration-form', onSubmit: function () {
              function onSubmit(e) {
                return _this3.handleSubmit(e);
              }

              return onSubmit;
            }() },
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'address',
              className: this.state.addressValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:registrationForm.addressPlaceholder'),
              onChange: this.handleChange
            })
          ),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'postcode',
              className: this.state.postcodeValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:registrationForm.postcodePlaceholder'),
              onChange: this.handleChange
            })
          ),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'city',
              className: this.state.cityValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:registrationForm.cityPlaceholder'),
              onChange: this.handleChange
            })
          ),
          _get__('React').createElement(_get__('Select'), {
            id: 'municipality',
            className: this.state.municipalityValid ? 'municipality is-valid' : 'municipality',
            options: this.state.municipalities,
            value: this.state.municipalities.filter(function (_ref) {
              var value = _ref.value;
              return value === _this3.state.municipality;
            }),
            onChange: function () {
              function onChange(value) {
                return _this3.handleChange({ target: { id: 'municipality', value: value.value } });
              }

              return onChange;
            }(),
            placeholder: t('identification:registrationForm.municipalityPlaceholder'),
            styles: _get__('customStyles')
          }),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group form-input-group-phone' },
            _get__('React').createElement(_get__('IntlTelInput'), {
              fieldId: 'visiblePhone',
              numberType: 'MOBILE',
              preferredCountries: ['fi', 'se', 'ee'],
              style: { width: '100%' },
              onPhoneNumberChange: this.handlePhoneInputChange,
              useMobileFullscreenDropdown: false,
              placeholder: t('identification:registrationForm.phoneNumberPlaceholder'),
              inputClassName: 'form-control ' + (this.state.isPhoneValid ? 'is-valid' : '')
            })
          ),
          _get__('React').createElement(
            'div',
            { className: 'form-input-group' },
            _get__('React').createElement('input', {
              id: 'email',
              className: this.state.emailValid ? 'is-valid' : '',
              type: 'text',
              placeholder: t('identification:registrationForm.emailPlaceholder'),
              onChange: this.handleChange
            })
          ),
          registrationExclusiveFieldsItems,
          _get__('React').createElement(
            'div',
            null,
            _get__('React').createElement(
              _get__('Checkbox'),
              {
                id: 'acceptedTerms',
                className: this.state.acceptedTermsValid ? 'is-valid' : '',
                onChange: this.handleCheckboxChange
              },
              _get__('React').createElement(
                'div',
                { className: 'terms-label-container' },
                _get__('React').createElement(
                  'div',
                  { className: 'terms-label' },
                  _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('identification:registrationForm.termsOfService') })
                ),
                _get__('React').createElement(
                  'div',
                  { className: 'terms-link' },
                  _get__('React').createElement(
                    'a',
                    { href: termsOfServiceUrl, target: '_blank' },
                    _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('identification:registrationForm.termsOfServiceLink') })
                  )
                )
              )
            )
          ),
          _get__('React').createElement(
            _get__('ErrorMessage'),
            { isVisible: !_get__('isEmpty')(this.state.validationError) || this.state.cyrillicLettersDetected },
            _get__('React').createElement(
              'strong',
              null,
              this.state.cyrillicLettersDetected ? t('cyrillicLettersNotAllowed') : t(this.state.validationError)
            )
          ),
          _get__('React').createElement(
            _get__('ErrorMessage'),
            { isVisible: registrationFailed },
            _get__('React').createElement(
              'strong',
              null,
              t('registrationFailedTitle')
            ),
            registrationFailedMessage && _get__('React').createElement(
              'p',
              null,
              t(registrationFailedMessage)
            )
          ),
          _get__('React').createElement(
            _get__('Button'),
            {
              className: 'action-btn center-block login-button',
              type: 'submit'
            },
            t('identification:registrationForm.continueButtonText')
          )
        );
      }

      return render;
    }()
  }]);

  return RegistrationForm;
}(_get__('Component'));

_get__('RegistrationForm').propTypes = {
  registerUser: _get__('PropTypes').func.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  afterSuccess: _get__('PropTypes').func,
  registrationFailed: _get__('PropTypes').bool.isRequired,
  registrationFailedMessage: _get__('PropTypes').string,
  firstName: _get__('PropTypes').string.isRequired,
  lastName: _get__('PropTypes').string.isRequired,
  personId: _get__('PropTypes').string.isRequired,
  termsOfServiceUrl: _get__('PropTypes').string.isRequired,
  t: _get__('PropTypes').func.isRequired,
  registrationExclusiveFields: _get__('PropTypes').array,
  relaxedSotuVerificationEnabled: _get__('PropTypes').bool.isRequired,
  creationIncomplete: _get__('PropTypes').bool.isRequired,
  updateUser: _get__('PropTypes').func.isRequired
};

_get__('RegistrationForm').defaultProps = {
  afterSuccess: null,
  registrationFailedMessage: null,
  firstName: '',
  lastName: '',
  personId: '',
  termsOfServiceUrl: '',
  registrationExclusiveFields: []
};

var _DefaultExportValue = _get__('translate')(['common', 'identification'], { wait: true })(_get__('RegistrationForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'FinnishSSN':
      return _finnishSsn2['default'];

    case 'i18n':
      return _i18n2['default'];

    case 'api':
      return _api2['default'];

    case 'cyrillicLetterScanner':
      return _helpers.cyrillicLetterScanner;

    case 'trim':
      return _string.trim;

    case 'customStyles':
      return customStyles;

    case 'isEmpty':
      return _lang.isEmpty;

    case 'Component':
      return _react.Component;

    case 'RegistrationForm':
      return RegistrationForm;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Select':
      return _reactSelect2['default'];

    case 'IntlTelInput':
      return _reactIntlTelInput2['default'];

    case 'Checkbox':
      return _reactBootstrap.Checkbox;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'ErrorMessage':
      return _ErrorMessage2['default'];

    case 'Button':
      return _reactBootstrap.Button;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(customStyles, 'customStyles', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/RegistrationForm.jsx');

  __REACT_HOT_LOADER__.register(RegistrationForm, 'RegistrationForm', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/RegistrationForm.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/RegistrationForm.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _RegistrationForm = __webpack_require__(1163);

var _RegistrationForm2 = _interopRequireDefault(_RegistrationForm);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      registrationFailed: state.session.registrationFailed,
      registrationFailedMessage: state.session.registrationFailedMessage,
      firstName: state.session.userRegistrationData.firstName,
      lastName: state.session.userRegistrationData.lastName,
      personId: state.session.userRegistrationData.personId,
      termsOfServiceUrl: state.organization.termsOfServiceUrl,
      registrationExclusiveFields: state.organization.registrationExclusiveFields,
      relaxedSotuVerificationEnabled: state.organization.relaxedSotuVerificationEnabled,
      creationIncomplete: state.session.creationIncomplete
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      registerUser: dispatch(_get__('registerUser')),
      updateUser: dispatch(_get__('updateUser'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('RegistrationForm'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'registerUser':
      return _session.registerUser;

    case 'updateUser':
      return _session.updateUser;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'RegistrationForm':
      return _RegistrationForm2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RegistrationForm/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _MainLogin = __webpack_require__(1125);

var _MainLogin2 = _interopRequireDefault(_MainLogin);

var _ServiceInfoBox = __webpack_require__(1138);

var _ServiceInfoBox2 = _interopRequireDefault(_ServiceInfoBox);

var _RootOptionGroup = __webpack_require__(1136);

var _RootOptionGroup2 = _interopRequireDefault(_RootOptionGroup);

var _LanguageSelector = __webpack_require__(549);

var _LanguageSelector2 = _interopRequireDefault(_LanguageSelector);

var _InnerHtmlContent = __webpack_require__(69);

var _InnerHtmlContent2 = _interopRequireDefault(_InnerHtmlContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RootSelection = function (_get__2) {
  _inherits(RootSelection, _get__2);

  function RootSelection(props) {
    _classCallCheck(this, RootSelection);

    var _this = _possibleConstructorReturn(this, (RootSelection.__proto__ || Object.getPrototypeOf(RootSelection)).call(this, props));

    _this.getPathsAsOptions = _this.getPathsAsOptions.bind(_this);
    _this.select = _this.select.bind(_this);
    if (props.goTo) {
      var _this$props = _this.props,
          goTo = _this$props.goTo,
          options = _this$props.options;

      var path = options.find(function (opt) {
        return opt.pathType === goTo;
      });
      if (path) {
        _this.select(path.id);
      }
    }
    return _this;
  }

  _createClass(RootSelection, [{
    key: 'getPathsAsOptions',
    value: function () {
      function getPathsAsOptions(options, viaSso) {
        return options.filter(function (option) {
          var requiresSSO = option.requiresSSO;

          if (!requiresSSO) {
            return true;
          }
          return requiresSSO && viaSso;
        });
      }

      return getPathsAsOptions;
    }()
  }, {
    key: 'select',
    value: function () {
      function select(selectionId) {
        var _props = this.props,
            options = _props.options,
            pathSelected = _props.pathSelected,
            googleAnalyticsTrackingId = _props.googleAnalyticsTrackingId;

        if (selectionId !== pathSelected) {
          var path = Object.assign(options.find(function (r) {
            return r.id === selectionId;
          }), { googleAnalyticsTrackingId: googleAnalyticsTrackingId });
          this.props.loadPath(path);
        }
      }

      return select;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props2 = this.props,
            options = _props2.options,
            pathSelected = _props2.pathSelected,
            pathLoaded = _props2.pathLoaded,
            loginFirst = _props2.loginFirst,
            userIdentified = _props2.userIdentified,
            uniquePath = _props2.uniquePath,
            languages = _props2.languages,
            viaSso = _props2.viaSso,
            fetchPathAfterLogin = _props2.fetchPathAfterLogin,
            loginFirstShowLoginForm = _props2.loginFirstShowLoginForm,
            t = _props2.t;

        var showInfoAndLoginDiv = pathLoaded && loginFirst || fetchPathAfterLogin;
        var rootSelectionOptions = _get__('React').createElement(_get__('RootOptionGroup'), {
          options: this.getPathsAsOptions(options, viaSso),
          onSelect: this.select,
          selected: pathSelected > -1 ? pathSelected : false,
          prefix: 'rootSelection',
          namespace: 'roots',
          key: 'root-selection'
        });

        return _get__('React').createElement(
          'div',
          null,
          _get__('React').createElement(_get__('ServiceInfoBox'), null),
          _get__('React').createElement(
            'div',
            { className: 'root-selection', style: { backgroundImage: 'url(' + this.props.organizationBackgroundImageUrl + ')' } },
            _get__('React').createElement(
              _get__('Collapse'),
              { 'in': !uniquePath, unmountOnExit: true },
              _get__('React').createElement(
                _get__('Grid'),
                { fluid: true, className: 'intro-box' },
                _get__('React').createElement(
                  _get__('Row'),
                  null,
                  _get__('React').createElement(
                    _get__('Col'),
                    { className: 'intro-box-left', xs: 12, sm: 12, md: 7, lg: 7 },
                    _get__('React').createElement(
                      'div',
                      null,
                      _get__('React').createElement(
                        'div',
                        { className: 'box-header' },
                        _get__('React').createElement(
                          'h1',
                          { tabIndex: 0, id: 'root-selection-title' },
                          t('root.title')
                        ),
                        _get__('React').createElement(
                          'p',
                          null,
                          _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('root.info') })
                        ),
                        _get__('React').createElement(
                          'p',
                          null,
                          _get__('React').createElement(_get__('InnerHtmlContent'), { content: t('root.info2') })
                        ),
                        _get__('React').createElement(_get__('LanguageSelector'), {
                          languages: languages
                        })
                      )
                    )
                  ),
                  _get__('React').createElement(
                    _get__('Col'),
                    { className: 'intro-box-right', xs: 12, sm: 12, md: 5, lg: 5 },
                    _get__('React').createElement(
                      'div',
                      { className: 'box-header' },
                      rootSelectionOptions
                    ),
                    _get__('React').createElement(
                      _get__('Button'),
                      {
                        onClick: this.props.setManagementOption,
                        bsStyle: 'link',
                        className: 'basic-action-link start-cancel-reservation-link center-block'
                      },
                      viaSso ? t('booking:sectionTitles.history') : t('booking:cancelReservation.startCancelling')
                    )
                  )
                )
              )
            ),
            showInfoAndLoginDiv && _get__('React').createElement(
              _get__('Collapse'),
              { 'in': uniquePath || !userIdentified, unmountOnExit: true },
              _get__('React').createElement(
                'div',
                { id: 'intro-box-login' },
                _get__('React').createElement(
                  'div',
                  null,
                  _get__('React').createElement('hr', { hidden: uniquePath }),
                  _get__('React').createElement(_get__('MainLogin'), { showLoginForm: !userIdentified && loginFirstShowLoginForm, triggerInitialScroll: this.props.triggerInitialScroll })
                )
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return RootSelection;
}(_get__('Component'));

_get__('RootSelection').propTypes = {
  triggerInitialScroll: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired,
  options: _get__('PropTypes').array.isRequired,
  loadPath: _get__('PropTypes').func.isRequired,
  setManagementOption: _get__('PropTypes').func.isRequired,
  pathLoaded: _get__('PropTypes').bool.isRequired,
  pathSelected: _get__('PropTypes').number,
  organizationBackgroundImageUrl: _get__('PropTypes').string,
  loginFirst: _get__('PropTypes').bool.isRequired,
  loginFirstShowLoginForm: _get__('PropTypes').bool.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  uniquePath: _get__('PropTypes').bool.isRequired,
  languages: _get__('PropTypes').array.isRequired,
  viaSso: _get__('PropTypes').bool.isRequired,
  fetchPathAfterLogin: _get__('PropTypes').bool.isRequired,
  googleAnalyticsTrackingId: _get__('PropTypes').string,
  goTo: _get__('PropTypes').string
};

_get__('RootSelection').defaultProps = {
  options: [],
  pathSelected: -1,
  organizationBackgroundImageUrl: '',
  pathLoaded: false,
  loginFirst: false,
  userIdentified: false,
  uniquePath: false,
  googleAnalyticsTrackingId: '',
  goTo: null
};

var _DefaultExportValue = _get__('translate')(['common', 'booking'], { wait: true })(_get__('RootSelection'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'RootSelection':
      return RootSelection;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'RootOptionGroup':
      return _RootOptionGroup2['default'];

    case 'ServiceInfoBox':
      return _ServiceInfoBox2['default'];

    case 'Collapse':
      return _reactBootstrap.Collapse;

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'InnerHtmlContent':
      return _InnerHtmlContent2['default'];

    case 'LanguageSelector':
      return _LanguageSelector2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'MainLogin':
      return _MainLogin2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RootSelection, 'RootSelection', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RootSelection/RootSelection.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RootSelection/RootSelection.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _RootSelection = __webpack_require__(1165);

var _RootSelection2 = _interopRequireDefault(_RootSelection);

var _booking = __webpack_require__(68);

var _cancelling = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      pathSelected: state.booking.path,
      organizationBackgroundImageUrl: state.organization.backgroundImageUrl,
      pathLoaded: state.booking.pathLoaded,
      loginFirst: state.booking.loginFirst,
      loginFirstShowLoginForm: state.booking.loginFirstShowLoginForm,
      uniquePath: state.booking.uniquePath,
      languages: state.organization.languages,
      viaSso: state.session.viaSso,
      fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
      googleAnalyticsTrackingId: state.organization.googleAnalyticsTrackingId
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      loadPath: dispatch(_get__('loadPath')),
      openCancelReservationScreen: function () {
        function openCancelReservationScreen() {
          dispatch(_get__('openCancelReservationScreen')());
        }

        return openCancelReservationScreen;
      }(),

      setManagementOption: dispatch(_get__('setManagementOption'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('RootSelection'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'loadPath':
      return _booking.loadPath;

    case 'openCancelReservationScreen':
      return _cancelling.openCancelReservationScreen;

    case 'setManagementOption':
      return _booking.setManagementOption;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'RootSelection':
      return _RootSelection2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RootSelection/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RootSelection/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/RootSelection/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _collection = __webpack_require__(198);

var _reactI18next = __webpack_require__(11);

var _reactScroll = __webpack_require__(213);

var _SimpleBox = __webpack_require__(219);

var _SimpleBox2 = _interopRequireDefault(_SimpleBox);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

var _constants = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectEmployerDepartment = function (_get__2) {
  _inherits(SelectEmployerDepartment, _get__2);

  function SelectEmployerDepartment(props) {
    _classCallCheck(this, SelectEmployerDepartment);

    var _this = _possibleConstructorReturn(this, (SelectEmployerDepartment.__proto__ || Object.getPrototypeOf(SelectEmployerDepartment)).call(this, props));

    _this.onHideModal = _this.onHideModal.bind(_this);
    _this.onSelectDepartment = _this.onSelectDepartment.bind(_this);
    _this.onSelectEmployer = _this.onSelectEmployer.bind(_this);
    return _this;
  }

  _createClass(SelectEmployerDepartment, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        this.autoSelectDepartment();
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        this.autoSelectDepartment();
        // If we are about to hide this modal then...
        var isGoingToClose = prevProps.show && !this.props.show;
        if (isGoingToClose) {
          // ...set a timeout to scroll to the booking-start element.
          setTimeout(function () {
            _get__('scroller').scrollTo('main-page-booking-start', _get__('scrollSettings'));
          }, 500);
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'onSelectDepartment',
    value: function () {
      function onSelectDepartment(department) {
        this.props.selectEmployerDepartment({
          hasEmployer: true,
          hasDepartment: true,
          department: department
        });
      }

      return onSelectDepartment;
    }()
  }, {
    key: 'onSelectEmployer',
    value: function () {
      function onSelectEmployer(employerIndex) {
        this.props.selectEmployer(employerIndex);
      }

      return onSelectEmployer;
    }()
  }, {
    key: 'onHideModal',
    value: function () {
      function onHideModal() {
        this.setState(this.initialState);
        this.props.logout();
      }

      return onHideModal;
    }()
  }, {
    key: 'getEmployers',
    value: function () {
      function getEmployers() {
        var employers = this.props.user.employers || [];
        // We need to store the index before sorting to reference the right department.
        var employerList = _get__('map')(employers || [], function (e, index) {
          return _extends({}, e, { index: index });
        });
        return _get__('sortBy')(employerList, function (e) {
          return e.name;
        });
      }

      return getEmployers;
    }()
  }, {
    key: 'getDepartments',
    value: function () {
      function getDepartments(employerIndex) {
        var employers = this.props.user.employers || [];
        var employer = employers[employerIndex] || {};
        var employerDepartments = 'departments' in employer ? employer.departments : [];
        // We need to store the index before sorting to reference the right department.
        var departmentList = _get__('map')(employerDepartments || [], function (d, index) {
          return _extends({}, d, { index: index });
        });
        return _get__('sortBy')(departmentList, function (d) {
          return d.name;
        });
      }

      return getDepartments;
    }()
  }, {
    key: 'autoSelectDepartment',
    value: function () {
      function autoSelectDepartment() {
        // Auto-select the department if there is only one.
        var selectedEmployer = this.props.selectedEmployer;

        if (selectedEmployer === -1) {
          return;
        }
        // up to this point there is a selected employer
        // get the departments of the employer
        // this method returns an empty array if there are no departments
        var departments = this.getDepartments(selectedEmployer);
        // if we have only one or no department then we skip the selection
        if (departments.length < 2) {
          // Select employer and don't show department selection.
          this.props.selectEmployerDepartment({
            hasEmployer: true,
            hasDepartment: false,
            department: -1
          });
        }
      }

      return autoSelectDepartment;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props = this.props,
            show = _props.show,
            selectedEmployer = _props.selectedEmployer,
            user = _props.user,
            t = _props.t;


        var employerSelection = selectedEmployer === -1 ? _get__('React').createElement(
          _get__('SimpleBox'),
          null,
          _get__('React').createElement(
            'div',
            { className: 'box-header' },
            _get__('React').createElement(
              'h1',
              { tabIndex: 0, className: 'select-employer' },
              t('selectEmployerDepartment.chooseEmployerTitle')
            ),
            _get__('React').createElement(
              'p',
              null,
              _get__('map')(this.getEmployers(), function (e) {
                return _get__('React').createElement(
                  _get__('Button'),
                  {
                    key: e.name,
                    className: 'action-btn-small select-department-button',
                    onClick: function () {
                      function onClick() {
                        _this2.onSelectEmployer(e.index);
                      }

                      return onClick;
                    }()
                  },
                  e.name
                );
              })
            )
          )
        ) : null;

        var departmentSelection = selectedEmployer > -1 ? _get__('React').createElement(
          _get__('SimpleBox'),
          null,
          _get__('React').createElement(
            'div',
            { className: 'box-header' },
            _get__('React').createElement(
              'h1',
              null,
              user.employers[selectedEmployer].name
            ),
            _get__('React').createElement(
              'h1',
              null,
              t('selectEmployerDepartment.chooseDepartmentTitle')
            ),
            _get__('React').createElement(
              'p',
              null,
              _get__('map')(this.getDepartments(selectedEmployer), function (d) {
                return _get__('React').createElement(
                  _get__('Button'),
                  {
                    key: d.name,
                    className: 'action-btn-small select-department-button',
                    onClick: function () {
                      function onClick() {
                        _this2.onSelectDepartment(d.index);
                      }

                      return onClick;
                    }()
                  },
                  d.name
                );
              })
            )
          )
        ) : null;

        return _get__('React').createElement(
          _get__('Modal'),
          {
            className: 'select-employer-department-screen',
            show: show,
            backdrop: 'static',
            keyboard: false
          },
          _get__('React').createElement(
            _get__('Button'),
            {
              bsStyle: 'link',
              className: 'close-link basic-action-link',
              onClick: function () {
                function onClick() {
                  _this2.onHideModal();
                }

                return onClick;
              }()
            },
            _get__('React').createElement(_get__('AppIcon'), { iconName: 'CLOSE', containerClass: 'close-icon' })
          ),
          employerSelection,
          departmentSelection
        );
      }

      return render;
    }()
  }]);

  return SelectEmployerDepartment;
}(_get__('Component'));

_get__('SelectEmployerDepartment').propTypes = {
  show: _get__('PropTypes').bool.isRequired,
  user: _get__('PropTypes').shape({
    employers: _get__('PropTypes').array.isRequired
  }).isRequired,
  selectEmployer: _get__('PropTypes').func.isRequired,
  selectEmployerDepartment: _get__('PropTypes').func.isRequired,
  selectedEmployer: _get__('PropTypes').number.isRequired,
  logout: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('SelectEmployerDepartment').defaultProps = {};

var _DefaultExportValue = _get__('translate')(['booking'])(_get__('SelectEmployerDepartment'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'scroller':
      return _reactScroll.scroller;

    case 'scrollSettings':
      return _constants.scrollSettings;

    case 'map':
      return _collection.map;

    case 'sortBy':
      return _collection.sortBy;

    case 'Component':
      return _react.Component;

    case 'SelectEmployerDepartment':
      return SelectEmployerDepartment;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'SimpleBox':
      return _SimpleBox2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'Modal':
      return _reactBootstrap.Modal;

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectEmployerDepartment, 'SelectEmployerDepartment', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/SelectEmployerDepartment/SelectEmployerDepartment.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/SelectEmployerDepartment/SelectEmployerDepartment.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _SelectEmployerDepartment = __webpack_require__(1167);

var _SelectEmployerDepartment2 = _interopRequireDefault(_SelectEmployerDepartment);

var _session = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      user: state.session.user,
      userIdentified: state.session.userIdentified,
      selectedEmployer: state.session.selectedEmployer
    };
  }

  return mapStateToProps;
}();
var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {
      selectEmployerDepartment: function () {
        function selectEmployerDepartment(actionPayload) {
          dispatch(_get__('setSelectEmployerDepartment'))(actionPayload);
        }

        return selectEmployerDepartment;
      }(),
      selectEmployer: function () {
        function selectEmployer(actionPayload) {
          dispatch(_get__('setSelectEmployer'))(actionPayload);
        }

        return selectEmployer;
      }(),

      logout: dispatch(_get__('clearSession'))
    };
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('SelectEmployerDepartment'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'setSelectEmployerDepartment':
      return _session.setSelectEmployerDepartment;

    case 'setSelectEmployer':
      return _session.setSelectEmployer;

    case 'clearSession':
      return _session.clearSession;

    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'SelectEmployerDepartment':
      return _SelectEmployerDepartment2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/SelectEmployerDepartment/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/SelectEmployerDepartment/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/SelectEmployerDepartment/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LeftNavButton = function () {
  function LeftNavButton(props) {
    return _get__('React').createElement(
      'div',
      { className: props.className, onClick: props.onClick },
      _get__('React').createElement(_get__('AppIcon'), { iconName: 'ARROW_UP', containerClass: 'arrow-icon' })
    );
  }

  return LeftNavButton;
}();

_get__('LeftNavButton').propTypes = {
  className: _get__('PropTypes').string,
  onClick: _get__('PropTypes').func
};

_get__('LeftNavButton').defaultProps = {
  className: '',
  onClick: function () {
    function onClick() {}

    return onClick;
  }()
};

var _default = _get__('LeftNavButton');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'LeftNavButton':
      return LeftNavButton;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof LeftNavButton === 'undefined' ? 'undefined' : _typeof(LeftNavButton);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(LeftNavButton, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LeftNavButton)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(LeftNavButton, 'LeftNavButton', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/LeftNavButton.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/LeftNavButton.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppIcon = __webpack_require__(60);

var _AppIcon2 = _interopRequireDefault(_AppIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RightNavButton = function () {
  function RightNavButton(props) {
    return _get__('React').createElement(
      'div',
      { className: props.className, onClick: props.onClick },
      _get__('React').createElement(_get__('AppIcon'), { iconName: 'ARROW_DOWN', containerClass: 'arrow-icon' })
    );
  }

  return RightNavButton;
}();

_get__('RightNavButton').propTypes = {
  className: _get__('PropTypes').string,
  onClick: _get__('PropTypes').func
};

_get__('RightNavButton').defaultProps = {
  className: '',
  onClick: function () {
    function onClick() {}

    return onClick;
  }()
};

var _default = _get__('RightNavButton');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'RightNavButton':
      return RightNavButton;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'AppIcon':
      return _AppIcon2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof RightNavButton === 'undefined' ? 'undefined' : _typeof(RightNavButton);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(RightNavButton, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(RightNavButton)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RightNavButton, 'RightNavButton', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/RightNavButton.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/RightNavButton.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(11);

var _reactSlick = __webpack_require__(510);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _lodash = __webpack_require__(117);

var _lodash2 = _interopRequireDefault(_lodash);

__webpack_require__(1499);

var _TimeSlotCard = __webpack_require__(175);

var _TimeSlotCard2 = _interopRequireDefault(_TimeSlotCard);

var _LeftNavButton = __webpack_require__(1169);

var _LeftNavButton2 = _interopRequireDefault(_LeftNavButton);

var _RightNavButton = __webpack_require__(1170);

var _RightNavButton2 = _interopRequireDefault(_RightNavButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var settings = {
  vertical: true,
  arrows: true,
  prevArrow: _get__('React').createElement(_get__('LeftNavButton'), null),
  nextArrow: _get__('React').createElement(_get__('RightNavButton'), null),
  slidesToShow: 4,
  slidesToScroll: 4,
  speed: 500,
  adaptiveHeight: false,
  infinite: false,
  autoplay: false,
  draggable: false,
  responsive: [{
    breakpoint: 768,
    settings: { slidesToShow: 2, slidesToScroll: 2 }
  }]
};

var TimeSlots = function (_get__$PureComponent) {
  _inherits(TimeSlots, _get__$PureComponent);

  function TimeSlots() {
    _classCallCheck(this, TimeSlots);

    return _possibleConstructorReturn(this, (TimeSlots.__proto__ || Object.getPrototypeOf(TimeSlots)).apply(this, arguments));
  }

  _createClass(TimeSlots, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        // Slider component has problems rendering its content properly on first render.
        // This fixes the issue (although not very elegantly).
        setTimeout(function () {
          _this2.slider.innerSlider.onWindowResized();
        }, 50);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        this.slider.slickGoTo(0);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var _props = this.props,
            timeSlots = _props.timeSlots,
            selectedTimeSlot = _props.selectedTimeSlot,
            onClick = _props.onClick,
            t = _props.t,
            units = _props.units;

        console.log('Rendering time slots', timeSlots, units);
        return _get__('React').createElement(
          'div',
          { className: 'time-slots-wrapper' },
          _get__('React').createElement(
            _get__('Slider'),
            _extends({ ref: function () {
                function ref(_ref) {
                  _this3.slider = _ref;
                }

                return ref;
              }() }, _get__('settings')),
            timeSlots.map(function (timeSlot) {
              var active = _get__('_').isEqual(timeSlot, selectedTimeSlot);
              return _get__('React').createElement(
                'div',
                { key: timeSlot.resource + '-' + timeSlot.timeMoment.format() },
                _get__('React').createElement(_get__('TimeSlotCard'), {
                  active: active,
                  timeSlot: timeSlot,
                  unit: units[timeSlot.unit],
                  onClick: onClick,
                  actionElement: _get__('React').createElement(
                    'span',
                    { className: 'time-slot-action-text' },
                    t('time_slot_call_to_action')
                  )
                })
              );
            })
          )
        );
      }

      return render;
    }()
  }]);

  return TimeSlots;
}(_get__('React').PureComponent);

_get__('TimeSlots').propTypes = {
  timeSlots: _get__('PropTypes').array.isRequired,
  units: _get__('PropTypes').shape({}).isRequired,
  selectedTimeSlot: _get__('PropTypes').object,
  onClick: _get__('PropTypes').func.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('TimeSlots').defaultProps = {
  selectedTimeSlot: null
};

var _DefaultExportValue = _get__('translate')(['booking'], { wait: true })(_get__('TimeSlots'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'settings':
      return settings;

    case '_':
      return _lodash2['default'];

    case 'React':
      return _react2['default'];

    case 'TimeSlots':
      return TimeSlots;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'LeftNavButton':
      return _LeftNavButton2['default'];

    case 'RightNavButton':
      return _RightNavButton2['default'];

    case 'Slider':
      return _reactSlick2['default'];

    case 'TimeSlotCard':
      return _TimeSlotCard2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(settings, 'settings', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/TimeSlots.jsx');

  __REACT_HOT_LOADER__.register(TimeSlots, 'TimeSlots', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/TimeSlots.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/TimeSlots.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _TimeSlots = __webpack_require__(1171);

var _TimeSlots2 = _interopRequireDefault(_TimeSlots);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    var resources = state.resources,
        units = state.units;

    return {
      resources: resources,
      units: units
    };
  }

  return mapStateToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'))(_get__('TimeSlots'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'TimeSlots':
      return _TimeSlots2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/TimeSlots/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _UnitMap = __webpack_require__(1174);

var _UnitMap2 = _interopRequireDefault(_UnitMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var UnitInfo = function () {
  function UnitInfo(_ref) {
    var unit = _ref.unit,
        notes = _ref.notes,
        pathNamespace = _ref.pathNamespace,
        t = _ref.t;

    var _get__2 = _get__('useState')(false),
        _get__3 = _slicedToArray(_get__2, 2),
        showMap = _get__3[0],
        setShowMap = _get__3[1];

    var showMapButton = _get__('React').createElement(
      _get__('Button'),
      {
        bsStyle: 'link',
        className: 'basic-action-link toggle-unit-info-btn center-block',
        onClick: function () {
          function onClick() {
            return setShowMap(function (prev) {
              return !prev;
            });
          }

          return onClick;
        }()
      },
      t('booking:unitInfoSection.buttonText_show')
    );

    return _get__('React').createElement(
      _get__('Grid'),
      { fluid: true, className: 'unit-info' },
      _get__('React').createElement(
        _get__('Row'),
        { className: 'unit-info-address' },
        _get__('React').createElement(
          _get__('Col'),
          { xs: 12, sm: 12, md: 6, lg: 6, mdPush: 6, lgPush: 6 },
          _get__('React').createElement(
            'div',
            { className: 'unit-details' },
            _get__('React').createElement(
              'h3',
              null,
              unit.name,
              _get__('React').createElement('br', null),
              unit.address,
              _get__('React').createElement('br', null),
              unit.postcode,
              ' ',
              unit.city
            ),
            notes && _get__('React').createElement(
              'p',
              null,
              notes
            )
          )
        ),
        _get__('React').createElement(
          _get__('Col'),
          {
            className: 'unit-map',
            xs: 12, sm: 12, md: 6, lg: 6, mdPull: 6, lgPull: 6
          },
          showMap ? _get__('React').createElement(_get__('UnitMap'), { unit: unit }) : showMapButton
        )
      ),
      _get__('React').createElement(
        'div',
        { className: 'unit-info-general-text' },
        _get__('React').createElement(
          'h3',
          null,
          t(pathNamespace + ':instructionsForReservationTitle')
        ),
        _get__('React').createElement(
          'p',
          null,
          t(pathNamespace + ':instructionsForReservationText')
        )
      )
    );
  }

  return UnitInfo;
}();

_get__('UnitInfo').propTypes = {
  unit: _get__('PropTypes').shape({}).isRequired,
  notes: _get__('PropTypes').string,
  pathNamespace: _get__('PropTypes').string.isRequired,
  t: _get__('PropTypes').func.isRequired
};

_get__('UnitInfo').defaultProps = {
  pathNamespace: '',
  notes: null
};

var _DefaultExportValue = _get__('translate')(function (props) {
  return ['common', 'booking', props.pathNamespace];
})(_get__('UnitInfo'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'useState':
      return _react.useState;

    case 'UnitInfo':
      return UnitInfo;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Button':
      return _reactBootstrap.Button;

    case 'Grid':
      return _reactBootstrap.Grid;

    case 'Row':
      return _reactBootstrap.Row;

    case 'Col':
      return _reactBootstrap.Col;

    case 'UnitMap':
      return _UnitMap2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UnitInfo, 'UnitInfo', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitInfo/UnitInfo.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitInfo/UnitInfo.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = __webpack_require__(14);

var _reactI18next = __webpack_require__(11);

var _constants = __webpack_require__(76);

var _brandLogo = __webpack_require__(1513);

var _brandLogo2 = _interopRequireDefault(_brandLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var UnitMap = function () {
  function UnitMap(_ref) {
    var unit = _ref.unit,
        t = _ref.t;

    var _get__2 = _get__('useState')(false),
        _get__3 = _slicedToArray(_get__2, 2),
        mapReady = _get__3[0],
        setMapReady = _get__3[1];

    var _get__4 = _get__('useState')(false),
        _get__5 = _slicedToArray(_get__4, 2),
        geocodeError = _get__5[0],
        setGeocodeError = _get__5[1];

    var initMap = function () {
      function initMap() {
        var mapElement = document.getElementById('google-map');
        if (!mapElement) {
          console.error('Map element not found');
          return;
        }
        /* global google */
        var map = new google.maps.Map(mapElement, {
          zoom: _get__('GOOGLE_MAPS_ZOOM'),
          scrollwheel: false
        });
        var geocoder = new google.maps.Geocoder();

        var address = unit.address + ', ' + unit.city;
        geocoder.geocode({ address: address }, function (results, status) {
          if (status === 'OK') {
            map.setCenter(results[0].geometry.location);
            setMapReady(true);
          } else {
            setGeocodeError(true);
          }
        });
      }

      return initMap;
    }();

    _get__('useEffect')(function () {
      initMap();
    }, [unit]);

    var mapElement = _get__('React').createElement('div', { id: 'google-map', className: 'unit-google-map ' + (mapReady ? 'loaded' : '') });

    var unitImage = _get__('React').createElement(
      'div',
      { className: 'unit-image ' + (geocodeError || !mapReady ? 'loaded' : '') },
      _get__('React').createElement(_get__('Image'), { alt: t('common:ariaLabels.brandImage'), src: _get__('brandImage') })
    );

    return _get__('React').createElement(
      'div',
      { style: { width: '100%', height: '100%' } },
      (!geocodeError || mapReady) && mapElement,
      geocodeError && !mapReady && unitImage
    );
  }

  return UnitMap;
}();

_get__('UnitMap').propTypes = {
  unit: _get__('PropTypes').shape({}).isRequired,
  t: _get__('PropTypes').func.isRequired
};

var _DefaultExportValue = _get__('translate')(function () {
  return ['common', 'booking'];
})(_get__('UnitMap'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'useState':
      return _react.useState;

    case 'GOOGLE_MAPS_ZOOM':
      return _constants.GOOGLE_MAPS_ZOOM;

    case 'useEffect':
      return _react.useEffect;

    case 'brandImage':
      return _brandLogo2['default'];

    case 'UnitMap':
      return UnitMap;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'translate':
      return _reactI18next.translate;

    case 'React':
      return _react2['default'];

    case 'Image':
      return _reactBootstrap.Image;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UnitMap, 'UnitMap', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitMap/UnitMap.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UnitMap/UnitMap.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(14);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserInfo = function (_get__2) {
  _inherits(UserInfo, _get__2);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, (UserInfo.__proto__ || Object.getPrototypeOf(UserInfo)).apply(this, arguments));
  }

  _createClass(UserInfo, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            user = _props.user,
            userIdentified = _props.userIdentified,
            selectedEmployer = _props.selectedEmployer;


        if (!userIdentified) {
          return null;
        }

        return _get__('React').createElement(
          'div',
          { className: 'user-info-container' },
          _get__('React').createElement(
            _get__('NavItem'),
            { className: 'user-name-info' },
            user.firstName,
            ' ',
            user.lastName
          ),
          user.employers && user.employers.length > 0 && user.employers[selectedEmployer] && user.employers[selectedEmployer].name && _get__('React').createElement(
            _get__('NavItem'),
            { className: 'user-company-info' },
            user.employers[selectedEmployer].name
          )
        );
      }

      return render;
    }()
  }]);

  return UserInfo;
}(_get__('Component'));

_get__('UserInfo').propTypes = {
  user: _get__('PropTypes').object.isRequired,
  userIdentified: _get__('PropTypes').bool.isRequired,
  selectedEmployer: _get__('PropTypes').number.isRequired
};

var _default = _get__('UserInfo');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'Component':
      return _react.Component;

    case 'UserInfo':
      return UserInfo;

    case 'PropTypes':
      return _propTypes2['default'];

    case 'React':
      return _react2['default'];

    case 'NavItem':
      return _reactBootstrap.NavItem;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof UserInfo === 'undefined' ? 'undefined' : _typeof(UserInfo);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(UserInfo, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(UserInfo)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(UserInfo, 'UserInfo', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UserInfo/UserInfo.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UserInfo/UserInfo.jsx');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reactRedux = __webpack_require__(12);

var _UserInfo = __webpack_require__(1175);

var _UserInfo2 = _interopRequireDefault(_UserInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mapStateToProps = function () {
  function mapStateToProps(state) {
    return {
      userIdentified: state.session.userIdentified,
      user: state.session.user,
      selectedEmployer: state.session.selectedEmployer
    };
  }

  return mapStateToProps;
}();

var mapDispatchToProps = function () {
  function mapDispatchToProps(dispatch) {
    return {};
  }

  return mapDispatchToProps;
}();

var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('UserInfo'));

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'connect':
      return _reactRedux.connect;

    case 'mapStateToProps':
      return mapStateToProps;

    case 'mapDispatchToProps':
      return mapDispatchToProps;

    case 'UserInfo':
      return _UserInfo2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UserInfo/index.js');

  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UserInfo/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/containers/UserInfo/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isError = exports.isError = function () {
  function isError(action) {
    return action.error || action.payload instanceof Error;
  }

  return isError;
}();

var errorHandler = function () {
  function errorHandler(store) {
    return function (next) {
      return function (action) {
        if (_get__("isError")(action)) {
          console.error(action.payload);
          // Disable generic error handling, do this in action generators explicitly!
          // return next(handleError(store.dispatch)(action.payload));
        }
        return next(action);
      };
    };
  }

  return errorHandler;
}();

var _default = _get__("errorHandler");

exports["default"] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "isError":
      return isError;

    case "errorHandler":
      return errorHandler;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof errorHandler === "undefined" ? "undefined" : _typeof(errorHandler);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(errorHandler, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(errorHandler)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(isError, "isError", "/Users/hannum/work/sources/mbooking/src/frontend/src/middleware/errorHandler.js");

  __REACT_HOT_LOADER__.register(errorHandler, "errorHandler", "/Users/hannum/work/sources/mbooking/src/frontend/src/middleware/errorHandler.js");

  __REACT_HOT_LOADER__.register(_default, "default", "/Users/hannum/work/sources/mbooking/src/frontend/src/middleware/errorHandler.js");
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _app = __webpack_require__(217);

var _ehrResources = __webpack_require__(174);

var _session = __webpack_require__(42);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loadingLocalizations: true,
  localizationsLoaded: false,
  loadingStaticData: false,
  staticDataLoaded: false,
  showLoginOnlyBySsoView: false,
  loadingConfiguration: false,
  configurationLoaded: false
};

var appReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('fetchingLocalizations'), function (state) {
  return _extends({}, state, {
    loadingLocalizations: true,
    localizationsLoaded: false
  });
}), _defineProperty(_get__2, _get__('localizationsFetched'), function (state) {
  return _extends({}, state, {
    loadingLocalizations: false,
    localizationsLoaded: true
  });
}), _defineProperty(_get__2, _get__('fetchingStaticData'), function (state) {
  return _extends({}, state, {
    loadingStaticData: true,
    staticDataLoaded: false
  });
}), _defineProperty(_get__2, _get__('staticDataFetched'), function (state) {
  return _extends({}, state, {
    loadingStaticData: false,
    staticDataLoaded: true
  });
}), _defineProperty(_get__2, _get__('restoreInitialState'), function (state) {
  return _extends({}, state, {
    loadingStaticData: false,
    staticDataLoaded: false
  });
}), _defineProperty(_get__2, _get__('loginOnlyBySsoView'), function (state) {
  return _extends({}, state, {
    showLoginOnlyBySsoView: true
  });
}), _defineProperty(_get__2, _get__('loadingConfiguration'), function (state) {
  return _extends({}, state, {
    loadingConfiguration: true,
    configurationLoaded: false
  });
}), _defineProperty(_get__2, _get__('configurationLoaded'), function (state) {
  return _extends({}, state, {
    configurationLoaded: true,
    loadingConfiguration: false
  });
}), _get__2), _get__('initialState'));

var _default = _get__('appReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'appReducer':
      return appReducer;

    case 'fetchingLocalizations':
      return _app.fetchingLocalizations;

    case 'localizationsFetched':
      return _app.localizationsFetched;

    case 'fetchingStaticData':
      return _ehrResources.fetchingStaticData;

    case 'staticDataFetched':
      return _ehrResources.staticDataFetched;

    case 'restoreInitialState':
      return _session.restoreInitialState;

    case 'loginOnlyBySsoView':
      return _app.loginOnlyBySsoView;

    case 'loadingConfiguration':
      return _app.loadingConfiguration;

    case 'configurationLoaded':
      return _app.configurationLoaded;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof appReducer === 'undefined' ? 'undefined' : _typeof(appReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(appReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(appReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/app.js');

  __REACT_HOT_LOADER__.register(appReducer, 'appReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/app.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/app.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _booking = __webpack_require__(68);

var _session = __webpack_require__(42);

var _pathTypes = __webpack_require__(554);

var _pathTypes2 = _interopRequireDefault(_pathTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  selectedOptionIds: [],
  rootLoading: false,
  rootLoaded: false,
  pathLoading: false,
  pathLoaded: false,
  fetchPathAfterLogin: false,
  pathToLoadAfterLogin: {},
  path: -1,
  managementSelected: false,
  additionalDiscussionChecked: false,
  requestingTimeSlots: false,
  timeSlotsRequested: false,
  timeSlots: {},
  storingReservation: false,
  reservation: {},
  reservationDone: false,
  roots: [],
  canAnonymousFetchTimes: false,
  loginFirst: true,
  loginFirstShowLoginForm: true,
  pathNamespace: '',
  pathReservationByCodeEnabled: false,
  uniquePath: false,
  utilizeEmployerInformation: false,
  selectedPathType: '',
  requireSingleEmployer: false,
  pathBasedBooking: true,
  legalEntity: '',
  shouldSelectEmployer: false,
  savedState: false,
  restoredState: false,
  selectedStoredTimeSlot: {}
};

var bookingReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('rootLoading'), function (state) {
  return _extends({}, state, {
    rootLoaded: false,
    rootLoading: true
  });
}), _defineProperty(_get__2, _get__('rootLoaded'), function (state, action) {
  return _extends({}, state, {
    rootLoaded: true,
    rootLoading: false,
    roots: action.payload,
    uniquePath: action.payload.length === 1
  });
}), _defineProperty(_get__2, _get__('pathLoading'), function (state) {
  return _extends({}, state, {
    pathLoaded: false,
    pathLoading: true
  });
}), _defineProperty(_get__2, _get__('setSelectionHandler'), function (state, action) {
  return _extends({}, state, {
    selectionHandler: action.payload
  });
}), _defineProperty(_get__2, _get__('setPathReservationReasonCode'), function (state, action) {
  return _extends({}, state, {
    reservationReasonCode: action.payload
  });
}), _defineProperty(_get__2, _get__('setLegalEntity'), function (state, action) {
  return _extends({}, state, {
    legalEntity: action.payload
  });
}), _defineProperty(_get__2, _get__('pathLoaded'), function (state, action) {
  return _extends({}, state, {
    pathLoaded: true,
    pathLoading: false,
    selectedOptionIds: []
  });
}), _defineProperty(_get__2, _get__('setFetchPathAfterLogin'), function (state, action) {
  return _extends({}, state, {
    fetchPathAfterLogin: true,
    pathToLoadAfterLogin: action.payload
  });
}), _defineProperty(_get__2, _get__('setSelectedPath'), function (state, action) {
  return _extends({}, state, {
    path: action.payload,
    managementSelected: false
  });
}), _defineProperty(_get__2, _get__('selectedOptionsChanged'), function (state, action) {
  return _extends({}, state, {
    selectedOptionIds: action.payload,
    timeSlotsRequested: false,
    timeSlots: {}
  });
}), _defineProperty(_get__2, _get__('additionalDiscussionChanged'), function (state, action) {
  return _extends({}, state, {
    additionalDiscussionChecked: action.payload,
    timeSlotsRequested: false,
    timeSlots: _get__('initialState').timeSlots
  });
}), _defineProperty(_get__2, _get__('requestingTimeSlots'), function (state) {
  return _extends({}, state, {
    requestingTimeSlots: true,
    timeSlotsRequested: true,
    timeSlots: null
  });
}), _defineProperty(_get__2, _get__('timeSlotsReceived'), function (state, action) {
  var timeSlots = action.payload;
  return _extends({}, state, {
    requestingTimeSlots: false,
    timeSlots: timeSlots
  });
}), _defineProperty(_get__2, _get__('clearTimeSlots'), function (state) {
  return _extends({}, state, {
    requestingTimeSlots: false,
    timeSlotsRequested: false,
    timeSlots: _get__('initialState').timeSlots
  });
}), _defineProperty(_get__2, _get__('storingReservation'), function (state) {
  return _extends({}, state, {
    storingReservation: true
  });
}), _defineProperty(_get__2, _get__('reservationStored'), function (state, action) {
  return _extends({}, state, {
    reservation: action.payload,
    reservationDone: true,
    storingReservation: false
  });
}), _defineProperty(_get__2, _get__('clearSessionSuccess'), function (state) {
  return _extends({}, _get__('initialState'), {
    rootLoaded: true,
    roots: state.roots,
    uniquePath: state.uniquePath,
    pathLoaded: state.uniquePath && !state.fetchPathAfterLogin ? state.pathLoaded : _get__('initialState').pathLoaded,
    pathLoading: state.uniquePath ? state.pathLoading : _get__('initialState').pathLoading,
    path: state.uniquePath ? state.path : _get__('initialState').path,
    selectionHandler: state.selectionHandler,
    managementSelected: false
  });
}), _defineProperty(_get__2, _get__('resetBooking'), function (state) {
  return _extends({}, _get__('initialState'), {
    rootLoaded: true,
    roots: state.roots,
    uniquePath: state.uniquePath,
    pathLoaded: state.uniquePath && !state.fetchPathAfterLogin ? state.pathLoaded : _get__('initialState').pathLoaded,
    pathLoading: state.uniquePath ? state.pathLoading : _get__('initialState').pathLoading,
    path: state.uniquePath ? state.path : _get__('initialState').path,
    selectionHandler: state.selectionHandler,
    managementSelected: false
  });
}), _defineProperty(_get__2, _get__('setFetchTimesPermissions'), function (state, action) {
  return _extends({}, state, {
    canAnonymousFetchTimes: action.payload
  });
}), _defineProperty(_get__2, _get__('setLoginFirst'), function (state, action) {
  return _extends({}, state, {
    loginFirst: action.payload
  });
}), _defineProperty(_get__2, _get__('setLoginFirstShowLoginForm'), function (state, action) {
  return _extends({}, state, {
    loginFirstShowLoginForm: action.payload
  });
}), _defineProperty(_get__2, _get__('setPathNamespace'), function (state, action) {
  return _extends({}, state, {
    pathNamespace: action.payload
  });
}), _defineProperty(_get__2, _get__('setPathReservationByCodeEnabled'), function (state, action) {
  return _extends({}, state, {
    pathReservationByCodeEnabled: action.payload
  });
}), _defineProperty(_get__2, _get__('setUtilizeEmployerInformation'), function (state, action) {
  return _extends({}, state, {
    utilizeEmployerInformation: action.payload
  });
}), _defineProperty(_get__2, _get__('setSelectedPathType'), function (state, action) {
  return _extends({}, state, {
    selectedPathType: action.payload,
    pathBasedBooking: action.payload === _get__('bookingTypes').OCCUPATIONAL || action.payload === _get__('bookingTypes').SELF_PAYING
  });
}), _defineProperty(_get__2, _get__('setRequireSingleEmployer'), function (state, action) {
  return _extends({}, state, {
    requireSingleEmployer: action.payload
  });
}), _defineProperty(_get__2, _get__('selectManagementOption'), function (state) {
  return _extends({}, state, {
    path: -1,
    pathLoaded: false,
    managementSelected: true
  });
}), _defineProperty(_get__2, _get__('selectManagementOptionWithSinglePath'), function (state) {
  return _extends({}, state, {
    managementSelected: true,
    requestingTimeSlots: false,
    timeSlotsRequested: false,
    timeSlots: _get__('initialState').timeSlots
  });
}), _defineProperty(_get__2, _get__('unselectManagementOptionWithSinglePath'), function (state) {
  return _extends({}, state, {
    managementSelected: false
  });
}), _defineProperty(_get__2, _get__('openPromptEmployerSelection'), function (state) {
  return _extends({}, state, {
    shouldSelectEmployer: true
  });
}), _defineProperty(_get__2, _get__('closePromptEmployerSelection'), function (state) {
  return _extends({}, state, {
    shouldSelectEmployer: false
  });
}), _defineProperty(_get__2, _get__('saveAppStateAndSelectionHandler'), function (state) {
  return _extends({}, state, {
    savedState: true
  });
}), _defineProperty(_get__2, _get__('loadStateAndSelectionHandler'), function (state) {
  return _extends({}, state, {
    savedState: false,
    restoredState: true
  });
}), _defineProperty(_get__2, _get__('setSelectedTimeslot'), function (state, action) {
  return _extends({}, state, {
    selectedStoredTimeSlot: action.payload
  });
}), _defineProperty(_get__2, _get__('unsetSelectedTimeslot'), function (state) {
  return _extends({}, state, {
    selectedStoredTimeSlot: {}
  });
}), _get__2), _get__('initialState'));

var _default = _get__('bookingReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'bookingTypes':
      return _pathTypes2['default'];

    case 'bookingReducer':
      return bookingReducer;

    case 'rootLoading':
      return _booking.rootLoading;

    case 'rootLoaded':
      return _booking.rootLoaded;

    case 'pathLoading':
      return _booking.pathLoading;

    case 'setSelectionHandler':
      return _booking.setSelectionHandler;

    case 'setPathReservationReasonCode':
      return _booking.setPathReservationReasonCode;

    case 'setLegalEntity':
      return _booking.setLegalEntity;

    case 'pathLoaded':
      return _booking.pathLoaded;

    case 'setFetchPathAfterLogin':
      return _booking.setFetchPathAfterLogin;

    case 'setSelectedPath':
      return _booking.setSelectedPath;

    case 'selectedOptionsChanged':
      return _booking.selectedOptionsChanged;

    case 'additionalDiscussionChanged':
      return _booking.additionalDiscussionChanged;

    case 'requestingTimeSlots':
      return _booking.requestingTimeSlots;

    case 'timeSlotsReceived':
      return _booking.timeSlotsReceived;

    case 'clearTimeSlots':
      return _booking.clearTimeSlots;

    case 'storingReservation':
      return _booking.storingReservation;

    case 'reservationStored':
      return _booking.reservationStored;

    case 'clearSessionSuccess':
      return _session.clearSessionSuccess;

    case 'resetBooking':
      return _booking.resetBooking;

    case 'setFetchTimesPermissions':
      return _booking.setFetchTimesPermissions;

    case 'setLoginFirst':
      return _booking.setLoginFirst;

    case 'setLoginFirstShowLoginForm':
      return _booking.setLoginFirstShowLoginForm;

    case 'setPathNamespace':
      return _booking.setPathNamespace;

    case 'setPathReservationByCodeEnabled':
      return _booking.setPathReservationByCodeEnabled;

    case 'setUtilizeEmployerInformation':
      return _booking.setUtilizeEmployerInformation;

    case 'setSelectedPathType':
      return _booking.setSelectedPathType;

    case 'setRequireSingleEmployer':
      return _booking.setRequireSingleEmployer;

    case 'selectManagementOption':
      return _booking.selectManagementOption;

    case 'selectManagementOptionWithSinglePath':
      return _booking.selectManagementOptionWithSinglePath;

    case 'unselectManagementOptionWithSinglePath':
      return _booking.unselectManagementOptionWithSinglePath;

    case 'openPromptEmployerSelection':
      return _booking.openPromptEmployerSelection;

    case 'closePromptEmployerSelection':
      return _booking.closePromptEmployerSelection;

    case 'saveAppStateAndSelectionHandler':
      return _booking.saveAppStateAndSelectionHandler;

    case 'loadStateAndSelectionHandler':
      return _booking.loadStateAndSelectionHandler;

    case 'setSelectedTimeslot':
      return _booking.setSelectedTimeslot;

    case 'unsetSelectedTimeslot':
      return _booking.unsetSelectedTimeslot;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof bookingReducer === 'undefined' ? 'undefined' : _typeof(bookingReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(bookingReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(bookingReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/booking.js');

  __REACT_HOT_LOADER__.register(bookingReducer, 'bookingReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/booking.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/booking.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _cancelling = __webpack_require__(103);

var _session = __webpack_require__(42);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  showCancelReservationScreen: false,
  fetchingReservation: false,
  fetchingReservationError: '',
  reservation: {},
  cancellingReservation: false,
  cancellingReservationError: '',
  reservationCancelled: false,
  reservationAlreadyCancelled: false
};

var cancellingReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('openCancelReservationScreen'), function (state) {
  return _extends({}, state, {
    showCancelReservationScreen: true
  });
}), _defineProperty(_get__2, _get__('closeCancelReservationScreen'), function (state) {
  return _get__('initialState');
}), _defineProperty(_get__2, _get__('fetchingReservation'), function (state) {
  return _extends({}, state, {
    fetchingReservationError: _get__('initialState').fetchingReservationError,
    fetchingReservation: true
  });
}), _defineProperty(_get__2, _get__('fetchingReservationFailed'), function (state, action) {
  return _extends({}, state, {
    fetchingReservation: false,
    fetchingReservationError: action.payload
  });
}), _defineProperty(_get__2, _get__('reservationReceived'), function (state, action) {
  return _extends({}, state, {
    fetchingReservation: false,
    reservation: action.payload
  });
}), _defineProperty(_get__2, _get__('cancellingReservation'), function (state) {
  return _extends({}, state, {
    cancellingReservationError: _get__('initialState').cancellingReservationError,
    cancellingReservation: true
  });
}), _defineProperty(_get__2, _get__('cancellingReservationFailed'), function (state, action) {
  return _extends({}, state, {
    cancellingReservation: false,
    cancellingReservationError: action.payload
  });
}), _defineProperty(_get__2, _get__('reservationCancelled'), function (state) {
  return _extends({}, state, {
    cancellingReservation: false,
    reservationCancelled: true
  });
}), _defineProperty(_get__2, _get__('reservationAlreadyCancelled'), function (state, action) {
  return _extends({}, state, {
    cancellingReservationError: '',
    fetchingReservation: false,
    reservation: action.payload,
    reservationCancelled: true,
    reservationAlreadyCancelled: true
  });
}), _defineProperty(_get__2, _get__('clearSessionSuccess'), function (state) {
  return _get__('initialState');
}), _get__2), _get__('initialState'));

var _default = _get__('cancellingReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'cancellingReducer':
      return cancellingReducer;

    case 'openCancelReservationScreen':
      return _cancelling.openCancelReservationScreen;

    case 'closeCancelReservationScreen':
      return _cancelling.closeCancelReservationScreen;

    case 'fetchingReservation':
      return _cancelling.fetchingReservation;

    case 'fetchingReservationFailed':
      return _cancelling.fetchingReservationFailed;

    case 'reservationReceived':
      return _cancelling.reservationReceived;

    case 'cancellingReservation':
      return _cancelling.cancellingReservation;

    case 'cancellingReservationFailed':
      return _cancelling.cancellingReservationFailed;

    case 'reservationCancelled':
      return _cancelling.reservationCancelled;

    case 'reservationAlreadyCancelled':
      return _cancelling.reservationAlreadyCancelled;

    case 'clearSessionSuccess':
      return _session.clearSessionSuccess;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof cancellingReducer === 'undefined' ? 'undefined' : _typeof(cancellingReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(cancellingReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(cancellingReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/cancelling.js');

  __REACT_HOT_LOADER__.register(cancellingReducer, 'cancellingReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/cancelling.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/cancelling.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _reduxActions = __webpack_require__(38);

var _errors = __webpack_require__(118);

var initialState = {};

var errorReducer = _get__('handleAction')(_get__('genericError'), {
  next: function () {
    function next(state, action) {
      return Object.assign({}, state, action.payload);
    }

    return next;
  }(),
  'throw': function () {
    function _throw(state, action) {
      console.error('Unintercepted error', action.payload);
      return Object.assign({}, state, action.payload);
    }

    return _throw;
  }()
}, _get__('initialState'));

var _default = _get__('errorReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleAction':
      return _reduxActions.handleAction;

    case 'genericError':
      return _errors.genericError;

    case 'initialState':
      return initialState;

    case 'errorReducer':
      return errorReducer;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof errorReducer === 'undefined' ? 'undefined' : _typeof(errorReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(errorReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(errorReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/errors.js');

  __REACT_HOT_LOADER__.register(errorReducer, 'errorReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/errors.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/errors.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _history = __webpack_require__(544);

var _booking = __webpack_require__(68);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  historyInitialLoading: false,
  historyInitialLoaded: false,
  historyLoading: false,
  historyLoaded: false,
  reservations: [],
  numberOfResults: 0
};

var ticketReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('historyInitialLoadStart'), function (state) {
  return _extends({}, state, {
    historyInitialLoading: true,
    historyInitialLoaded: false
  });
}), _defineProperty(_get__2, _get__('historyInitialLoadCompleted'), function (state, action) {
  return _extends({}, state, {
    historyInitialLoading: false,
    historyInitialLoaded: true,
    reservations: state.reservations.concat(action.payload),
    numberOfResults: action.payload.length
  });
}), _defineProperty(_get__2, _get__('historyLoadStart'), function (state) {
  return _extends({}, state, {
    historyLoading: true,
    historyLoaded: false
  });
}), _defineProperty(_get__2, _get__('historyLoadCompleted'), function (state, action) {
  return _extends({}, state, {
    historyLoading: false,
    historyLoaded: true,
    reservations: state.reservations.concat(action.payload),
    numberOfResults: action.payload.length
  });
}), _defineProperty(_get__2, _get__('historyFailed'), function (state) {
  return _extends({}, state, {
    historyLoading: false,
    historyLoaded: false
  });
}), _defineProperty(_get__2, _get__('removeAppointmentFromHistory'), function (state, action) {
  return _extends({}, state, {
    reservations: state.reservations.filter(function (r) {
      return r.reservation !== action.payload;
    })
  });
}), _defineProperty(_get__2, _get__('resetBooking'), function () {
  return _extends({}, _get__('initialState'));
}), _get__2), _get__('initialState'));

var _default = _get__('ticketReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'ticketReducer':
      return ticketReducer;

    case 'historyInitialLoadStart':
      return _history.historyInitialLoadStart;

    case 'historyInitialLoadCompleted':
      return _history.historyInitialLoadCompleted;

    case 'historyLoadStart':
      return _history.historyLoadStart;

    case 'historyLoadCompleted':
      return _history.historyLoadCompleted;

    case 'historyFailed':
      return _history.historyFailed;

    case 'removeAppointmentFromHistory':
      return _history.removeAppointmentFromHistory;

    case 'resetBooking':
      return _booking.resetBooking;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof ticketReducer === 'undefined' ? 'undefined' : _typeof(ticketReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(ticketReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ticketReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/history.js');

  __REACT_HOT_LOADER__.register(ticketReducer, 'ticketReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/history.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/history.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _redux = __webpack_require__(166);

var _reduxActions = __webpack_require__(38);

var _ehrResources = __webpack_require__(174);

var _organization = __webpack_require__(1184);

var _organization2 = _interopRequireDefault(_organization);

var _session = __webpack_require__(1185);

var _session2 = _interopRequireDefault(_session);

var _booking = __webpack_require__(1179);

var _booking2 = _interopRequireDefault(_booking);

var _app = __webpack_require__(1178);

var _app2 = _interopRequireDefault(_app);

var _errors = __webpack_require__(1181);

var _errors2 = _interopRequireDefault(_errors);

var _cancelling = __webpack_require__(1180);

var _cancelling2 = _interopRequireDefault(_cancelling);

var _ticket = __webpack_require__(1186);

var _ticket2 = _interopRequireDefault(_ticket);

var _history = __webpack_require__(1182);

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultReducer = {
  next: function () {
    function next(state, action) {
      return action.payload;
    }

    return next;
  }(),
  'throw': function () {
    function _throw(state, action) {
      throw action.payload;
    }

    return _throw;
  }()
};

var getMapper = function () {
  function getMapper(key) {
    return function (array) {
      var map = Object.create(null);
      array.forEach(function (item) {
        map[item[key]] = item;
      });
      return map;
    };
  }

  return getMapper;
}();

var getMappingReducer = function () {
  function getMappingReducer(key) {
    return {
      next: function () {
        function next(state, action) {
          return _get__('getMapper')(key)(action.payload);
        }

        return next;
      }(),
      'throw': function () {
        function _throw(state, action) {
          throw action.payload;
        }

        return _throw;
      }()
    };
  }

  return getMappingReducer;
}();

var unitInfoReducer = {
  next: function () {
    function next(state, action) {
      return _defineProperty({}, action.payload.unit, action.payload.notes || action.payload.loadingInfo);
    }

    return next;
  }(),
  'throw': function () {
    function _throw(state, action) {
      throw action.payload;
    }

    return _throw;
  }()
};

var _DefaultExportValue = _get__('combineReducers')({
  errors: _get__('errors'),
  session: _get__('session'),
  organization: _get__('organization'),
  booking: _get__('booking'),
  app: _get__('app'),
  groups: _get__('handleAction')(_get__('groupsReceived'), _get__('defaultReducer'), {}),
  resources: _get__('handleAction')(_get__('resourcesReceived'), _get__('getMappingReducer')('resource'), {}),
  units: _get__('handleAction')(_get__('unitsReceived'), _get__('getMappingReducer')('unit'), {}),
  unitInfos: _get__('handleAction')(_get__('combineActions')(_get__('unitInfoRequested'), _get__('unitInfoReceived')), _get__('unitInfoReducer'), Object.create(null)),
  cancelling: _get__('cancelling'),
  ticket: _get__('ticket'),
  history: _get__('history')
});

var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'getMapper':
      return getMapper;

    case 'combineReducers':
      return _redux.combineReducers;

    case 'errors':
      return _errors2['default'];

    case 'session':
      return _session2['default'];

    case 'organization':
      return _organization2['default'];

    case 'booking':
      return _booking2['default'];

    case 'app':
      return _app2['default'];

    case 'handleAction':
      return _reduxActions.handleAction;

    case 'groupsReceived':
      return _ehrResources.groupsReceived;

    case 'defaultReducer':
      return defaultReducer;

    case 'resourcesReceived':
      return _ehrResources.resourcesReceived;

    case 'getMappingReducer':
      return getMappingReducer;

    case 'unitsReceived':
      return _ehrResources.unitsReceived;

    case 'combineActions':
      return _reduxActions.combineActions;

    case 'unitInfoRequested':
      return _ehrResources.unitInfoRequested;

    case 'unitInfoReceived':
      return _ehrResources.unitInfoReceived;

    case 'unitInfoReducer':
      return unitInfoReducer;

    case 'cancelling':
      return _cancelling2['default'];

    case 'ticket':
      return _ticket2['default'];

    case 'history':
      return _history2['default'];
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultReducer, 'defaultReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(getMapper, 'getMapper', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(getMappingReducer, 'getMappingReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(unitInfoReducer, 'unitInfoReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/index.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _organization = __webpack_require__(545);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  logoUrl: '',
  backgroundImageUrl: '',
  termsOfServiceUrl: '',
  languages: ['fi', 'en'],
  googleAnalyticsTrackingId: '',
  googleTagManagerId: '',
  optionalReservationText: false,
  loginOnlyBySso: false,
  defaultLocale: '',
  relaxedSotuVerificationEnabled: false,
  employerSelectionEnabled: false,
  loginPolicyType: 'ONLY_SSN',
  smsConfirmationEnabled: false,
  emailConfirmationEnabled: false
};

var organizationReducer = _get__('handleActions')(_defineProperty({}, _get__('organizationReceived'), function (state, action) {
  return _extends({}, state, {
    logoUrl: action.payload.logoUrl,
    backgroundImageUrl: action.payload.backgroundImageUrl,
    brandingCssUrl: action.payload.brandingCssUrl,
    reservationByCodeEnabled: action.payload.reservationByCodeEnabled,
    termsOfServiceUrl: action.payload.termsOfServiceUrl,
    languages: action.payload.locales.map(function (locale) {
      return locale.split('_')[0];
    }),
    googleAnalyticsTrackingId: action.payload.googleAnalyticsTrackingId ? action.payload.googleAnalyticsTrackingId : '',
    googleTagManagerId: action.payload.googleTagManagerId ? action.payload.googleTagManagerId : '',
    optionalReservationText: action.payload.optionalReservationText,
    loginOnlyBySso: action.payload.loginOnlyBySso,
    defaultLocale: action.payload.defaultLocale,
    relaxedSotuVerificationEnabled: action.payload.relaxedSotuVerificationEnabled,
    employerSelectionEnabled: action.payload.employerSelectionEnabled,
    loginPolicyType: action.payload.loginPolicyType,
    registrationExclusiveFields: action.payload.registrationExclusiveFields,
    showOwnTeamByDefault: action.payload.showOwnTeamByDefault,
    smsConfirmationEnabled: action.payload.smsConfirmationEnabled,
    emailConfirmationEnabled: action.payload.emailConfirmationEnabled
  });
}), _get__('initialState'));

var _default = _get__('organizationReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'organizationReducer':
      return organizationReducer;

    case 'organizationReceived':
      return _organization.organizationReceived;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof organizationReducer === 'undefined' ? 'undefined' : _typeof(organizationReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(organizationReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(organizationReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/organization.js');

  __REACT_HOT_LOADER__.register(organizationReducer, 'organizationReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/organization.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/organization.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _session = __webpack_require__(42);

var _i18n = __webpack_require__(61);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  userIdentified: false,
  currentlyIdentifying: false,
  doneIdentifying: false,
  loginFailed: false,
  loginFailedMessage: null,
  requireContinueConfirmation: false,
  userConfirmedContinue: false,
  hasEmployer: false,
  hasDepartment: false,
  selectedEmployer: -1,
  selectedDepartment: -1,
  sessionCleared: false,
  sessionTimeout: false,
  user: {
    employers: []
  },
  createUserIfNotExists: false,
  requiresEmployer: false,
  prepareUserRegistration: false,
  userRegistrationData: {
    firstName: '',
    lastName: '',
    personId: ''
  },
  userRegistered: false,
  currentlyRegistering: false,
  registrationFailed: false,
  registrationFailedMessage: null,
  loginFailedNotAllowedByEmployer: false,
  loginFailedNotDueToMultipleEmployers: false,
  messageLocalizationKey: '',
  viaSso: false,
  language: '',
  triggerInitialScroll: false,
  bankRedirectingInProcess: false,
  creationIncomplete: false
};

var getAgreementLevelActionFromMainEmployer = function () {
  function getAgreementLevelActionFromMainEmployer(user) {
    if (user.employers.length > 0) {
      var mainEmployer = user.employers.filter(function (e) {
        return e.mainEmployer;
      });
      if (mainEmployer.length > 0) {
        var employer = mainEmployer[0];
        var organizationAgreementLevel = employer.organizationAgreementLevel;

        if (organizationAgreementLevel) {
          return organizationAgreementLevel.action === 'SHOW_NOTIFICATION';
        }
      }
    }
    return false;
  }

  return getAgreementLevelActionFromMainEmployer;
}();

// Set first main employer as a user's selected employer.
// When/if we later have a feature for user to select employer, we have to change this logic
var getFirstMainEmployerAsSelectedEmployer = function () {
  function getFirstMainEmployerAsSelectedEmployer(user) {
    var employerIndex = _get__('initialState').selectedEmployer;
    if (user.employers.length > 0) {
      // take the first one and then try to find the main employer
      employerIndex = 0;
      for (var i = 0; i < user.employers.length; i += 1) {
        if (user.employers[i].mainEmployer) {
          employerIndex = i;
          break;
        }
      }
    }
    return employerIndex;
  }

  return getFirstMainEmployerAsSelectedEmployer;
}();

var sessionReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('identifyUserStart'), function (state) {
  return _extends({}, state, {
    currentlyIdentifying: true,
    doneIdentifying: false,
    loginFailed: false,
    loginFailedMessage: _get__('initialState').loginFailedMessage
  });
}), _defineProperty(_get__2, _get__('identifyUserSuccess'), function (state, action) {
  if (action.payload.viaSso && action.payload.language) {
    _get__('i18n').changeLanguage(action.payload.language);
  }
  return _extends({}, state, {
    currentlyIdentifying: false,
    doneIdentifying: true,
    userIdentified: true,
    triggerInitialScroll: true,
    user: Object.assign(_get__('initialState').user, action.payload),
    hasEmployer: action.payload.employers && action.payload.employers.length > 0,
    viaSso: action.payload.viaSso,
    language: action.payload.language,
    requireContinueConfirmation: _get__('getAgreementLevelActionFromMainEmployer')(action.payload),
    creationIncomplete: action.payload.creationIncomplete
  });
}), _defineProperty(_get__2, _get__('selectMainEmployer'), function (state, action) {
  return _extends({}, state, {
    selectedEmployer: _get__('getFirstMainEmployerAsSelectedEmployer')(action.payload)
  });
}), _defineProperty(_get__2, _get__('selectEmployer'), function (state, action) {
  return _extends({}, state, {
    selectedEmployer: action.payload // employerIndex

  });
}), _defineProperty(_get__2, _get__('checkUserFailure'), function (state) {
  return _extends({}, state, {
    currentlyIdentifying: false,
    doneIdentifying: true
  });
}), _defineProperty(_get__2, _get__('identifyUserFailure'), function (state, action) {
  return _extends({}, state, {
    currentlyIdentifying: false,
    doneIdentifying: true,
    loginFailed: true,
    loginFailedMessage: action.payload
  });
}), _defineProperty(_get__2, _get__('identifyUserFailureAccessNotAllowedByEmployer'), function (state, action) {
  return _extends({}, state, {
    currentlyIdentifying: false,
    doneIdentifying: true,
    loginFailed: false,
    loginFailedMessage: '',
    loginFailedNotAllowedByEmployer: true,
    messageLocalizationKey: action.payload
  });
}), _defineProperty(_get__2, _get__('identifyUserFailureAccessNotAllowedByEmployerUserNoted'), function (state) {
  return _extends({}, state, {
    loginFailedNotAllowedByEmployer: false
  });
}), _defineProperty(_get__2, _get__('selectEmployerDepartment'), function (state, action) {
  return _extends({}, state, {
    hasEmployer: action.payload.hasEmployer,
    hasDepartment: action.payload.hasDepartment,
    // selectedEmployer: action.payload.employer,
    selectedDepartment: action.payload.department
  });
}), _defineProperty(_get__2, _get__('confirmContinue'), function (state) {
  return _extends({}, state, {
    userConfirmedContinue: true
  });
}), _defineProperty(_get__2, _get__('clearSessionSuccess'), function (state) {
  return _extends({}, _get__('initialState'), {
    // requiresEmployer: state.requiresEmployer,
    // createUserIfNotExists: state.createUserIfNotExists,
    sessionCleared: true,
    user: {
      employers: []
    }
  });
}), _defineProperty(_get__2, _get__('restoreInitialState'), function (state) {
  return _extends({}, _get__('initialState'), { // restore the original state
    // requiresEmployer: state.requiresEmployer,
    // createUserIfNotExists: state.createUserIfNotExists
    user: {
      employers: []
    }
  });
}), _defineProperty(_get__2, _get__('sessionTimeOut'), function (state) {
  return _extends({}, _get__('initialState'), {
    // requiresEmployer: state.requiresEmployer,
    // createUserIfNotExists: state.createUserIfNotExists,
    sessionTimeout: true,
    user: {
      employers: []
    }
  });
}), _defineProperty(_get__2, _get__('setFlagCreateUserIfNotExists'), function (state, action) {
  return _extends({}, state, {
    createUserIfNotExists: action.payload
  });
}), _defineProperty(_get__2, _get__('setFlagRequiresEmployer'), function (state, action) {
  return _extends({}, state, {
    requiresEmployer: action.payload
  });
}), _defineProperty(_get__2, _get__('setUserPreRegistrationData'), function (state, action) {
  return _extends({}, state, {
    currentlyIdentifying: false,
    currentlyRegistering: false,
    loginFailed: false,
    prepareUserRegistration: true,
    userRegistrationData: action.payload
  });
}), _defineProperty(_get__2, _get__('registrationUserStart'), function (state) {
  return _extends({}, state, {
    userRegistered: false,
    currentlyRegistering: true,
    registrationFailed: false,
    registrationFailedMessage: null
  });
}), _defineProperty(_get__2, _get__('registrationUserSuccess'), function (state) {
  return _extends({}, state, {
    userRegistered: true,
    currentlyRegistering: false,
    registrationFailed: false,
    registrationFailedMessage: null
  });
}), _defineProperty(_get__2, _get__('registrationUserFailure'), function (state) {
  return _extends({}, state, {
    userRegistered: false,
    currentlyRegistering: false,
    registrationFailed: true,
    registrationFailedMessage: 'registrationError'
  });
}), _defineProperty(_get__2, _get__('identityUserFailureDueToMultipleEmployers'), function (state) {
  return _extends({}, state, {
    loginFailedNotDueToMultipleEmployers: true,
    messageLocalizationKey: 'loginFailedDueToMultipleEmployers'
  });
}), _defineProperty(_get__2, _get__('bankAuthenticationStarted'), function (state) {
  return _extends({}, state, {
    bankRedirectingInProcess: true
  });
}), _defineProperty(_get__2, _get__('bankAuthenticationLinkReceived'), function (state) {
  return _extends({}, state, {
    bankRedirectingInProcess: false
  });
}), _get__2), _get__('initialState'));

var _default = _get__('sessionReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'initialState':
      return initialState;

    case 'handleActions':
      return _reduxActions.handleActions;

    case 'i18n':
      return _i18n2['default'];

    case 'getAgreementLevelActionFromMainEmployer':
      return getAgreementLevelActionFromMainEmployer;

    case 'getFirstMainEmployerAsSelectedEmployer':
      return getFirstMainEmployerAsSelectedEmployer;

    case 'sessionReducer':
      return sessionReducer;

    case 'identifyUserStart':
      return _session.identifyUserStart;

    case 'identifyUserSuccess':
      return _session.identifyUserSuccess;

    case 'selectMainEmployer':
      return _session.selectMainEmployer;

    case 'selectEmployer':
      return _session.selectEmployer;

    case 'checkUserFailure':
      return _session.checkUserFailure;

    case 'identifyUserFailure':
      return _session.identifyUserFailure;

    case 'identifyUserFailureAccessNotAllowedByEmployer':
      return _session.identifyUserFailureAccessNotAllowedByEmployer;

    case 'identifyUserFailureAccessNotAllowedByEmployerUserNoted':
      return _session.identifyUserFailureAccessNotAllowedByEmployerUserNoted;

    case 'selectEmployerDepartment':
      return _session.selectEmployerDepartment;

    case 'confirmContinue':
      return _session.confirmContinue;

    case 'clearSessionSuccess':
      return _session.clearSessionSuccess;

    case 'restoreInitialState':
      return _session.restoreInitialState;

    case 'sessionTimeOut':
      return _session.sessionTimeOut;

    case 'setFlagCreateUserIfNotExists':
      return _session.setFlagCreateUserIfNotExists;

    case 'setFlagRequiresEmployer':
      return _session.setFlagRequiresEmployer;

    case 'setUserPreRegistrationData':
      return _session.setUserPreRegistrationData;

    case 'registrationUserStart':
      return _session.registrationUserStart;

    case 'registrationUserSuccess':
      return _session.registrationUserSuccess;

    case 'registrationUserFailure':
      return _session.registrationUserFailure;

    case 'identityUserFailureDueToMultipleEmployers':
      return _session.identityUserFailureDueToMultipleEmployers;

    case 'bankAuthenticationStarted':
      return _session.bankAuthenticationStarted;

    case 'bankAuthenticationLinkReceived':
      return _session.bankAuthenticationLinkReceived;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof sessionReducer === 'undefined' ? 'undefined' : _typeof(sessionReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(sessionReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(sessionReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/session.js');

  __REACT_HOT_LOADER__.register(getAgreementLevelActionFromMainEmployer, 'getAgreementLevelActionFromMainEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/session.js');

  __REACT_HOT_LOADER__.register(getFirstMainEmployerAsSelectedEmployer, 'getFirstMainEmployerAsSelectedEmployer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/session.js');

  __REACT_HOT_LOADER__.register(sessionReducer, 'sessionReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/session.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/session.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _get__2;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxActions = __webpack_require__(38);

var _ticket = __webpack_require__(546);

var _booking = __webpack_require__(68);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  ticketsLoading: false,
  ticketsLoaded: false,
  tickets: [],
  selectedTicket: {},
  selectedTicketCode: '',
  hasSelectedTicket: false
};

var ticketReducer = _get__('handleActions')((_get__2 = {}, _defineProperty(_get__2, _get__('ticketsLoading'), function (state) {
  return _extends({}, state, {
    ticketsLoading: true,
    ticketsLoaded: false,
    tickets: [],
    selectedTicketCode: '',
    selectedTicket: {}
  });
}), _defineProperty(_get__2, _get__('ticketsLoaded'), function (state, action) {
  return _extends({}, state, {
    ticketsLoading: false,
    ticketsLoaded: true,
    tickets: action.payload,
    selectedTicket: {},
    selectedTicketCode: ''
  });
}), _defineProperty(_get__2, _get__('ticketSelected'), function (state, action) {
  return _extends({}, state, {
    selectedTicket: action.payload,
    selectedTicketCode: action.payload.code,
    hasSelectedTicket: true
  });
}), _defineProperty(_get__2, _get__('ticketFailed'), function (state) {
  return _extends({}, state, {
    ticketsLoading: false,
    ticketsLoaded: false
  });
}), _defineProperty(_get__2, _get__('resetBooking'), function () {
  return _extends({}, _get__('initialState'));
}), _get__2), _get__('initialState'));

var _default = _get__('ticketReducer');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'handleActions':
      return _reduxActions.handleActions;

    case 'initialState':
      return initialState;

    case 'ticketReducer':
      return ticketReducer;

    case 'ticketsLoading':
      return _ticket.ticketsLoading;

    case 'ticketsLoaded':
      return _ticket.ticketsLoaded;

    case 'ticketSelected':
      return _ticket.ticketSelected;

    case 'ticketFailed':
      return _ticket.ticketFailed;

    case 'resetBooking':
      return _booking.resetBooking;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof ticketReducer === 'undefined' ? 'undefined' : _typeof(ticketReducer);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(ticketReducer, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ticketReducer)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/ticket.js');

  __REACT_HOT_LOADER__.register(ticketReducer, 'ticketReducer', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/ticket.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/reducers/ticket.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _redux = __webpack_require__(166);

var _reduxLogger = __webpack_require__(511);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reduxThunk = __webpack_require__(512);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _ClientStorage = __webpack_require__(351);

var _ClientStorage2 = _interopRequireDefault(_ClientStorage);

var _errorHandler = __webpack_require__(1177);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _reducers = __webpack_require__(1183);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
  Configure the redux store instance and add middlewares.
*/
/* global _ */
var configureStore = function () {
  function configureStore() {
    var persistedState = _get__('ClientStorage').getPersistedState();
    var middlewares = [_get__('thunk'), _get__('errorHandler')];

    // Use logger in development mode.
    if (false) {
      middlewares.push(_get__('createLogger')());
    }

    var store = _get__('createStore')(_get__('reducer'), persistedState && persistedState.booking.savedState ? persistedState : undefined, _get__('compose')(_get__('applyMiddleware').apply(undefined, middlewares), window.devToolsExtension ? window.devToolsExtension() : function (f) {
      return f;
    }));

    return store;
  }

  return configureStore;
}();

var _default = _get__('configureStore');

exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case 'ClientStorage':
      return _ClientStorage2['default'];

    case 'thunk':
      return _reduxThunk2['default'];

    case 'errorHandler':
      return _errorHandler2['default'];

    case 'createLogger':
      return _reduxLogger2['default'];

    case 'createStore':
      return _redux.createStore;

    case 'reducer':
      return _reducers2['default'];

    case 'compose':
      return _redux.compose;

    case 'applyMiddleware':
      return _redux.applyMiddleware;

    case 'configureStore':
      return configureStore;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof configureStore === 'undefined' ? 'undefined' : _typeof(configureStore);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(configureStore, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(configureStore)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(configureStore, 'configureStore', '/Users/hannum/work/sources/mbooking/src/frontend/src/store.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/store.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(117);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var unitFiltering = function () {
  function unitFiltering(params, user, units, canAnonymousFetchTimes, legalEntity, dedicated) {
    var inUnits = params.inUnits,
        notInUnits = params.notInUnits;

    // if dedicated units are used

    if (dedicated && (inUnits || notInUnits)) {
      var _unitKeysToKeep = void 0;

      if (inUnits) {
        // get units that are not dedicated
        var filteredUnitKeys = inUnits.filter(function (u) {
          return u !== 'dedicated';
        });

        // if => check if there is dedicated unit and add it to the list
        // else => otherwise just take filtered units
        if (inUnits.indexOf('dedicated') > -1) {
          _unitKeysToKeep = [].concat(_toConsumableArray(filteredUnitKeys), [dedicated[0]]);
        } else {
          _unitKeysToKeep = filteredUnitKeys;
        }
      } else if (notInUnits) {
        // exculude units from all units that are "notInUnits" list 
        _unitKeysToKeep = _get__('_').keys(units).filter(function (unitKey) {
          return notInUnits.filter(function (n) {
            return n === unitKey;
          }).length === 0;
        });
      }
      // exculude filtered units that are "notInUnits" list
      if (notInUnits) {
        _unitKeysToKeep = _get__('_').keys(_unitKeysToKeep).filter(function (unitKey) {
          return notInUnits.filter(function (n) {
            return n === unitKey;
          }).length === 0;
        });
      }
      return _unitKeysToKeep.reduce(function (obj, key) {
        return _extends({}, obj, _defineProperty({}, key, units[key]));
      }, {});
    }

    if (legalEntity) {
      return _get__('_').keys(units).filter(function (unitKey) {
        return units[unitKey].legalUnit === legalEntity;
      }).reduce(function (obj, key) {
        return _extends({}, obj, _defineProperty({}, key, units[key]));
      }, {});
    }
    // filter out units based on the selected path if the properties "inUnits" and "notInUnits" are present
    if (!inUnits && !notInUnits) {
      return units;
    }
    // If canAnonymousFetchTimes and no legalEntity is defined then do not filter units.
    if (canAnonymousFetchTimes && !legalEntity) {
      return units;
    }

    // Filter according to inUnits property
    if (inUnits) {
      var _filteredUnitKeys = inUnits.filter(function (u) {
        return u !== 'dedicated';
      });
      // NOTE: it has been decided to replace the 'dedicated' keyword with the user's home unit
      /*
      const respUnits = employers.map(e => e.respUnit);
      const sameRespUnit = respUnits.every(e => e === respUnits[0]);
      if (!sameRespUnit) {
        return null;
      }
      */
      if (inUnits.indexOf('dedicated') > -1 && user.dedicatedUnit) {
        // add the main employer unit
        // const homeUnit = user.employers.filter(e => e.mainEmployer).map(e => e.respUnit);
        _filteredUnitKeys.push(user.dedicatedUnit);
      }
      return _filteredUnitKeys.reduce(function (obj, key) {
        return _extends({}, obj, _defineProperty({}, key, units[key]));
      }, {});
    }
    // Filter according to notInUnits property
    console.log('filter out units');
    var unitKeysToKeep = _get__('_').keys(units).filter(function (unitKey) {
      return notInUnits.filter(function (n) {
        return n === unitKey;
      }).length === 0;
    });
    return unitKeysToKeep.reduce(function (obj, key) {
      return _extends({}, obj, _defineProperty({}, key, units[key]));
    }, {});
  }

  return unitFiltering;
}();

var _DefaultExportValue = {
  unitFiltering: _get__('unitFiltering')
};
var _default = _DefaultExportValue;
exports['default'] = _default;

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function () {
  function registerResetAll() {
    var theGlobalVariable = _getGlobalObject();

    if (!theGlobalVariable['__rewire_reset_all__']) {
      theGlobalVariable['__rewire_reset_all__'] = function () {
        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
      };
    }
  }

  return registerResetAll;
})()();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case '_':
      return _lodash2['default'];

    case 'unitFiltering':
      return unitFiltering;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)['catch'](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(_DefaultExportValue, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}

exports.__get__ = _get__;
exports.__GetDependency__ = _get__;
exports.__Rewire__ = _set__;
exports.__set__ = _set__;
exports.__ResetDependency__ = _reset__;
exports.__RewireAPI__ = _RewireAPI__;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(unitFiltering, 'unitFiltering', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/unitHelper.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/hannum/work/sources/mbooking/src/frontend/src/util/unitHelper.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1244);
module.exports = __webpack_require__(79).RegExp.escape;


/***/ }),
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(265);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(18);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(95);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(140);
var gOPS = __webpack_require__(269);
var pIE = __webpack_require__(224);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(225)('native-function-to-string', Function.toString);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(4);
var $re = __webpack_require__(1243)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { copyWithin: __webpack_require__(571) });

__webpack_require__(120)('copyWithin');


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $every = __webpack_require__(92)(4);

$export($export.P + $export.F * !__webpack_require__(81)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(4);

$export($export.P, 'Array', { fill: __webpack_require__(361) });

__webpack_require__(120)('fill');


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $filter = __webpack_require__(92)(2);

$export($export.P + $export.F * !__webpack_require__(81)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(92)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(120)(KEY);


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(4);
var $find = __webpack_require__(92)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(120)(KEY);


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $forEach = __webpack_require__(92)(0);
var STRICT = __webpack_require__(81)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(80);
var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var call = __webpack_require__(582);
var isArrayIter = __webpack_require__(369);
var toLength = __webpack_require__(29);
var createProperty = __webpack_require__(363);
var getIterFn = __webpack_require__(385);

$export($export.S + $export.F * !__webpack_require__(267)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $indexOf = __webpack_require__(262)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(81)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(4);

$export($export.S, 'Array', { isArray: __webpack_require__(265) });


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(4);
var toIObject = __webpack_require__(73);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(223) != Object || !__webpack_require__(81)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(73);
var toInteger = __webpack_require__(82);
var toLength = __webpack_require__(29);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(81)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $map = __webpack_require__(92)(1);

$export($export.P + $export.F * !__webpack_require__(81)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var createProperty = __webpack_require__(363);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(18)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(573);

$export($export.P + $export.F * !__webpack_require__(81)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $reduce = __webpack_require__(573);

$export($export.P + $export.F * !__webpack_require__(81)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var html = __webpack_require__(367);
var cof = __webpack_require__(78);
var toAbsoluteIndex = __webpack_require__(144);
var toLength = __webpack_require__(29);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(18)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $some = __webpack_require__(92)(3);

$export($export.P + $export.F * !__webpack_require__(81)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var aFunction = __webpack_require__(50);
var toObject = __webpack_require__(35);
var fails = __webpack_require__(18);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(81)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143)('Array');


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(4);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(4);
var toISOString = __webpack_require__(1239);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(95);

$export($export.P + $export.F * __webpack_require__(18)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(63)(proto, TO_PRIMITIVE, __webpack_require__(1240));


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(64)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(4);

$export($export.P, 'Function', { bind: __webpack_require__(574) });


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(72);
var HAS_INSTANCE = __webpack_require__(28)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(33).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(31) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(4);
var log1p = __webpack_require__(585);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(4);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(4);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(4);
var sign = __webpack_require__(373);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(4);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(4);
var $expm1 = __webpack_require__(372);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { fround: __webpack_require__(584) });


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(4);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(4);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { log1p: __webpack_require__(585) });


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', { sign: __webpack_require__(373) });


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(372);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(18)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(4);
var expm1 = __webpack_require__(372);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var has = __webpack_require__(70);
var cof = __webpack_require__(78);
var inheritIfRequired = __webpack_require__(368);
var toPrimitive = __webpack_require__(95);
var fails = __webpack_require__(18);
var gOPN = __webpack_require__(139).f;
var gOPD = __webpack_require__(71).f;
var dP = __webpack_require__(33).f;
var $trim = __webpack_require__(180).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(138)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(31) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(64)(global, NUMBER, $Number);
}


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(4);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(4);
var _isFinite = __webpack_require__(15).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', { isInteger: __webpack_require__(581) });


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(4);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(4);
var isInteger = __webpack_require__(581);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(4);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(593);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(594);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toInteger = __webpack_require__(82);
var aNumberValue = __webpack_require__(570);
var repeat = __webpack_require__(380);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(18)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $fails = __webpack_require__(18);
var aNumberValue = __webpack_require__(570);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(587) });


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(138) });


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperties: __webpack_require__(588) });


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(31), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(122).onFreeze;

__webpack_require__(94)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(73);
var $getOwnPropertyDescriptor = __webpack_require__(71).f;

__webpack_require__(94)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(94)('getOwnPropertyNames', function () {
  return __webpack_require__(589).f;
});


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(35);
var $getPrototypeOf = __webpack_require__(72);

__webpack_require__(94)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(20);

__webpack_require__(94)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(20);

__webpack_require__(94)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(20);

__webpack_require__(94)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { is: __webpack_require__(597) });


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(35);
var $keys = __webpack_require__(140);

__webpack_require__(94)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(122).onFreeze;

__webpack_require__(94)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(20);
var meta = __webpack_require__(122).onFreeze;

__webpack_require__(94)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(4);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(377).set });


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(177);
var test = {};
test[__webpack_require__(28)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(64)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseFloat = __webpack_require__(593);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $parseInt = __webpack_require__(594);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(121);
var global = __webpack_require__(15);
var ctx = __webpack_require__(80);
var classof = __webpack_require__(177);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(50);
var anInstance = __webpack_require__(136);
var forOf = __webpack_require__(137);
var speciesConstructor = __webpack_require__(226);
var task = __webpack_require__(382).set;
var microtask = __webpack_require__(374)();
var newPromiseCapabilityModule = __webpack_require__(375);
var perform = __webpack_require__(595);
var userAgent = __webpack_require__(275);
var promiseResolve = __webpack_require__(596);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(142)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(179)($Promise, PROMISE);
__webpack_require__(143)(PROMISE);
Wrapper = __webpack_require__(79)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(267)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(4);
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(10);
var rApply = (__webpack_require__(15).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(18)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(4);
var create = __webpack_require__(138);
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var fails = __webpack_require__(18);
var bind = __webpack_require__(574);
var rConstruct = (__webpack_require__(15).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(33);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var toPrimitive = __webpack_require__(95);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(18)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(4);
var gOPD = __webpack_require__(71).f;
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(370)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(71);
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(4);
var getProto = __webpack_require__(72);
var anObject = __webpack_require__(10);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(71);
var getPrototypeOf = __webpack_require__(72);
var has = __webpack_require__(70);
var $export = __webpack_require__(4);
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(10);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(4);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(592) });


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(4);
var anObject = __webpack_require__(10);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(4);
var setProto = __webpack_require__(377);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(33);
var gOPD = __webpack_require__(71);
var getPrototypeOf = __webpack_require__(72);
var has = __webpack_require__(70);
var $export = __webpack_require__(4);
var createDesc = __webpack_require__(141);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var inheritIfRequired = __webpack_require__(368);
var dP = __webpack_require__(33).f;
var gOPN = __webpack_require__(139).f;
var isRegExp = __webpack_require__(266);
var $flags = __webpack_require__(222);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(31) && (!CORRECT_NEW || __webpack_require__(18)(function () {
  re2[__webpack_require__(28)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(64)(global, 'RegExp', $RegExp);
}

__webpack_require__(143)('RegExp');


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toLength = __webpack_require__(29);
var advanceStringIndex = __webpack_require__(360);
var regExpExec = __webpack_require__(270);

// @@match logic
__webpack_require__(264)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(29);
var toInteger = __webpack_require__(82);
var advanceStringIndex = __webpack_require__(360);
var regExpExec = __webpack_require__(270);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(264)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(10);
var sameValue = __webpack_require__(597);
var regExpExec = __webpack_require__(270);

// @@search logic
__webpack_require__(264)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(266);
var anObject = __webpack_require__(10);
var speciesConstructor = __webpack_require__(226);
var advanceStringIndex = __webpack_require__(360);
var toLength = __webpack_require__(29);
var callRegExpExec = __webpack_require__(270);
var regexpExec = __webpack_require__(376);
var fails = __webpack_require__(18);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(264)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(603);
var anObject = __webpack_require__(10);
var $flags = __webpack_require__(222);
var DESCRIPTORS = __webpack_require__(31);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(64)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(18)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(65)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(65)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(65)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(65)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $at = __webpack_require__(273)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(29);
var context = __webpack_require__(379);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(366)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(65)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(65)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(65)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toAbsoluteIndex = __webpack_require__(144);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(4);
var context = __webpack_require__(379);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(366)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(65)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(273)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(371)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(65)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var toIObject = __webpack_require__(73);
var toLength = __webpack_require__(29);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(380)
});


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(65)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(4);
var toLength = __webpack_require__(29);
var context = __webpack_require__(379);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(366)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(65)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(65)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(65)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(180)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(15);
var has = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(31);
var $export = __webpack_require__(4);
var redefine = __webpack_require__(64);
var META = __webpack_require__(122).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(225);
var setToStringTag = __webpack_require__(179);
var uid = __webpack_require__(145);
var wks = __webpack_require__(28);
var wksExt = __webpack_require__(600);
var wksDefine = __webpack_require__(384);
var enumKeys = __webpack_require__(1241);
var isArray = __webpack_require__(265);
var anObject = __webpack_require__(10);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(35);
var toIObject = __webpack_require__(73);
var toPrimitive = __webpack_require__(95);
var createDesc = __webpack_require__(141);
var _create = __webpack_require__(138);
var gOPNExt = __webpack_require__(589);
var $GOPD = __webpack_require__(71);
var $GOPS = __webpack_require__(269);
var $DP = __webpack_require__(33);
var $keys = __webpack_require__(140);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(139).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(224).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(121)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(63)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var $typed = __webpack_require__(274);
var buffer = __webpack_require__(383);
var anObject = __webpack_require__(10);
var toAbsoluteIndex = __webpack_require__(144);
var toLength = __webpack_require__(29);
var isObject = __webpack_require__(20);
var ArrayBuffer = __webpack_require__(15).ArrayBuffer;
var speciesConstructor = __webpack_require__(226);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(18)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(143)(ARRAY_BUFFER);


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
$export($export.G + $export.W + $export.F * !__webpack_require__(274).ABV, {
  DataView: __webpack_require__(383).DataView
});


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(577);
var validate = __webpack_require__(146);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(263)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(578);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(29);
var aFunction = __webpack_require__(50);
var arraySpeciesCreate = __webpack_require__(362);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(120)('flatMap');


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(4);
var flattenIntoArray = __webpack_require__(578);
var toObject = __webpack_require__(35);
var toLength = __webpack_require__(29);
var toInteger = __webpack_require__(82);
var arraySpeciesCreate = __webpack_require__(362);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(120)('flatten');


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(4);
var $includes = __webpack_require__(262)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(120)('includes');


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(4);
var microtask = __webpack_require__(374)();
var process = __webpack_require__(15).process;
var isNode = __webpack_require__(78)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(4);
var cof = __webpack_require__(78);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.G, { global: __webpack_require__(15) });


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(271)('Map');


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(272)('Map');


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(576)('Map') });


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var scale = __webpack_require__(586);
var fround = __webpack_require__(584);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(4);

$export($export.S, 'Math', { scale: __webpack_require__(586) });


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(4);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(4);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var aFunction = __webpack_require__(50);
var $defineProperty = __webpack_require__(33);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(31) && $export($export.P + __webpack_require__(268), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var aFunction = __webpack_require__(50);
var $defineProperty = __webpack_require__(33);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(31) && $export($export.P + __webpack_require__(268), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $entries = __webpack_require__(591)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(4);
var ownKeys = __webpack_require__(592);
var toIObject = __webpack_require__(73);
var gOPD = __webpack_require__(71);
var createProperty = __webpack_require__(363);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(95);
var getPrototypeOf = __webpack_require__(72);
var getOwnPropertyDescriptor = __webpack_require__(71).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(31) && $export($export.P + __webpack_require__(268), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(4);
var toObject = __webpack_require__(35);
var toPrimitive = __webpack_require__(95);
var getPrototypeOf = __webpack_require__(72);
var getOwnPropertyDescriptor = __webpack_require__(71).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(31) && $export($export.P + __webpack_require__(268), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(4);
var $values = __webpack_require__(591)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(4);
var global = __webpack_require__(15);
var core = __webpack_require__(79);
var microtask = __webpack_require__(374)();
var OBSERVABLE = __webpack_require__(28)('observable');
var aFunction = __webpack_require__(50);
var anObject = __webpack_require__(10);
var anInstance = __webpack_require__(136);
var redefineAll = __webpack_require__(142);
var hide = __webpack_require__(63);
var forOf = __webpack_require__(137);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(143)('Observable');


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(4);
var core = __webpack_require__(79);
var global = __webpack_require__(15);
var speciesConstructor = __webpack_require__(226);
var promiseResolve = __webpack_require__(596);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(4);
var newPromiseCapability = __webpack_require__(375);
var perform = __webpack_require__(595);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(604);
var from = __webpack_require__(572);
var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(72);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(72);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(72);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(105);
var anObject = __webpack_require__(10);
var aFunction = __webpack_require__(50);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(271)('Set');


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(272)('Set');


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(4);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(576)('Set') });


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(4);
var $at = __webpack_require__(273)(true);
var $fails = __webpack_require__(18);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(4);
var defined = __webpack_require__(93);
var toLength = __webpack_require__(29);
var isRegExp = __webpack_require__(266);
var getFlags = __webpack_require__(222);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(370)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(598);
var userAgent = __webpack_require__(275);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(4);
var $pad = __webpack_require__(598);
var userAgent = __webpack_require__(275);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(180)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(180)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384)('asyncIterator');


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384)('observable');


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(4);

$export($export.S, 'System', { global: __webpack_require__(15) });


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(271)('WeakMap');


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(272)('WeakMap');


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(271)('WeakSet');


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(272)('WeakSet');


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(386);
var getKeys = __webpack_require__(140);
var redefine = __webpack_require__(64);
var global = __webpack_require__(15);
var hide = __webpack_require__(63);
var Iterators = __webpack_require__(178);
var wks = __webpack_require__(28);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
var $task = __webpack_require__(382);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(15);
var $export = __webpack_require__(4);
var userAgent = __webpack_require__(275);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1364);
__webpack_require__(1303);
__webpack_require__(1305);
__webpack_require__(1304);
__webpack_require__(1307);
__webpack_require__(1309);
__webpack_require__(1314);
__webpack_require__(1308);
__webpack_require__(1306);
__webpack_require__(1316);
__webpack_require__(1315);
__webpack_require__(1311);
__webpack_require__(1312);
__webpack_require__(1310);
__webpack_require__(1302);
__webpack_require__(1313);
__webpack_require__(1317);
__webpack_require__(1318);
__webpack_require__(1270);
__webpack_require__(1272);
__webpack_require__(1271);
__webpack_require__(1320);
__webpack_require__(1319);
__webpack_require__(1290);
__webpack_require__(1300);
__webpack_require__(1301);
__webpack_require__(1291);
__webpack_require__(1292);
__webpack_require__(1293);
__webpack_require__(1294);
__webpack_require__(1295);
__webpack_require__(1296);
__webpack_require__(1297);
__webpack_require__(1298);
__webpack_require__(1299);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(1288);
__webpack_require__(1289);
__webpack_require__(1351);
__webpack_require__(1356);
__webpack_require__(1363);
__webpack_require__(1354);
__webpack_require__(1346);
__webpack_require__(1347);
__webpack_require__(1352);
__webpack_require__(1357);
__webpack_require__(1359);
__webpack_require__(1342);
__webpack_require__(1343);
__webpack_require__(1344);
__webpack_require__(1345);
__webpack_require__(1348);
__webpack_require__(1349);
__webpack_require__(1350);
__webpack_require__(1353);
__webpack_require__(1355);
__webpack_require__(1358);
__webpack_require__(1360);
__webpack_require__(1361);
__webpack_require__(1362);
__webpack_require__(1265);
__webpack_require__(1267);
__webpack_require__(1266);
__webpack_require__(1269);
__webpack_require__(1268);
__webpack_require__(1254);
__webpack_require__(1252);
__webpack_require__(1258);
__webpack_require__(1255);
__webpack_require__(1261);
__webpack_require__(1263);
__webpack_require__(1251);
__webpack_require__(1257);
__webpack_require__(1248);
__webpack_require__(1262);
__webpack_require__(1246);
__webpack_require__(1260);
__webpack_require__(1259);
__webpack_require__(1253);
__webpack_require__(1256);
__webpack_require__(1245);
__webpack_require__(1247);
__webpack_require__(1250);
__webpack_require__(1249);
__webpack_require__(1264);
__webpack_require__(386);
__webpack_require__(1336);
__webpack_require__(602);
__webpack_require__(1341);
__webpack_require__(603);
__webpack_require__(1337);
__webpack_require__(1338);
__webpack_require__(1339);
__webpack_require__(1340);
__webpack_require__(1321);
__webpack_require__(601);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(1376);
__webpack_require__(1365);
__webpack_require__(1366);
__webpack_require__(1371);
__webpack_require__(1374);
__webpack_require__(1375);
__webpack_require__(1369);
__webpack_require__(1372);
__webpack_require__(1370);
__webpack_require__(1373);
__webpack_require__(1367);
__webpack_require__(1368);
__webpack_require__(1322);
__webpack_require__(1323);
__webpack_require__(1324);
__webpack_require__(1325);
__webpack_require__(1326);
__webpack_require__(1329);
__webpack_require__(1327);
__webpack_require__(1328);
__webpack_require__(1330);
__webpack_require__(1331);
__webpack_require__(1332);
__webpack_require__(1333);
__webpack_require__(1335);
__webpack_require__(1334);
__webpack_require__(1379);
__webpack_require__(1377);
__webpack_require__(1378);
__webpack_require__(1420);
__webpack_require__(1423);
__webpack_require__(1422);
__webpack_require__(1424);
__webpack_require__(1425);
__webpack_require__(1421);
__webpack_require__(1426);
__webpack_require__(1427);
__webpack_require__(1401);
__webpack_require__(1404);
__webpack_require__(1400);
__webpack_require__(1398);
__webpack_require__(1399);
__webpack_require__(1402);
__webpack_require__(1403);
__webpack_require__(1385);
__webpack_require__(1419);
__webpack_require__(1384);
__webpack_require__(1418);
__webpack_require__(1430);
__webpack_require__(1432);
__webpack_require__(1383);
__webpack_require__(1417);
__webpack_require__(1429);
__webpack_require__(1431);
__webpack_require__(1382);
__webpack_require__(1428);
__webpack_require__(1381);
__webpack_require__(1386);
__webpack_require__(1387);
__webpack_require__(1388);
__webpack_require__(1389);
__webpack_require__(1390);
__webpack_require__(1392);
__webpack_require__(1391);
__webpack_require__(1393);
__webpack_require__(1394);
__webpack_require__(1395);
__webpack_require__(1397);
__webpack_require__(1396);
__webpack_require__(1406);
__webpack_require__(1407);
__webpack_require__(1408);
__webpack_require__(1409);
__webpack_require__(1411);
__webpack_require__(1410);
__webpack_require__(1413);
__webpack_require__(1412);
__webpack_require__(1414);
__webpack_require__(1415);
__webpack_require__(1416);
__webpack_require__(1380);
__webpack_require__(1405);
__webpack_require__(1435);
__webpack_require__(1434);
__webpack_require__(1433);
module.exports = __webpack_require__(79);


/***/ }),
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/aab65d1e7305a94afde7c49163f71439.png";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/594a11897c977bf8027fa7c3ce38463d.png";

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/6df60243ee7dbe25f3b2403d1a02d1fc.png";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/db4b7078eb100d0cacd3bff58e62f4fa.png";

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/eb66511d4f0b04e2f18cff0638b8cd13.svg";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/23d93f074a7ded8239ea80615a7d0dc7.svg";

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/1893bfe30c2600e045fcedc9846a4323.png";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/0f406030b2921cc24f1f8118480f891d.png";

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/2f6a1b19c83f9365ae0f3012d41050f4.png";

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/c8e83c294b00695ce5622a3dd6dbf6de.png";

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/b74ece1a3440b97351050835b0046449.png";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/ab5ce7f15531458ea41b2f7782e31a9d.png";

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/266e62e50d1b4cc3b7cb1f444465e0ee.svg";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/95a103bbd4f28a62f119a9ad2279e698.png";

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/a3ae7225b79b6dd01115092bf1a55857.svg";

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/1a7eaa01f6cbf9b3ef8e11a85ebb6285.png";

/***/ }),
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157),
    root = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1767),
    hashDelete = __webpack_require__(1768),
    hashGet = __webpack_require__(1769),
    hashHas = __webpack_require__(1770),
    hashSet = __webpack_require__(1771);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(157),
    root = __webpack_require__(45);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1704 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 1705 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEachRight;


/***/ }),
/* 1706 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

module.exports = arrayReduceRight;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    copyArray = __webpack_require__(85),
    shuffleSelf = __webpack_require__(309);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(85),
    shuffleSelf = __webpack_require__(309);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(436);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1710 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1711 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(126);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    keysIn = __webpack_require__(58);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var baseConformsTo = __webpack_require__(677),
    keys = __webpack_require__(46);

/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = keys(source);
  return function(object) {
    return baseConformsTo(object, source, props);
  };
}

module.exports = baseConforms;


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(126);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(21),
    toLength = __webpack_require__(764);

/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = toInteger(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : toInteger(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

module.exports = baseFill;


/***/ }),
/* 1717 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1720 */
/***/ (function(module, exports) {

/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOfWith;


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(152);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

var arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
}

module.exports = baseIsArrayBuffer;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return isObjectLike(value) && baseGetTag(value) == dateTag;
}

module.exports = baseIsDate;


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(292),
    equalArrays = __webpack_require__(719),
    equalByTag = __webpack_require__(1759),
    equalObjects = __webpack_require__(1760),
    getTag = __webpack_require__(113),
    isArray = __webpack_require__(16),
    isBuffer = __webpack_require__(158),
    isTypedArray = __webpack_require__(200);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(113),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(113),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isLength = __webpack_require__(310),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(39),
    isPrototype = __webpack_require__(237),
    nativeKeysIn = __webpack_require__(1793);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(674),
    cloneBuffer = __webpack_require__(702),
    cloneTypedArray = __webpack_require__(703),
    copyArray = __webpack_require__(85),
    initCloneObject = __webpack_require__(725),
    isArguments = __webpack_require__(199),
    isArray = __webpack_require__(16),
    isArrayLikeObject = __webpack_require__(57),
    isBuffer = __webpack_require__(158),
    isFunction = __webpack_require__(115),
    isObject = __webpack_require__(39),
    isPlainObject = __webpack_require__(238),
    isTypedArray = __webpack_require__(200),
    safeGet = __webpack_require__(734),
    toPlainObject = __webpack_require__(767);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(690),
    hasIn = __webpack_require__(459);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1735 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(673),
    values = __webpack_require__(201);

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

module.exports = baseSample;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    shuffleSelf = __webpack_require__(309),
    values = __webpack_require__(201);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(457),
    defineProperty = __webpack_require__(718),
    identity = __webpack_require__(114);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(309),
    values = __webpack_require__(201);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(126);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1741 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(445);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(151);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(704);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    getSymbols = __webpack_require__(452);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    getSymbolsIn = __webpack_require__(723);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1749 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(302),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    createCtor = __webpack_require__(302),
    createHybrid = __webpack_require__(713),
    createRecurry = __webpack_require__(716),
    getHolder = __webpack_require__(450),
    replaceHolders = __webpack_require__(307),
    root = __webpack_require__(45);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    createCtor = __webpack_require__(302),
    root = __webpack_require__(45);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(667),
    noop = __webpack_require__(462),
    setToArray = __webpack_require__(308);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(695),
    createBind = __webpack_require__(1750),
    createCurry = __webpack_require__(1751),
    createHybrid = __webpack_require__(713),
    createPartial = __webpack_require__(1752),
    getData = __webpack_require__(449),
    mergeData = __webpack_require__(1791),
    setData = __webpack_require__(735),
    setWrapToString = __webpack_require__(736),
    toInteger = __webpack_require__(21);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(86);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(435),
    isObject = __webpack_require__(39);

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(238);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(437);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(151),
    Uint8Array = __webpack_require__(668),
    eq = __webpack_require__(86),
    equalArrays = __webpack_require__(719),
    mapToArray = __webpack_require__(454),
    setToArray = __webpack_require__(308);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(721);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(437);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

module.exports = escapeHtmlChar;


/***/ }),
/* 1762 */
/***/ (function(module, exports) {

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

module.exports = escapeStringChar;


/***/ }),
/* 1763 */,
/* 1764 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1765 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1766 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(306);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1768 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(306);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(306);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(306);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1772 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(445),
    cloneDataView = __webpack_require__(1743),
    cloneRegExp = __webpack_require__(1744),
    cloneSymbol = __webpack_require__(1745),
    cloneTypedArray = __webpack_require__(703);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1774 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(151),
    isArguments = __webpack_require__(199),
    isArray = __webpack_require__(16);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1776 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(707),
    isFunction = __webpack_require__(115),
    stubFalse = __webpack_require__(464);

/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = coreJsData ? isFunction : stubFalse;

module.exports = isMaskable;


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(707);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1779 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 1780 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(294);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(294);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(294);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(294);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1702),
    ListCache = __webpack_require__(290),
    Map = __webpack_require__(424);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(304);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(304);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(304);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(304);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1920);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(705),
    composeArgsRight = __webpack_require__(706),
    replaceHolders = __webpack_require__(307);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(730);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1793 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1794 */,
/* 1795 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

module.exports = reEscape;


/***/ }),
/* 1796 */
/***/ (function(module, exports) {

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

module.exports = reEvaluate;


/***/ }),
/* 1797 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(85),
    isIndex = __webpack_require__(128);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1799 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1800 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1801 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(290);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1803 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1804 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1805 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(290),
    Map = __webpack_require__(424),
    MapCache = __webpack_require__(425);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1807 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1808 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

module.exports = strictLastIndexOf;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(437);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

module.exports = unescapeHtmlChar;


/***/ }),
/* 1810 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1811 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1812 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    arrayIncludes = __webpack_require__(293);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(422),
    LodashWrapper = __webpack_require__(423),
    copyArray = __webpack_require__(85);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(234),
    copyObject = __webpack_require__(99),
    createAssigner = __webpack_require__(193),
    isArrayLike = __webpack_require__(56),
    isPrototype = __webpack_require__(237),
    keys = __webpack_require__(46);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(99),
    createAssigner = __webpack_require__(193),
    keys = __webpack_require__(46);

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

module.exports = assignWith;


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

var baseAt = __webpack_require__(676),
    flatRest = __webpack_require__(156);

/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = flatRest(baseAt);

module.exports = at;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    createWrap = __webpack_require__(1754),
    getHolder = __webpack_require__(450),
    replaceHolders = __webpack_require__(307);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    baseAssignValue = __webpack_require__(109),
    bind = __webpack_require__(1818),
    flatRest = __webpack_require__(156),
    toKey = __webpack_require__(100);

/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = flatRest(function(object, methodNames) {
  arrayEach(methodNames, function(key) {
    key = toKey(key);
    baseAssignValue(object, key, bind(object[key], object));
  });
  return object;
});

module.exports = bindAll;


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(744),
    createCompounder = __webpack_require__(194);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(16);

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    isIterateeCall = __webpack_require__(66),
    toInteger = __webpack_require__(21);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneDeepWith;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
}

module.exports = cloneWith;


/***/ }),
/* 1827 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(233),
    baseFlatten = __webpack_require__(51),
    copyArray = __webpack_require__(85),
    isArray = __webpack_require__(16);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    arrayMap = __webpack_require__(36),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = baseIteratee;

  pairs = !length ? [] : arrayMap(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return baseRest(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (apply(pair[0], this, args)) {
        return apply(pair[1], this, args);
      }
    }
  });
}

module.exports = cond;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110),
    baseConforms = __webpack_require__(1714);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
}

module.exports = conforms;


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

var baseConformsTo = __webpack_require__(677),
    keys = __webpack_require__(46);

/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || baseConformsTo(object, source, keys(source));
}

module.exports = conformsTo;


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    createAggregator = __webpack_require__(301);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    baseAssignValue(result, key, 1);
  }
});

module.exports = countBy;


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssign = __webpack_require__(675),
    baseCreate = __webpack_require__(191);

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties == null ? result : baseAssign(result, properties);
}

module.exports = create;


/***/ }),
/* 1834 */,
/* 1835 */
/***/ (function(module, exports) {

/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

module.exports = defaultTo;


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    eq = __webpack_require__(86),
    isIterateeCall = __webpack_require__(66),
    keysIn = __webpack_require__(58);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    baseRest = __webpack_require__(22),
    customDefaultsMerge = __webpack_require__(1756),
    mergeWith = __webpack_require__(757);

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(235),
    baseFlatten = __webpack_require__(51),
    baseRest = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(57);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(235),
    baseFlatten = __webpack_require__(51),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
    : [];
});

module.exports = differenceBy;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(235),
    baseFlatten = __webpack_require__(51),
    baseRest = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

module.exports = differenceWith;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    toInteger = __webpack_require__(21);

/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = drop;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    toInteger = __webpack_require__(21);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseWhile = __webpack_require__(299);

/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), true, true)
    : [];
}

module.exports = dropRightWhile;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseWhile = __webpack_require__(299);

/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), true)
    : [];
}

module.exports = dropWhile;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(750);


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(751);


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    baseToString = __webpack_require__(111),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = toString(string);
  target = baseToString(target);

  var length = string.length;
  position = position === undefined
    ? length
    : baseClamp(toInteger(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

module.exports = endsWith;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(765);


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(766);


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(670),
    baseEvery = __webpack_require__(1715),
    baseIteratee = __webpack_require__(13),
    isArray = __webpack_require__(16),
    isIterateeCall = __webpack_require__(66);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(742);


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(456);


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

var baseFill = __webpack_require__(1716),
    isIterateeCall = __webpack_require__(66);

/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return baseFill(array, value, start, end);
}

module.exports = fill;


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    baseFilter = __webpack_require__(679),
    baseIteratee = __webpack_require__(13),
    isArray = __webpack_require__(16);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(711),
    findIndex = __webpack_require__(747);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(680),
    baseForOwn = __webpack_require__(152),
    baseIteratee = __webpack_require__(13);

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

module.exports = findKey;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(711),
    findLastIndex = __webpack_require__(748);

/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = createFind(findLastIndex);

module.exports = findLast;


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(680),
    baseForOwnRight = __webpack_require__(429),
    baseIteratee = __webpack_require__(13);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
}

module.exports = findLastKey;


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(752);


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    map = __webpack_require__(312);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    map = __webpack_require__(312);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), INFINITY);
}

module.exports = flatMapDeep;


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    map = __webpack_require__(312),
    toInteger = __webpack_require__(21);

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : toInteger(depth);
  return baseFlatten(map(collection, iteratee), depth);
}

module.exports = flatMapDepth;


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, INFINITY) : [];
}

module.exports = flattenDeep;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    toInteger = __webpack_require__(21);

/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : toInteger(depth);
  return baseFlatten(array, depth);
}

module.exports = flattenDepth;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(712);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(712);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(428),
    castFunction = __webpack_require__(112),
    keysIn = __webpack_require__(58);

/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : baseFor(object, castFunction(iteratee), keysIn);
}

module.exports = forIn;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(681),
    castFunction = __webpack_require__(112),
    keysIn = __webpack_require__(58);

/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : baseForRight(object, castFunction(iteratee), keysIn);
}

module.exports = forInRight;


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(152),
    castFunction = __webpack_require__(112);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(429),
    castFunction = __webpack_require__(112);

/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && baseForOwnRight(object, castFunction(iteratee));
}

module.exports = forOwnRight;


/***/ }),
/* 1872 */
/***/ (function(module, exports) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

var baseFunctions = __webpack_require__(430),
    keys = __webpack_require__(46);

/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : baseFunctions(object, keys(object));
}

module.exports = functions;


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

var baseFunctions = __webpack_require__(430),
    keysIn = __webpack_require__(58);

/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : baseFunctions(object, keysIn(object));
}

module.exports = functionsIn;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    createAggregator = __webpack_require__(301);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

var baseGt = __webpack_require__(1717),
    createRelationalOperation = __webpack_require__(303);

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

module.exports = gt;


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__(303);

/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = createRelationalOperation(function(value, other) {
  return value >= other;
});

module.exports = gte;


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1718),
    hasPath = __webpack_require__(724);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(192),
    isArrayLike = __webpack_require__(56),
    isString = __webpack_require__(311),
    toInteger = __webpack_require__(21),
    values = __webpack_require__(201);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(192),
    toInteger = __webpack_require__(21);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83);

/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 0, -1) : [];
}

module.exports = initial;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIntersection = __webpack_require__(431),
    baseRest = __webpack_require__(22),
    castArrayLikeObject = __webpack_require__(444);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIntersection = __webpack_require__(431),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22),
    castArrayLikeObject = __webpack_require__(444),
    last = __webpack_require__(87);

/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = baseRest(function(arrays) {
  var iteratee = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  if (iteratee === last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, baseIteratee(iteratee, 2))
    : [];
});

module.exports = intersectionBy;


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseIntersection = __webpack_require__(431),
    baseRest = __webpack_require__(22),
    castArrayLikeObject = __webpack_require__(444),
    last = __webpack_require__(87);

/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = baseRest(function(arrays) {
  var comparator = last(arrays),
      mapped = arrayMap(arrays, castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped, undefined, comparator)
    : [];
});

module.exports = intersectionWith;


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(457),
    createInverter = __webpack_require__(714),
    identity = __webpack_require__(114);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    createInverter = __webpack_require__(714);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  if (hasOwnProperty.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, baseIteratee);

module.exports = invertBy;


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(296),
    baseRest = __webpack_require__(22);

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

module.exports = invoke;


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(98),
    baseEach = __webpack_require__(126),
    baseInvoke = __webpack_require__(296),
    baseRest = __webpack_require__(22),
    isArrayLike = __webpack_require__(56);

/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = baseRest(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value) {
    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
  });
  return result;
});

module.exports = invokeMap;


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArrayBuffer = __webpack_require__(1723),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

module.exports = isArrayBuffer;


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsDate = __webpack_require__(1724),
    baseUnary = __webpack_require__(84),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsDate = nodeUtil && nodeUtil.isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

module.exports = isDate;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

var isObjectLike = __webpack_require__(34),
    isPlainObject = __webpack_require__(238);

/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
}

module.exports = isElement;


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(433),
    getTag = __webpack_require__(113),
    isArguments = __webpack_require__(199),
    isArray = __webpack_require__(16),
    isArrayLike = __webpack_require__(56),
    isBuffer = __webpack_require__(158),
    isPrototype = __webpack_require__(237),
    isTypedArray = __webpack_require__(200);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(297);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(297);

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(45);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(432),
    getMatchData = __webpack_require__(451);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(432),
    getMatchData = __webpack_require__(451);

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return baseIsMatch(object, source, getMatchData(source), customizer);
}

module.exports = isMatchWith;


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(755);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(684),
    isMaskable = __webpack_require__(1777);

/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return baseIsNative(value);
}

module.exports = isNative;


/***/ }),
/* 1901 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 1902 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

module.exports = isNull;


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

var isInteger = __webpack_require__(753);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
}

module.exports = isSafeInteger;


/***/ }),
/* 1904 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(113),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(55),
    isObjectLike = __webpack_require__(34);

/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return isObjectLike(value) && baseGetTag(value) == weakSetTag;
}

module.exports = isWeakSet;


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110),
    baseIteratee = __webpack_require__(13);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 1908 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(194);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    createAggregator = __webpack_require__(301);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(295),
    baseIsNaN = __webpack_require__(683),
    strictLastIndexOf = __webpack_require__(1808),
    toInteger = __webpack_require__(21);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = toInteger(fromIndex);
    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
  }
  return value === value
    ? strictLastIndexOf(array, value, index)
    : baseFindIndex(array, baseIsNaN, index, true);
}

module.exports = lastIndexOf;


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(194);

/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

module.exports = lowerCase;


/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(710);

/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = createCaseFirst('toLowerCase');

module.exports = lowerFirst;


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

var baseLt = __webpack_require__(1731),
    createRelationalOperation = __webpack_require__(303);

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

module.exports = lt;


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

var createRelationalOperation = __webpack_require__(303);

/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = createRelationalOperation(function(value, other) {
  return value <= other;
});

module.exports = lte;


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    baseForOwn = __webpack_require__(152),
    baseIteratee = __webpack_require__(13);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(109),
    baseForOwn = __webpack_require__(152),
    baseIteratee = __webpack_require__(13);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110),
    baseMatches = __webpack_require__(686);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
}

module.exports = matches;


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(110),
    baseMatchesProperty = __webpack_require__(687);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matchesProperty(path, srcValue) {
  return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
}

module.exports = matchesProperty;


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(425);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(435),
    createAssigner = __webpack_require__(193);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(296),
    baseRest = __webpack_require__(22);

/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = baseRest(function(path, args) {
  return function(object) {
    return baseInvoke(object, path, args);
  };
});

module.exports = method;


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(296),
    baseRest = __webpack_require__(22);

/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = baseRest(function(object, args) {
  return function(path) {
    return baseInvoke(object, path, args);
  };
});

module.exports = methodOf;


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    arrayPush = __webpack_require__(233),
    baseFunctions = __webpack_require__(430),
    copyArray = __webpack_require__(85),
    isFunction = __webpack_require__(115),
    isObject = __webpack_require__(39),
    keys = __webpack_require__(46);

/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin(object, source, options) {
  var props = keys(source),
      methodNames = baseFunctions(source, props);

  var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
      isFunc = isFunction(object);

  arrayEach(methodNames, function(methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function() {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
              actions = result.__actions__ = copyArray(this.__actions__);

          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, arrayPush([this.value()], arguments));
      };
    }
  });

  return object;
}

module.exports = mixin;


/***/ }),
/* 1925 */,
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__(688),
    toInteger = __webpack_require__(21);

/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
}

module.exports = nth;


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var baseNth = __webpack_require__(688),
    baseRest = __webpack_require__(22),
    toInteger = __webpack_require__(21);

/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = toInteger(n);
  return baseRest(function(args) {
    return baseNth(args, n);
  });
}

module.exports = nthArg;


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseClone = __webpack_require__(110),
    baseUnset = __webpack_require__(441),
    castPath = __webpack_require__(127),
    copyObject = __webpack_require__(99),
    customOmitClone = __webpack_require__(1757),
    flatRest = __webpack_require__(156),
    getAllKeysIn = __webpack_require__(448);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    negate = __webpack_require__(758),
    pickBy = __webpack_require__(759);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(689),
    isArray = __webpack_require__(16);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    createOver = __webpack_require__(446);

/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = createOver(arrayMap);

module.exports = over;


/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(670),
    createOver = __webpack_require__(446);

/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = createOver(arrayEvery);

module.exports = overEvery;


/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(427),
    createOver = __webpack_require__(446);

/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 *
 * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
 * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
 */
var overSome = createOver(arraySome);

module.exports = overSome;


/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(447),
    stringSize = __webpack_require__(197),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeFloor = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return (
    createPadding(nativeFloor(mid), chars) +
    string +
    createPadding(nativeCeil(mid), chars)
  );
}

module.exports = pad;


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(447),
    stringSize = __webpack_require__(197),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (string + createPadding(length - strLength, chars))
    : string;
}

module.exports = padEnd;


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(447),
    stringSize = __webpack_require__(197),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

module.exports = padStart;


/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(45),
    toString = __webpack_require__(25);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = root.parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
}

module.exports = parseInt;


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var createAggregator = __webpack_require__(301);

/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

module.exports = partition;


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1733),
    flatRest = __webpack_require__(156);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(153);

/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function(path) {
    return object == null ? undefined : baseGet(object, path);
  };
}

module.exports = propertyOf;


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    pullAll = __webpack_require__(761);

/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = baseRest(pullAll);

module.exports = pull;


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    basePullAll = __webpack_require__(438);

/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, baseIteratee(iteratee, 2))
    : array;
}

module.exports = pullAllBy;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

var basePullAll = __webpack_require__(438);

/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? basePullAll(array, values, undefined, comparator)
    : array;
}

module.exports = pullAllWith;


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    baseAt = __webpack_require__(676),
    basePullAt = __webpack_require__(691),
    compareAscending = __webpack_require__(704),
    flatRest = __webpack_require__(156),
    isIndex = __webpack_require__(128);

/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = flatRest(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = baseAt(array, indexes);

  basePullAt(array, arrayMap(indexes, function(index) {
    return isIndex(index, length) ? +index : index;
  }).sort(compareAscending));

  return result;
});

module.exports = pullAt;


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(715);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(715);

/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = createRange(true);

module.exports = rangeRight;


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(672),
    baseEach = __webpack_require__(126),
    baseIteratee = __webpack_require__(13),
    baseReduce = __webpack_require__(693),
    isArray = __webpack_require__(16);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduceRight = __webpack_require__(1706),
    baseEachRight = __webpack_require__(678),
    baseIteratee = __webpack_require__(13),
    baseReduce = __webpack_require__(693),
    isArray = __webpack_require__(16);

/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduceRight : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
}

module.exports = reduceRight;


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    baseFilter = __webpack_require__(679),
    baseIteratee = __webpack_require__(13),
    isArray = __webpack_require__(16),
    negate = __webpack_require__(758);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    basePullAt = __webpack_require__(691);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(694),
    isIterateeCall = __webpack_require__(66),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  return baseRepeat(toString(string), n);
}

module.exports = repeat;


/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(127),
    isFunction = __webpack_require__(115),
    toKey = __webpack_require__(100);

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = castPath(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;


/***/ }),
/* 1954 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

module.exports = reverse;


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(673),
    baseSample = __webpack_require__(1736),
    isArray = __webpack_require__(16);

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

module.exports = sample;


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(1707),
    baseSampleSize = __webpack_require__(1737),
    isArray = __webpack_require__(16),
    isIterateeCall = __webpack_require__(66),
    toInteger = __webpack_require__(21);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(236);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(236);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(1708),
    baseShuffle = __webpack_require__(1739),
    isArray = __webpack_require__(16);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(433),
    getTag = __webpack_require__(113),
    isArrayLike = __webpack_require__(56),
    isString = __webpack_require__(311),
    stringSize = __webpack_require__(197);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    isIterateeCall = __webpack_require__(66),
    toInteger = __webpack_require__(21);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(194);

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

module.exports = snakeCase;


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(427),
    baseIteratee = __webpack_require__(13),
    baseSome = __webpack_require__(1740),
    isArray = __webpack_require__(16),
    isIterateeCall = __webpack_require__(66);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    baseOrderBy = __webpack_require__(689),
    baseRest = __webpack_require__(22),
    isIterateeCall = __webpack_require__(66);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(298);

/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return baseSortedIndex(array, value);
}

module.exports = sortedIndex;


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseSortedIndexBy = __webpack_require__(439);

/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2));
}

module.exports = sortedIndexBy;


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(298),
    eq = __webpack_require__(86);

/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value);
    if (index < length && eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = sortedIndexOf;


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(298);

/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return baseSortedIndex(array, value, true);
}

module.exports = sortedLastIndex;


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseSortedIndexBy = __webpack_require__(439);

/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return baseSortedIndexBy(array, value, baseIteratee(iteratee, 2), true);
}

module.exports = sortedLastIndexBy;


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedIndex = __webpack_require__(298),
    eq = __webpack_require__(86);

/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = baseSortedIndex(array, value, true) - 1;
    if (eq(array[index], value)) {
      return index;
    }
  }
  return -1;
}

module.exports = sortedLastIndexOf;


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

var baseSortedUniq = __webpack_require__(696);

/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? baseSortedUniq(array)
    : [];
}

module.exports = sortedUniq;


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseSortedUniq = __webpack_require__(696);

/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? baseSortedUniq(array, baseIteratee(iteratee, 2))
    : [];
}

module.exports = sortedUniqBy;


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111),
    castSlice = __webpack_require__(155),
    hasUnicode = __webpack_require__(195),
    isIterateeCall = __webpack_require__(66),
    isRegExp = __webpack_require__(461),
    stringToArray = __webpack_require__(129),
    toString = __webpack_require__(25);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(194),
    upperFirst = __webpack_require__(467);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    baseToString = __webpack_require__(111),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 1976 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

module.exports = stubObject;


/***/ }),
/* 1977 */
/***/ (function(module, exports) {

/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

module.exports = stubString;


/***/ }),
/* 1978 */
/***/ (function(module, exports) {

/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

module.exports = stubTrue;


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83);

/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseSlice(array, 1, length) : [];
}

module.exports = tail;


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    toInteger = __webpack_require__(21);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(83),
    toInteger = __webpack_require__(21);

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = takeRight;


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseWhile = __webpack_require__(299);

/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3), false, true)
    : [];
}

module.exports = takeRightWhile;


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseWhile = __webpack_require__(299);

/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? baseWhile(array, baseIteratee(predicate, 3))
    : [];
}

module.exports = takeWhile;


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

var assignInWith = __webpack_require__(456),
    attempt = __webpack_require__(743),
    baseValues = __webpack_require__(442),
    customDefaultsAssignIn = __webpack_require__(1755),
    escapeStringChar = __webpack_require__(1762),
    isError = __webpack_require__(460),
    isIterateeCall = __webpack_require__(66),
    keys = __webpack_require__(46),
    reInterpolate = __webpack_require__(733),
    templateSettings = __webpack_require__(762),
    toString = __webpack_require__(25);

/** Error message constants. */
var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to validate the `validate` option in `_.template` variable.
 *
 * Forbids characters which could potentially change the meaning of the function argument definition:
 * - "()," (modification of function parameters)
 * - "=" (default value)
 * - "[]{}" (destructuring of function parameters)
 * - "/" (beginning of a comment)
 * - whitespace
 */
var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, customDefaultsAssignIn);

  var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
  // and escape the comment, thus injecting code that gets evaled.
  var sourceURL = hasOwnProperty.call(options, 'sourceURL')
    ? ('//# sourceURL=' +
       (options.sourceURL + '').replace(/\s/g, ' ') +
       '\n')
    : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = hasOwnProperty.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Throw an error if a forbidden character was found in `variable`, to prevent
  // potential command injection attacks.
  else if (reForbiddenIdentifierChars.test(variable)) {
    throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
  }

  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

module.exports = template;


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(440),
    castFunction = __webpack_require__(112),
    toInteger = __webpack_require__(21);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(151),
    copyArray = __webpack_require__(85),
    getTag = __webpack_require__(113),
    isArrayLike = __webpack_require__(56),
    isString = __webpack_require__(311),
    iteratorToArray = __webpack_require__(1779),
    mapToArray = __webpack_require__(454),
    setToArray = __webpack_require__(308),
    stringToArray = __webpack_require__(129),
    values = __webpack_require__(201);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25);

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(36),
    copyArray = __webpack_require__(85),
    isArray = __webpack_require__(16),
    isSymbol = __webpack_require__(116),
    stringToPath = __webpack_require__(738),
    toKey = __webpack_require__(100),
    toString = __webpack_require__(25);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(190),
    toInteger = __webpack_require__(21);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

module.exports = toSafeInteger;


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25);

/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return toString(value).toUpperCase();
}

module.exports = toUpper;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(189),
    baseCreate = __webpack_require__(191),
    baseForOwn = __webpack_require__(152),
    baseIteratee = __webpack_require__(13),
    getPrototype = __webpack_require__(305),
    isArray = __webpack_require__(16),
    isBuffer = __webpack_require__(158),
    isFunction = __webpack_require__(115),
    isObject = __webpack_require__(39),
    isTypedArray = __webpack_require__(200);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111),
    baseTrim = __webpack_require__(697),
    castSlice = __webpack_require__(155),
    charsEndIndex = __webpack_require__(700),
    charsStartIndex = __webpack_require__(701),
    stringToArray = __webpack_require__(129),
    toString = __webpack_require__(25);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111),
    castSlice = __webpack_require__(155),
    charsEndIndex = __webpack_require__(700),
    stringToArray = __webpack_require__(129),
    toString = __webpack_require__(25),
    trimmedEndIndex = __webpack_require__(740);

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

module.exports = trimEnd;


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111),
    castSlice = __webpack_require__(155),
    charsStartIndex = __webpack_require__(701),
    stringToArray = __webpack_require__(129),
    toString = __webpack_require__(25);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

module.exports = trimStart;


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(111),
    castSlice = __webpack_require__(155),
    hasUnicode = __webpack_require__(195),
    isObject = __webpack_require__(39),
    isRegExp = __webpack_require__(461),
    stringSize = __webpack_require__(197),
    stringToArray = __webpack_require__(129),
    toInteger = __webpack_require__(21),
    toString = __webpack_require__(25);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

module.exports = truncate;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25),
    unescapeHtmlChar = __webpack_require__(1809);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

module.exports = unescape;


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    baseRest = __webpack_require__(22),
    baseUniq = __webpack_require__(154),
    isArrayLikeObject = __webpack_require__(57);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22),
    baseUniq = __webpack_require__(154),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(51),
    baseRest = __webpack_require__(22),
    baseUniq = __webpack_require__(154),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(154);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(13),
    baseUniq = __webpack_require__(154);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(154);

/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
}

module.exports = uniqWith;


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(441);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

var baseUpdate = __webpack_require__(698),
    castFunction = __webpack_require__(112);

/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update(object, path, updater) {
  return object == null ? object : baseUpdate(object, path, castFunction(updater));
}

module.exports = update;


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

var baseUpdate = __webpack_require__(698),
    castFunction = __webpack_require__(112);

/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
}

module.exports = updateWith;


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(194);

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

module.exports = upperCase;


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'attempt': __webpack_require__(743),
  'bindAll': __webpack_require__(1819),
  'cond': __webpack_require__(1829),
  'conforms': __webpack_require__(1830),
  'constant': __webpack_require__(457),
  'defaultTo': __webpack_require__(1835),
  'flow': __webpack_require__(1866),
  'flowRight': __webpack_require__(1867),
  'identity': __webpack_require__(114),
  'iteratee': __webpack_require__(1907),
  'matches': __webpack_require__(1918),
  'matchesProperty': __webpack_require__(1919),
  'method': __webpack_require__(1922),
  'methodOf': __webpack_require__(1923),
  'mixin': __webpack_require__(1924),
  'noop': __webpack_require__(462),
  'nthArg': __webpack_require__(1927),
  'over': __webpack_require__(1931),
  'overEvery': __webpack_require__(1932),
  'overSome': __webpack_require__(1933),
  'property': __webpack_require__(760),
  'propertyOf': __webpack_require__(1940),
  'range': __webpack_require__(1945),
  'rangeRight': __webpack_require__(1946),
  'stubArray': __webpack_require__(463),
  'stubFalse': __webpack_require__(464),
  'stubObject': __webpack_require__(1976),
  'stubString': __webpack_require__(1977),
  'stubTrue': __webpack_require__(1978),
  'times': __webpack_require__(1985),
  'toPath': __webpack_require__(1988),
  'uniqueId': __webpack_require__(2003)
};


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(442),
    keysIn = __webpack_require__(58);

/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : baseValues(object, keysIn(object));
}

module.exports = valuesIn;


/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(235),
    baseRest = __webpack_require__(22),
    isArrayLikeObject = __webpack_require__(57);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(422),
    LodashWrapper = __webpack_require__(423),
    baseLodash = __webpack_require__(434),
    isArray = __webpack_require__(16),
    isObjectLike = __webpack_require__(34),
    wrapperClone = __webpack_require__(1814);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    baseRest = __webpack_require__(22),
    baseXor = __webpack_require__(443),
    isArrayLikeObject = __webpack_require__(57);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    baseIteratee = __webpack_require__(13),
    baseRest = __webpack_require__(22),
    baseXor = __webpack_require__(443),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee, 2));
});

module.exports = xorBy;


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(125),
    baseRest = __webpack_require__(22),
    baseXor = __webpack_require__(443),
    isArrayLikeObject = __webpack_require__(57),
    last = __webpack_require__(87);

/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
});

module.exports = xorWith;


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    unzip = __webpack_require__(466);

/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = baseRest(unzip);

module.exports = zip;


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(234),
    baseZipObject = __webpack_require__(699);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

module.exports = zipObject;


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(236),
    baseZipObject = __webpack_require__(699);

/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return baseZipObject(props || [], values || [], baseSet);
}

module.exports = zipObjectDeep;


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(22),
    unzipWith = __webpack_require__(768);

/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = baseRest(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return unzipWith(arrays, iteratee);
});

module.exports = zipWith;


/***/ }),
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2140)


/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(2139);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(2141);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(2138);

/***/ }),
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1029);
module.exports = __webpack_require__(1028);


/***/ })
],[2339]);


// WEBPACK FOOTER //
// app.js